
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec6d9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec6d9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5Jx4e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42cace357cab000e$export$2e2bcd8739ae039; });

var $ht9qF = parcelRequire("ht9qF");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $ht9qF.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $42cace357cab000e$export$2e2bcd8739ae039 = cloneBuffer;

});
parcelRegister("ht9qF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb7c758ba31e8adb$export$2e2bcd8739ae039; });

var $lnjqR = parcelRequire("lnjqR");
/** Detect free variable `self`. */ var $cb7c758ba31e8adb$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $cb7c758ba31e8adb$var$root = (0, $lnjqR.default) || $cb7c758ba31e8adb$var$freeSelf || Function("return this")();
var $cb7c758ba31e8adb$export$2e2bcd8739ae039 = $cb7c758ba31e8adb$var$root;

});
parcelRegister("lnjqR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8fad1cf9ed61e7d$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $f8fad1cf9ed61e7d$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $f8fad1cf9ed61e7d$export$2e2bcd8739ae039 = $f8fad1cf9ed61e7d$var$freeGlobal;

});



parcelRegister("dG9Ze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f56f1bd7e0d24af$export$2e2bcd8739ae039; });

var $ht9qF = parcelRequire("ht9qF");

var $9bks7 = parcelRequire("9bks7");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $ht9qF.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $9bks7.default);
var $9f56f1bd7e0d24af$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("9bks7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6af501938a8671fc$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $6af501938a8671fc$var$stubFalse() {
    return false;
}
var $6af501938a8671fc$export$2e2bcd8739ae039 = $6af501938a8671fc$var$stubFalse;

});


parcelRegister("rj6Om", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0521585a27b61cb6$export$2e2bcd8739ae039; });

var $lnjqR = parcelRequire("lnjqR");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $lnjqR.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $0521585a27b61cb6$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("6VEzq", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("iK1WR", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});


var $j3H8N = parcelRequire("j3H8N");

const $941b38af69543b93$export$e95f23a3da8bb3c7 = ()=>{
    // Datepicker
    const DATEPICKER_ELS = document.querySelectorAll(".date-picker");
    DATEPICKER_ELS.forEach((el)=>{
        const DATEPICKER = new (0, $j3H8N.Datepicker)(el, {
            todayHighlight: true,
            buttonClass: "btn",
            nextArrow: "<i class='ph ph-arrow-right'></i>",
            prevArrow: "<i class='ph ph-arrow-left'></i>"
        });
    });
    // Date Range Picker
    const RANGEPICKER_ELS = document.querySelectorAll(".date-range-picker");
    RANGEPICKER_ELS.forEach((el)=>{
        const RANGEPICKER = new (0, $j3H8N.DateRangePicker)(el, {
            buttonClass: "btn",
            nextArrow: "<i class='ph ph-arrow-right'></i>",
            prevArrow: "<i class='ph ph-arrow-left'></i>",
            clearButton: true,
            todayButton: true
        });
    });
};


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $bf3aa8a5d36dc031$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $bf3aa8a5d36dc031$export$2e2bcd8739ae039 = $bf3aa8a5d36dc031$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $9f16bf068e420061$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $9f16bf068e420061$export$2e2bcd8739ae039 = $9f16bf068e420061$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $8e881937f4270f38$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $9f16bf068e420061$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $8e881937f4270f38$export$2e2bcd8739ae039 = $8e881937f4270f38$var$assocIndexOf;


/** Used for built-in method references. */ var $d06b0629fe9a97f3$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d06b0629fe9a97f3$var$splice = $d06b0629fe9a97f3$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d06b0629fe9a97f3$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $8e881937f4270f38$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d06b0629fe9a97f3$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $d06b0629fe9a97f3$export$2e2bcd8739ae039 = $d06b0629fe9a97f3$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3f92871c4820804b$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $8e881937f4270f38$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $3f92871c4820804b$export$2e2bcd8739ae039 = $3f92871c4820804b$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $738891dd2ea6395d$var$listCacheHas(key) {
    return (0, $8e881937f4270f38$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $738891dd2ea6395d$export$2e2bcd8739ae039 = $738891dd2ea6395d$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $155f09356a656583$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $8e881937f4270f38$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $155f09356a656583$export$2e2bcd8739ae039 = $155f09356a656583$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9f09b9e2766c7547$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$9f09b9e2766c7547$var$ListCache.prototype.clear = (0, $bf3aa8a5d36dc031$export$2e2bcd8739ae039);
$9f09b9e2766c7547$var$ListCache.prototype["delete"] = (0, $d06b0629fe9a97f3$export$2e2bcd8739ae039);
$9f09b9e2766c7547$var$ListCache.prototype.get = (0, $3f92871c4820804b$export$2e2bcd8739ae039);
$9f09b9e2766c7547$var$ListCache.prototype.has = (0, $738891dd2ea6395d$export$2e2bcd8739ae039);
$9f09b9e2766c7547$var$ListCache.prototype.set = (0, $155f09356a656583$export$2e2bcd8739ae039);
var $9f09b9e2766c7547$export$2e2bcd8739ae039 = $9f09b9e2766c7547$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $2f8c9203a7625266$var$stackClear() {
    this.__data__ = new (0, $9f09b9e2766c7547$export$2e2bcd8739ae039);
    this.size = 0;
}
var $2f8c9203a7625266$export$2e2bcd8739ae039 = $2f8c9203a7625266$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $84d00c906dc4a239$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $84d00c906dc4a239$export$2e2bcd8739ae039 = $84d00c906dc4a239$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4abafc3a4f6b6693$var$stackGet(key) {
    return this.__data__.get(key);
}
var $4abafc3a4f6b6693$export$2e2bcd8739ae039 = $4abafc3a4f6b6693$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8af1e0658d99a1af$var$stackHas(key) {
    return this.__data__.has(key);
}
var $8af1e0658d99a1af$export$2e2bcd8739ae039 = $8af1e0658d99a1af$var$stackHas;




var $ht9qF = parcelRequire("ht9qF");
/** Built-in value references. */ var $2adae95c0aedb06d$var$Symbol = (0, $ht9qF.default).Symbol;
var $2adae95c0aedb06d$export$2e2bcd8739ae039 = $2adae95c0aedb06d$var$Symbol;



/** Used for built-in method references. */ var $b210416a934e520f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b210416a934e520f$var$hasOwnProperty = $b210416a934e520f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b210416a934e520f$var$nativeObjectToString = $b210416a934e520f$var$objectProto.toString;
/** Built-in value references. */ var $b210416a934e520f$var$symToStringTag = (0, $2adae95c0aedb06d$export$2e2bcd8739ae039) ? (0, $2adae95c0aedb06d$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b210416a934e520f$var$getRawTag(value) {
    var isOwn = $b210416a934e520f$var$hasOwnProperty.call(value, $b210416a934e520f$var$symToStringTag), tag = value[$b210416a934e520f$var$symToStringTag];
    try {
        value[$b210416a934e520f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b210416a934e520f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b210416a934e520f$var$symToStringTag] = tag;
        else delete value[$b210416a934e520f$var$symToStringTag];
    }
    return result;
}
var $b210416a934e520f$export$2e2bcd8739ae039 = $b210416a934e520f$var$getRawTag;


/** Used for built-in method references. */ var $a6191a42dd634bd6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a6191a42dd634bd6$var$nativeObjectToString = $a6191a42dd634bd6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $a6191a42dd634bd6$var$objectToString(value) {
    return $a6191a42dd634bd6$var$nativeObjectToString.call(value);
}
var $a6191a42dd634bd6$export$2e2bcd8739ae039 = $a6191a42dd634bd6$var$objectToString;


/** `Object#toString` result references. */ var $f9754adf838f9df5$var$nullTag = "[object Null]", $f9754adf838f9df5$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $f9754adf838f9df5$var$symToStringTag = (0, $2adae95c0aedb06d$export$2e2bcd8739ae039) ? (0, $2adae95c0aedb06d$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $f9754adf838f9df5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $f9754adf838f9df5$var$undefinedTag : $f9754adf838f9df5$var$nullTag;
    return $f9754adf838f9df5$var$symToStringTag && $f9754adf838f9df5$var$symToStringTag in Object(value) ? (0, $b210416a934e520f$export$2e2bcd8739ae039)(value) : (0, $a6191a42dd634bd6$export$2e2bcd8739ae039)(value);
}
var $f9754adf838f9df5$export$2e2bcd8739ae039 = $f9754adf838f9df5$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $2305f62ead79bff9$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $2305f62ead79bff9$export$2e2bcd8739ae039 = $2305f62ead79bff9$var$isObject;


/** `Object#toString` result references. */ var $39a501729f57ce1d$var$asyncTag = "[object AsyncFunction]", $39a501729f57ce1d$var$funcTag = "[object Function]", $39a501729f57ce1d$var$genTag = "[object GeneratorFunction]", $39a501729f57ce1d$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $39a501729f57ce1d$var$isFunction(value) {
    if (!(0, $2305f62ead79bff9$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $f9754adf838f9df5$export$2e2bcd8739ae039)(value);
    return tag == $39a501729f57ce1d$var$funcTag || tag == $39a501729f57ce1d$var$genTag || tag == $39a501729f57ce1d$var$asyncTag || tag == $39a501729f57ce1d$var$proxyTag;
}
var $39a501729f57ce1d$export$2e2bcd8739ae039 = $39a501729f57ce1d$var$isFunction;



var $ht9qF = parcelRequire("ht9qF");
/** Used to detect overreaching core-js shims. */ var $90a870296bf5a81d$var$coreJsData = (0, $ht9qF.default)["__core-js_shared__"];
var $90a870296bf5a81d$export$2e2bcd8739ae039 = $90a870296bf5a81d$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $4c0a4a982c49804d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $90a870296bf5a81d$export$2e2bcd8739ae039) && (0, $90a870296bf5a81d$export$2e2bcd8739ae039).keys && (0, $90a870296bf5a81d$export$2e2bcd8739ae039).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $4c0a4a982c49804d$var$isMasked(func) {
    return !!$4c0a4a982c49804d$var$maskSrcKey && $4c0a4a982c49804d$var$maskSrcKey in func;
}
var $4c0a4a982c49804d$export$2e2bcd8739ae039 = $4c0a4a982c49804d$var$isMasked;



/** Used for built-in method references. */ var $8ac7b9d2a7e86a84$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $8ac7b9d2a7e86a84$var$funcToString = $8ac7b9d2a7e86a84$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $8ac7b9d2a7e86a84$var$toSource(func) {
    if (func != null) {
        try {
            return $8ac7b9d2a7e86a84$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $8ac7b9d2a7e86a84$export$2e2bcd8739ae039 = $8ac7b9d2a7e86a84$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $2858a307efd982ce$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $2858a307efd982ce$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $2858a307efd982ce$var$funcProto = Function.prototype, $2858a307efd982ce$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $2858a307efd982ce$var$funcToString = $2858a307efd982ce$var$funcProto.toString;
/** Used to check objects for own properties. */ var $2858a307efd982ce$var$hasOwnProperty = $2858a307efd982ce$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $2858a307efd982ce$var$reIsNative = RegExp("^" + $2858a307efd982ce$var$funcToString.call($2858a307efd982ce$var$hasOwnProperty).replace($2858a307efd982ce$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $2858a307efd982ce$var$baseIsNative(value) {
    if (!(0, $2305f62ead79bff9$export$2e2bcd8739ae039)(value) || (0, $4c0a4a982c49804d$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $39a501729f57ce1d$export$2e2bcd8739ae039)(value) ? $2858a307efd982ce$var$reIsNative : $2858a307efd982ce$var$reIsHostCtor;
    return pattern.test((0, $8ac7b9d2a7e86a84$export$2e2bcd8739ae039)(value));
}
var $2858a307efd982ce$export$2e2bcd8739ae039 = $2858a307efd982ce$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $4cb0d49e5bb399ca$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $4cb0d49e5bb399ca$export$2e2bcd8739ae039 = $4cb0d49e5bb399ca$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $27fdeb15c1d5ca69$var$getNative(object, key) {
    var value = (0, $4cb0d49e5bb399ca$export$2e2bcd8739ae039)(object, key);
    return (0, $2858a307efd982ce$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $27fdeb15c1d5ca69$export$2e2bcd8739ae039 = $27fdeb15c1d5ca69$var$getNative;



var $ht9qF = parcelRequire("ht9qF");
/* Built-in method references that are verified to be native. */ var $cfda3e888c8b1f4f$var$Map = (0, $27fdeb15c1d5ca69$export$2e2bcd8739ae039)((0, $ht9qF.default), "Map");
var $cfda3e888c8b1f4f$export$2e2bcd8739ae039 = $cfda3e888c8b1f4f$var$Map;



/* Built-in method references that are verified to be native. */ var $254023d7bbf7ddf8$var$nativeCreate = (0, $27fdeb15c1d5ca69$export$2e2bcd8739ae039)(Object, "create");
var $254023d7bbf7ddf8$export$2e2bcd8739ae039 = $254023d7bbf7ddf8$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $9aa9e2298ab77b02$var$hashClear() {
    this.__data__ = (0, $254023d7bbf7ddf8$export$2e2bcd8739ae039) ? (0, $254023d7bbf7ddf8$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $9aa9e2298ab77b02$export$2e2bcd8739ae039 = $9aa9e2298ab77b02$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0d9972cf3d7386fa$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $0d9972cf3d7386fa$export$2e2bcd8739ae039 = $0d9972cf3d7386fa$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $edbc9b63c98fe64f$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $edbc9b63c98fe64f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $edbc9b63c98fe64f$var$hasOwnProperty = $edbc9b63c98fe64f$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $edbc9b63c98fe64f$var$hashGet(key) {
    var data = this.__data__;
    if (0, $254023d7bbf7ddf8$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $edbc9b63c98fe64f$var$HASH_UNDEFINED ? undefined : result;
    }
    return $edbc9b63c98fe64f$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $edbc9b63c98fe64f$export$2e2bcd8739ae039 = $edbc9b63c98fe64f$var$hashGet;



/** Used for built-in method references. */ var $f04466f7eb5ee475$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f04466f7eb5ee475$var$hasOwnProperty = $f04466f7eb5ee475$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f04466f7eb5ee475$var$hashHas(key) {
    var data = this.__data__;
    return (0, $254023d7bbf7ddf8$export$2e2bcd8739ae039) ? data[key] !== undefined : $f04466f7eb5ee475$var$hasOwnProperty.call(data, key);
}
var $f04466f7eb5ee475$export$2e2bcd8739ae039 = $f04466f7eb5ee475$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $babaf2f8fade7c81$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $babaf2f8fade7c81$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $254023d7bbf7ddf8$export$2e2bcd8739ae039) && value === undefined ? $babaf2f8fade7c81$var$HASH_UNDEFINED : value;
    return this;
}
var $babaf2f8fade7c81$export$2e2bcd8739ae039 = $babaf2f8fade7c81$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ea25a4f998b2e490$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$ea25a4f998b2e490$var$Hash.prototype.clear = (0, $9aa9e2298ab77b02$export$2e2bcd8739ae039);
$ea25a4f998b2e490$var$Hash.prototype["delete"] = (0, $0d9972cf3d7386fa$export$2e2bcd8739ae039);
$ea25a4f998b2e490$var$Hash.prototype.get = (0, $edbc9b63c98fe64f$export$2e2bcd8739ae039);
$ea25a4f998b2e490$var$Hash.prototype.has = (0, $f04466f7eb5ee475$export$2e2bcd8739ae039);
$ea25a4f998b2e490$var$Hash.prototype.set = (0, $babaf2f8fade7c81$export$2e2bcd8739ae039);
var $ea25a4f998b2e490$export$2e2bcd8739ae039 = $ea25a4f998b2e490$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $60c2c37cff5514b7$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $ea25a4f998b2e490$export$2e2bcd8739ae039),
        "map": new ((0, $cfda3e888c8b1f4f$export$2e2bcd8739ae039) || (0, $9f09b9e2766c7547$export$2e2bcd8739ae039)),
        "string": new (0, $ea25a4f998b2e490$export$2e2bcd8739ae039)
    };
}
var $60c2c37cff5514b7$export$2e2bcd8739ae039 = $60c2c37cff5514b7$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b5111e42ccfdfbfa$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $b5111e42ccfdfbfa$export$2e2bcd8739ae039 = $b5111e42ccfdfbfa$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $3176f53dc44f1702$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $b5111e42ccfdfbfa$export$2e2bcd8739ae039)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $3176f53dc44f1702$export$2e2bcd8739ae039 = $3176f53dc44f1702$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d7d24fce6f3d5eeb$var$mapCacheDelete(key) {
    var result = (0, $3176f53dc44f1702$export$2e2bcd8739ae039)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $d7d24fce6f3d5eeb$export$2e2bcd8739ae039 = $d7d24fce6f3d5eeb$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $73b97545b5b39a3d$var$mapCacheGet(key) {
    return (0, $3176f53dc44f1702$export$2e2bcd8739ae039)(this, key).get(key);
}
var $73b97545b5b39a3d$export$2e2bcd8739ae039 = $73b97545b5b39a3d$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6e186de77d1b85ad$var$mapCacheHas(key) {
    return (0, $3176f53dc44f1702$export$2e2bcd8739ae039)(this, key).has(key);
}
var $6e186de77d1b85ad$export$2e2bcd8739ae039 = $6e186de77d1b85ad$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $672c4494f49800b9$var$mapCacheSet(key, value) {
    var data = (0, $3176f53dc44f1702$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $672c4494f49800b9$export$2e2bcd8739ae039 = $672c4494f49800b9$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1943cd310943703a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$1943cd310943703a$var$MapCache.prototype.clear = (0, $60c2c37cff5514b7$export$2e2bcd8739ae039);
$1943cd310943703a$var$MapCache.prototype["delete"] = (0, $d7d24fce6f3d5eeb$export$2e2bcd8739ae039);
$1943cd310943703a$var$MapCache.prototype.get = (0, $73b97545b5b39a3d$export$2e2bcd8739ae039);
$1943cd310943703a$var$MapCache.prototype.has = (0, $6e186de77d1b85ad$export$2e2bcd8739ae039);
$1943cd310943703a$var$MapCache.prototype.set = (0, $672c4494f49800b9$export$2e2bcd8739ae039);
var $1943cd310943703a$export$2e2bcd8739ae039 = $1943cd310943703a$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $5d411d2b5962b6a4$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $5d411d2b5962b6a4$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $9f09b9e2766c7547$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $cfda3e888c8b1f4f$export$2e2bcd8739ae039) || pairs.length < $5d411d2b5962b6a4$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $1943cd310943703a$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $5d411d2b5962b6a4$export$2e2bcd8739ae039 = $5d411d2b5962b6a4$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b95edf1c0e6bc0d8$var$Stack(entries) {
    var data = this.__data__ = new (0, $9f09b9e2766c7547$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$b95edf1c0e6bc0d8$var$Stack.prototype.clear = (0, $2f8c9203a7625266$export$2e2bcd8739ae039);
$b95edf1c0e6bc0d8$var$Stack.prototype["delete"] = (0, $84d00c906dc4a239$export$2e2bcd8739ae039);
$b95edf1c0e6bc0d8$var$Stack.prototype.get = (0, $4abafc3a4f6b6693$export$2e2bcd8739ae039);
$b95edf1c0e6bc0d8$var$Stack.prototype.has = (0, $8af1e0658d99a1af$export$2e2bcd8739ae039);
$b95edf1c0e6bc0d8$var$Stack.prototype.set = (0, $5d411d2b5962b6a4$export$2e2bcd8739ae039);
var $b95edf1c0e6bc0d8$export$2e2bcd8739ae039 = $b95edf1c0e6bc0d8$var$Stack;



var $d14d1daa2d2b9717$var$defineProperty = function() {
    try {
        var func = (0, $27fdeb15c1d5ca69$export$2e2bcd8739ae039)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $d14d1daa2d2b9717$export$2e2bcd8739ae039 = $d14d1daa2d2b9717$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $0c8f2d84067e3e51$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $d14d1daa2d2b9717$export$2e2bcd8739ae039)) (0, $d14d1daa2d2b9717$export$2e2bcd8739ae039)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $0c8f2d84067e3e51$export$2e2bcd8739ae039 = $0c8f2d84067e3e51$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $da3ab8739fccfd9e$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $9f16bf068e420061$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $0c8f2d84067e3e51$export$2e2bcd8739ae039)(object, key, value);
}
var $da3ab8739fccfd9e$export$2e2bcd8739ae039 = $da3ab8739fccfd9e$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $ff38a1eed96f9716$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $ff38a1eed96f9716$export$2e2bcd8739ae039 = $ff38a1eed96f9716$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $a90859013c301aa7$var$baseFor = (0, $ff38a1eed96f9716$export$2e2bcd8739ae039)();
var $a90859013c301aa7$export$2e2bcd8739ae039 = $a90859013c301aa7$var$baseFor;




var $5Jx4e = parcelRequire("5Jx4e");

var $ht9qF = parcelRequire("ht9qF");
/** Built-in value references. */ var $17739cb3beac2917$var$Uint8Array = (0, $ht9qF.default).Uint8Array;
var $17739cb3beac2917$export$2e2bcd8739ae039 = $17739cb3beac2917$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $7cb9a859afbe21a6$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $17739cb3beac2917$export$2e2bcd8739ae039)(result).set(new (0, $17739cb3beac2917$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $7cb9a859afbe21a6$export$2e2bcd8739ae039 = $7cb9a859afbe21a6$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $d8d053df9ba5c0b4$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $7cb9a859afbe21a6$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $d8d053df9ba5c0b4$export$2e2bcd8739ae039 = $d8d053df9ba5c0b4$var$cloneTypedArray;


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $6b7aec747d72d89b$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $6b7aec747d72d89b$export$2e2bcd8739ae039 = $6b7aec747d72d89b$var$copyArray;



/** Built-in value references. */ var $91a93494a9a7cebd$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $91a93494a9a7cebd$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $2305f62ead79bff9$export$2e2bcd8739ae039)(proto)) return {};
        if ($91a93494a9a7cebd$var$objectCreate) return $91a93494a9a7cebd$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $91a93494a9a7cebd$export$2e2bcd8739ae039 = $91a93494a9a7cebd$var$baseCreate;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $f23d7a5ca798f3a1$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $f23d7a5ca798f3a1$export$2e2bcd8739ae039 = $f23d7a5ca798f3a1$var$overArg;


/** Built-in value references. */ var $ecfb3d63d5f046d1$var$getPrototype = (0, $f23d7a5ca798f3a1$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $ecfb3d63d5f046d1$export$2e2bcd8739ae039 = $ecfb3d63d5f046d1$var$getPrototype;


/** Used for built-in method references. */ var $24ad81fab1c4f1be$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $24ad81fab1c4f1be$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $24ad81fab1c4f1be$var$objectProto;
    return value === proto;
}
var $24ad81fab1c4f1be$export$2e2bcd8739ae039 = $24ad81fab1c4f1be$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $cbb9c0149707bc3c$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $24ad81fab1c4f1be$export$2e2bcd8739ae039)(object) ? (0, $91a93494a9a7cebd$export$2e2bcd8739ae039)((0, $ecfb3d63d5f046d1$export$2e2bcd8739ae039)(object)) : {};
}
var $cbb9c0149707bc3c$export$2e2bcd8739ae039 = $cbb9c0149707bc3c$var$initCloneObject;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b48ae904b6702ab5$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $b48ae904b6702ab5$export$2e2bcd8739ae039 = $b48ae904b6702ab5$var$isObjectLike;


/** `Object#toString` result references. */ var $e16915cf504cfbd7$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $e16915cf504cfbd7$var$baseIsArguments(value) {
    return (0, $b48ae904b6702ab5$export$2e2bcd8739ae039)(value) && (0, $f9754adf838f9df5$export$2e2bcd8739ae039)(value) == $e16915cf504cfbd7$var$argsTag;
}
var $e16915cf504cfbd7$export$2e2bcd8739ae039 = $e16915cf504cfbd7$var$baseIsArguments;



/** Used for built-in method references. */ var $b6cc128a4a2ebaa6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b6cc128a4a2ebaa6$var$hasOwnProperty = $b6cc128a4a2ebaa6$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $b6cc128a4a2ebaa6$var$propertyIsEnumerable = $b6cc128a4a2ebaa6$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $b6cc128a4a2ebaa6$var$isArguments = (0, $e16915cf504cfbd7$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $e16915cf504cfbd7$export$2e2bcd8739ae039) : function(value) {
    return (0, $b48ae904b6702ab5$export$2e2bcd8739ae039)(value) && $b6cc128a4a2ebaa6$var$hasOwnProperty.call(value, "callee") && !$b6cc128a4a2ebaa6$var$propertyIsEnumerable.call(value, "callee");
};
var $b6cc128a4a2ebaa6$export$2e2bcd8739ae039 = $b6cc128a4a2ebaa6$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $4c33bcad49280ffb$var$isArray = Array.isArray;
var $4c33bcad49280ffb$export$2e2bcd8739ae039 = $4c33bcad49280ffb$var$isArray;



/** Used as references for various `Number` constants. */ var $58fc79c4a1195508$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $58fc79c4a1195508$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $58fc79c4a1195508$var$MAX_SAFE_INTEGER;
}
var $58fc79c4a1195508$export$2e2bcd8739ae039 = $58fc79c4a1195508$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $e0409e5405754f3c$var$isArrayLike(value) {
    return value != null && (0, $58fc79c4a1195508$export$2e2bcd8739ae039)(value.length) && !(0, $39a501729f57ce1d$export$2e2bcd8739ae039)(value);
}
var $e0409e5405754f3c$export$2e2bcd8739ae039 = $e0409e5405754f3c$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $1bdb6c6f8998b123$var$isArrayLikeObject(value) {
    return (0, $b48ae904b6702ab5$export$2e2bcd8739ae039)(value) && (0, $e0409e5405754f3c$export$2e2bcd8739ae039)(value);
}
var $1bdb6c6f8998b123$export$2e2bcd8739ae039 = $1bdb6c6f8998b123$var$isArrayLikeObject;



var $dG9Ze = parcelRequire("dG9Ze");





/** `Object#toString` result references. */ var $c79d098c113d294d$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $c79d098c113d294d$var$funcProto = Function.prototype, $c79d098c113d294d$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c79d098c113d294d$var$funcToString = $c79d098c113d294d$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c79d098c113d294d$var$hasOwnProperty = $c79d098c113d294d$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $c79d098c113d294d$var$objectCtorString = $c79d098c113d294d$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $c79d098c113d294d$var$isPlainObject(value) {
    if (!(0, $b48ae904b6702ab5$export$2e2bcd8739ae039)(value) || (0, $f9754adf838f9df5$export$2e2bcd8739ae039)(value) != $c79d098c113d294d$var$objectTag) return false;
    var proto = (0, $ecfb3d63d5f046d1$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $c79d098c113d294d$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $c79d098c113d294d$var$funcToString.call(Ctor) == $c79d098c113d294d$var$objectCtorString;
}
var $c79d098c113d294d$export$2e2bcd8739ae039 = $c79d098c113d294d$var$isPlainObject;





/** `Object#toString` result references. */ var $204665d8ee191de6$var$argsTag = "[object Arguments]", $204665d8ee191de6$var$arrayTag = "[object Array]", $204665d8ee191de6$var$boolTag = "[object Boolean]", $204665d8ee191de6$var$dateTag = "[object Date]", $204665d8ee191de6$var$errorTag = "[object Error]", $204665d8ee191de6$var$funcTag = "[object Function]", $204665d8ee191de6$var$mapTag = "[object Map]", $204665d8ee191de6$var$numberTag = "[object Number]", $204665d8ee191de6$var$objectTag = "[object Object]", $204665d8ee191de6$var$regexpTag = "[object RegExp]", $204665d8ee191de6$var$setTag = "[object Set]", $204665d8ee191de6$var$stringTag = "[object String]", $204665d8ee191de6$var$weakMapTag = "[object WeakMap]";
var $204665d8ee191de6$var$arrayBufferTag = "[object ArrayBuffer]", $204665d8ee191de6$var$dataViewTag = "[object DataView]", $204665d8ee191de6$var$float32Tag = "[object Float32Array]", $204665d8ee191de6$var$float64Tag = "[object Float64Array]", $204665d8ee191de6$var$int8Tag = "[object Int8Array]", $204665d8ee191de6$var$int16Tag = "[object Int16Array]", $204665d8ee191de6$var$int32Tag = "[object Int32Array]", $204665d8ee191de6$var$uint8Tag = "[object Uint8Array]", $204665d8ee191de6$var$uint8ClampedTag = "[object Uint8ClampedArray]", $204665d8ee191de6$var$uint16Tag = "[object Uint16Array]", $204665d8ee191de6$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $204665d8ee191de6$var$typedArrayTags = {};
$204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$float32Tag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$float64Tag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$int8Tag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$int16Tag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$int32Tag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$uint8Tag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$uint8ClampedTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$uint16Tag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$uint32Tag] = true;
$204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$argsTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$arrayTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$arrayBufferTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$boolTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$dataViewTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$dateTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$errorTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$funcTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$mapTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$numberTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$objectTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$regexpTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$setTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$stringTag] = $204665d8ee191de6$var$typedArrayTags[$204665d8ee191de6$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $204665d8ee191de6$var$baseIsTypedArray(value) {
    return (0, $b48ae904b6702ab5$export$2e2bcd8739ae039)(value) && (0, $58fc79c4a1195508$export$2e2bcd8739ae039)(value.length) && !!$204665d8ee191de6$var$typedArrayTags[(0, $f9754adf838f9df5$export$2e2bcd8739ae039)(value)];
}
var $204665d8ee191de6$export$2e2bcd8739ae039 = $204665d8ee191de6$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $518e0db33eb18891$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $518e0db33eb18891$export$2e2bcd8739ae039 = $518e0db33eb18891$var$baseUnary;



var $rj6Om = parcelRequire("rj6Om");
/* Node.js helper references. */ var $a120d6e330ceecf2$var$nodeIsTypedArray = (0, $rj6Om.default) && (0, $rj6Om.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $a120d6e330ceecf2$var$isTypedArray = $a120d6e330ceecf2$var$nodeIsTypedArray ? (0, $518e0db33eb18891$export$2e2bcd8739ae039)($a120d6e330ceecf2$var$nodeIsTypedArray) : (0, $204665d8ee191de6$export$2e2bcd8739ae039);
var $a120d6e330ceecf2$export$2e2bcd8739ae039 = $a120d6e330ceecf2$var$isTypedArray;


/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e06c0a94cfd6e462$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
var $e06c0a94cfd6e462$export$2e2bcd8739ae039 = $e06c0a94cfd6e462$var$safeGet;




/** Used for built-in method references. */ var $043f92d50e6317d6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $043f92d50e6317d6$var$hasOwnProperty = $043f92d50e6317d6$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $043f92d50e6317d6$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($043f92d50e6317d6$var$hasOwnProperty.call(object, key) && (0, $9f16bf068e420061$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $0c8f2d84067e3e51$export$2e2bcd8739ae039)(object, key, value);
}
var $043f92d50e6317d6$export$2e2bcd8739ae039 = $043f92d50e6317d6$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $b2ac96df956dbf36$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $0c8f2d84067e3e51$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $043f92d50e6317d6$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $b2ac96df956dbf36$export$2e2bcd8739ae039 = $b2ac96df956dbf36$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $9e45333b5d8fa99f$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $9e45333b5d8fa99f$export$2e2bcd8739ae039 = $9e45333b5d8fa99f$var$baseTimes;





var $dG9Ze = parcelRequire("dG9Ze");
/** Used as references for various `Number` constants. */ var $abbb9697bee716a8$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $abbb9697bee716a8$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $abbb9697bee716a8$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $abbb9697bee716a8$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $abbb9697bee716a8$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $abbb9697bee716a8$export$2e2bcd8739ae039 = $abbb9697bee716a8$var$isIndex;



/** Used for built-in method references. */ var $c30247f2b2061777$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c30247f2b2061777$var$hasOwnProperty = $c30247f2b2061777$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $c30247f2b2061777$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $4c33bcad49280ffb$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $b6cc128a4a2ebaa6$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $dG9Ze.default)(value), isType = !isArr && !isArg && !isBuff && (0, $a120d6e330ceecf2$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $9e45333b5d8fa99f$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $c30247f2b2061777$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $abbb9697bee716a8$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $c30247f2b2061777$export$2e2bcd8739ae039 = $c30247f2b2061777$var$arrayLikeKeys;




/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2749eb5879797dc6$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $2749eb5879797dc6$export$2e2bcd8739ae039 = $2749eb5879797dc6$var$nativeKeysIn;


/** Used for built-in method references. */ var $20c380ecf73d2dab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $20c380ecf73d2dab$var$hasOwnProperty = $20c380ecf73d2dab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $20c380ecf73d2dab$var$baseKeysIn(object) {
    if (!(0, $2305f62ead79bff9$export$2e2bcd8739ae039)(object)) return (0, $2749eb5879797dc6$export$2e2bcd8739ae039)(object);
    var isProto = (0, $24ad81fab1c4f1be$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$20c380ecf73d2dab$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $20c380ecf73d2dab$export$2e2bcd8739ae039 = $20c380ecf73d2dab$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $64f3dc4cba180c2e$var$keysIn(object) {
    return (0, $e0409e5405754f3c$export$2e2bcd8739ae039)(object) ? (0, $c30247f2b2061777$export$2e2bcd8739ae039)(object, true) : (0, $20c380ecf73d2dab$export$2e2bcd8739ae039)(object);
}
var $64f3dc4cba180c2e$export$2e2bcd8739ae039 = $64f3dc4cba180c2e$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $38a0f2672a6b3897$var$toPlainObject(value) {
    return (0, $b2ac96df956dbf36$export$2e2bcd8739ae039)(value, (0, $64f3dc4cba180c2e$export$2e2bcd8739ae039)(value));
}
var $38a0f2672a6b3897$export$2e2bcd8739ae039 = $38a0f2672a6b3897$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $0f909a6cc65d0fa8$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $e06c0a94cfd6e462$export$2e2bcd8739ae039)(object, key), srcValue = (0, $e06c0a94cfd6e462$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $da3ab8739fccfd9e$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $4c33bcad49280ffb$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $dG9Ze.default)(srcValue), isTyped = !isArr && !isBuff && (0, $a120d6e330ceecf2$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $4c33bcad49280ffb$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $1bdb6c6f8998b123$export$2e2bcd8739ae039)(objValue)) newValue = (0, $6b7aec747d72d89b$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $5Jx4e.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $d8d053df9ba5c0b4$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $c79d098c113d294d$export$2e2bcd8739ae039)(srcValue) || (0, $b6cc128a4a2ebaa6$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $b6cc128a4a2ebaa6$export$2e2bcd8739ae039)(objValue)) newValue = (0, $38a0f2672a6b3897$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $2305f62ead79bff9$export$2e2bcd8739ae039)(objValue) || (0, $39a501729f57ce1d$export$2e2bcd8739ae039)(objValue)) newValue = (0, $cbb9c0149707bc3c$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    (0, $da3ab8739fccfd9e$export$2e2bcd8739ae039)(object, key, newValue);
}
var $0f909a6cc65d0fa8$export$2e2bcd8739ae039 = $0f909a6cc65d0fa8$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $813ad8cf05daba38$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $a90859013c301aa7$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $b95edf1c0e6bc0d8$export$2e2bcd8739ae039));
        if ((0, $2305f62ead79bff9$export$2e2bcd8739ae039)(srcValue)) (0, $0f909a6cc65d0fa8$export$2e2bcd8739ae039)(object, source, key, srcIndex, $813ad8cf05daba38$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $e06c0a94cfd6e462$export$2e2bcd8739ae039)(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $da3ab8739fccfd9e$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $64f3dc4cba180c2e$export$2e2bcd8739ae039));
}
var $813ad8cf05daba38$export$2e2bcd8739ae039 = $813ad8cf05daba38$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $fae95d2a63338da5$var$identity(value) {
    return value;
}
var $fae95d2a63338da5$export$2e2bcd8739ae039 = $fae95d2a63338da5$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $41f7306561e54cc7$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $41f7306561e54cc7$export$2e2bcd8739ae039 = $41f7306561e54cc7$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $347f0d9c8f4e4365$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $347f0d9c8f4e4365$var$overRest(func, start, transform) {
    start = $347f0d9c8f4e4365$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $347f0d9c8f4e4365$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $41f7306561e54cc7$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $347f0d9c8f4e4365$export$2e2bcd8739ae039 = $347f0d9c8f4e4365$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $06133ec74189da32$var$constant(value) {
    return function() {
        return value;
    };
}
var $06133ec74189da32$export$2e2bcd8739ae039 = $06133ec74189da32$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $045011265c1d9f74$var$baseSetToString = !(0, $d14d1daa2d2b9717$export$2e2bcd8739ae039) ? (0, $fae95d2a63338da5$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $d14d1daa2d2b9717$export$2e2bcd8739ae039)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, $06133ec74189da32$export$2e2bcd8739ae039)(string),
        "writable": true
    });
};
var $045011265c1d9f74$export$2e2bcd8739ae039 = $045011265c1d9f74$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $828dd48c18eeb405$var$HOT_COUNT = 800, $828dd48c18eeb405$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $828dd48c18eeb405$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $828dd48c18eeb405$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $828dd48c18eeb405$var$nativeNow(), remaining = $828dd48c18eeb405$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $828dd48c18eeb405$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $828dd48c18eeb405$export$2e2bcd8739ae039 = $828dd48c18eeb405$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b8945eb4459d23ac$var$setToString = (0, $828dd48c18eeb405$export$2e2bcd8739ae039)((0, $045011265c1d9f74$export$2e2bcd8739ae039));
var $b8945eb4459d23ac$export$2e2bcd8739ae039 = $b8945eb4459d23ac$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $6cff08e86ec0b0f3$var$baseRest(func, start) {
    return (0, $b8945eb4459d23ac$export$2e2bcd8739ae039)((0, $347f0d9c8f4e4365$export$2e2bcd8739ae039)(func, start, (0, $fae95d2a63338da5$export$2e2bcd8739ae039)), func + "");
}
var $6cff08e86ec0b0f3$export$2e2bcd8739ae039 = $6cff08e86ec0b0f3$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $d008de50bf24a13a$var$isIterateeCall(value, index, object) {
    if (!(0, $2305f62ead79bff9$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, $e0409e5405754f3c$export$2e2bcd8739ae039)(object) && (0, $abbb9697bee716a8$export$2e2bcd8739ae039)(index, object.length) : type == "string" && index in object) return (0, $9f16bf068e420061$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $d008de50bf24a13a$export$2e2bcd8739ae039 = $d008de50bf24a13a$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $b0ca1dc6c9a7f9fa$var$createAssigner(assigner) {
    return (0, $6cff08e86ec0b0f3$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && (0, $d008de50bf24a13a$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $b0ca1dc6c9a7f9fa$export$2e2bcd8739ae039 = $b0ca1dc6c9a7f9fa$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $f1bd5ef7b2b6a87a$var$merge = (0, $b0ca1dc6c9a7f9fa$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $813ad8cf05daba38$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $f1bd5ef7b2b6a87a$export$2e2bcd8739ae039 = $f1bd5ef7b2b6a87a$var$merge;


var $4617b32e1de5ada7$exports = {};

$parcel$export($4617b32e1de5ada7$exports, "Scope", function () { return $4617b32e1de5ada7$export$775b6bb06e53a214; });
$parcel$export($4617b32e1de5ada7$exports, "Attributor", function () { return $4617b32e1de5ada7$export$217610c4183502d0; });
$parcel$export($4617b32e1de5ada7$exports, "Registry", function () { return $4617b32e1de5ada7$export$4d9facee29974f3; });
$parcel$export($4617b32e1de5ada7$exports, "ClassAttributor", function () { return $4617b32e1de5ada7$export$651d45509677cf07; });
$parcel$export($4617b32e1de5ada7$exports, "StyleAttributor", function () { return $4617b32e1de5ada7$export$7c8099bbfe87b94d; });
$parcel$export($4617b32e1de5ada7$exports, "AttributorStore", function () { return $4617b32e1de5ada7$export$68ad86ab95e8de42; });
$parcel$export($4617b32e1de5ada7$exports, "LeafBlot", function () { return $4617b32e1de5ada7$export$7420b9c542181544; });
$parcel$export($4617b32e1de5ada7$exports, "ParentBlot", function () { return $4617b32e1de5ada7$export$e43113f0aad76fe; });
$parcel$export($4617b32e1de5ada7$exports, "InlineBlot", function () { return $4617b32e1de5ada7$export$f67a34bc25a7a861; });
$parcel$export($4617b32e1de5ada7$exports, "BlockBlot", function () { return $4617b32e1de5ada7$export$4f7f03641f7bfc8c; });
$parcel$export($4617b32e1de5ada7$exports, "ContainerBlot", function () { return $4617b32e1de5ada7$export$c898d510319704c0; });
$parcel$export($4617b32e1de5ada7$exports, "EmbedBlot", function () { return $4617b32e1de5ada7$export$297a1fa96f55f00f; });
$parcel$export($4617b32e1de5ada7$exports, "ScrollBlot", function () { return $4617b32e1de5ada7$export$7175329dad7a46f1; });
$parcel$export($4617b32e1de5ada7$exports, "TextBlot", function () { return $4617b32e1de5ada7$export$10ac0c5716409de6; });
var $4617b32e1de5ada7$export$775b6bb06e53a214 = /* @__PURE__ */ ((Scope2)=>(Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))($4617b32e1de5ada7$export$775b6bb06e53a214 || {});
class $4617b32e1de5ada7$export$217610c4183502d0 {
    constructor(attrName, keyName, options = {}){
        this.attrName = attrName, this.keyName = keyName;
        const attributeBit = $4617b32e1de5ada7$export$775b6bb06e53a214.TYPE & $4617b32e1de5ada7$export$775b6bb06e53a214.ATTRIBUTE;
        this.scope = options.scope != null ? // Ignore type bits, force attribute bit
        options.scope & $4617b32e1de5ada7$export$775b6bb06e53a214.LEVEL | attributeBit : $4617b32e1de5ada7$export$775b6bb06e53a214.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
    }
    static keys(node) {
        return Array.from(node.attributes).map((item)=>item.name);
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
    canAdd(_node, value) {
        return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
    remove(node) {
        node.removeAttribute(this.keyName);
    }
    value(node) {
        const value = node.getAttribute(this.keyName);
        return this.canAdd(node, value) && value ? value : "";
    }
}
class $4617b32e1de5ada7$var$ParchmentError extends Error {
    constructor(message){
        message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
    }
}
const $4617b32e1de5ada7$var$_Registry = class _Registry {
    constructor(){
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
    }
    static find(node, bubble = !1) {
        if (node == null) return null;
        if (this.blots.has(node)) return this.blots.get(node) || null;
        if (bubble) {
            let parentNode = null;
            try {
                parentNode = node.parentNode;
            } catch  {
                return null;
            }
            return this.find(parentNode, bubble);
        }
        return null;
    }
    create(scroll, input, value) {
        const match2 = this.query(input);
        if (match2 == null) throw new $4617b32e1de5ada7$var$ParchmentError(`Unable to create ${input} blot`);
        const blotClass = match2, node = // @ts-expect-error Fix me later
        input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value), blot = new blotClass(scroll, node, value);
        return _Registry.blots.set(blot.domNode, blot), blot;
    }
    find(node, bubble = !1) {
        return _Registry.find(node, bubble);
    }
    query(query, scope = $4617b32e1de5ada7$export$775b6bb06e53a214.ANY) {
        let match2;
        return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & $4617b32e1de5ada7$export$775b6bb06e53a214.LEVEL & $4617b32e1de5ada7$export$775b6bb06e53a214.BLOCK ? match2 = this.types.block : query & $4617b32e1de5ada7$export$775b6bb06e53a214.LEVEL & $4617b32e1de5ada7$export$775b6bb06e53a214.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name)=>(match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & $4617b32e1de5ada7$export$775b6bb06e53a214.LEVEL & match2.scope && scope & $4617b32e1de5ada7$export$775b6bb06e53a214.TYPE & match2.scope ? match2 : null;
    }
    register(...definitions) {
        return definitions.map((definition)=>{
            const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
            if (!isBlot && !isAttr) throw new $4617b32e1de5ada7$var$ParchmentError("Invalid definition");
            if (isBlot && definition.blotName === "abstract") throw new $4617b32e1de5ada7$var$ParchmentError("Cannot register abstract class");
            const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
            return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName)=>tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [
                definition.tagName
            ]).forEach((tag)=>{
                (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
            }))), definition;
        });
    }
};
$4617b32e1de5ada7$var$_Registry.blots = /* @__PURE__ */ new WeakMap();
let $4617b32e1de5ada7$export$4d9facee29974f3 = $4617b32e1de5ada7$var$_Registry;
function $4617b32e1de5ada7$var$match(node, prefix) {
    return (node.getAttribute("class") || "").split(/\s+/).filter((name)=>name.indexOf(`${prefix}-`) === 0);
}
class $4617b32e1de5ada7$var$ClassAttributor extends $4617b32e1de5ada7$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("class") || "").split(/\s+/).map((name)=>name.split("-").slice(0, -1).join("-"));
    }
    add(node, value) {
        return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
    }
    remove(node) {
        $4617b32e1de5ada7$var$match(node, this.keyName).forEach((name)=>{
            node.classList.remove(name);
        }), node.classList.length === 0 && node.removeAttribute("class");
    }
    value(node) {
        const value = ($4617b32e1de5ada7$var$match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(node, value) ? value : "";
    }
}
const $4617b32e1de5ada7$export$651d45509677cf07 = $4617b32e1de5ada7$var$ClassAttributor;
function $4617b32e1de5ada7$var$camelize(name) {
    const parts = name.split("-"), rest = parts.slice(1).map((part)=>part[0].toUpperCase() + part.slice(1)).join("");
    return parts[0] + rest;
}
class $4617b32e1de5ada7$var$StyleAttributor extends $4617b32e1de5ada7$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("style") || "").split(";").map((value)=>value.split(":")[0].trim());
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.style[$4617b32e1de5ada7$var$camelize(this.keyName)] = value, !0) : !1;
    }
    remove(node) {
        node.style[$4617b32e1de5ada7$var$camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
    value(node) {
        const value = node.style[$4617b32e1de5ada7$var$camelize(this.keyName)];
        return this.canAdd(node, value) ? value : "";
    }
}
const $4617b32e1de5ada7$export$7c8099bbfe87b94d = $4617b32e1de5ada7$var$StyleAttributor;
class $4617b32e1de5ada7$var$AttributorStore {
    constructor(domNode){
        this.attributes = {}, this.domNode = domNode, this.build();
    }
    attribute(attribute, value) {
        value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
    }
    build() {
        this.attributes = {};
        const blot = $4617b32e1de5ada7$export$4d9facee29974f3.find(this.domNode);
        if (blot == null) return;
        const attributes = $4617b32e1de5ada7$export$217610c4183502d0.keys(this.domNode), classes = $4617b32e1de5ada7$export$651d45509677cf07.keys(this.domNode), styles = $4617b32e1de5ada7$export$7c8099bbfe87b94d.keys(this.domNode);
        attributes.concat(classes).concat(styles).forEach((name)=>{
            const attr = blot.scroll.query(name, $4617b32e1de5ada7$export$775b6bb06e53a214.ATTRIBUTE);
            attr instanceof $4617b32e1de5ada7$export$217610c4183502d0 && (this.attributes[attr.attrName] = attr);
        });
    }
    copy(target) {
        Object.keys(this.attributes).forEach((key)=>{
            const value = this.attributes[key].value(this.domNode);
            target.format(key, value);
        });
    }
    move(target) {
        this.copy(target), Object.keys(this.attributes).forEach((key)=>{
            this.attributes[key].remove(this.domNode);
        }), this.attributes = {};
    }
    values() {
        return Object.keys(this.attributes).reduce((attributes, name)=>(attributes[name] = this.attributes[name].value(this.domNode), attributes), {});
    }
}
const $4617b32e1de5ada7$export$68ad86ab95e8de42 = $4617b32e1de5ada7$var$AttributorStore, $4617b32e1de5ada7$var$_ShadowBlot = class _ShadowBlot {
    constructor(scroll, domNode){
        this.scroll = scroll, this.domNode = domNode, $4617b32e1de5ada7$export$4d9facee29974f3.blots.set(domNode, this), this.prev = null, this.next = null;
    }
    static create(rawValue) {
        if (this.tagName == null) throw new $4617b32e1de5ada7$var$ParchmentError("Blot definition missing tagName");
        let node, value;
        return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
    // Hack for accessing inherited static methods
    get statics() {
        return this.constructor;
    }
    attach() {}
    clone() {
        const domNode = this.domNode.cloneNode(!1);
        return this.scroll.create(domNode);
    }
    detach() {
        this.parent != null && this.parent.removeChild(this), $4617b32e1de5ada7$export$4d9facee29974f3.blots.delete(this.domNode);
    }
    deleteAt(index, length) {
        this.isolate(index, length).remove();
    }
    formatAt(index, length, name, value) {
        const blot = this.isolate(index, length);
        if (this.scroll.query(name, $4617b32e1de5ada7$export$775b6bb06e53a214.BLOT) != null && value) blot.wrap(name, value);
        else if (this.scroll.query(name, $4617b32e1de5ada7$export$775b6bb06e53a214.ATTRIBUTE) != null) {
            const parent = this.scroll.create(this.statics.scope);
            blot.wrap(parent), parent.format(name, value);
        }
    }
    insertAt(index, value, def) {
        const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
        this.parent.insertBefore(blot, ref || void 0);
    }
    isolate(index, length) {
        const target = this.split(index);
        if (target == null) throw new Error("Attempt to isolate at end");
        return target.split(length), target;
    }
    length() {
        return 1;
    }
    offset(root = this.parent) {
        return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
    optimize(_context) {
        this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
    remove() {
        this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
    split(index, _force) {
        return index === 0 ? this : this.next;
    }
    update(_mutations, _context) {}
    wrap(name, value) {
        const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
        if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new $4617b32e1de5ada7$var$ParchmentError(`Cannot wrap ${name}`);
        return wrapper.appendChild(this), wrapper;
    }
};
$4617b32e1de5ada7$var$_ShadowBlot.blotName = "abstract";
let $4617b32e1de5ada7$var$ShadowBlot = $4617b32e1de5ada7$var$_ShadowBlot;
const $4617b32e1de5ada7$var$_LeafBlot = class _LeafBlot extends $4617b32e1de5ada7$var$ShadowBlot {
    /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */ static value(_domNode) {
        return !0;
    }
    /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */ index(node, offset) {
        return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */ position(index, _inclusive) {
        let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return index > 0 && (offset += 1), [
            this.parent.domNode,
            offset
        ];
    }
    /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */ value() {
        return {
            [this.statics.blotName]: this.statics.value(this.domNode) || !0
        };
    }
};
$4617b32e1de5ada7$var$_LeafBlot.scope = $4617b32e1de5ada7$export$775b6bb06e53a214.INLINE_BLOT;
let $4617b32e1de5ada7$var$LeafBlot = $4617b32e1de5ada7$var$_LeafBlot;
const $4617b32e1de5ada7$export$7420b9c542181544 = $4617b32e1de5ada7$var$LeafBlot;
class $4617b32e1de5ada7$var$LinkedList {
    constructor(){
        this.head = null, this.tail = null, this.length = 0;
    }
    append(...nodes) {
        if (this.insertBefore(nodes[0], null), nodes.length > 1) {
            const rest = nodes.slice(1);
            this.append(...rest);
        }
    }
    at(index) {
        const next = this.iterator();
        let cur = next();
        for(; cur && index > 0;)index -= 1, cur = next();
        return cur;
    }
    contains(node) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            if (cur === node) return !0;
            cur = next();
        }
        return !1;
    }
    indexOf(node) {
        const next = this.iterator();
        let cur = next(), index = 0;
        for(; cur;){
            if (cur === node) return index;
            index += 1, cur = next();
        }
        return -1;
    }
    insertBefore(node, refNode) {
        node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
    offset(target) {
        let index = 0, cur = this.head;
        for(; cur != null;){
            if (cur === target) return index;
            index += cur.length(), cur = cur.next;
        }
        return -1;
    }
    remove(node) {
        this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
    iterator(curNode = this.head) {
        return ()=>{
            const ret = curNode;
            return curNode != null && (curNode = curNode.next), ret;
        };
    }
    find(index, inclusive = !1) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            const length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                cur,
                index
            ];
            index -= length, cur = next();
        }
        return [
            null,
            0
        ];
    }
    forEach(callback) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)callback(cur), cur = next();
    }
    forEachAt(index, length, callback) {
        if (length <= 0) return;
        const [startNode, offset] = this.find(index);
        let curIndex = index - offset;
        const next = this.iterator(startNode);
        let cur = next();
        for(; cur && curIndex < index + length;){
            const curLength = cur.length();
            index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
        }
    }
    map(callback) {
        return this.reduce((memo, cur)=>(memo.push(callback(cur)), memo), []);
    }
    reduce(callback, memo) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)memo = callback(memo, cur), cur = next();
        return memo;
    }
}
function $4617b32e1de5ada7$var$makeAttachedBlot(node, scroll) {
    const found = scroll.find(node);
    if (found) return found;
    try {
        return scroll.create(node);
    } catch  {
        const blot = scroll.create($4617b32e1de5ada7$export$775b6bb06e53a214.INLINE);
        return Array.from(node.childNodes).forEach((child)=>{
            blot.domNode.appendChild(child);
        }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
    }
}
const $4617b32e1de5ada7$var$_ParentBlot = class _ParentBlot extends $4617b32e1de5ada7$var$ShadowBlot {
    constructor(scroll, domNode){
        super(scroll, domNode), this.uiNode = null, this.build();
    }
    appendChild(other) {
        this.insertBefore(other);
    }
    attach() {
        super.attach(), this.children.forEach((child)=>{
            child.attach();
        });
    }
    attachUI(node) {
        this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
   * Called during construction, should fill its own children LinkedList.
   */ build() {
        this.children = new $4617b32e1de5ada7$var$LinkedList(), Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode).reverse().forEach((node)=>{
            try {
                const child = $4617b32e1de5ada7$var$makeAttachedBlot(node, this.scroll);
                this.insertBefore(child, this.children.head || void 0);
            } catch (err) {
                if (err instanceof $4617b32e1de5ada7$var$ParchmentError) return;
                throw err;
            }
        });
    }
    deleteAt(index, length) {
        if (index === 0 && length === this.length()) return this.remove();
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.deleteAt(offset, childLength);
        });
    }
    descendant(criteria, index = 0) {
        const [child, offset] = this.children.find(index);
        return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [
            child,
            offset
        ] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [
            null,
            -1
        ];
    }
    descendants(criteria, index = 0, length = Number.MAX_VALUE) {
        let descendants = [], lengthLeft = length;
        return this.children.forEachAt(index, length, (child, childIndex, childLength)=>{
            (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
        }), descendants;
    }
    detach() {
        this.children.forEach((child)=>{
            child.detach();
        }), super.detach();
    }
    enforceAllowedChildren() {
        let done = !1;
        this.children.forEach((child)=>{
            done || this.statics.allowedChildren.some((def)=>child instanceof def) || (child.statics.scope === $4617b32e1de5ada7$export$775b6bb06e53a214.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
        });
    }
    formatAt(index, length, name, value) {
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.formatAt(offset, childLength, name, value);
        });
    }
    insertAt(index, value, def) {
        const [child, offset] = this.children.find(index);
        if (child) child.insertAt(offset, value, def);
        else {
            const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
            this.appendChild(blot);
        }
    }
    insertBefore(childBlot, refBlot) {
        childBlot.parent != null && childBlot.parent.children.remove(childBlot);
        let refDomNode = null;
        this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
    length() {
        return this.children.reduce((memo, child)=>memo + child.length(), 0);
    }
    moveChildren(targetParent, refNode) {
        this.children.forEach((child)=>{
            targetParent.insertBefore(child, refNode);
        });
    }
    optimize(context) {
        if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                const child = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(child);
            } else this.remove();
        }
    }
    path(index, inclusive = !1) {
        const [child, offset] = this.children.find(index, inclusive), position = [
            [
                this,
                index
            ]
        ];
        return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([
            child,
            offset
        ]), position);
    }
    removeChild(child) {
        this.children.remove(child);
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.clone();
        return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length)=>{
            const split = child.split(offset, force);
            split != null && after.appendChild(split);
        }), after;
    }
    splitAfter(child) {
        const after = this.clone();
        for(; child.next != null;)after.appendChild(child.next);
        return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
    unwrap() {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
    update(mutations, _context) {
        const addedNodes = [], removedNodes = [];
        mutations.forEach((mutation)=>{
            mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
        }), removedNodes.forEach((node)=>{
            if (node.parentNode != null && // @ts-expect-error Fix me later
            node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
            const blot = this.scroll.find(node);
            blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
        }), addedNodes.filter((node)=>node.parentNode === this.domNode && node !== this.uiNode).sort((a, b)=>a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node)=>{
            let refBlot = null;
            node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
            const blot = $4617b32e1de5ada7$var$makeAttachedBlot(node, this.scroll);
            (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
        }), this.enforceAllowedChildren();
    }
};
$4617b32e1de5ada7$var$_ParentBlot.uiClass = "";
let $4617b32e1de5ada7$var$ParentBlot = $4617b32e1de5ada7$var$_ParentBlot;
const $4617b32e1de5ada7$export$e43113f0aad76fe = $4617b32e1de5ada7$var$ParentBlot;
function $4617b32e1de5ada7$var$isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;
    for(const prop in obj1)if (obj1[prop] !== obj2[prop]) return !1;
    return !0;
}
const $4617b32e1de5ada7$var$_InlineBlot = class _InlineBlot extends $4617b32e1de5ada7$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_InlineBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $4617b32e1de5ada7$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        if (name === this.statics.blotName && !value) this.children.forEach((child)=>{
            child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
        }), this.unwrap();
        else {
            const format = this.scroll.query(name, $4617b32e1de5ada7$export$775b6bb06e53a214.INLINE);
            if (format == null) return;
            format instanceof $4617b32e1de5ada7$export$217610c4183502d0 ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
        }
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.formats()[name] != null || this.scroll.query(name, $4617b32e1de5ada7$export$775b6bb06e53a214.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        const formats = this.formats();
        if (Object.keys(formats).length === 0) return this.unwrap();
        const next = this.next;
        next instanceof _InlineBlot && next.prev === this && $4617b32e1de5ada7$var$isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    wrap(name, value) {
        const wrapper = super.wrap(name, value);
        return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
};
$4617b32e1de5ada7$var$_InlineBlot.allowedChildren = [
    $4617b32e1de5ada7$var$_InlineBlot,
    $4617b32e1de5ada7$export$7420b9c542181544
], $4617b32e1de5ada7$var$_InlineBlot.blotName = "inline", $4617b32e1de5ada7$var$_InlineBlot.scope = $4617b32e1de5ada7$export$775b6bb06e53a214.INLINE_BLOT, $4617b32e1de5ada7$var$_InlineBlot.tagName = "SPAN";
let $4617b32e1de5ada7$var$InlineBlot = $4617b32e1de5ada7$var$_InlineBlot;
const $4617b32e1de5ada7$export$f67a34bc25a7a861 = $4617b32e1de5ada7$var$InlineBlot, $4617b32e1de5ada7$var$_BlockBlot = class _BlockBlot extends $4617b32e1de5ada7$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_BlockBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $4617b32e1de5ada7$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        const format = this.scroll.query(name, $4617b32e1de5ada7$export$775b6bb06e53a214.BLOCK);
        format != null && (format instanceof $4617b32e1de5ada7$export$217610c4183502d0 ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.scroll.query(name, $4617b32e1de5ada7$export$775b6bb06e53a214.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        if (def == null || this.scroll.query(value, $4617b32e1de5ada7$export$775b6bb06e53a214.INLINE) != null) super.insertAt(index, value, def);
        else {
            const after = this.split(index);
            if (after != null) {
                const blot = this.scroll.create(value, def);
                after.parent.insertBefore(blot, after);
            } else throw new Error("Attempt to insertAt after block boundaries");
        }
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
};
$4617b32e1de5ada7$var$_BlockBlot.blotName = "block", $4617b32e1de5ada7$var$_BlockBlot.scope = $4617b32e1de5ada7$export$775b6bb06e53a214.BLOCK_BLOT, $4617b32e1de5ada7$var$_BlockBlot.tagName = "P", $4617b32e1de5ada7$var$_BlockBlot.allowedChildren = [
    $4617b32e1de5ada7$export$f67a34bc25a7a861,
    $4617b32e1de5ada7$var$_BlockBlot,
    $4617b32e1de5ada7$export$7420b9c542181544
];
let $4617b32e1de5ada7$var$BlockBlot = $4617b32e1de5ada7$var$_BlockBlot;
const $4617b32e1de5ada7$export$4f7f03641f7bfc8c = $4617b32e1de5ada7$var$BlockBlot, $4617b32e1de5ada7$var$_ContainerBlot = class _ContainerBlot extends $4617b32e1de5ada7$export$e43113f0aad76fe {
    checkMerge() {
        return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length), this.enforceAllowedChildren();
    }
    formatAt(index, length, name, value) {
        super.formatAt(index, length, name, value), this.enforceAllowedChildren();
    }
    insertAt(index, value, def) {
        super.insertAt(index, value, def), this.enforceAllowedChildren();
    }
    optimize(context) {
        super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
};
$4617b32e1de5ada7$var$_ContainerBlot.blotName = "container", $4617b32e1de5ada7$var$_ContainerBlot.scope = $4617b32e1de5ada7$export$775b6bb06e53a214.BLOCK_BLOT;
let $4617b32e1de5ada7$var$ContainerBlot = $4617b32e1de5ada7$var$_ContainerBlot;
const $4617b32e1de5ada7$export$c898d510319704c0 = $4617b32e1de5ada7$var$ContainerBlot;
class $4617b32e1de5ada7$var$EmbedBlot extends $4617b32e1de5ada7$export$7420b9c542181544 {
    static formats(_domNode, _scroll) {}
    format(name, value) {
        super.formatAt(0, this.length(), name, value);
    }
    formatAt(index, length, name, value) {
        index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    formats() {
        return this.statics.formats(this.domNode, this.scroll);
    }
}
const $4617b32e1de5ada7$export$297a1fa96f55f00f = $4617b32e1de5ada7$var$EmbedBlot, $4617b32e1de5ada7$var$OBSERVER_CONFIG = {
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
}, $4617b32e1de5ada7$var$MAX_OPTIMIZE_ITERATIONS = 100, $4617b32e1de5ada7$var$_ScrollBlot = class _ScrollBlot extends $4617b32e1de5ada7$export$e43113f0aad76fe {
    constructor(registry, node){
        super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations)=>{
            this.update(mutations);
        }), this.observer.observe(this.domNode, $4617b32e1de5ada7$var$OBSERVER_CONFIG), this.attach();
    }
    create(input, value) {
        return this.registry.create(this, input, value);
    }
    find(node, bubble = !1) {
        const blot = this.registry.find(node, bubble);
        return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
    query(query, scope = $4617b32e1de5ada7$export$775b6bb06e53a214.ANY) {
        return this.registry.query(query, scope);
    }
    register(...definitions) {
        return this.registry.register(...definitions);
    }
    build() {
        this.scroll != null && super.build();
    }
    detach() {
        super.detach(), this.observer.disconnect();
    }
    deleteAt(index, length) {
        this.update(), index === 0 && length === this.length() ? this.children.forEach((child)=>{
            child.remove();
        }) : super.deleteAt(index, length);
    }
    formatAt(index, length, name, value) {
        this.update(), super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        this.update(), super.insertAt(index, value, def);
    }
    optimize(mutations = [], context = {}) {
        super.optimize(context);
        const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
        let records = Array.from(this.observer.takeRecords());
        for(; records.length > 0;)mutations.push(records.pop());
        const mark = (blot, markParent = !0)=>{
            blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
        }, optimize = (blot)=>{
            mutationsMap.has(blot.domNode) && (blot instanceof $4617b32e1de5ada7$export$e43113f0aad76fe && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
        };
        let remaining = mutations;
        for(let i = 0; remaining.length > 0; i += 1){
            if (i >= $4617b32e1de5ada7$var$MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
            for(remaining.forEach((mutation)=>{
                const blot = this.find(mutation.target, !0);
                blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node)=>{
                    const child = this.find(node, !1);
                    mark(child, !1), child instanceof $4617b32e1de5ada7$export$e43113f0aad76fe && child.children.forEach((grandChild)=>{
                        mark(grandChild, !1);
                    });
                })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
            }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;)mutations.push(records.pop());
        }
    }
    update(mutations, context = {}) {
        mutations = mutations || this.observer.takeRecords();
        const mutationsMap = /* @__PURE__ */ new WeakMap();
        mutations.map((mutation)=>{
            const blot = this.find(mutation.target, !0);
            return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [
                mutation
            ]), blot);
        }).forEach((blot)=>{
            blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
        }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
};
$4617b32e1de5ada7$var$_ScrollBlot.blotName = "scroll", $4617b32e1de5ada7$var$_ScrollBlot.defaultChild = $4617b32e1de5ada7$export$4f7f03641f7bfc8c, $4617b32e1de5ada7$var$_ScrollBlot.allowedChildren = [
    $4617b32e1de5ada7$export$4f7f03641f7bfc8c,
    $4617b32e1de5ada7$export$c898d510319704c0
], $4617b32e1de5ada7$var$_ScrollBlot.scope = $4617b32e1de5ada7$export$775b6bb06e53a214.BLOCK_BLOT, $4617b32e1de5ada7$var$_ScrollBlot.tagName = "DIV";
let $4617b32e1de5ada7$var$ScrollBlot = $4617b32e1de5ada7$var$_ScrollBlot;
const $4617b32e1de5ada7$export$7175329dad7a46f1 = $4617b32e1de5ada7$var$ScrollBlot, $4617b32e1de5ada7$var$_TextBlot = class _TextBlot extends $4617b32e1de5ada7$export$7420b9c542181544 {
    static create(value) {
        return document.createTextNode(value);
    }
    static value(domNode) {
        return domNode.data;
    }
    constructor(scroll, node){
        super(scroll, node), this.text = this.statics.value(this.domNode);
    }
    deleteAt(index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
    index(node, offset) {
        return this.domNode === node ? offset : -1;
    }
    insertAt(index, value, def) {
        def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
    }
    length() {
        return this.text.length;
    }
    optimize(context) {
        super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
    position(index, _inclusive = !1) {
        return [
            this.domNode,
            index
        ];
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.scroll.create(this.domNode.splitText(index));
        return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
    update(mutations, _context) {
        mutations.some((mutation)=>mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
    }
    value() {
        return this.text;
    }
};
$4617b32e1de5ada7$var$_TextBlot.blotName = "text", $4617b32e1de5ada7$var$_TextBlot.scope = $4617b32e1de5ada7$export$775b6bb06e53a214.INLINE_BLOT;
let $4617b32e1de5ada7$var$TextBlot = $4617b32e1de5ada7$var$_TextBlot;
const $4617b32e1de5ada7$export$10ac0c5716409de6 = $4617b32e1de5ada7$var$TextBlot;


var $5cea9abc67034d4a$exports = {};
"use strict";
Object.defineProperty($5cea9abc67034d4a$exports, "__esModule", {
    value: true
});
$5cea9abc67034d4a$exports.AttributeMap = $5cea9abc67034d4a$exports.OpIterator = $5cea9abc67034d4a$exports.Op = void 0;
var $f6dfd28031c6f994$exports = {};
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $f6dfd28031c6f994$var$DIFF_DELETE = -1;
var $f6dfd28031c6f994$var$DIFF_INSERT = 1;
var $f6dfd28031c6f994$var$DIFF_EQUAL = 0;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
 * @return {Array} Array of diff tuples.
 */ function $f6dfd28031c6f994$var$diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
    // Check for equality
    if (text1 === text2) {
        if (text1) return [
            [
                $f6dfd28031c6f994$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (cursor_pos != null) {
        var editdiff = $f6dfd28031c6f994$var$find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editdiff) return editdiff;
    }
    // Trim off common prefix (speedup).
    var commonlength = $f6dfd28031c6f994$var$diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = $f6dfd28031c6f994$var$diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = $f6dfd28031c6f994$var$diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $f6dfd28031c6f994$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $f6dfd28031c6f994$var$DIFF_EQUAL,
        commonsuffix
    ]);
    $f6dfd28031c6f994$var$diff_cleanupMerge(diffs, _fix_unicode);
    if (cleanup) $f6dfd28031c6f994$var$diff_cleanupSemantic(diffs);
    return diffs;
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function $f6dfd28031c6f994$var$diff_compute_(text1, text2) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $f6dfd28031c6f994$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $f6dfd28031c6f994$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $f6dfd28031c6f994$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $f6dfd28031c6f994$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $f6dfd28031c6f994$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $f6dfd28031c6f994$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length === 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $f6dfd28031c6f994$var$DIFF_DELETE,
            text1
        ],
        [
            $f6dfd28031c6f994$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = $f6dfd28031c6f994$var$diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = $f6dfd28031c6f994$var$diff_main(text1_a, text2_a);
        var diffs_b = $f6dfd28031c6f994$var$diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([
            [
                $f6dfd28031c6f994$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    return $f6dfd28031c6f994$var$diff_bisect_(text1, text2);
}
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function $f6dfd28031c6f994$var$diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 !== 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return $f6dfd28031c6f994$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return $f6dfd28031c6f994$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $f6dfd28031c6f994$var$DIFF_DELETE,
            text1
        ],
        [
            $f6dfd28031c6f994$var$DIFF_INSERT,
            text2
        ]
    ];
}
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function $f6dfd28031c6f994$var$diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = $f6dfd28031c6f994$var$diff_main(text1a, text2a);
    var diffsb = $f6dfd28031c6f994$var$diff_main(text1b, text2b);
    return diffs.concat(diffsb);
}
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function $f6dfd28031c6f994$var$diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($f6dfd28031c6f994$var$is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) pointermid--;
    return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ function $f6dfd28031c6f994$var$diff_commonOverlap_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
}
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function $f6dfd28031c6f994$var$diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($f6dfd28031c6f994$var$is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) pointermid--;
    return pointermid;
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function $f6dfd28031c6f994$var$diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) !== -1){
            var prefixLength = $f6dfd28031c6f994$var$diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = $f6dfd28031c6f994$var$diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $f6dfd28031c6f994$var$diff_cleanupSemantic(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $f6dfd28031c6f994$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $f6dfd28031c6f994$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $f6dfd28031c6f994$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $f6dfd28031c6f994$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) $f6dfd28031c6f994$var$diff_cleanupMerge(diffs);
    $f6dfd28031c6f994$var$diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $f6dfd28031c6f994$var$DIFF_DELETE && diffs[pointer][0] == $f6dfd28031c6f994$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = $f6dfd28031c6f994$var$diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = $f6dfd28031c6f994$var$diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $f6dfd28031c6f994$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $f6dfd28031c6f994$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $f6dfd28031c6f994$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $f6dfd28031c6f994$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
}
var $f6dfd28031c6f994$var$nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
var $f6dfd28031c6f994$var$whitespaceRegex_ = /\s/;
var $f6dfd28031c6f994$var$linebreakRegex_ = /[\r\n]/;
var $f6dfd28031c6f994$var$blanklineEndRegex_ = /\n\r?\n$/;
var $f6dfd28031c6f994$var$blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $f6dfd28031c6f994$var$diff_cleanupSemanticLossless(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($f6dfd28031c6f994$var$nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($f6dfd28031c6f994$var$nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($f6dfd28031c6f994$var$whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($f6dfd28031c6f994$var$whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($f6dfd28031c6f994$var$linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($f6dfd28031c6f994$var$linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($f6dfd28031c6f994$var$blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($f6dfd28031c6f994$var$blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $f6dfd28031c6f994$var$DIFF_EQUAL && diffs[pointer + 1][0] == $f6dfd28031c6f994$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = $f6dfd28031c6f994$var$diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */ function $f6dfd28031c6f994$var$diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([
        $f6dfd28031c6f994$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length){
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch(diffs[pointer][0]){
            case $f6dfd28031c6f994$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $f6dfd28031c6f994$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $f6dfd28031c6f994$var$DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && $f6dfd28031c6f994$var$ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray + text_delete;
                        text_insert = stray + text_insert;
                        if (!diffs[previous_equality][1]) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === $f6dfd28031c6f994$var$DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1] + text_insert;
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === $f6dfd28031c6f994$var$DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1] + text_delete;
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if ($f6dfd28031c6f994$var$starts_with_pair_end(diffs[pointer][1])) {
                        var stray = diffs[pointer][1].charAt(0);
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete += stray;
                        text_insert += stray;
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonlength = $f6dfd28031c6f994$var$diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (previous_equality >= 0) diffs[previous_equality][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, [
                                    $f6dfd28031c6f994$var$DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)
                                ]);
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        // Factor out any common suffixes.
                        commonlength = $f6dfd28031c6f994$var$diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    } else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $f6dfd28031c6f994$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 1;
                    } else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $f6dfd28031c6f994$var$DIFF_DELETE,
                            text_delete
                        ]);
                        pointer = pointer - n + 1;
                    } else {
                        diffs.splice(pointer - n, n, [
                            $f6dfd28031c6f994$var$DIFF_DELETE,
                            text_delete
                        ], [
                            $f6dfd28031c6f994$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === $f6dfd28031c6f994$var$DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] === $f6dfd28031c6f994$var$DIFF_EQUAL && diffs[pointer + 1][0] === $f6dfd28031c6f994$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) $f6dfd28031c6f994$var$diff_cleanupMerge(diffs, fix_unicode);
}
function $f6dfd28031c6f994$var$is_surrogate_pair_start(charCode) {
    return charCode >= 0xd800 && charCode <= 0xdbff;
}
function $f6dfd28031c6f994$var$is_surrogate_pair_end(charCode) {
    return charCode >= 0xdc00 && charCode <= 0xdfff;
}
function $f6dfd28031c6f994$var$starts_with_pair_end(str) {
    return $f6dfd28031c6f994$var$is_surrogate_pair_end(str.charCodeAt(0));
}
function $f6dfd28031c6f994$var$ends_with_pair_start(str) {
    return $f6dfd28031c6f994$var$is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function $f6dfd28031c6f994$var$remove_empty_tuples(tuples) {
    var ret = [];
    for(var i = 0; i < tuples.length; i++)if (tuples[i][1].length > 0) ret.push(tuples[i]);
    return ret;
}
function $f6dfd28031c6f994$var$make_edit_splice(before, oldMiddle, newMiddle, after) {
    if ($f6dfd28031c6f994$var$ends_with_pair_start(before) || $f6dfd28031c6f994$var$starts_with_pair_end(after)) return null;
    return $f6dfd28031c6f994$var$remove_empty_tuples([
        [
            $f6dfd28031c6f994$var$DIFF_EQUAL,
            before
        ],
        [
            $f6dfd28031c6f994$var$DIFF_DELETE,
            oldMiddle
        ],
        [
            $f6dfd28031c6f994$var$DIFF_INSERT,
            newMiddle
        ],
        [
            $f6dfd28031c6f994$var$DIFF_EQUAL,
            after
        ]
    ]);
}
function $f6dfd28031c6f994$var$find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === "number" ? {
        index: cursor_pos,
        length: 0
    } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) break editBefore;
            if (newCursor < 0 || newCursor > newLength) break editBefore;
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (newAfter !== oldAfter) break editBefore;
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (oldPrefix !== newPrefix) break editBefore;
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return $f6dfd28031c6f994$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) break editAfter;
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (newBefore !== oldBefore) break editAfter;
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (oldSuffix !== newSuffix) break editAfter;
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return $f6dfd28031c6f994$var$make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) replaceRange: {
        // see if diff could be a splice of the old selection range
        var oldPrefix = oldText.slice(0, oldRange.index);
        var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
        var prefixLength = oldPrefix.length;
        var suffixLength = oldSuffix.length;
        if (newLength < prefixLength + suffixLength) break replaceRange;
        var newPrefix = newText.slice(0, prefixLength);
        var newSuffix = newText.slice(newLength - suffixLength);
        if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) break replaceRange;
        var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
        var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
        return $f6dfd28031c6f994$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
    return null;
}
function $f6dfd28031c6f994$var$diff(text1, text2, cursor_pos, cleanup) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    return $f6dfd28031c6f994$var$diff_main(text1, text2, cursor_pos, cleanup, true);
}
$f6dfd28031c6f994$var$diff.INSERT = $f6dfd28031c6f994$var$DIFF_INSERT;
$f6dfd28031c6f994$var$diff.DELETE = $f6dfd28031c6f994$var$DIFF_DELETE;
$f6dfd28031c6f994$var$diff.EQUAL = $f6dfd28031c6f994$var$DIFF_EQUAL;
$f6dfd28031c6f994$exports = $f6dfd28031c6f994$var$diff;



var $6VEzq = parcelRequire("6VEzq");

var $iK1WR = parcelRequire("iK1WR");
var $4300be4a01ef1e8e$exports = {};
"use strict";
Object.defineProperty($4300be4a01ef1e8e$exports, "__esModule", {
    value: true
});

var $6VEzq = parcelRequire("6VEzq");

var $iK1WR = parcelRequire("iK1WR");
var $4300be4a01ef1e8e$var$AttributeMap;
(function(AttributeMap) {
    function compose(a = {}, b = {}, keepNull = false) {
        if (typeof a !== "object") a = {};
        if (typeof b !== "object") b = {};
        let attributes = $6VEzq(b);
        if (!keepNull) attributes = Object.keys(attributes).reduce((copy, key)=>{
            if (attributes[key] != null) copy[key] = attributes[key];
            return copy;
        }, {});
        for(const key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.compose = compose;
    function diff(a = {}, b = {}) {
        if (typeof a !== "object") a = {};
        if (typeof b !== "object") b = {};
        const attributes = Object.keys(a).concat(Object.keys(b)).reduce((attrs, key)=>{
            if (!$iK1WR(a[key], b[key])) attrs[key] = b[key] === undefined ? null : b[key];
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.diff = diff;
    function invert(attr = {}, base = {}) {
        attr = attr || {};
        const baseInverted = Object.keys(base).reduce((memo, key)=>{
            if (base[key] !== attr[key] && attr[key] !== undefined) memo[key] = base[key];
            return memo;
        }, {});
        return Object.keys(attr).reduce((memo, key)=>{
            if (attr[key] !== base[key] && base[key] === undefined) memo[key] = null;
            return memo;
        }, baseInverted);
    }
    AttributeMap.invert = invert;
    function transform(a, b, priority = false) {
        if (typeof a !== "object") return b;
        if (typeof b !== "object") return undefined;
        if (!priority) return b; // b simply overwrites us without priority
        const attributes = Object.keys(b).reduce((attrs, key)=>{
            if (a[key] === undefined) attrs[key] = b[key]; // null is a valid value
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.transform = transform;
})($4300be4a01ef1e8e$var$AttributeMap || ($4300be4a01ef1e8e$var$AttributeMap = {}));
$4300be4a01ef1e8e$exports.default = $4300be4a01ef1e8e$var$AttributeMap;


$5cea9abc67034d4a$exports.AttributeMap = $4300be4a01ef1e8e$exports.default;
var $cd8713dd485bd7df$exports = {};
"use strict";
Object.defineProperty($cd8713dd485bd7df$exports, "__esModule", {
    value: true
});
var $cd8713dd485bd7df$var$Op;
(function(Op) {
    function length(op) {
        if (typeof op.delete === "number") return op.delete;
        else if (typeof op.retain === "number") return op.retain;
        else if (typeof op.retain === "object" && op.retain !== null) return 1;
        else return typeof op.insert === "string" ? op.insert.length : 1;
    }
    Op.length = length;
})($cd8713dd485bd7df$var$Op || ($cd8713dd485bd7df$var$Op = {}));
$cd8713dd485bd7df$exports.default = $cd8713dd485bd7df$var$Op;


$5cea9abc67034d4a$exports.Op = $cd8713dd485bd7df$exports.default;
var $7d2019508bbb1467$exports = {};
"use strict";
Object.defineProperty($7d2019508bbb1467$exports, "__esModule", {
    value: true
});

class $7d2019508bbb1467$var$Iterator {
    constructor(ops){
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
    hasNext() {
        return this.peekLength() < Infinity;
    }
    next(length) {
        if (!length) length = Infinity;
        const nextOp = this.ops[this.index];
        if (nextOp) {
            const offset = this.offset;
            const opLength = $cd8713dd485bd7df$exports.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            } else this.offset += length;
            if (typeof nextOp.delete === "number") return {
                delete: length
            };
            else {
                const retOp = {};
                if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                if (typeof nextOp.retain === "number") retOp.retain = length;
                else if (typeof nextOp.retain === "object" && nextOp.retain !== null) // offset should === 0, length should === 1
                retOp.retain = nextOp.retain;
                else if (typeof nextOp.insert === "string") retOp.insert = nextOp.insert.substr(offset, length);
                else // offset should === 0, length should === 1
                retOp.insert = nextOp.insert;
                return retOp;
            }
        } else return {
            retain: Infinity
        };
    }
    peek() {
        return this.ops[this.index];
    }
    peekLength() {
        if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
        return $cd8713dd485bd7df$exports.default.length(this.ops[this.index]) - this.offset;
        else return Infinity;
    }
    peekType() {
        const op = this.ops[this.index];
        if (op) {
            if (typeof op.delete === "number") return "delete";
            else if (typeof op.retain === "number" || typeof op.retain === "object" && op.retain !== null) return "retain";
            else return "insert";
        }
        return "retain";
    }
    rest() {
        if (!this.hasNext()) return [];
        else if (this.offset === 0) return this.ops.slice(this.index);
        else {
            const offset = this.offset;
            const index = this.index;
            const next = this.next();
            const rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [
                next
            ].concat(rest);
        }
    }
}
$7d2019508bbb1467$exports.default = $7d2019508bbb1467$var$Iterator;


$5cea9abc67034d4a$exports.OpIterator = $7d2019508bbb1467$exports.default;
const $5cea9abc67034d4a$var$NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
const $5cea9abc67034d4a$var$getEmbedTypeAndData = (a, b)=>{
    if (typeof a !== "object" || a === null) throw new Error(`cannot retain a ${typeof a}`);
    if (typeof b !== "object" || b === null) throw new Error(`cannot retain a ${typeof b}`);
    const embedType = Object.keys(a)[0];
    if (!embedType || embedType !== Object.keys(b)[0]) throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
    return [
        embedType,
        a[embedType],
        b[embedType]
    ];
};
class $5cea9abc67034d4a$var$Delta {
    constructor(ops){
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) this.ops = ops;
        else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
        else this.ops = [];
    }
    static registerEmbed(embedType, handler) {
        this.handlers[embedType] = handler;
    }
    static unregisterEmbed(embedType) {
        delete this.handlers[embedType];
    }
    static getHandler(embedType) {
        const handler = this.handlers[embedType];
        if (!handler) throw new Error(`no handlers for embed type "${embedType}"`);
        return handler;
    }
    insert(arg, attributes) {
        const newOp = {};
        if (typeof arg === "string" && arg.length === 0) return this;
        newOp.insert = arg;
        if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    delete(length) {
        if (length <= 0) return this;
        return this.push({
            delete: length
        });
    }
    retain(length, attributes) {
        if (typeof length === "number" && length <= 0) return this;
        const newOp = {
            retain: length
        };
        if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    push(newOp) {
        let index = this.ops.length;
        let lastOp = this.ops[index - 1];
        newOp = $6VEzq(newOp);
        if (typeof lastOp === "object") {
            if (typeof newOp.delete === "number" && typeof lastOp.delete === "number") {
                this.ops[index - 1] = {
                    delete: lastOp.delete + newOp.delete
                };
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === "number" && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== "object") {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if ($iK1WR(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === "string" && typeof lastOp.insert === "string") {
                    this.ops[index - 1] = {
                        insert: lastOp.insert + newOp.insert
                    };
                    if (typeof newOp.attributes === "object") this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                } else if (typeof newOp.retain === "number" && typeof lastOp.retain === "number") {
                    this.ops[index - 1] = {
                        retain: lastOp.retain + newOp.retain
                    };
                    if (typeof newOp.attributes === "object") this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                }
            }
        }
        if (index === this.ops.length) this.ops.push(newOp);
        else this.ops.splice(index, 0, newOp);
        return this;
    }
    chop() {
        const lastOp = this.ops[this.ops.length - 1];
        if (lastOp && typeof lastOp.retain === "number" && !lastOp.attributes) this.ops.pop();
        return this;
    }
    filter(predicate) {
        return this.ops.filter(predicate);
    }
    forEach(predicate) {
        this.ops.forEach(predicate);
    }
    map(predicate) {
        return this.ops.map(predicate);
    }
    partition(predicate) {
        const passed = [];
        const failed = [];
        this.forEach((op)=>{
            const target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [
            passed,
            failed
        ];
    }
    reduce(predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    }
    changeLength() {
        return this.reduce((length, elem)=>{
            if (elem.insert) return length + $cd8713dd485bd7df$exports.default.length(elem);
            else if (elem.delete) return length - elem.delete;
            return length;
        }, 0);
    }
    length() {
        return this.reduce((length, elem)=>{
            return length + $cd8713dd485bd7df$exports.default.length(elem);
        }, 0);
    }
    slice(start = 0, end = Infinity) {
        const ops = [];
        const iter = new $7d2019508bbb1467$exports.default(this.ops);
        let index = 0;
        while(index < end && iter.hasNext()){
            let nextOp;
            if (index < start) nextOp = iter.next(start - index);
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += $cd8713dd485bd7df$exports.default.length(nextOp);
        }
        return new $5cea9abc67034d4a$var$Delta(ops);
    }
    compose(other) {
        const thisIter = new $7d2019508bbb1467$exports.default(this.ops);
        const otherIter = new $7d2019508bbb1467$exports.default(other.ops);
        const ops = [];
        const firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === "number" && firstOther.attributes == null) {
            let firstLeft = firstOther.retain;
            while(thisIter.peekType() === "insert" && thisIter.peekLength() <= firstLeft){
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
        }
        const delta = new $5cea9abc67034d4a$var$Delta(ops);
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (otherIter.peekType() === "insert") delta.push(otherIter.next());
            else if (thisIter.peekType() === "delete") delta.push(thisIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (otherOp.retain) {
                    const newOp = {};
                    if (typeof thisOp.retain === "number") newOp.retain = typeof otherOp.retain === "number" ? length : otherOp.retain;
                    else if (typeof otherOp.retain === "number") {
                        if (thisOp.retain == null) newOp.insert = thisOp.insert;
                        else newOp.retain = thisOp.retain;
                    } else {
                        const action = thisOp.retain == null ? "insert" : "retain";
                        const [embedType, thisData, otherData] = $5cea9abc67034d4a$var$getEmbedTypeAndData(thisOp[action], otherOp.retain);
                        const handler = $5cea9abc67034d4a$var$Delta.getHandler(embedType);
                        newOp[action] = {
                            [embedType]: handler.compose(thisData, otherData, action === "retain")
                        };
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    const attributes = $4300be4a01ef1e8e$exports.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === "number");
                    if (attributes) newOp.attributes = attributes;
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() && $iK1WR(delta.ops[delta.ops.length - 1], newOp)) {
                        const rest = new $5cea9abc67034d4a$var$Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                // Other op should be delete, we could be an insert or retain
                // Insert + delete cancels out
                } else if (typeof otherOp.delete === "number" && (typeof thisOp.retain === "number" || typeof thisOp.retain === "object" && thisOp.retain !== null)) delta.push(otherOp);
            }
        }
        return delta.chop();
    }
    concat(other) {
        const delta = new $5cea9abc67034d4a$var$Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    }
    diff(other, cursor) {
        if (this.ops === other.ops) return new $5cea9abc67034d4a$var$Delta();
        const strings = [
            this,
            other
        ].map((delta)=>{
            return delta.map((op)=>{
                if (op.insert != null) return typeof op.insert === "string" ? op.insert : $5cea9abc67034d4a$var$NULL_CHARACTER;
                const prep = delta === other ? "on" : "with";
                throw new Error("diff() called " + prep + " non-document");
            }).join("");
        });
        const retDelta = new $5cea9abc67034d4a$var$Delta();
        const diffResult = $f6dfd28031c6f994$exports(strings[0], strings[1], cursor, true);
        const thisIter = new $7d2019508bbb1467$exports.default(this.ops);
        const otherIter = new $7d2019508bbb1467$exports.default(other.ops);
        diffResult.forEach((component)=>{
            let length = component[1].length;
            while(length > 0){
                let opLength = 0;
                switch(component[0]){
                    case $f6dfd28031c6f994$exports.INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case $f6dfd28031c6f994$exports.DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case $f6dfd28031c6f994$exports.EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        const thisOp = thisIter.next(opLength);
                        const otherOp = otherIter.next(opLength);
                        if ($iK1WR(thisOp.insert, otherOp.insert)) retDelta.retain(opLength, $4300be4a01ef1e8e$exports.default.diff(thisOp.attributes, otherOp.attributes));
                        else retDelta.push(otherOp).delete(opLength);
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    }
    eachLine(predicate, newline = "\n") {
        const iter = new $7d2019508bbb1467$exports.default(this.ops);
        let line = new $5cea9abc67034d4a$var$Delta();
        let i = 0;
        while(iter.hasNext()){
            if (iter.peekType() !== "insert") return;
            const thisOp = iter.peek();
            const start = $cd8713dd485bd7df$exports.default.length(thisOp) - iter.peekLength();
            const index = typeof thisOp.insert === "string" ? thisOp.insert.indexOf(newline, start) - start : -1;
            if (index < 0) line.push(iter.next());
            else if (index > 0) line.push(iter.next(index));
            else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                i += 1;
                line = new $5cea9abc67034d4a$var$Delta();
            }
        }
        if (line.length() > 0) predicate(line, {}, i);
    }
    invert(base) {
        const inverted = new $5cea9abc67034d4a$var$Delta();
        this.reduce((baseIndex, op)=>{
            if (op.insert) inverted.delete($cd8713dd485bd7df$exports.default.length(op));
            else if (typeof op.retain === "number" && op.attributes == null) {
                inverted.retain(op.retain);
                return baseIndex + op.retain;
            } else if (op.delete || typeof op.retain === "number") {
                const length = op.delete || op.retain;
                const slice = base.slice(baseIndex, baseIndex + length);
                slice.forEach((baseOp)=>{
                    if (op.delete) inverted.push(baseOp);
                    else if (op.retain && op.attributes) inverted.retain($cd8713dd485bd7df$exports.default.length(baseOp), $4300be4a01ef1e8e$exports.default.invert(op.attributes, baseOp.attributes));
                });
                return baseIndex + length;
            } else if (typeof op.retain === "object" && op.retain !== null) {
                const slice = base.slice(baseIndex, baseIndex + 1);
                const baseOp = new $7d2019508bbb1467$exports.default(slice.ops).next();
                const [embedType, opData, baseOpData] = $5cea9abc67034d4a$var$getEmbedTypeAndData(op.retain, baseOp.insert);
                const handler = $5cea9abc67034d4a$var$Delta.getHandler(embedType);
                inverted.retain({
                    [embedType]: handler.invert(opData, baseOpData)
                }, $4300be4a01ef1e8e$exports.default.invert(op.attributes, baseOp.attributes));
                return baseIndex + 1;
            }
            return baseIndex;
        }, 0);
        return inverted.chop();
    }
    transform(arg, priority = false) {
        priority = !!priority;
        if (typeof arg === "number") return this.transformPosition(arg, priority);
        const other = arg;
        const thisIter = new $7d2019508bbb1467$exports.default(this.ops);
        const otherIter = new $7d2019508bbb1467$exports.default(other.ops);
        const delta = new $5cea9abc67034d4a$var$Delta();
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (thisIter.peekType() === "insert" && (priority || otherIter.peekType() !== "insert")) delta.retain($cd8713dd485bd7df$exports.default.length(thisIter.next()));
            else if (otherIter.peekType() === "insert") delta.push(otherIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (thisOp.delete) continue;
                else if (otherOp.delete) delta.push(otherOp);
                else {
                    const thisData = thisOp.retain;
                    const otherData = otherOp.retain;
                    let transformedData = typeof otherData === "object" && otherData !== null ? otherData : length;
                    if (typeof thisData === "object" && thisData !== null && typeof otherData === "object" && otherData !== null) {
                        const embedType = Object.keys(thisData)[0];
                        if (embedType === Object.keys(otherData)[0]) {
                            const handler = $5cea9abc67034d4a$var$Delta.getHandler(embedType);
                            if (handler) transformedData = {
                                [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority)
                            };
                        }
                    }
                    // We retain either their retain or insert
                    delta.retain(transformedData, $4300be4a01ef1e8e$exports.default.transform(thisOp.attributes, otherOp.attributes, priority));
                }
            }
        }
        return delta.chop();
    }
    transformPosition(index, priority = false) {
        priority = !!priority;
        const thisIter = new $7d2019508bbb1467$exports.default(this.ops);
        let offset = 0;
        while(thisIter.hasNext() && offset <= index){
            const length = thisIter.peekLength();
            const nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === "delete") {
                index -= Math.min(length, index - offset);
                continue;
            } else if (nextType === "insert" && (offset < index || !priority)) index += length;
            offset += length;
        }
        return index;
    }
}
$5cea9abc67034d4a$var$Delta.Op = $cd8713dd485bd7df$exports.default;
$5cea9abc67034d4a$var$Delta.OpIterator = $7d2019508bbb1467$exports.default;
$5cea9abc67034d4a$var$Delta.AttributeMap = $4300be4a01ef1e8e$exports.default;
$5cea9abc67034d4a$var$Delta.handlers = {};
$5cea9abc67034d4a$exports.default = $5cea9abc67034d4a$var$Delta;
$5cea9abc67034d4a$exports = $5cea9abc67034d4a$var$Delta;
$5cea9abc67034d4a$exports.default = $5cea9abc67034d4a$var$Delta;



/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $9811b7860a81ec3c$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $9811b7860a81ec3c$export$2e2bcd8739ae039 = $9811b7860a81ec3c$var$arrayEach;







/* Built-in method references for those with the same name as other `lodash` methods. */ var $610b1bd508d704d4$var$nativeKeys = (0, $f23d7a5ca798f3a1$export$2e2bcd8739ae039)(Object.keys, Object);
var $610b1bd508d704d4$export$2e2bcd8739ae039 = $610b1bd508d704d4$var$nativeKeys;


/** Used for built-in method references. */ var $21350c5a809de3a8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $21350c5a809de3a8$var$hasOwnProperty = $21350c5a809de3a8$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $21350c5a809de3a8$var$baseKeys(object) {
    if (!(0, $24ad81fab1c4f1be$export$2e2bcd8739ae039)(object)) return (0, $610b1bd508d704d4$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($21350c5a809de3a8$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $21350c5a809de3a8$export$2e2bcd8739ae039 = $21350c5a809de3a8$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $06cad22c8c72161b$var$keys(object) {
    return (0, $e0409e5405754f3c$export$2e2bcd8739ae039)(object) ? (0, $c30247f2b2061777$export$2e2bcd8739ae039)(object) : (0, $21350c5a809de3a8$export$2e2bcd8739ae039)(object);
}
var $06cad22c8c72161b$export$2e2bcd8739ae039 = $06cad22c8c72161b$var$keys;


/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $6b82e454dca397d9$var$baseAssign(object, source) {
    return object && (0, $b2ac96df956dbf36$export$2e2bcd8739ae039)(source, (0, $06cad22c8c72161b$export$2e2bcd8739ae039)(source), object);
}
var $6b82e454dca397d9$export$2e2bcd8739ae039 = $6b82e454dca397d9$var$baseAssign;




/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $3d9db2a94035b5d9$var$baseAssignIn(object, source) {
    return object && (0, $b2ac96df956dbf36$export$2e2bcd8739ae039)(source, (0, $64f3dc4cba180c2e$export$2e2bcd8739ae039)(source), object);
}
var $3d9db2a94035b5d9$export$2e2bcd8739ae039 = $3d9db2a94035b5d9$var$baseAssignIn;



var $5Jx4e = parcelRequire("5Jx4e");


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $c5a462bb0f3c2338$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $c5a462bb0f3c2338$export$2e2bcd8739ae039 = $c5a462bb0f3c2338$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $ad9e0c7f5297dcd6$var$stubArray() {
    return [];
}
var $ad9e0c7f5297dcd6$export$2e2bcd8739ae039 = $ad9e0c7f5297dcd6$var$stubArray;


/** Used for built-in method references. */ var $591b67f485363ef9$var$objectProto = Object.prototype;
/** Built-in value references. */ var $591b67f485363ef9$var$propertyIsEnumerable = $591b67f485363ef9$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $591b67f485363ef9$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $591b67f485363ef9$var$getSymbols = !$591b67f485363ef9$var$nativeGetSymbols ? (0, $ad9e0c7f5297dcd6$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $c5a462bb0f3c2338$export$2e2bcd8739ae039)($591b67f485363ef9$var$nativeGetSymbols(object), function(symbol) {
        return $591b67f485363ef9$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $591b67f485363ef9$export$2e2bcd8739ae039 = $591b67f485363ef9$var$getSymbols;


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $3eed1ca0a0ca5970$var$copySymbols(source, object) {
    return (0, $b2ac96df956dbf36$export$2e2bcd8739ae039)(source, (0, $591b67f485363ef9$export$2e2bcd8739ae039)(source), object);
}
var $3eed1ca0a0ca5970$export$2e2bcd8739ae039 = $3eed1ca0a0ca5970$var$copySymbols;



/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $45fc3f495f3fc5e7$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $45fc3f495f3fc5e7$export$2e2bcd8739ae039 = $45fc3f495f3fc5e7$var$arrayPush;





/* Built-in method references for those with the same name as other `lodash` methods. */ var $f862a33ff29d947e$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $f862a33ff29d947e$var$getSymbolsIn = !$f862a33ff29d947e$var$nativeGetSymbols ? (0, $ad9e0c7f5297dcd6$export$2e2bcd8739ae039) : function(object) {
    var result = [];
    while(object){
        (0, $45fc3f495f3fc5e7$export$2e2bcd8739ae039)(result, (0, $591b67f485363ef9$export$2e2bcd8739ae039)(object));
        object = (0, $ecfb3d63d5f046d1$export$2e2bcd8739ae039)(object);
    }
    return result;
};
var $f862a33ff29d947e$export$2e2bcd8739ae039 = $f862a33ff29d947e$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $72692ffc9460d802$var$copySymbolsIn(source, object) {
    return (0, $b2ac96df956dbf36$export$2e2bcd8739ae039)(source, (0, $f862a33ff29d947e$export$2e2bcd8739ae039)(source), object);
}
var $72692ffc9460d802$export$2e2bcd8739ae039 = $72692ffc9460d802$var$copySymbolsIn;




/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $951897db3d633d3c$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $4c33bcad49280ffb$export$2e2bcd8739ae039)(object) ? result : (0, $45fc3f495f3fc5e7$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $951897db3d633d3c$export$2e2bcd8739ae039 = $951897db3d633d3c$var$baseGetAllKeys;




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $355cfe543c48a8d5$var$getAllKeys(object) {
    return (0, $951897db3d633d3c$export$2e2bcd8739ae039)(object, (0, $06cad22c8c72161b$export$2e2bcd8739ae039), (0, $591b67f485363ef9$export$2e2bcd8739ae039));
}
var $355cfe543c48a8d5$export$2e2bcd8739ae039 = $355cfe543c48a8d5$var$getAllKeys;





/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2d924aaeb44c8b13$var$getAllKeysIn(object) {
    return (0, $951897db3d633d3c$export$2e2bcd8739ae039)(object, (0, $64f3dc4cba180c2e$export$2e2bcd8739ae039), (0, $f862a33ff29d947e$export$2e2bcd8739ae039));
}
var $2d924aaeb44c8b13$export$2e2bcd8739ae039 = $2d924aaeb44c8b13$var$getAllKeysIn;




var $ht9qF = parcelRequire("ht9qF");
/* Built-in method references that are verified to be native. */ var $61a5b8d0b65d7d60$var$DataView = (0, $27fdeb15c1d5ca69$export$2e2bcd8739ae039)((0, $ht9qF.default), "DataView");
var $61a5b8d0b65d7d60$export$2e2bcd8739ae039 = $61a5b8d0b65d7d60$var$DataView;





var $ht9qF = parcelRequire("ht9qF");
/* Built-in method references that are verified to be native. */ var $710ed235e231d78a$var$Promise = (0, $27fdeb15c1d5ca69$export$2e2bcd8739ae039)((0, $ht9qF.default), "Promise");
var $710ed235e231d78a$export$2e2bcd8739ae039 = $710ed235e231d78a$var$Promise;




var $ht9qF = parcelRequire("ht9qF");
/* Built-in method references that are verified to be native. */ var $c6b3ecac99e4f683$var$Set = (0, $27fdeb15c1d5ca69$export$2e2bcd8739ae039)((0, $ht9qF.default), "Set");
var $c6b3ecac99e4f683$export$2e2bcd8739ae039 = $c6b3ecac99e4f683$var$Set;




var $ht9qF = parcelRequire("ht9qF");
/* Built-in method references that are verified to be native. */ var $c56b72e82a644623$var$WeakMap = (0, $27fdeb15c1d5ca69$export$2e2bcd8739ae039)((0, $ht9qF.default), "WeakMap");
var $c56b72e82a644623$export$2e2bcd8739ae039 = $c56b72e82a644623$var$WeakMap;




/** `Object#toString` result references. */ var $082c839a71f4f028$var$mapTag = "[object Map]", $082c839a71f4f028$var$objectTag = "[object Object]", $082c839a71f4f028$var$promiseTag = "[object Promise]", $082c839a71f4f028$var$setTag = "[object Set]", $082c839a71f4f028$var$weakMapTag = "[object WeakMap]";
var $082c839a71f4f028$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $082c839a71f4f028$var$dataViewCtorString = (0, $8ac7b9d2a7e86a84$export$2e2bcd8739ae039)((0, $61a5b8d0b65d7d60$export$2e2bcd8739ae039)), $082c839a71f4f028$var$mapCtorString = (0, $8ac7b9d2a7e86a84$export$2e2bcd8739ae039)((0, $cfda3e888c8b1f4f$export$2e2bcd8739ae039)), $082c839a71f4f028$var$promiseCtorString = (0, $8ac7b9d2a7e86a84$export$2e2bcd8739ae039)((0, $710ed235e231d78a$export$2e2bcd8739ae039)), $082c839a71f4f028$var$setCtorString = (0, $8ac7b9d2a7e86a84$export$2e2bcd8739ae039)((0, $c6b3ecac99e4f683$export$2e2bcd8739ae039)), $082c839a71f4f028$var$weakMapCtorString = (0, $8ac7b9d2a7e86a84$export$2e2bcd8739ae039)((0, $c56b72e82a644623$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $082c839a71f4f028$var$getTag = (0, $f9754adf838f9df5$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $61a5b8d0b65d7d60$export$2e2bcd8739ae039) && $082c839a71f4f028$var$getTag(new (0, $61a5b8d0b65d7d60$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $082c839a71f4f028$var$dataViewTag || (0, $cfda3e888c8b1f4f$export$2e2bcd8739ae039) && $082c839a71f4f028$var$getTag(new (0, $cfda3e888c8b1f4f$export$2e2bcd8739ae039)) != $082c839a71f4f028$var$mapTag || (0, $710ed235e231d78a$export$2e2bcd8739ae039) && $082c839a71f4f028$var$getTag((0, $710ed235e231d78a$export$2e2bcd8739ae039).resolve()) != $082c839a71f4f028$var$promiseTag || (0, $c6b3ecac99e4f683$export$2e2bcd8739ae039) && $082c839a71f4f028$var$getTag(new (0, $c6b3ecac99e4f683$export$2e2bcd8739ae039)) != $082c839a71f4f028$var$setTag || (0, $c56b72e82a644623$export$2e2bcd8739ae039) && $082c839a71f4f028$var$getTag(new (0, $c56b72e82a644623$export$2e2bcd8739ae039)) != $082c839a71f4f028$var$weakMapTag) $082c839a71f4f028$var$getTag = function(value) {
    var result = (0, $f9754adf838f9df5$export$2e2bcd8739ae039)(value), Ctor = result == $082c839a71f4f028$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $8ac7b9d2a7e86a84$export$2e2bcd8739ae039)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $082c839a71f4f028$var$dataViewCtorString:
            return $082c839a71f4f028$var$dataViewTag;
        case $082c839a71f4f028$var$mapCtorString:
            return $082c839a71f4f028$var$mapTag;
        case $082c839a71f4f028$var$promiseCtorString:
            return $082c839a71f4f028$var$promiseTag;
        case $082c839a71f4f028$var$setCtorString:
            return $082c839a71f4f028$var$setTag;
        case $082c839a71f4f028$var$weakMapCtorString:
            return $082c839a71f4f028$var$weakMapTag;
    }
    return result;
};
var $082c839a71f4f028$export$2e2bcd8739ae039 = $082c839a71f4f028$var$getTag;


/** Used for built-in method references. */ var $f80a5cedca62ef8d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f80a5cedca62ef8d$var$hasOwnProperty = $f80a5cedca62ef8d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $f80a5cedca62ef8d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $f80a5cedca62ef8d$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $f80a5cedca62ef8d$export$2e2bcd8739ae039 = $f80a5cedca62ef8d$var$initCloneArray;




/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $5fa979f690ce64ff$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $7cb9a859afbe21a6$export$2e2bcd8739ae039)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $5fa979f690ce64ff$export$2e2bcd8739ae039 = $5fa979f690ce64ff$var$cloneDataView;


/** Used to match `RegExp` flags from their coerced string values. */ var $70bb663703ad591f$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $70bb663703ad591f$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $70bb663703ad591f$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $70bb663703ad591f$export$2e2bcd8739ae039 = $70bb663703ad591f$var$cloneRegExp;



/** Used to convert symbols to primitives and strings. */ var $caa5fc9aa7fa06ce$var$symbolProto = (0, $2adae95c0aedb06d$export$2e2bcd8739ae039) ? (0, $2adae95c0aedb06d$export$2e2bcd8739ae039).prototype : undefined, $caa5fc9aa7fa06ce$var$symbolValueOf = $caa5fc9aa7fa06ce$var$symbolProto ? $caa5fc9aa7fa06ce$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $caa5fc9aa7fa06ce$var$cloneSymbol(symbol) {
    return $caa5fc9aa7fa06ce$var$symbolValueOf ? Object($caa5fc9aa7fa06ce$var$symbolValueOf.call(symbol)) : {};
}
var $caa5fc9aa7fa06ce$export$2e2bcd8739ae039 = $caa5fc9aa7fa06ce$var$cloneSymbol;



/** `Object#toString` result references. */ var $056018bb132b99f6$var$boolTag = "[object Boolean]", $056018bb132b99f6$var$dateTag = "[object Date]", $056018bb132b99f6$var$mapTag = "[object Map]", $056018bb132b99f6$var$numberTag = "[object Number]", $056018bb132b99f6$var$regexpTag = "[object RegExp]", $056018bb132b99f6$var$setTag = "[object Set]", $056018bb132b99f6$var$stringTag = "[object String]", $056018bb132b99f6$var$symbolTag = "[object Symbol]";
var $056018bb132b99f6$var$arrayBufferTag = "[object ArrayBuffer]", $056018bb132b99f6$var$dataViewTag = "[object DataView]", $056018bb132b99f6$var$float32Tag = "[object Float32Array]", $056018bb132b99f6$var$float64Tag = "[object Float64Array]", $056018bb132b99f6$var$int8Tag = "[object Int8Array]", $056018bb132b99f6$var$int16Tag = "[object Int16Array]", $056018bb132b99f6$var$int32Tag = "[object Int32Array]", $056018bb132b99f6$var$uint8Tag = "[object Uint8Array]", $056018bb132b99f6$var$uint8ClampedTag = "[object Uint8ClampedArray]", $056018bb132b99f6$var$uint16Tag = "[object Uint16Array]", $056018bb132b99f6$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $056018bb132b99f6$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $056018bb132b99f6$var$arrayBufferTag:
            return (0, $7cb9a859afbe21a6$export$2e2bcd8739ae039)(object);
        case $056018bb132b99f6$var$boolTag:
        case $056018bb132b99f6$var$dateTag:
            return new Ctor(+object);
        case $056018bb132b99f6$var$dataViewTag:
            return (0, $5fa979f690ce64ff$export$2e2bcd8739ae039)(object, isDeep);
        case $056018bb132b99f6$var$float32Tag:
        case $056018bb132b99f6$var$float64Tag:
        case $056018bb132b99f6$var$int8Tag:
        case $056018bb132b99f6$var$int16Tag:
        case $056018bb132b99f6$var$int32Tag:
        case $056018bb132b99f6$var$uint8Tag:
        case $056018bb132b99f6$var$uint8ClampedTag:
        case $056018bb132b99f6$var$uint16Tag:
        case $056018bb132b99f6$var$uint32Tag:
            return (0, $d8d053df9ba5c0b4$export$2e2bcd8739ae039)(object, isDeep);
        case $056018bb132b99f6$var$mapTag:
            return new Ctor;
        case $056018bb132b99f6$var$numberTag:
        case $056018bb132b99f6$var$stringTag:
            return new Ctor(object);
        case $056018bb132b99f6$var$regexpTag:
            return (0, $70bb663703ad591f$export$2e2bcd8739ae039)(object);
        case $056018bb132b99f6$var$setTag:
            return new Ctor;
        case $056018bb132b99f6$var$symbolTag:
            return (0, $caa5fc9aa7fa06ce$export$2e2bcd8739ae039)(object);
    }
}
var $056018bb132b99f6$export$2e2bcd8739ae039 = $056018bb132b99f6$var$initCloneByTag;





var $dG9Ze = parcelRequire("dG9Ze");


/** `Object#toString` result references. */ var $af3f4ae5d6e5c04a$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $af3f4ae5d6e5c04a$var$baseIsMap(value) {
    return (0, $b48ae904b6702ab5$export$2e2bcd8739ae039)(value) && (0, $082c839a71f4f028$export$2e2bcd8739ae039)(value) == $af3f4ae5d6e5c04a$var$mapTag;
}
var $af3f4ae5d6e5c04a$export$2e2bcd8739ae039 = $af3f4ae5d6e5c04a$var$baseIsMap;




var $rj6Om = parcelRequire("rj6Om");
/* Node.js helper references. */ var $b0bc80ec5d9e1d00$var$nodeIsMap = (0, $rj6Om.default) && (0, $rj6Om.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $b0bc80ec5d9e1d00$var$isMap = $b0bc80ec5d9e1d00$var$nodeIsMap ? (0, $518e0db33eb18891$export$2e2bcd8739ae039)($b0bc80ec5d9e1d00$var$nodeIsMap) : (0, $af3f4ae5d6e5c04a$export$2e2bcd8739ae039);
var $b0bc80ec5d9e1d00$export$2e2bcd8739ae039 = $b0bc80ec5d9e1d00$var$isMap;





/** `Object#toString` result references. */ var $c9502f3e9ede70c4$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $c9502f3e9ede70c4$var$baseIsSet(value) {
    return (0, $b48ae904b6702ab5$export$2e2bcd8739ae039)(value) && (0, $082c839a71f4f028$export$2e2bcd8739ae039)(value) == $c9502f3e9ede70c4$var$setTag;
}
var $c9502f3e9ede70c4$export$2e2bcd8739ae039 = $c9502f3e9ede70c4$var$baseIsSet;




var $rj6Om = parcelRequire("rj6Om");
/* Node.js helper references. */ var $7b7090eb13652515$var$nodeIsSet = (0, $rj6Om.default) && (0, $rj6Om.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $7b7090eb13652515$var$isSet = $7b7090eb13652515$var$nodeIsSet ? (0, $518e0db33eb18891$export$2e2bcd8739ae039)($7b7090eb13652515$var$nodeIsSet) : (0, $c9502f3e9ede70c4$export$2e2bcd8739ae039);
var $7b7090eb13652515$export$2e2bcd8739ae039 = $7b7090eb13652515$var$isSet;




/** Used to compose bitmasks for cloning. */ var $450603bd29fdf77c$var$CLONE_DEEP_FLAG = 1, $450603bd29fdf77c$var$CLONE_FLAT_FLAG = 2, $450603bd29fdf77c$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $450603bd29fdf77c$var$argsTag = "[object Arguments]", $450603bd29fdf77c$var$arrayTag = "[object Array]", $450603bd29fdf77c$var$boolTag = "[object Boolean]", $450603bd29fdf77c$var$dateTag = "[object Date]", $450603bd29fdf77c$var$errorTag = "[object Error]", $450603bd29fdf77c$var$funcTag = "[object Function]", $450603bd29fdf77c$var$genTag = "[object GeneratorFunction]", $450603bd29fdf77c$var$mapTag = "[object Map]", $450603bd29fdf77c$var$numberTag = "[object Number]", $450603bd29fdf77c$var$objectTag = "[object Object]", $450603bd29fdf77c$var$regexpTag = "[object RegExp]", $450603bd29fdf77c$var$setTag = "[object Set]", $450603bd29fdf77c$var$stringTag = "[object String]", $450603bd29fdf77c$var$symbolTag = "[object Symbol]", $450603bd29fdf77c$var$weakMapTag = "[object WeakMap]";
var $450603bd29fdf77c$var$arrayBufferTag = "[object ArrayBuffer]", $450603bd29fdf77c$var$dataViewTag = "[object DataView]", $450603bd29fdf77c$var$float32Tag = "[object Float32Array]", $450603bd29fdf77c$var$float64Tag = "[object Float64Array]", $450603bd29fdf77c$var$int8Tag = "[object Int8Array]", $450603bd29fdf77c$var$int16Tag = "[object Int16Array]", $450603bd29fdf77c$var$int32Tag = "[object Int32Array]", $450603bd29fdf77c$var$uint8Tag = "[object Uint8Array]", $450603bd29fdf77c$var$uint8ClampedTag = "[object Uint8ClampedArray]", $450603bd29fdf77c$var$uint16Tag = "[object Uint16Array]", $450603bd29fdf77c$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $450603bd29fdf77c$var$cloneableTags = {};
$450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$argsTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$arrayTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$arrayBufferTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$dataViewTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$boolTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$dateTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$float32Tag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$float64Tag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$int8Tag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$int16Tag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$int32Tag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$mapTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$numberTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$objectTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$regexpTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$setTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$stringTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$symbolTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$uint8Tag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$uint8ClampedTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$uint16Tag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$uint32Tag] = true;
$450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$errorTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$funcTag] = $450603bd29fdf77c$var$cloneableTags[$450603bd29fdf77c$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $450603bd29fdf77c$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $450603bd29fdf77c$var$CLONE_DEEP_FLAG, isFlat = bitmask & $450603bd29fdf77c$var$CLONE_FLAT_FLAG, isFull = bitmask & $450603bd29fdf77c$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $2305f62ead79bff9$export$2e2bcd8739ae039)(value)) return value;
    var isArr = (0, $4c33bcad49280ffb$export$2e2bcd8739ae039)(value);
    if (isArr) {
        result = (0, $f80a5cedca62ef8d$export$2e2bcd8739ae039)(value);
        if (!isDeep) return (0, $6b7aec747d72d89b$export$2e2bcd8739ae039)(value, result);
    } else {
        var tag = (0, $082c839a71f4f028$export$2e2bcd8739ae039)(value), isFunc = tag == $450603bd29fdf77c$var$funcTag || tag == $450603bd29fdf77c$var$genTag;
        if ((0, $dG9Ze.default)(value)) return (0, $5Jx4e.default)(value, isDeep);
        if (tag == $450603bd29fdf77c$var$objectTag || tag == $450603bd29fdf77c$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $cbb9c0149707bc3c$export$2e2bcd8739ae039)(value);
            if (!isDeep) return isFlat ? (0, $72692ffc9460d802$export$2e2bcd8739ae039)(value, (0, $3d9db2a94035b5d9$export$2e2bcd8739ae039)(result, value)) : (0, $3eed1ca0a0ca5970$export$2e2bcd8739ae039)(value, (0, $6b82e454dca397d9$export$2e2bcd8739ae039)(result, value));
        } else {
            if (!$450603bd29fdf77c$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $056018bb132b99f6$export$2e2bcd8739ae039)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $b95edf1c0e6bc0d8$export$2e2bcd8739ae039));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $7b7090eb13652515$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue) {
        result.add($450603bd29fdf77c$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $b0bc80ec5d9e1d00$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue, key) {
        result.set(key, $450603bd29fdf77c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $2d924aaeb44c8b13$export$2e2bcd8739ae039) : (0, $355cfe543c48a8d5$export$2e2bcd8739ae039) : isFlat ? (0, $64f3dc4cba180c2e$export$2e2bcd8739ae039) : (0, $06cad22c8c72161b$export$2e2bcd8739ae039);
    var props = isArr ? undefined : keysFunc(value);
    (0, $9811b7860a81ec3c$export$2e2bcd8739ae039)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $043f92d50e6317d6$export$2e2bcd8739ae039)(result, key, $450603bd29fdf77c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $450603bd29fdf77c$export$2e2bcd8739ae039 = $450603bd29fdf77c$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $7b7037edc7b00187$var$CLONE_DEEP_FLAG = 1, $7b7037edc7b00187$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $7b7037edc7b00187$var$cloneDeep(value) {
    return (0, $450603bd29fdf77c$export$2e2bcd8739ae039)(value, $7b7037edc7b00187$var$CLONE_DEEP_FLAG | $7b7037edc7b00187$var$CLONE_SYMBOLS_FLAG);
}
var $7b7037edc7b00187$export$2e2bcd8739ae039 = $7b7037edc7b00187$var$cloneDeep;



/** Used to stand-in for `undefined` hash values. */ var $d0a448bae93e98ca$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $d0a448bae93e98ca$var$setCacheAdd(value) {
    this.__data__.set(value, $d0a448bae93e98ca$var$HASH_UNDEFINED);
    return this;
}
var $d0a448bae93e98ca$export$2e2bcd8739ae039 = $d0a448bae93e98ca$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $06936f0ca806b0ae$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $06936f0ca806b0ae$export$2e2bcd8739ae039 = $06936f0ca806b0ae$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $5670f0664ca589c5$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $1943cd310943703a$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$5670f0664ca589c5$var$SetCache.prototype.add = $5670f0664ca589c5$var$SetCache.prototype.push = (0, $d0a448bae93e98ca$export$2e2bcd8739ae039);
$5670f0664ca589c5$var$SetCache.prototype.has = (0, $06936f0ca806b0ae$export$2e2bcd8739ae039);
var $5670f0664ca589c5$export$2e2bcd8739ae039 = $5670f0664ca589c5$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $0fd345b00df0f3aa$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $0fd345b00df0f3aa$export$2e2bcd8739ae039 = $0fd345b00df0f3aa$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $121f709954319735$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $121f709954319735$export$2e2bcd8739ae039 = $121f709954319735$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $7e757f47d17cebe1$var$COMPARE_PARTIAL_FLAG = 1, $7e757f47d17cebe1$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $7e757f47d17cebe1$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $7e757f47d17cebe1$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $7e757f47d17cebe1$var$COMPARE_UNORDERED_FLAG ? new (0, $5670f0664ca589c5$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $0fd345b00df0f3aa$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $121f709954319735$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
var $7e757f47d17cebe1$export$2e2bcd8739ae039 = $7e757f47d17cebe1$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $35a9ef75ea5892ea$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $35a9ef75ea5892ea$export$2e2bcd8739ae039 = $35a9ef75ea5892ea$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $5c79672df9123320$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $5c79672df9123320$export$2e2bcd8739ae039 = $5c79672df9123320$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $2cfd8e6aeecc95ad$var$COMPARE_PARTIAL_FLAG = 1, $2cfd8e6aeecc95ad$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $2cfd8e6aeecc95ad$var$boolTag = "[object Boolean]", $2cfd8e6aeecc95ad$var$dateTag = "[object Date]", $2cfd8e6aeecc95ad$var$errorTag = "[object Error]", $2cfd8e6aeecc95ad$var$mapTag = "[object Map]", $2cfd8e6aeecc95ad$var$numberTag = "[object Number]", $2cfd8e6aeecc95ad$var$regexpTag = "[object RegExp]", $2cfd8e6aeecc95ad$var$setTag = "[object Set]", $2cfd8e6aeecc95ad$var$stringTag = "[object String]", $2cfd8e6aeecc95ad$var$symbolTag = "[object Symbol]";
var $2cfd8e6aeecc95ad$var$arrayBufferTag = "[object ArrayBuffer]", $2cfd8e6aeecc95ad$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $2cfd8e6aeecc95ad$var$symbolProto = (0, $2adae95c0aedb06d$export$2e2bcd8739ae039) ? (0, $2adae95c0aedb06d$export$2e2bcd8739ae039).prototype : undefined, $2cfd8e6aeecc95ad$var$symbolValueOf = $2cfd8e6aeecc95ad$var$symbolProto ? $2cfd8e6aeecc95ad$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2cfd8e6aeecc95ad$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $2cfd8e6aeecc95ad$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $2cfd8e6aeecc95ad$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $17739cb3beac2917$export$2e2bcd8739ae039)(object), new (0, $17739cb3beac2917$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $2cfd8e6aeecc95ad$var$boolTag:
        case $2cfd8e6aeecc95ad$var$dateTag:
        case $2cfd8e6aeecc95ad$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $9f16bf068e420061$export$2e2bcd8739ae039)(+object, +other);
        case $2cfd8e6aeecc95ad$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $2cfd8e6aeecc95ad$var$regexpTag:
        case $2cfd8e6aeecc95ad$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $2cfd8e6aeecc95ad$var$mapTag:
            var convert = (0, $35a9ef75ea5892ea$export$2e2bcd8739ae039);
        case $2cfd8e6aeecc95ad$var$setTag:
            var isPartial = bitmask & $2cfd8e6aeecc95ad$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $5c79672df9123320$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $2cfd8e6aeecc95ad$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $7e757f47d17cebe1$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $2cfd8e6aeecc95ad$var$symbolTag:
            if ($2cfd8e6aeecc95ad$var$symbolValueOf) return $2cfd8e6aeecc95ad$var$symbolValueOf.call(object) == $2cfd8e6aeecc95ad$var$symbolValueOf.call(other);
    }
    return false;
}
var $2cfd8e6aeecc95ad$export$2e2bcd8739ae039 = $2cfd8e6aeecc95ad$var$equalByTag;



/** Used to compose bitmasks for value comparisons. */ var $2afd2a923a51431d$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $2afd2a923a51431d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2afd2a923a51431d$var$hasOwnProperty = $2afd2a923a51431d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2afd2a923a51431d$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $2afd2a923a51431d$var$COMPARE_PARTIAL_FLAG, objProps = (0, $355cfe543c48a8d5$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $355cfe543c48a8d5$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $2afd2a923a51431d$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
var $2afd2a923a51431d$export$2e2bcd8739ae039 = $2afd2a923a51431d$var$equalObjects;





var $dG9Ze = parcelRequire("dG9Ze");

/** Used to compose bitmasks for value comparisons. */ var $377cbff69e3a31ea$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $377cbff69e3a31ea$var$argsTag = "[object Arguments]", $377cbff69e3a31ea$var$arrayTag = "[object Array]", $377cbff69e3a31ea$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $377cbff69e3a31ea$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $377cbff69e3a31ea$var$hasOwnProperty = $377cbff69e3a31ea$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $377cbff69e3a31ea$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $4c33bcad49280ffb$export$2e2bcd8739ae039)(object), othIsArr = (0, $4c33bcad49280ffb$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $377cbff69e3a31ea$var$arrayTag : (0, $082c839a71f4f028$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $377cbff69e3a31ea$var$arrayTag : (0, $082c839a71f4f028$export$2e2bcd8739ae039)(other);
    objTag = objTag == $377cbff69e3a31ea$var$argsTag ? $377cbff69e3a31ea$var$objectTag : objTag;
    othTag = othTag == $377cbff69e3a31ea$var$argsTag ? $377cbff69e3a31ea$var$objectTag : othTag;
    var objIsObj = objTag == $377cbff69e3a31ea$var$objectTag, othIsObj = othTag == $377cbff69e3a31ea$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $dG9Ze.default)(object)) {
        if (!(0, $dG9Ze.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $b95edf1c0e6bc0d8$export$2e2bcd8739ae039));
        return objIsArr || (0, $a120d6e330ceecf2$export$2e2bcd8739ae039)(object) ? (0, $7e757f47d17cebe1$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $2cfd8e6aeecc95ad$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $377cbff69e3a31ea$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $377cbff69e3a31ea$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $377cbff69e3a31ea$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $b95edf1c0e6bc0d8$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $b95edf1c0e6bc0d8$export$2e2bcd8739ae039));
    return (0, $2afd2a923a51431d$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $377cbff69e3a31ea$export$2e2bcd8739ae039 = $377cbff69e3a31ea$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $32b0a6dae5ccb34f$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $b48ae904b6702ab5$export$2e2bcd8739ae039)(value) && !(0, $b48ae904b6702ab5$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $377cbff69e3a31ea$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $32b0a6dae5ccb34f$var$baseIsEqual, stack);
}
var $32b0a6dae5ccb34f$export$2e2bcd8739ae039 = $32b0a6dae5ccb34f$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $969c2efa807ab995$var$isEqual(value, other) {
    return (0, $32b0a6dae5ccb34f$export$2e2bcd8739ae039)(value, other);
}
var $969c2efa807ab995$export$2e2bcd8739ae039 = $969c2efa807ab995$var$isEqual;







class $55d7c792844fdf31$var$Break extends (0, $4617b32e1de5ada7$export$297a1fa96f55f00f) {
    static value() {
        return undefined;
    }
    optimize() {
        if (this.prev || this.next) this.remove();
    }
    length() {
        return 0;
    }
    value() {
        return "";
    }
}
$55d7c792844fdf31$var$Break.blotName = "break";
$55d7c792844fdf31$var$Break.tagName = "BR";
var $55d7c792844fdf31$export$2e2bcd8739ae039 = $55d7c792844fdf31$var$Break;





class $725c99fa2d4b9334$export$2e2bcd8739ae039 extends (0, $4617b32e1de5ada7$export$10ac0c5716409de6) {
}
function $725c99fa2d4b9334$export$96e6fc3a139b2555(text) {
    return text.replace(/[&<>"']/g, (s)=>{
        // https://lodash.com/docs#escape
        const entityMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        };
        return entityMap[s];
    });
}


class $6713b0f866164989$var$Inline extends (0, $4617b32e1de5ada7$export$f67a34bc25a7a861) {
    static allowedChildren = [
        $6713b0f866164989$var$Inline,
        (0, $55d7c792844fdf31$export$2e2bcd8739ae039),
        (0, $4617b32e1de5ada7$export$297a1fa96f55f00f),
        (0, $725c99fa2d4b9334$export$2e2bcd8739ae039)
    ];
    // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
    static order = [
        "cursor",
        "inline",
        // Must be lower
        "link",
        // Chrome wants <a> to be lower
        "underline",
        "strike",
        "italic",
        "bold",
        "script",
        "code" // Must be higher
    ];
    static compare(self, other) {
        const selfIndex = $6713b0f866164989$var$Inline.order.indexOf(self);
        const otherIndex = $6713b0f866164989$var$Inline.order.indexOf(other);
        if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
        if (self === other) return 0;
        if (self < other) return -1;
        return 1;
    }
    formatAt(index, length, name, value) {
        if ($6713b0f866164989$var$Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOT)) {
            const blot = this.isolate(index, length);
            if (value) blot.wrap(name, value);
        } else super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent instanceof $6713b0f866164989$var$Inline && $6713b0f866164989$var$Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            const parent = this.parent.isolate(this.offset(), this.length());
            // @ts-expect-error TODO: make isolate generic
            this.moveChildren(parent);
            parent.wrap(this);
        }
    }
}
var $6713b0f866164989$export$2e2bcd8739ae039 = $6713b0f866164989$var$Inline;



const $0b2398fdb319908b$var$NEWLINE_LENGTH = 1;
class $0b2398fdb319908b$export$2e2bcd8739ae039 extends (0, $4617b32e1de5ada7$export$4f7f03641f7bfc8c) {
    cache = {};
    delta() {
        if (this.cache.delta == null) this.cache.delta = $0b2398fdb319908b$export$992ff47219af5a2b(this);
        return this.cache.delta;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length);
        this.cache = {};
    }
    formatAt(index, length, name, value) {
        if (length <= 0) return;
        if (this.scroll.query(name, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK)) {
            if (index + length === this.length()) this.format(name, value);
        } else super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
        this.cache = {};
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            this.cache = {};
            return;
        }
        if (value.length === 0) return;
        const lines = value.split("\n");
        const text = lines.shift();
        if (text.length > 0) {
            if (index < this.length() - 1 || this.children.tail == null) super.insertAt(Math.min(index, this.length() - 1), text);
            else this.children.tail.insertAt(this.children.tail.length(), text);
            this.cache = {};
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let block = this;
        lines.reduce((lineIndex, line)=>{
            // @ts-expect-error Fix me later
            block = block.split(lineIndex, true);
            block.insertAt(0, line);
            return line.length;
        }, index + text.length);
    }
    insertBefore(blot, ref) {
        const { head: head } = this.children;
        super.insertBefore(blot, ref);
        if (head instanceof (0, $55d7c792844fdf31$export$2e2bcd8739ae039)) head.remove();
        this.cache = {};
    }
    length() {
        if (this.cache.length == null) this.cache.length = super.length() + $0b2398fdb319908b$var$NEWLINE_LENGTH;
        return this.cache.length;
    }
    moveChildren(target, ref) {
        super.moveChildren(target, ref);
        this.cache = {};
    }
    optimize(context) {
        super.optimize(context);
        this.cache = {};
    }
    path(index) {
        return super.path(index, true);
    }
    removeChild(child) {
        super.removeChild(child);
        this.cache = {};
    }
    split(index) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (force && (index === 0 || index >= this.length() - $0b2398fdb319908b$var$NEWLINE_LENGTH)) {
            const clone = this.clone();
            if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
            }
            this.parent.insertBefore(clone, this.next);
            return clone;
        }
        const next = super.split(index, force);
        this.cache = {};
        return next;
    }
}
$0b2398fdb319908b$export$2e2bcd8739ae039.blotName = "block";
$0b2398fdb319908b$export$2e2bcd8739ae039.tagName = "P";
$0b2398fdb319908b$export$2e2bcd8739ae039.defaultChild = (0, $55d7c792844fdf31$export$2e2bcd8739ae039);
$0b2398fdb319908b$export$2e2bcd8739ae039.allowedChildren = [
    (0, $55d7c792844fdf31$export$2e2bcd8739ae039),
    (0, $6713b0f866164989$export$2e2bcd8739ae039),
    (0, $4617b32e1de5ada7$export$297a1fa96f55f00f),
    (0, $725c99fa2d4b9334$export$2e2bcd8739ae039)
];
class $0b2398fdb319908b$export$48b9f0688962d028 extends (0, $4617b32e1de5ada7$export$297a1fa96f55f00f) {
    attach() {
        super.attach();
        this.attributes = new (0, $4617b32e1de5ada7$export$68ad86ab95e8de42)(this.domNode);
    }
    delta() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().insert(this.value(), {
            ...this.formats(),
            ...this.attributes.values()
        });
    }
    format(name, value) {
        const attribute = this.scroll.query(name, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK_ATTRIBUTE);
        if (attribute != null) // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
        this.attributes.attribute(attribute, value);
    }
    formatAt(index, length, name, value) {
        this.format(name, value);
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            return;
        }
        const lines = value.split("\n");
        const text = lines.pop();
        const blocks = lines.map((line)=>{
            const block = this.scroll.create($0b2398fdb319908b$export$2e2bcd8739ae039.blotName);
            block.insertAt(0, line);
            return block;
        });
        const ref = this.split(index);
        blocks.forEach((block)=>{
            this.parent.insertBefore(block, ref);
        });
        if (text) this.parent.insertBefore(this.scroll.create("text", text), ref);
    }
}
$0b2398fdb319908b$export$48b9f0688962d028.scope = (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements
function $0b2398fdb319908b$export$992ff47219af5a2b(blot) {
    let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return blot.descendants((0, $4617b32e1de5ada7$export$7420b9c542181544)).reduce((delta, leaf)=>{
        if (leaf.length() === 0) return delta;
        return delta.insert(leaf.value(), $0b2398fdb319908b$export$e4bb5a6163449612(leaf, {}, filter));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))()).insert("\n", $0b2398fdb319908b$export$e4bb5a6163449612(blot));
}
function $0b2398fdb319908b$export$e4bb5a6163449612(blot) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (blot == null) return formats;
    if ("formats" in blot && typeof blot.formats === "function") {
        formats = {
            ...formats,
            ...blot.formats()
        };
        if (filter) // exclude syntax highlighting from deltas and getFormat()
        delete formats["code-token"];
    }
    if (blot.parent == null || blot.parent.statics.blotName === "scroll" || blot.parent.statics.scope !== blot.statics.scope) return formats;
    return $0b2398fdb319908b$export$e4bb5a6163449612(blot.parent, formats, filter);
}





class $4df559780cba7baa$var$Cursor extends (0, $4617b32e1de5ada7$export$297a1fa96f55f00f) {
    static blotName = "cursor";
    static className = "ql-cursor";
    static tagName = "span";
    static CONTENTS = "\uFEFF";
    static value() {
        return undefined;
    }
    constructor(scroll, domNode, selection){
        super(scroll, domNode);
        this.selection = selection;
        this.textNode = document.createTextNode($4df559780cba7baa$var$Cursor.CONTENTS);
        this.domNode.appendChild(this.textNode);
        this.savedLength = 0;
    }
    detach() {
        // super.detach() will also clear domNode.__blot
        if (this.parent != null) this.parent.removeChild(this);
    }
    format(name, value) {
        if (this.savedLength !== 0) {
            super.format(name, value);
            return;
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let target = this;
        let index = 0;
        while(target != null && target.statics.scope !== (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK_BLOT){
            index += target.offset(target.parent);
            target = target.parent;
        }
        if (target != null) {
            this.savedLength = $4df559780cba7baa$var$Cursor.CONTENTS.length;
            // @ts-expect-error TODO: allow empty context in Parchment
            target.optimize();
            target.formatAt(index, $4df559780cba7baa$var$Cursor.CONTENTS.length, name, value);
            this.savedLength = 0;
        }
    }
    index(node, offset) {
        if (node === this.textNode) return 0;
        return super.index(node, offset);
    }
    length() {
        return this.savedLength;
    }
    position() {
        return [
            this.textNode,
            this.textNode.data.length
        ];
    }
    remove() {
        super.remove();
        // @ts-expect-error Fix me later
        this.parent = null;
    }
    restore() {
        if (this.selection.composing || this.parent == null) return null;
        const range = this.selection.getNativeRange();
        // Browser may push down styles/nodes inside the cursor blot.
        // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
        while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)// @ts-expect-error Fix me later
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
        const prevTextBlot = this.prev instanceof (0, $725c99fa2d4b9334$export$2e2bcd8739ae039) ? this.prev : null;
        const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
        const nextTextBlot = this.next instanceof (0, $725c99fa2d4b9334$export$2e2bcd8739ae039) ? this.next : null;
        // @ts-expect-error TODO: make TextBlot.text public
        const nextText = nextTextBlot ? nextTextBlot.text : "";
        const { textNode: textNode } = this;
        // take text from inside this blot and reset it
        const newText = textNode.data.split($4df559780cba7baa$var$Cursor.CONTENTS).join("");
        textNode.data = $4df559780cba7baa$var$Cursor.CONTENTS;
        // proactively merge TextBlots around cursor so that optimization
        // doesn't lose the cursor.  the reason we are here in cursor.restore
        // could be that the user clicked in prevTextBlot or nextTextBlot, or
        // the user typed something.
        let mergedTextBlot;
        if (prevTextBlot) {
            mergedTextBlot = prevTextBlot;
            if (newText || nextTextBlot) {
                prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
                if (nextTextBlot) nextTextBlot.remove();
            }
        } else if (nextTextBlot) {
            mergedTextBlot = nextTextBlot;
            nextTextBlot.insertAt(0, newText);
        } else {
            const newTextNode = document.createTextNode(newText);
            mergedTextBlot = this.scroll.create(newTextNode);
            this.parent.insertBefore(mergedTextBlot, this);
        }
        this.remove();
        if (range) {
            // calculate selection to restore
            const remapOffset = (node, offset)=>{
                if (prevTextBlot && node === prevTextBlot.domNode) return offset;
                if (node === textNode) return prevTextLength + offset - 1;
                if (nextTextBlot && node === nextTextBlot.domNode) return prevTextLength + newText.length + offset;
                return null;
            };
            const start = remapOffset(range.start.node, range.start.offset);
            const end = remapOffset(range.end.node, range.end.offset);
            if (start !== null && end !== null) return {
                startNode: mergedTextBlot.domNode,
                startOffset: start,
                endNode: mergedTextBlot.domNode,
                endOffset: end
            };
        }
        return null;
    }
    update(mutations, context) {
        if (mutations.some((mutation)=>{
            return mutation.type === "characterData" && mutation.target === this.textNode;
        })) {
            const range = this.restore();
            if (range) context.range = range;
        }
    }
    // Avoid .ql-cursor being a descendant of `<a/>`.
    // The reason is Safari pushes down `<a/>` on text insertion.
    // That will cause DOM nodes not sync with the model.
    //
    // For example ({I} is the caret), given the markup:
    //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
    // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
    //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
    // And then "x" will be inserted after `<a/>`:
    //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
    optimize(context) {
        // @ts-expect-error Fix me later
        super.optimize(context);
        let { parent: parent } = this;
        while(parent){
            if (parent.domNode.tagName === "A") {
                this.savedLength = $4df559780cba7baa$var$Cursor.CONTENTS.length;
                // @ts-expect-error TODO: make isolate generic
                parent.isolate(this.offset(parent), this.length()).unwrap();
                this.savedLength = 0;
                break;
            }
            parent = parent.parent;
        }
    }
    value() {
        return "";
    }
}
var $4df559780cba7baa$export$2e2bcd8739ae039 = $4df559780cba7baa$var$Cursor;





var $5bcfbf153438b60f$exports = {};
"use strict";
var $5bcfbf153438b60f$var$has = Object.prototype.hasOwnProperty, $5bcfbf153438b60f$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $5bcfbf153438b60f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $5bcfbf153438b60f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $5bcfbf153438b60f$var$Events().__proto__) $5bcfbf153438b60f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $5bcfbf153438b60f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $5bcfbf153438b60f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $5bcfbf153438b60f$var$EE(fn, context || emitter, once), evt = $5bcfbf153438b60f$var$prefix ? $5bcfbf153438b60f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $5bcfbf153438b60f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $5bcfbf153438b60f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $5bcfbf153438b60f$var$EventEmitter() {
    this._events = new $5bcfbf153438b60f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $5bcfbf153438b60f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($5bcfbf153438b60f$var$has.call(events, name)) names.push($5bcfbf153438b60f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $5bcfbf153438b60f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $5bcfbf153438b60f$var$prefix ? $5bcfbf153438b60f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $5bcfbf153438b60f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $5bcfbf153438b60f$var$prefix ? $5bcfbf153438b60f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $5bcfbf153438b60f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $5bcfbf153438b60f$var$prefix ? $5bcfbf153438b60f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $5bcfbf153438b60f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $5bcfbf153438b60f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $5bcfbf153438b60f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $5bcfbf153438b60f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $5bcfbf153438b60f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $5bcfbf153438b60f$var$prefix ? $5bcfbf153438b60f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $5bcfbf153438b60f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $5bcfbf153438b60f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $5bcfbf153438b60f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $5bcfbf153438b60f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $5bcfbf153438b60f$var$prefix ? $5bcfbf153438b60f$var$prefix + event : event;
        if (this._events[evt]) $5bcfbf153438b60f$var$clearEvent(this, evt);
    } else {
        this._events = new $5bcfbf153438b60f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$5bcfbf153438b60f$var$EventEmitter.prototype.off = $5bcfbf153438b60f$var$EventEmitter.prototype.removeListener;
$5bcfbf153438b60f$var$EventEmitter.prototype.addListener = $5bcfbf153438b60f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$5bcfbf153438b60f$var$EventEmitter.prefixed = $5bcfbf153438b60f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$5bcfbf153438b60f$var$EventEmitter.EventEmitter = $5bcfbf153438b60f$var$EventEmitter;
$5bcfbf153438b60f$exports = $5bcfbf153438b60f$var$EventEmitter;


var $a7445250980710a7$export$2e2bcd8739ae039 = new WeakMap();


const $4548fff023e32856$var$levels = [
    "error",
    "warn",
    "log",
    "info"
];
let $4548fff023e32856$var$level = "warn";
function $4548fff023e32856$var$debug(method) {
    if ($4548fff023e32856$var$level) {
        if ($4548fff023e32856$var$levels.indexOf(method) <= $4548fff023e32856$var$levels.indexOf($4548fff023e32856$var$level)) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            console[method](...args); // eslint-disable-line no-console
        }
    }
}
function $4548fff023e32856$var$namespace(ns) {
    return $4548fff023e32856$var$levels.reduce((logger, method)=>{
        logger[method] = $4548fff023e32856$var$debug.bind(console, method, ns);
        return logger;
    }, {});
}
$4548fff023e32856$var$namespace.level = (newLevel)=>{
    $4548fff023e32856$var$level = newLevel;
};
$4548fff023e32856$var$debug.level = $4548fff023e32856$var$namespace.level;
var $4548fff023e32856$export$2e2bcd8739ae039 = $4548fff023e32856$var$namespace;


const $427c503a5337bba7$var$debug = (0, $4548fff023e32856$export$2e2bcd8739ae039)("quill:events");
const $427c503a5337bba7$var$EVENTS = [
    "selectionchange",
    "mousedown",
    "mouseup",
    "click"
];
$427c503a5337bba7$var$EVENTS.forEach((eventName)=>{
    document.addEventListener(eventName, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        Array.from(document.querySelectorAll(".ql-container")).forEach((node)=>{
            const quill = (0, $a7445250980710a7$export$2e2bcd8739ae039).get(node);
            if (quill && quill.emitter) quill.emitter.handleDOM(...args);
        });
    });
});
class $427c503a5337bba7$var$Emitter extends (0, $5bcfbf153438b60f$exports.EventEmitter) {
    static events = {
        EDITOR_CHANGE: "editor-change",
        SCROLL_BEFORE_UPDATE: "scroll-before-update",
        SCROLL_BLOT_MOUNT: "scroll-blot-mount",
        SCROLL_BLOT_UNMOUNT: "scroll-blot-unmount",
        SCROLL_OPTIMIZE: "scroll-optimize",
        SCROLL_UPDATE: "scroll-update",
        SCROLL_EMBED_UPDATE: "scroll-embed-update",
        SELECTION_CHANGE: "selection-change",
        TEXT_CHANGE: "text-change",
        COMPOSITION_BEFORE_START: "composition-before-start",
        COMPOSITION_START: "composition-start",
        COMPOSITION_BEFORE_END: "composition-before-end",
        COMPOSITION_END: "composition-end"
    };
    static sources = {
        API: "api",
        SILENT: "silent",
        USER: "user"
    };
    constructor(){
        super();
        this.domListeners = {};
        this.on("error", $427c503a5337bba7$var$debug.error);
    }
    emit() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $427c503a5337bba7$var$debug.log.call($427c503a5337bba7$var$debug, ...args);
        // @ts-expect-error
        return super.emit(...args);
    }
    handleDOM(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        (this.domListeners[event.type] || []).forEach((_ref)=>{
            let { node: node, handler: handler } = _ref;
            if (event.target === node || node.contains(event.target)) handler(event, ...args);
        });
    }
    listenDOM(eventName, node, handler) {
        if (!this.domListeners[eventName]) this.domListeners[eventName] = [];
        this.domListeners[eventName].push({
            node: node,
            handler: handler
        });
    }
}
var $427c503a5337bba7$export$2e2bcd8739ae039 = $427c503a5337bba7$var$Emitter;



const $da439b8df62e063a$var$debug = (0, $4548fff023e32856$export$2e2bcd8739ae039)("quill:selection");
class $da439b8df62e063a$export$9a58ef0d7ad3278c {
    constructor(index){
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.index = index;
        this.length = length;
    }
}
class $da439b8df62e063a$var$Selection {
    constructor(scroll, emitter){
        this.emitter = emitter;
        this.scroll = scroll;
        this.composing = false;
        this.mouseDown = false;
        this.root = this.scroll.domNode;
        // @ts-expect-error
        this.cursor = this.scroll.create("cursor", this);
        // savedRange is last non-null range
        this.savedRange = new $da439b8df62e063a$export$9a58ef0d7ad3278c(0, 0);
        this.lastRange = this.savedRange;
        this.lastNative = null;
        this.handleComposition();
        this.handleDragging();
        this.emitter.listenDOM("selectionchange", document, ()=>{
            if (!this.mouseDown && !this.composing) setTimeout(this.update.bind(this, (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER), 1);
        });
        this.emitter.on((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, ()=>{
            if (!this.hasFocus()) return;
            const native = this.getNativeRange();
            if (native == null) return;
            if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
            this.emitter.once((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
                try {
                    if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                    const triggeredByTyping = mutations.some((mutation)=>mutation.type === "characterData" || mutation.type === "childList" || mutation.type === "attributes" && mutation.target === this.root);
                    this.update(triggeredByTyping ? (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.SILENT : source);
                } catch (ignored) {
                // ignore
                }
            });
        });
        this.emitter.on((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations, context)=>{
            if (context.range) {
                const { startNode: startNode, startOffset: startOffset, endNode: endNode, endOffset: endOffset } = context.range;
                this.setNativeRange(startNode, startOffset, endNode, endOffset);
                this.update((0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.SILENT);
            }
        });
        this.update((0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.SILENT);
    }
    handleComposition() {
        this.emitter.on((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.composing = true;
        });
        this.emitter.on((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.COMPOSITION_END, ()=>{
            this.composing = false;
            if (this.cursor.parent) {
                const range = this.cursor.restore();
                if (!range) return;
                setTimeout(()=>{
                    this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
            }
        });
    }
    handleDragging() {
        this.emitter.listenDOM("mousedown", document.body, ()=>{
            this.mouseDown = true;
        });
        this.emitter.listenDOM("mouseup", document.body, ()=>{
            this.mouseDown = false;
            this.update((0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER);
        });
    }
    focus() {
        if (this.hasFocus()) return;
        this.root.focus({
            preventScroll: true
        });
        this.setRange(this.savedRange);
    }
    format(format, value) {
        this.scroll.update();
        const nativeRange = this.getNativeRange();
        if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK)) return;
        if (nativeRange.start.node !== this.cursor.textNode) {
            const blot = this.scroll.find(nativeRange.start.node, false);
            if (blot == null) return;
            // TODO Give blot ability to not split
            if (blot instanceof (0, $4617b32e1de5ada7$export$7420b9c542181544)) {
                const after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
            } else // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
            blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
            this.cursor.attach();
        }
        this.cursor.format(format, value);
        this.scroll.optimize();
        this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
        this.update();
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const scrollLength = this.scroll.length();
        index = Math.min(index, scrollLength - 1);
        length = Math.min(index + length, scrollLength - 1) - index;
        let node;
        let [leaf, offset] = this.scroll.leaf(index);
        if (leaf == null) return null;
        if (length > 0 && offset === leaf.length()) {
            const [next] = this.scroll.leaf(index + 1);
            if (next) {
                const [line] = this.scroll.line(index);
                const [nextLine] = this.scroll.line(index + 1);
                if (line === nextLine) {
                    leaf = next;
                    offset = 0;
                }
            }
        }
        [node, offset] = leaf.position(offset, true);
        const range = document.createRange();
        if (length > 0) {
            range.setStart(node, offset);
            [leaf, offset] = this.scroll.leaf(index + length);
            if (leaf == null) return null;
            [node, offset] = leaf.position(offset, true);
            range.setEnd(node, offset);
            return range.getBoundingClientRect();
        }
        let side = "left";
        let rect;
        if (node instanceof Text) {
            // Return null if the text node is empty because it is
            // not able to get a useful client rect:
            // https://github.com/w3c/csswg-drafts/issues/2514.
            // Empty text nodes are most likely caused by TextBlot#optimize()
            // not getting called when editor content changes.
            if (!node.data.length) return null;
            if (offset < node.data.length) {
                range.setStart(node, offset);
                range.setEnd(node, offset + 1);
            } else {
                range.setStart(node, offset - 1);
                range.setEnd(node, offset);
                side = "right";
            }
            rect = range.getBoundingClientRect();
        } else {
            if (!(leaf.domNode instanceof Element)) return null;
            rect = leaf.domNode.getBoundingClientRect();
            if (offset > 0) side = "right";
        }
        return {
            bottom: rect.top + rect.height,
            height: rect.height,
            left: rect[side],
            right: rect[side],
            top: rect.top,
            width: 0
        };
    }
    getNativeRange() {
        const selection = document.getSelection();
        if (selection == null || selection.rangeCount <= 0) return null;
        const nativeRange = selection.getRangeAt(0);
        if (nativeRange == null) return null;
        const range = this.normalizeNative(nativeRange);
        $da439b8df62e063a$var$debug.info("getNativeRange", range);
        return range;
    }
    getRange() {
        const root = this.scroll.domNode;
        if ("isConnected" in root && !root.isConnected) // document.getSelection() forces layout on Blink, so we trend to
        // not calling it.
        return [
            null,
            null
        ];
        const normalized = this.getNativeRange();
        if (normalized == null) return [
            null,
            null
        ];
        const range = this.normalizedToRange(normalized);
        return [
            range,
            normalized
        ];
    }
    hasFocus() {
        return document.activeElement === this.root || document.activeElement != null && $da439b8df62e063a$var$contains(this.root, document.activeElement);
    }
    normalizedToRange(range) {
        const positions = [
            [
                range.start.node,
                range.start.offset
            ]
        ];
        if (!range.native.collapsed) positions.push([
            range.end.node,
            range.end.offset
        ]);
        const indexes = positions.map((position)=>{
            const [node, offset] = position;
            const blot = this.scroll.find(node, true);
            // @ts-expect-error Fix me later
            const index = blot.offset(this.scroll);
            if (offset === 0) return index;
            if (blot instanceof (0, $4617b32e1de5ada7$export$7420b9c542181544)) return index + blot.index(node, offset);
            // @ts-expect-error Fix me later
            return index + blot.length();
        });
        const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
        const start = Math.min(end, ...indexes);
        return new $da439b8df62e063a$export$9a58ef0d7ad3278c(start, end - start);
    }
    normalizeNative(nativeRange) {
        if (!$da439b8df62e063a$var$contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !$da439b8df62e063a$var$contains(this.root, nativeRange.endContainer)) return null;
        const range = {
            start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
            },
            end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
            },
            native: nativeRange
        };
        [
            range.start,
            range.end
        ].forEach((position)=>{
            let { node: node, offset: offset } = position;
            while(!(node instanceof Text) && node.childNodes.length > 0){
                if (node.childNodes.length > offset) {
                    node = node.childNodes[offset];
                    offset = 0;
                } else if (node.childNodes.length === offset) {
                    // @ts-expect-error Fix me later
                    node = node.lastChild;
                    if (node instanceof Text) offset = node.data.length;
                    else if (node.childNodes.length > 0) // Container case
                    offset = node.childNodes.length;
                    else // Embed case
                    offset = node.childNodes.length + 1;
                } else break;
            }
            position.node = node;
            position.offset = offset;
        });
        return range;
    }
    rangeToNative(range) {
        const scrollLength = this.scroll.length();
        const getPosition = (index, inclusive)=>{
            index = Math.min(scrollLength - 1, index);
            const [leaf, leafOffset] = this.scroll.leaf(index);
            return leaf ? leaf.position(leafOffset, inclusive) : [
                null,
                -1
            ];
        };
        return [
            ...getPosition(range.index, false),
            ...getPosition(range.index + range.length, true)
        ];
    }
    setNativeRange(startNode, startOffset) {
        let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
        let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
        let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $da439b8df62e063a$var$debug.info("setNativeRange", startNode, startOffset, endNode, endOffset);
        if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || // @ts-expect-error Fix me later
        endNode.parentNode == null)) return;
        const selection = document.getSelection();
        if (selection == null) return;
        if (startNode != null) {
            if (!this.hasFocus()) this.root.focus({
                preventScroll: true
            });
            const { native: native } = this.getNativeRange() || {};
            if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                if (startNode instanceof Element && startNode.tagName === "BR") {
                    // @ts-expect-error Fix me later
                    startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
                    startNode = startNode.parentNode;
                }
                if (endNode instanceof Element && endNode.tagName === "BR") {
                    // @ts-expect-error Fix me later
                    endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
                    endNode = endNode.parentNode;
                }
                const range = document.createRange();
                // @ts-expect-error Fix me later
                range.setStart(startNode, startOffset);
                // @ts-expect-error Fix me later
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } else {
            selection.removeAllRanges();
            this.root.blur();
        }
    }
    setRange(range) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.API;
        if (typeof force === "string") {
            source = force;
            force = false;
        }
        $da439b8df62e063a$var$debug.info("setRange", range);
        if (range != null) {
            const args = this.rangeToNative(range);
            this.setNativeRange(...args, force);
        } else this.setNativeRange(null);
        this.update(source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER;
        const oldRange = this.lastRange;
        const [lastRange, nativeRange] = this.getRange();
        this.lastRange = lastRange;
        this.lastNative = nativeRange;
        if (this.lastRange != null) this.savedRange = this.lastRange;
        if (!(0, $969c2efa807ab995$export$2e2bcd8739ae039)(oldRange, this.lastRange)) {
            if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                const range = this.cursor.restore();
                if (range) this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
            }
            const args = [
                (0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SELECTION_CHANGE,
                (0, $7b7037edc7b00187$export$2e2bcd8739ae039)(this.lastRange),
                (0, $7b7037edc7b00187$export$2e2bcd8739ae039)(oldRange),
                source
            ];
            this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
            if (source !== (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
        }
    }
}
function $da439b8df62e063a$var$contains(parent, descendant) {
    try {
        // Firefox inserts inaccessible nodes around video elements
        descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
    } catch (e) {
        return false;
    }
    return parent.contains(descendant);
}
var $da439b8df62e063a$export$2e2bcd8739ae039 = $da439b8df62e063a$var$Selection;


const $f6bbdd56f38b3b8b$var$ASCII = /^[ -~]*$/;
class $f6bbdd56f38b3b8b$var$Editor {
    constructor(scroll){
        this.scroll = scroll;
        this.delta = this.getDelta();
    }
    applyDelta(delta) {
        this.scroll.update();
        let scrollLength = this.scroll.length();
        this.scroll.batchStart();
        const normalizedDelta = $f6bbdd56f38b3b8b$var$normalizeDelta(delta);
        const deleteDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))();
        const normalizedOps = $f6bbdd56f38b3b8b$var$splitOpLines(normalizedDelta.ops.slice());
        normalizedOps.reduce((index, op)=>{
            const length = (0, $5cea9abc67034d4a$exports.Op).length(op);
            let attributes = op.attributes || {};
            let isImplicitNewlinePrepended = false;
            let isImplicitNewlineAppended = false;
            if (op.insert != null) {
                deleteDelta.retain(length);
                if (typeof op.insert === "string") {
                    const text = op.insert;
                    isImplicitNewlineAppended = !text.endsWith("\n") && (scrollLength <= index || !!this.scroll.descendant((0, $0b2398fdb319908b$export$48b9f0688962d028), index)[0]);
                    this.scroll.insertAt(index, text);
                    const [line, offset] = this.scroll.line(index);
                    let formats = (0, $f1bd5ef7b2b6a87a$export$2e2bcd8739ae039)({}, (0, $0b2398fdb319908b$export$e4bb5a6163449612)(line));
                    if (line instanceof (0, $0b2398fdb319908b$export$2e2bcd8739ae039)) {
                        const [leaf] = line.descendant((0, $4617b32e1de5ada7$export$7420b9c542181544), offset);
                        if (leaf) formats = (0, $f1bd5ef7b2b6a87a$export$2e2bcd8739ae039)(formats, (0, $0b2398fdb319908b$export$e4bb5a6163449612)(leaf));
                    }
                    attributes = (0, $5cea9abc67034d4a$exports.AttributeMap).diff(formats, attributes) || {};
                } else if (typeof op.insert === "object") {
                    const key = Object.keys(op.insert)[0]; // There should only be one key
                    if (key == null) return index;
                    const isInlineEmbed = this.scroll.query(key, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE) != null;
                    if (isInlineEmbed) {
                        if (scrollLength <= index || !!this.scroll.descendant((0, $0b2398fdb319908b$export$48b9f0688962d028), index)[0]) isImplicitNewlineAppended = true;
                    } else if (index > 0) {
                        const [leaf, offset] = this.scroll.descendant((0, $4617b32e1de5ada7$export$7420b9c542181544), index - 1);
                        if (leaf instanceof (0, $725c99fa2d4b9334$export$2e2bcd8739ae039)) {
                            const text = leaf.value();
                            if (text[offset] !== "\n") isImplicitNewlinePrepended = true;
                        } else if (leaf instanceof (0, $4617b32e1de5ada7$export$297a1fa96f55f00f) && leaf.statics.scope === (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE_BLOT) isImplicitNewlinePrepended = true;
                    }
                    this.scroll.insertAt(index, key, op.insert[key]);
                    if (isInlineEmbed) {
                        const [leaf] = this.scroll.descendant((0, $4617b32e1de5ada7$export$7420b9c542181544), index);
                        if (leaf) {
                            const formats = (0, $f1bd5ef7b2b6a87a$export$2e2bcd8739ae039)({}, (0, $0b2398fdb319908b$export$e4bb5a6163449612)(leaf));
                            attributes = (0, $5cea9abc67034d4a$exports.AttributeMap).diff(formats, attributes) || {};
                        }
                    }
                }
                scrollLength += length;
            } else {
                deleteDelta.push(op);
                if (op.retain !== null && typeof op.retain === "object") {
                    const key = Object.keys(op.retain)[0];
                    if (key == null) return index;
                    this.scroll.updateEmbedAt(index, key, op.retain[key]);
                }
            }
            Object.keys(attributes).forEach((name)=>{
                this.scroll.formatAt(index, length, name, attributes[name]);
            });
            const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
            const addedLength = isImplicitNewlineAppended ? 1 : 0;
            scrollLength += prependedLength + addedLength;
            deleteDelta.retain(prependedLength);
            deleteDelta.delete(addedLength);
            return index + length + prependedLength + addedLength;
        }, 0);
        deleteDelta.reduce((index, op)=>{
            if (typeof op.delete === "number") {
                this.scroll.deleteAt(index, op.delete);
                return index;
            }
            return index + (0, $5cea9abc67034d4a$exports.Op).length(op);
        }, 0);
        this.scroll.batchEnd();
        this.scroll.optimize();
        return this.update(normalizedDelta);
    }
    deleteText(index, length) {
        this.scroll.deleteAt(index, length);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(index).delete(length));
    }
    formatLine(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.scroll.update();
        Object.keys(formats).forEach((format)=>{
            this.scroll.lines(index, Math.max(length, 1)).forEach((line)=>{
                line.format(format, formats[format]);
            });
        });
        this.scroll.optimize();
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(index).retain(length, (0, $7b7037edc7b00187$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    formatText(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, length, format, formats[format]);
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(index).retain(length, (0, $7b7037edc7b00187$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    getContents(index, length) {
        return this.delta.slice(index, index + length);
    }
    getDelta() {
        return this.scroll.lines().reduce((delta, line)=>{
            return delta.concat(line.delta());
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))());
    }
    getFormat(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let lines = [];
        let leaves = [];
        if (length === 0) this.scroll.path(index).forEach((path)=>{
            const [blot] = path;
            if (blot instanceof (0, $0b2398fdb319908b$export$2e2bcd8739ae039)) lines.push(blot);
            else if (blot instanceof (0, $4617b32e1de5ada7$export$7420b9c542181544)) leaves.push(blot);
        });
        else {
            lines = this.scroll.lines(index, length);
            leaves = this.scroll.descendants((0, $4617b32e1de5ada7$export$7420b9c542181544), index, length);
        }
        const [lineFormats, leafFormats] = [
            lines,
            leaves
        ].map((blots)=>{
            const blot = blots.shift();
            if (blot == null) return {};
            let formats = (0, $0b2398fdb319908b$export$e4bb5a6163449612)(blot);
            while(Object.keys(formats).length > 0){
                const blot = blots.shift();
                if (blot == null) return formats;
                formats = $f6bbdd56f38b3b8b$var$combineFormats((0, $0b2398fdb319908b$export$e4bb5a6163449612)(blot), formats);
            }
            return formats;
        });
        return {
            ...lineFormats,
            ...leafFormats
        };
    }
    getHTML(index, length) {
        const [line, lineOffset] = this.scroll.line(index);
        if (line) {
            const lineLength = line.length();
            const isWithinLine = line.length() >= lineOffset + length;
            if (isWithinLine && !(lineOffset === 0 && length === lineLength)) return $f6bbdd56f38b3b8b$var$convertHTML(line, lineOffset, length, true);
            return $f6bbdd56f38b3b8b$var$convertHTML(this.scroll, index, length, true);
        }
        return "";
    }
    getText(index, length) {
        return this.getContents(index, length).filter((op)=>typeof op.insert === "string").map((op)=>op.insert).join("");
    }
    insertContents(index, contents) {
        const normalizedDelta = $f6bbdd56f38b3b8b$var$normalizeDelta(contents);
        const change = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(index).concat(normalizedDelta);
        this.scroll.insertContents(index, normalizedDelta);
        return this.update(change);
    }
    insertEmbed(index, embed, value) {
        this.scroll.insertAt(index, embed, value);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(index).insert({
            [embed]: value
        }));
    }
    insertText(index, text) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        text = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        this.scroll.insertAt(index, text);
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, text.length, format, formats[format]);
        });
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(index).insert(text, (0, $7b7037edc7b00187$export$2e2bcd8739ae039)(formats)));
    }
    isBlank() {
        if (this.scroll.children.length === 0) return true;
        if (this.scroll.children.length > 1) return false;
        const blot = this.scroll.children.head;
        if (blot?.statics.blotName !== (0, $0b2398fdb319908b$export$2e2bcd8739ae039).blotName) return false;
        const block = blot;
        if (block.children.length > 1) return false;
        return block.children.head instanceof (0, $55d7c792844fdf31$export$2e2bcd8739ae039);
    }
    removeFormat(index, length) {
        const text = this.getText(index, length);
        const [line, offset] = this.scroll.line(index + length);
        let suffixLength = 0;
        let suffix = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))();
        if (line != null) {
            suffixLength = line.length() - offset;
            suffix = line.delta().slice(offset, offset + suffixLength - 1).insert("\n");
        }
        const contents = this.getContents(index, length + suffixLength);
        const diff = contents.diff(new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().insert(text).concat(suffix));
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(index).concat(diff);
        return this.applyDelta(delta);
    }
    update(change) {
        let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        const oldDelta = this.delta;
        if (mutations.length === 1 && mutations[0].type === "characterData" && // @ts-expect-error Fix me later
        mutations[0].target.data.match($f6bbdd56f38b3b8b$var$ASCII) && this.scroll.find(mutations[0].target)) {
            // Optimization for character changes
            const textBlot = this.scroll.find(mutations[0].target);
            const formats = (0, $0b2398fdb319908b$export$e4bb5a6163449612)(textBlot);
            const index = textBlot.offset(this.scroll);
            // @ts-expect-error Fix me later
            const oldValue = mutations[0].oldValue.replace((0, $4df559780cba7baa$export$2e2bcd8739ae039).CONTENTS, "");
            const oldText = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().insert(oldValue);
            // @ts-expect-error
            const newText = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().insert(textBlot.value());
            const relativeSelectionInfo = selectionInfo && {
                oldRange: $f6bbdd56f38b3b8b$var$shiftRange(selectionInfo.oldRange, -index),
                newRange: $f6bbdd56f38b3b8b$var$shiftRange(selectionInfo.newRange, -index)
            };
            const diffDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
            change = diffDelta.reduce((delta, op)=>{
                if (op.insert) return delta.insert(op.insert, formats);
                return delta.push(op);
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))());
            this.delta = oldDelta.compose(change);
        } else {
            this.delta = this.getDelta();
            if (!change || !(0, $969c2efa807ab995$export$2e2bcd8739ae039)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, selectionInfo);
        }
        return change;
    }
}
function $f6bbdd56f38b3b8b$var$convertListHTML(items, lastIndent, types) {
    if (items.length === 0) {
        const [endTag] = $f6bbdd56f38b3b8b$var$getListType(types.pop());
        if (lastIndent <= 0) return `</li></${endTag}>`;
        return `</li></${endTag}>${$f6bbdd56f38b3b8b$var$convertListHTML([], lastIndent - 1, types)}`;
    }
    const [{ child: child, offset: offset, length: length, indent: indent, type: type }, ...rest] = items;
    const [tag, attribute] = $f6bbdd56f38b3b8b$var$getListType(type);
    if (indent > lastIndent) {
        types.push(type);
        if (indent === lastIndent + 1) return `<${tag}><li${attribute}>${$f6bbdd56f38b3b8b$var$convertHTML(child, offset, length)}${$f6bbdd56f38b3b8b$var$convertListHTML(rest, indent, types)}`;
        return `<${tag}><li>${$f6bbdd56f38b3b8b$var$convertListHTML(items, lastIndent + 1, types)}`;
    }
    const previousType = types[types.length - 1];
    if (indent === lastIndent && type === previousType) return `</li><li${attribute}>${$f6bbdd56f38b3b8b$var$convertHTML(child, offset, length)}${$f6bbdd56f38b3b8b$var$convertListHTML(rest, indent, types)}`;
    const [endTag] = $f6bbdd56f38b3b8b$var$getListType(types.pop());
    return `</li></${endTag}>${$f6bbdd56f38b3b8b$var$convertListHTML(items, lastIndent - 1, types)}`;
}
function $f6bbdd56f38b3b8b$var$convertHTML(blot, index, length) {
    let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if ("html" in blot && typeof blot.html === "function") return blot.html(index, length);
    if (blot instanceof (0, $725c99fa2d4b9334$export$2e2bcd8739ae039)) return (0, $725c99fa2d4b9334$export$96e6fc3a139b2555)(blot.value().slice(index, index + length));
    if (blot instanceof (0, $4617b32e1de5ada7$export$e43113f0aad76fe)) {
        // TODO fix API
        if (blot.statics.blotName === "list-container") {
            const items = [];
            blot.children.forEachAt(index, length, (child, offset, childLength)=>{
                const formats = "formats" in child && typeof child.formats === "function" ? child.formats() : {};
                items.push({
                    child: child,
                    offset: offset,
                    length: childLength,
                    indent: formats.indent || 0,
                    type: formats.list
                });
            });
            return $f6bbdd56f38b3b8b$var$convertListHTML(items, -1, []);
        }
        const parts = [];
        blot.children.forEachAt(index, length, (child, offset, childLength)=>{
            parts.push($f6bbdd56f38b3b8b$var$convertHTML(child, offset, childLength));
        });
        if (isRoot || blot.statics.blotName === "list") return parts.join("");
        const { outerHTML: outerHTML, innerHTML: innerHTML } = blot.domNode;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        // TODO cleanup
        if (start === "<table") return `<table style="border: 1px solid #000;">${parts.join("")}<${end}`;
        return `${start}>${parts.join("")}<${end}`;
    }
    return blot.domNode instanceof Element ? blot.domNode.outerHTML : "";
}
function $f6bbdd56f38b3b8b$var$combineFormats(formats, combined) {
    return Object.keys(combined).reduce((merged, name)=>{
        if (formats[name] == null) return merged;
        const combinedValue = combined[name];
        if (combinedValue === formats[name]) merged[name] = combinedValue;
        else if (Array.isArray(combinedValue)) {
            if (combinedValue.indexOf(formats[name]) < 0) merged[name] = combinedValue.concat([
                formats[name]
            ]);
            else // If style already exists, don't add to an array, but don't lose other styles
            merged[name] = combinedValue;
        } else merged[name] = [
            combinedValue,
            formats[name]
        ];
        return merged;
    }, {});
}
function $f6bbdd56f38b3b8b$var$getListType(type) {
    const tag = type === "ordered" ? "ol" : "ul";
    switch(type){
        case "checked":
            return [
                tag,
                ' data-list="checked"'
            ];
        case "unchecked":
            return [
                tag,
                ' data-list="unchecked"'
            ];
        default:
            return [
                tag,
                ""
            ];
    }
}
function $f6bbdd56f38b3b8b$var$normalizeDelta(delta) {
    return delta.reduce((normalizedDelta, op)=>{
        if (typeof op.insert === "string") {
            const text = op.insert.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
            return normalizedDelta.insert(text, op.attributes);
        }
        return normalizedDelta.push(op);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))());
}
function $f6bbdd56f38b3b8b$var$shiftRange(_ref, amount) {
    let { index: index, length: length } = _ref;
    return new (0, $da439b8df62e063a$export$9a58ef0d7ad3278c)(index + amount, length);
}
function $f6bbdd56f38b3b8b$var$splitOpLines(ops) {
    const split = [];
    ops.forEach((op)=>{
        if (typeof op.insert === "string") {
            const lines = op.insert.split("\n");
            lines.forEach((line, index)=>{
                if (index) split.push({
                    insert: "\n",
                    attributes: op.attributes
                });
                if (line) split.push({
                    insert: line,
                    attributes: op.attributes
                });
            });
        } else split.push(op);
    });
    return split;
}
var $f6bbdd56f38b3b8b$export$2e2bcd8739ae039 = $f6bbdd56f38b3b8b$var$Editor;





class $cdd9fa07e4762b38$var$Module {
    static DEFAULTS = {};
    constructor(quill){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.quill = quill;
        this.options = options;
    }
}
var $cdd9fa07e4762b38$export$2e2bcd8739ae039 = $cdd9fa07e4762b38$var$Module;





const $96e5a527124b0524$var$GUARD_TEXT = "\uFEFF";
class $96e5a527124b0524$var$Embed extends (0, $4617b32e1de5ada7$export$297a1fa96f55f00f) {
    constructor(scroll, node){
        super(scroll, node);
        this.contentNode = document.createElement("span");
        this.contentNode.setAttribute("contenteditable", "false");
        Array.from(this.domNode.childNodes).forEach((childNode)=>{
            this.contentNode.appendChild(childNode);
        });
        this.leftGuard = document.createTextNode($96e5a527124b0524$var$GUARD_TEXT);
        this.rightGuard = document.createTextNode($96e5a527124b0524$var$GUARD_TEXT);
        this.domNode.appendChild(this.leftGuard);
        this.domNode.appendChild(this.contentNode);
        this.domNode.appendChild(this.rightGuard);
    }
    index(node, offset) {
        if (node === this.leftGuard) return 0;
        if (node === this.rightGuard) return 1;
        return super.index(node, offset);
    }
    restore(node) {
        let range = null;
        let textNode;
        const text = node.data.split($96e5a527124b0524$var$GUARD_TEXT).join("");
        if (node === this.leftGuard) {
            if (this.prev instanceof (0, $725c99fa2d4b9334$export$2e2bcd8739ae039)) {
                const prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                    startNode: this.prev.domNode,
                    startOffset: prevLength + text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        } else if (node === this.rightGuard) {
            if (this.next instanceof (0, $725c99fa2d4b9334$export$2e2bcd8739ae039)) {
                this.next.insertAt(0, text);
                range = {
                    startNode: this.next.domNode,
                    startOffset: text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this.next);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        }
        node.data = $96e5a527124b0524$var$GUARD_TEXT;
        return range;
    }
    update(mutations, context) {
        mutations.forEach((mutation)=>{
            if (mutation.type === "characterData" && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
                const range = this.restore(mutation.target);
                if (range) context.range = range;
            }
        });
    }
}
var $96e5a527124b0524$export$2e2bcd8739ae039 = $96e5a527124b0524$var$Embed;



class $8e7065cf24d1dc88$var$Composition {
    isComposing = false;
    constructor(scroll, emitter){
        this.scroll = scroll;
        this.emitter = emitter;
        this.setupListeners();
    }
    setupListeners() {
        this.scroll.domNode.addEventListener("compositionstart", (event)=>{
            if (!this.isComposing) this.handleCompositionStart(event);
        });
        this.scroll.domNode.addEventListener("compositionend", (event)=>{
            if (this.isComposing) // Webkit makes DOM changes after compositionend, so we use microtask to
            // ensure the order.
            // https://bugs.webkit.org/show_bug.cgi?id=31902
            queueMicrotask(()=>{
                this.handleCompositionEnd(event);
            });
        });
    }
    handleCompositionStart(event) {
        const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
        if (blot && !(blot instanceof (0, $96e5a527124b0524$export$2e2bcd8739ae039))) {
            this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, event);
            this.scroll.batchStart();
            this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.COMPOSITION_START, event);
            this.isComposing = true;
        }
    }
    handleCompositionEnd(event) {
        this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_END, event);
        this.scroll.batchEnd();
        this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.COMPOSITION_END, event);
        this.isComposing = false;
    }
}
var $8e7065cf24d1dc88$export$2e2bcd8739ae039 = $8e7065cf24d1dc88$var$Composition;


class $a5d391299f891d74$var$Theme {
    static DEFAULTS = {
        modules: {}
    };
    static themes = {
        default: $a5d391299f891d74$var$Theme
    };
    modules = {};
    constructor(quill, options){
        this.quill = quill;
        this.options = options;
    }
    init() {
        Object.keys(this.options.modules).forEach((name)=>{
            if (this.modules[name] == null) this.addModule(name);
        });
    }
    addModule(name) {
        // @ts-expect-error
        const ModuleClass = this.quill.constructor.import(`modules/${name}`);
        this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
        return this.modules[name];
    }
}
var $a5d391299f891d74$export$2e2bcd8739ae039 = $a5d391299f891d74$var$Theme;


const $b42514112d9791f5$var$getParentElement = (element)=>element.parentElement || element.getRootNode().host || null;
const $b42514112d9791f5$var$getElementRect = (element)=>{
    const rect = element.getBoundingClientRect();
    const scaleX = "offsetWidth" in element && Math.abs(rect.width) / element.offsetWidth || 1;
    const scaleY = "offsetHeight" in element && Math.abs(rect.height) / element.offsetHeight || 1;
    return {
        top: rect.top,
        right: rect.left + element.clientWidth * scaleX,
        bottom: rect.top + element.clientHeight * scaleY,
        left: rect.left
    };
};
const $b42514112d9791f5$var$paddingValueToInt = (value)=>{
    const number = parseInt(value, 10);
    return Number.isNaN(number) ? 0 : number;
};
// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
// assuming that the scroll option is set to 'nearest'.
const $b42514112d9791f5$var$getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd)=>{
    if (targetStart < scrollStart && targetEnd > scrollEnd) return 0;
    if (targetStart < scrollStart) return -(scrollStart - targetStart + scrollPaddingStart);
    if (targetEnd > scrollEnd) return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
    return 0;
};
const $b42514112d9791f5$var$scrollRectIntoView = (root, targetRect)=>{
    const document = root.ownerDocument;
    let rect = targetRect;
    let current = root;
    while(current){
        const isDocumentBody = current === document.body;
        const bounding = isDocumentBody ? {
            top: 0,
            right: window.visualViewport?.width ?? document.documentElement.clientWidth,
            bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
            left: 0
        } : $b42514112d9791f5$var$getElementRect(current);
        const style = getComputedStyle(current);
        const scrollDistanceX = $b42514112d9791f5$var$getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, $b42514112d9791f5$var$paddingValueToInt(style.scrollPaddingLeft), $b42514112d9791f5$var$paddingValueToInt(style.scrollPaddingRight));
        const scrollDistanceY = $b42514112d9791f5$var$getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, $b42514112d9791f5$var$paddingValueToInt(style.scrollPaddingTop), $b42514112d9791f5$var$paddingValueToInt(style.scrollPaddingBottom));
        if (scrollDistanceX || scrollDistanceY) {
            if (isDocumentBody) document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
            else {
                const { scrollLeft: scrollLeft, scrollTop: scrollTop } = current;
                if (scrollDistanceY) current.scrollTop += scrollDistanceY;
                if (scrollDistanceX) current.scrollLeft += scrollDistanceX;
                const scrolledLeft = current.scrollLeft - scrollLeft;
                const scrolledTop = current.scrollTop - scrollTop;
                rect = {
                    left: rect.left - scrolledLeft,
                    top: rect.top - scrolledTop,
                    right: rect.right - scrolledLeft,
                    bottom: rect.bottom - scrolledTop
                };
            }
        }
        current = isDocumentBody || style.position === "fixed" ? null : $b42514112d9791f5$var$getParentElement(current);
    }
};
var $b42514112d9791f5$export$2e2bcd8739ae039 = $b42514112d9791f5$var$scrollRectIntoView;



const $76039bbdf840fe06$var$MAX_REGISTER_ITERATIONS = 100;
const $76039bbdf840fe06$var$CORE_FORMATS = [
    "block",
    "break",
    "cursor",
    "inline",
    "scroll",
    "text"
];
const $76039bbdf840fe06$var$createRegistryWithFormats = (formats, sourceRegistry, debug)=>{
    const registry = new (0, $4617b32e1de5ada7$export$4d9facee29974f3)();
    $76039bbdf840fe06$var$CORE_FORMATS.forEach((name)=>{
        const coreBlot = sourceRegistry.query(name);
        if (coreBlot) registry.register(coreBlot);
    });
    formats.forEach((name)=>{
        let format = sourceRegistry.query(name);
        if (!format) debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
        let iterations = 0;
        while(format){
            registry.register(format);
            format = "blotName" in format ? format.requiredContainer ?? null : null;
            iterations += 1;
            if (iterations > $76039bbdf840fe06$var$MAX_REGISTER_ITERATIONS) {
                debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
                break;
            }
        }
    });
    return registry;
};
var $76039bbdf840fe06$export$2e2bcd8739ae039 = $76039bbdf840fe06$var$createRegistryWithFormats;


const $a10f3bd4ce427c01$var$debug = (0, $4548fff023e32856$export$2e2bcd8739ae039)("quill");
const $a10f3bd4ce427c01$export$bc58ce2776ecdb6f = new $4617b32e1de5ada7$exports.Registry();
$4617b32e1de5ada7$exports.ParentBlot.uiClass = "ql-ui";
/**
 * Options for initializing a Quill instance
 */ /**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */ class $a10f3bd4ce427c01$export$2e2bcd8739ae039 {
    static DEFAULTS = {
        bounds: null,
        modules: {
            clipboard: true,
            keyboard: true,
            history: true,
            uploader: true
        },
        placeholder: "",
        readOnly: false,
        registry: $a10f3bd4ce427c01$export$bc58ce2776ecdb6f,
        theme: "default"
    };
    static events = (0, $427c503a5337bba7$export$2e2bcd8739ae039).events;
    static sources = (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources;
    static version = "2.0.2";
    static imports = {
        delta: (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports))),
        parchment: $4617b32e1de5ada7$exports,
        "core/module": (0, $cdd9fa07e4762b38$export$2e2bcd8739ae039),
        "core/theme": (0, $a5d391299f891d74$export$2e2bcd8739ae039)
    };
    static debug(limit) {
        if (limit === true) limit = "log";
        (0, $4548fff023e32856$export$2e2bcd8739ae039).level(limit);
    }
    static find(node) {
        let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return (0, $a7445250980710a7$export$2e2bcd8739ae039).get(node) || $a10f3bd4ce427c01$export$bc58ce2776ecdb6f.find(node, bubble);
    }
    static import(name) {
        if (this.imports[name] == null) $a10f3bd4ce427c01$var$debug.error(`Cannot import ${name}. Are you sure it was registered?`);
        return this.imports[name];
    }
    static register() {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== "string") {
            const target = arguments.length <= 0 ? undefined : arguments[0];
            const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
            const name = "attrName" in target ? target.attrName : target.blotName;
            if (typeof name === "string") // Shortcut for formats:
            // register(Blot | Attributor, overwrite)
            this.register(`formats/${name}`, target, overwrite);
            else Object.keys(target).forEach((key)=>{
                this.register(key, target[key], overwrite);
            });
        } else {
            const path = arguments.length <= 0 ? undefined : arguments[0];
            const target = arguments.length <= 1 ? undefined : arguments[1];
            const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
            if (this.imports[path] != null && !overwrite) $a10f3bd4ce427c01$var$debug.warn(`Overwriting ${path} with`, target);
            this.imports[path] = target;
            if ((path.startsWith("blots/") || path.startsWith("formats/")) && target && typeof target !== "boolean" && target.blotName !== "abstract") $a10f3bd4ce427c01$export$bc58ce2776ecdb6f.register(target);
            if (typeof target.register === "function") target.register($a10f3bd4ce427c01$export$bc58ce2776ecdb6f);
        }
    }
    constructor(container){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = $a10f3bd4ce427c01$export$72ab7189806b6df5(container, options);
        this.container = this.options.container;
        if (this.container == null) {
            $a10f3bd4ce427c01$var$debug.error("Invalid Quill container", container);
            return;
        }
        if (this.options.debug) $a10f3bd4ce427c01$export$2e2bcd8739ae039.debug(this.options.debug);
        const html = this.container.innerHTML.trim();
        this.container.classList.add("ql-container");
        this.container.innerHTML = "";
        (0, $a7445250980710a7$export$2e2bcd8739ae039).set(this.container, this);
        this.root = this.addContainer("ql-editor");
        this.root.classList.add("ql-blank");
        this.emitter = new (0, $427c503a5337bba7$export$2e2bcd8739ae039)();
        const scrollBlotName = $4617b32e1de5ada7$exports.ScrollBlot.blotName;
        const ScrollBlot = this.options.registry.query(scrollBlotName);
        if (!ScrollBlot || !("blotName" in ScrollBlot)) throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
        this.scroll = new ScrollBlot(this.options.registry, this.root, {
            emitter: this.emitter
        });
        this.editor = new (0, $f6bbdd56f38b3b8b$export$2e2bcd8739ae039)(this.scroll);
        this.selection = new (0, $da439b8df62e063a$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.composition = new (0, $8e7065cf24d1dc88$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
        this.keyboard = this.theme.addModule("keyboard");
        this.clipboard = this.theme.addModule("clipboard");
        this.history = this.theme.addModule("history");
        this.uploader = this.theme.addModule("uploader");
        this.theme.addModule("input");
        this.theme.addModule("uiNode");
        this.theme.init();
        this.emitter.on((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type)=>{
            if (type === (0, $427c503a5337bba7$export$2e2bcd8739ae039).events.TEXT_CHANGE) this.root.classList.toggle("ql-blank", this.editor.isBlank());
        });
        this.emitter.on((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $a10f3bd4ce427c01$var$modify.call(this, ()=>this.editor.update(null, mutations, selectionInfo), source);
        });
        this.emitter.on((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, (blot, delta)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $a10f3bd4ce427c01$var$modify.call(this, ()=>{
                const change = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(blot.offset(this)).retain({
                    [blot.statics.blotName]: delta
                });
                return this.editor.update(change, [], selectionInfo);
            }, $a10f3bd4ce427c01$export$2e2bcd8739ae039.sources.USER);
        });
        if (html) {
            const contents = this.clipboard.convert({
                html: `${html}<p><br></p>`,
                text: "\n"
            });
            this.setContents(contents);
        }
        this.history.clear();
        if (this.options.placeholder) this.root.setAttribute("data-placeholder", this.options.placeholder);
        if (this.options.readOnly) this.disable();
        this.allowReadOnlyEdits = false;
    }
    addContainer(container) {
        let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof container === "string") {
            const className = container;
            container = document.createElement("div");
            container.classList.add(className);
        }
        this.container.insertBefore(container, refNode);
        return container;
    }
    blur() {
        this.selection.setRange(null);
    }
    deleteText(index, length, source) {
        // @ts-expect-error
        [index, length, , source] = $a10f3bd4ce427c01$export$e336952123c0bccd(index, length, source);
        return $a10f3bd4ce427c01$var$modify.call(this, ()=>{
            return this.editor.deleteText(index, length);
        }, source, index, -1 * length);
    }
    disable() {
        this.enable(false);
    }
    editReadOnly(modifier) {
        this.allowReadOnlyEdits = true;
        const value = modifier();
        this.allowReadOnlyEdits = false;
        return value;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.scroll.enable(enabled);
        this.container.classList.toggle("ql-disabled", !enabled);
    }
    focus() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.selection.focus();
        if (!options.preventScroll) this.scrollSelectionIntoView();
    }
    format(name, value) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.API;
        return $a10f3bd4ce427c01$var$modify.call(this, ()=>{
            const range = this.getSelection(true);
            let change = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))();
            if (range == null) return change;
            if (this.scroll.query(name, $4617b32e1de5ada7$exports.Scope.BLOCK)) change = this.editor.formatLine(range.index, range.length, {
                [name]: value
            });
            else if (range.length === 0) {
                this.selection.format(name, value);
                return change;
            } else change = this.editor.formatText(range.index, range.length, {
                [name]: value
            });
            this.setSelection(range, (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.SILENT);
            return change;
        }, source);
    }
    formatLine(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $a10f3bd4ce427c01$export$e336952123c0bccd(index, length, // @ts-expect-error
        name, value, source);
        return $a10f3bd4ce427c01$var$modify.call(this, ()=>{
            return this.editor.formatLine(index, length, formats);
        }, source, index, 0);
    }
    formatText(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $a10f3bd4ce427c01$export$e336952123c0bccd(// @ts-expect-error
        index, length, name, value, source);
        return $a10f3bd4ce427c01$var$modify.call(this, ()=>{
            return this.editor.formatText(index, length, formats);
        }, source, index, 0);
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let bounds = null;
        if (typeof index === "number") bounds = this.selection.getBounds(index, length);
        else bounds = this.selection.getBounds(index.index, index.length);
        if (!bounds) return null;
        const containerBounds = this.container.getBoundingClientRect();
        return {
            bottom: bounds.bottom - containerBounds.top,
            height: bounds.height,
            left: bounds.left - containerBounds.left,
            right: bounds.right - containerBounds.left,
            top: bounds.top - containerBounds.top,
            width: bounds.width
        };
    }
    getContents() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
        [index, length] = $a10f3bd4ce427c01$export$e336952123c0bccd(index, length);
        return this.editor.getContents(index, length);
    }
    getFormat() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof index === "number") return this.editor.getFormat(index, length);
        return this.editor.getFormat(index.index, index.length);
    }
    getIndex(blot) {
        return blot.offset(this.scroll);
    }
    getLength() {
        return this.scroll.length();
    }
    getLeaf(index) {
        return this.scroll.leaf(index);
    }
    getLine(index) {
        return this.scroll.line(index);
    }
    getLines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        if (typeof index !== "number") return this.scroll.lines(index.index, index.length);
        return this.scroll.lines(index, length);
    }
    getModule(name) {
        return this.theme.modules[name];
    }
    getSelection() {
        let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (focus) this.focus();
        this.update(); // Make sure we access getRange with editor in consistent state
        return this.selection.getRange()[0];
    }
    getSemanticHTML() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === "number") length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $a10f3bd4ce427c01$export$e336952123c0bccd(index, length);
        return this.editor.getHTML(index, length);
    }
    getText() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === "number") length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $a10f3bd4ce427c01$export$e336952123c0bccd(index, length);
        return this.editor.getText(index, length);
    }
    hasFocus() {
        return this.selection.hasFocus();
    }
    insertEmbed(index, embed, value) {
        let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $a10f3bd4ce427c01$export$2e2bcd8739ae039.sources.API;
        return $a10f3bd4ce427c01$var$modify.call(this, ()=>{
            return this.editor.insertEmbed(index, embed, value);
        }, source, index);
    }
    insertText(index, text, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        // @ts-expect-error
        [index, , formats, source] = $a10f3bd4ce427c01$export$e336952123c0bccd(index, 0, name, value, source);
        return $a10f3bd4ce427c01$var$modify.call(this, ()=>{
            return this.editor.insertText(index, text, formats);
        }, source, index, text.length);
    }
    isEnabled() {
        return this.scroll.isEnabled();
    }
    off() {
        return this.emitter.off(...arguments);
    }
    on() {
        return this.emitter.on(...arguments);
    }
    once() {
        return this.emitter.once(...arguments);
    }
    removeFormat(index, length, source) {
        [index, length, , source] = $a10f3bd4ce427c01$export$e336952123c0bccd(index, length, source);
        return $a10f3bd4ce427c01$var$modify.call(this, ()=>{
            return this.editor.removeFormat(index, length);
        }, source, index);
    }
    scrollRectIntoView(rect) {
        (0, $b42514112d9791f5$export$2e2bcd8739ae039)(this.root, rect);
    }
    /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */ scrollIntoView() {
        console.warn("Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.");
        this.scrollSelectionIntoView();
    }
    /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */ scrollSelectionIntoView() {
        const range = this.selection.lastRange;
        const bounds = range && this.selection.getBounds(range.index, range.length);
        if (bounds) this.scrollRectIntoView(bounds);
    }
    setContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.API;
        return $a10f3bd4ce427c01$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))(delta);
            const length = this.getLength();
            // Quill will set empty editor to \n
            const delete1 = this.editor.deleteText(0, length);
            const applied = this.editor.insertContents(0, delta);
            // Remove extra \n from empty editor initialization
            const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
            return delete1.compose(applied).compose(delete2);
        }, source);
    }
    setSelection(index, length, source) {
        if (index == null) // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || $a10f3bd4ce427c01$export$2e2bcd8739ae039.sources.API);
        else {
            // @ts-expect-error
            [index, length, , source] = $a10f3bd4ce427c01$export$e336952123c0bccd(index, length, source);
            this.selection.setRange(new (0, $da439b8df62e063a$export$9a58ef0d7ad3278c)(Math.max(0, index), length), source);
            if (source !== (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.SILENT) this.scrollSelectionIntoView();
        }
    }
    setText(text) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.API;
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().insert(text);
        return this.setContents(delta, source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER;
        const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
        this.selection.update(source);
        // TODO this is usually undefined
        return change;
    }
    updateContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.API;
        return $a10f3bd4ce427c01$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))(delta);
            return this.editor.applyDelta(delta);
        }, source, true);
    }
}
function $a10f3bd4ce427c01$var$resolveSelector(selector) {
    return typeof selector === "string" ? document.querySelector(selector) : selector;
}
function $a10f3bd4ce427c01$var$expandModuleConfig(config) {
    return Object.entries(config ?? {}).reduce((expanded, _ref)=>{
        let [key, value] = _ref;
        return {
            ...expanded,
            [key]: value === true ? {} : value
        };
    }, {});
}
function $a10f3bd4ce427c01$var$omitUndefinedValuesFromOptions(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>entry[1] !== undefined));
}
function $a10f3bd4ce427c01$export$72ab7189806b6df5(containerOrSelector, options) {
    const container = $a10f3bd4ce427c01$var$resolveSelector(containerOrSelector);
    if (!container) throw new Error("Invalid Quill container");
    const shouldUseDefaultTheme = !options.theme || options.theme === $a10f3bd4ce427c01$export$2e2bcd8739ae039.DEFAULTS.theme;
    const theme = shouldUseDefaultTheme ? (0, $a5d391299f891d74$export$2e2bcd8739ae039) : $a10f3bd4ce427c01$export$2e2bcd8739ae039.import(`themes/${options.theme}`);
    if (!theme) throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
    const { modules: quillModuleDefaults, ...quillDefaults } = $a10f3bd4ce427c01$export$2e2bcd8739ae039.DEFAULTS;
    const { modules: themeModuleDefaults, ...themeDefaults } = theme.DEFAULTS;
    let userModuleOptions = $a10f3bd4ce427c01$var$expandModuleConfig(options.modules);
    // Special case toolbar shorthand
    if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) userModuleOptions = {
        ...userModuleOptions,
        toolbar: {
            container: userModuleOptions.toolbar
        }
    };
    const modules = (0, $f1bd5ef7b2b6a87a$export$2e2bcd8739ae039)({}, $a10f3bd4ce427c01$var$expandModuleConfig(quillModuleDefaults), $a10f3bd4ce427c01$var$expandModuleConfig(themeModuleDefaults), userModuleOptions);
    const config = {
        ...quillDefaults,
        ...$a10f3bd4ce427c01$var$omitUndefinedValuesFromOptions(themeDefaults),
        ...$a10f3bd4ce427c01$var$omitUndefinedValuesFromOptions(options)
    };
    let registry = options.registry;
    if (registry) {
        if (options.formats) $a10f3bd4ce427c01$var$debug.warn('Ignoring "formats" option because "registry" is specified');
    } else registry = options.formats ? (0, $76039bbdf840fe06$export$2e2bcd8739ae039)(options.formats, config.registry, $a10f3bd4ce427c01$var$debug) : config.registry;
    return {
        ...config,
        registry: registry,
        container: container,
        theme: theme,
        modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2)=>{
            let [name, value] = _ref2;
            if (!value) return modulesWithDefaults;
            const moduleClass = $a10f3bd4ce427c01$export$2e2bcd8739ae039.import(`modules/${name}`);
            if (moduleClass == null) {
                $a10f3bd4ce427c01$var$debug.error(`Cannot load ${name} module. Are you sure you registered it?`);
                return modulesWithDefaults;
            }
            return {
                ...modulesWithDefaults,
                // @ts-expect-error
                [name]: (0, $f1bd5ef7b2b6a87a$export$2e2bcd8739ae039)({}, moduleClass.DEFAULTS || {}, value)
            };
        }, {}),
        bounds: $a10f3bd4ce427c01$var$resolveSelector(config.bounds)
    };
}
// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function $a10f3bd4ce427c01$var$modify(modifier, source, index, shift) {
    if (!this.isEnabled() && source === (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER && !this.allowReadOnlyEdits) return new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))();
    let range = index == null ? null : this.getSelection();
    const oldDelta = this.editor.delta;
    const change = modifier();
    if (range != null) {
        if (index === true) index = range.index; // eslint-disable-line prefer-destructuring
        if (shift == null) range = $a10f3bd4ce427c01$var$shiftRange(range, change, source);
        else if (shift !== 0) // @ts-expect-error index should always be number
        range = $a10f3bd4ce427c01$var$shiftRange(range, index, shift, source);
        this.setSelection(range, (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.SILENT);
    }
    if (change.length() > 0) {
        const args = [
            (0, $427c503a5337bba7$export$2e2bcd8739ae039).events.TEXT_CHANGE,
            change,
            oldDelta,
            source
        ];
        this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
        if (source !== (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
    }
    return change;
}
function $a10f3bd4ce427c01$export$e336952123c0bccd(index, length, name, value, source) {
    let formats = {};
    // @ts-expect-error
    if (typeof index.index === "number" && typeof index.length === "number") {
        // Allow for throwaway end (used by insertText/insertEmbed)
        if (typeof length !== "number") {
            // @ts-expect-error
            source = value;
            value = name;
            name = length;
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        } else {
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        }
    } else if (typeof length !== "number") {
        // @ts-expect-error
        source = value;
        value = name;
        name = length;
        length = 0;
    }
    // Handle format being object, two format name/value strings or excluded
    if (typeof name === "object") {
        // @ts-expect-error Fix me later
        formats = name;
        // @ts-expect-error
        source = value;
    } else if (typeof name === "string") {
        if (value != null) formats[name] = value;
        else // @ts-expect-error
        source = name;
    }
    // Handle optional source
    source = source || (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.API;
    // @ts-expect-error
    return [
        index,
        length,
        formats,
        source
    ];
}
function $a10f3bd4ce427c01$var$shiftRange(range, index, lengthOrSource, source) {
    const length = typeof lengthOrSource === "number" ? lengthOrSource : 0;
    if (range == null) return null;
    let start;
    let end;
    // @ts-expect-error -- TODO: add a better type guard around `index`
    if (index && typeof index.transformPosition === "function") [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>// @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER));
    else [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>{
        // @ts-expect-error -- TODO: add a better type guard around `index`
        if (pos < index || pos === index && source === (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER) return pos;
        if (length >= 0) return pos + length;
        // @ts-expect-error -- TODO: add a better type guard around `index`
        return Math.max(index, pos + length);
    });
    return new (0, $da439b8df62e063a$export$9a58ef0d7ad3278c)(start, end - start);
}





class $c85e381b4b7319fe$var$Container extends (0, $4617b32e1de5ada7$export$c898d510319704c0) {
}
var $c85e381b4b7319fe$export$2e2bcd8739ae039 = $c85e381b4b7319fe$var$Container;











function $292dfb5df194549e$var$isLine(blot) {
    return blot instanceof (0, $0b2398fdb319908b$export$2e2bcd8739ae039) || blot instanceof (0, $0b2398fdb319908b$export$48b9f0688962d028);
}
function $292dfb5df194549e$var$isUpdatable(blot) {
    return typeof blot.updateContent === "function";
}
class $292dfb5df194549e$var$Scroll extends (0, $4617b32e1de5ada7$export$7175329dad7a46f1) {
    static blotName = "scroll";
    static className = "ql-editor";
    static tagName = "DIV";
    static defaultChild = (0, $0b2398fdb319908b$export$2e2bcd8739ae039);
    static allowedChildren = [
        (0, $0b2398fdb319908b$export$2e2bcd8739ae039),
        (0, $0b2398fdb319908b$export$48b9f0688962d028),
        (0, $c85e381b4b7319fe$export$2e2bcd8739ae039)
    ];
    constructor(registry, domNode, _ref){
        let { emitter: emitter } = _ref;
        super(registry, domNode);
        this.emitter = emitter;
        this.batch = false;
        this.optimize();
        this.enable();
        this.domNode.addEventListener("dragstart", (e)=>this.handleDragStart(e));
    }
    batchStart() {
        if (!Array.isArray(this.batch)) this.batch = [];
    }
    batchEnd() {
        if (!this.batch) return;
        const mutations = this.batch;
        this.batch = false;
        this.update(mutations);
    }
    emitMount(blot) {
        this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, blot);
    }
    emitUnmount(blot) {
        this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_BLOT_UNMOUNT, blot);
    }
    emitEmbedUpdate(blot, change) {
        this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, blot, change);
    }
    deleteAt(index, length) {
        const [first, offset] = this.line(index);
        const [last] = this.line(index + length);
        super.deleteAt(index, length);
        if (last != null && first !== last && offset > 0) {
            if (first instanceof (0, $0b2398fdb319908b$export$48b9f0688962d028) || last instanceof (0, $0b2398fdb319908b$export$48b9f0688962d028)) {
                this.optimize();
                return;
            }
            const ref = last.children.head instanceof (0, $55d7c792844fdf31$export$2e2bcd8739ae039) ? null : last.children.head;
            // @ts-expect-error
            first.moveChildren(last, ref);
            // @ts-expect-error
            first.remove();
        }
        this.optimize();
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.domNode.setAttribute("contenteditable", enabled ? "true" : "false");
    }
    formatAt(index, length, format, value) {
        super.formatAt(index, length, format, value);
        this.optimize();
    }
    insertAt(index, value, def) {
        if (index >= this.length()) {
            if (def == null || this.scroll.query(value, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK) == null) {
                const blot = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(blot);
                if (def == null && value.endsWith("\n")) blot.insertAt(0, value.slice(0, -1), def);
                else blot.insertAt(0, value, def);
            } else {
                const embed = this.scroll.create(value, def);
                this.appendChild(embed);
            }
        } else super.insertAt(index, value, def);
        this.optimize();
    }
    insertBefore(blot, ref) {
        if (blot.statics.scope === (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE_BLOT) {
            const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
            wrapper.appendChild(blot);
            super.insertBefore(wrapper, ref);
        } else super.insertBefore(blot, ref);
    }
    insertContents(index, delta) {
        const renderBlocks = this.deltaToRenderBlocks(delta.concat(new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().insert("\n")));
        const last = renderBlocks.pop();
        if (last == null) return;
        this.batchStart();
        const first = renderBlocks.shift();
        if (first) {
            const shouldInsertNewlineChar = first.type === "block" && (first.delta.length() === 0 || !this.descendant((0, $0b2398fdb319908b$export$48b9f0688962d028), index)[0] && index < this.length());
            const delta = first.type === "block" ? first.delta : new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().insert({
                [first.key]: first.value
            });
            $292dfb5df194549e$var$insertInlineContents(this, index, delta);
            const newlineCharLength = first.type === "block" ? 1 : 0;
            const lineEndIndex = index + delta.length() + newlineCharLength;
            if (shouldInsertNewlineChar) this.insertAt(lineEndIndex - 1, "\n");
            const formats = (0, $0b2398fdb319908b$export$e4bb5a6163449612)(this.line(index)[0]);
            const attributes = (0, $5cea9abc67034d4a$exports.AttributeMap).diff(formats, first.attributes) || {};
            Object.keys(attributes).forEach((name)=>{
                this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
            });
            index = lineEndIndex;
        }
        let [refBlot, refBlotOffset] = this.children.find(index);
        if (renderBlocks.length) {
            if (refBlot) {
                refBlot = refBlot.split(refBlotOffset);
                refBlotOffset = 0;
            }
            renderBlocks.forEach((renderBlock)=>{
                if (renderBlock.type === "block") {
                    const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
                    $292dfb5df194549e$var$insertInlineContents(block, 0, renderBlock.delta);
                } else {
                    const blockEmbed = this.create(renderBlock.key, renderBlock.value);
                    this.insertBefore(blockEmbed, refBlot || undefined);
                    Object.keys(renderBlock.attributes).forEach((name)=>{
                        blockEmbed.format(name, renderBlock.attributes[name]);
                    });
                }
            });
        }
        if (last.type === "block" && last.delta.length()) {
            const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
            $292dfb5df194549e$var$insertInlineContents(this, offset, last.delta);
        }
        this.batchEnd();
        this.optimize();
    }
    isEnabled() {
        return this.domNode.getAttribute("contenteditable") === "true";
    }
    leaf(index) {
        const last = this.path(index).pop();
        if (!last) return [
            null,
            -1
        ];
        const [blot, offset] = last;
        return blot instanceof (0, $4617b32e1de5ada7$export$7420b9c542181544) ? [
            blot,
            offset
        ] : [
            null,
            -1
        ];
    }
    line(index) {
        if (index === this.length()) return this.line(index - 1);
        // @ts-expect-error TODO: make descendant() generic
        return this.descendant($292dfb5df194549e$var$isLine, index);
    }
    lines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        const getLines = (blot, blotIndex, blotLength)=>{
            let lines = [];
            let lengthLeft = blotLength;
            blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength)=>{
                if ($292dfb5df194549e$var$isLine(child)) lines.push(child);
                else if (child instanceof (0, $4617b32e1de5ada7$export$c898d510319704c0)) lines = lines.concat(getLines(child, childIndex, lengthLeft));
                lengthLeft -= childLength;
            });
            return lines;
        };
        return getLines(this, index, length);
    }
    optimize() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.batch) return;
        super.optimize(mutations, context);
        if (mutations.length > 0) this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, mutations, context);
    }
    path(index) {
        return super.path(index).slice(1); // Exclude self
    }
    remove() {
    // Never remove self
    }
    update(mutations) {
        if (this.batch) {
            if (Array.isArray(mutations)) this.batch = this.batch.concat(mutations);
            return;
        }
        let source = (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER;
        if (typeof mutations === "string") source = mutations;
        if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
        mutations = mutations.filter((_ref2)=>{
            let { target: target } = _ref2;
            const blot = this.find(target, true);
            return blot && !$292dfb5df194549e$var$isUpdatable(blot);
        });
        if (mutations.length > 0) this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, source, mutations);
        super.update(mutations.concat([])); // pass copy
        if (mutations.length > 0) this.emitter.emit((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_UPDATE, source, mutations);
    }
    updateEmbedAt(index, key, change) {
        // Currently it only supports top-level embeds (BlockEmbed).
        // We can update `ParentBlot` in parchment to support inline embeds.
        const [blot] = this.descendant((b)=>b instanceof (0, $0b2398fdb319908b$export$48b9f0688962d028), index);
        if (blot && blot.statics.blotName === key && $292dfb5df194549e$var$isUpdatable(blot)) blot.updateContent(change);
    }
    handleDragStart(event) {
        event.preventDefault();
    }
    deltaToRenderBlocks(delta) {
        const renderBlocks = [];
        let currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))();
        delta.forEach((op)=>{
            const insert = op?.insert;
            if (!insert) return;
            if (typeof insert === "string") {
                const splitted = insert.split("\n");
                splitted.slice(0, -1).forEach((text)=>{
                    currentBlockDelta.insert(text, op.attributes);
                    renderBlocks.push({
                        type: "block",
                        delta: currentBlockDelta,
                        attributes: op.attributes ?? {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))();
                });
                const last = splitted[splitted.length - 1];
                if (last) currentBlockDelta.insert(last, op.attributes);
            } else {
                const key = Object.keys(insert)[0];
                if (!key) return;
                if (this.query(key, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE)) currentBlockDelta.push(op);
                else {
                    if (currentBlockDelta.length()) renderBlocks.push({
                        type: "block",
                        delta: currentBlockDelta,
                        attributes: {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))();
                    renderBlocks.push({
                        type: "blockEmbed",
                        key: key,
                        value: insert[key],
                        attributes: op.attributes ?? {}
                    });
                }
            }
        });
        if (currentBlockDelta.length()) renderBlocks.push({
            type: "block",
            delta: currentBlockDelta,
            attributes: {}
        });
        return renderBlocks;
    }
    createBlock(attributes, refBlot) {
        let blotName;
        const formats = {};
        Object.entries(attributes).forEach((_ref3)=>{
            let [key, value] = _ref3;
            const isBlockBlot = this.query(key, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK & (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOT) != null;
            if (isBlockBlot) blotName = key;
            else formats[key] = value;
        });
        const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
        this.insertBefore(block, refBlot || undefined);
        const length = block.length();
        Object.entries(formats).forEach((_ref4)=>{
            let [key, value] = _ref4;
            block.formatAt(0, length, key, value);
        });
        return block;
    }
}
function $292dfb5df194549e$var$insertInlineContents(parent, index, inlineContents) {
    inlineContents.reduce((index, op)=>{
        const length = (0, $5cea9abc67034d4a$exports.Op).length(op);
        let attributes = op.attributes || {};
        if (op.insert != null) {
            if (typeof op.insert === "string") {
                const text = op.insert;
                parent.insertAt(index, text);
                const [leaf] = parent.descendant((0, $4617b32e1de5ada7$export$7420b9c542181544), index);
                const formats = (0, $0b2398fdb319908b$export$e4bb5a6163449612)(leaf);
                attributes = (0, $5cea9abc67034d4a$exports.AttributeMap).diff(formats, attributes) || {};
            } else if (typeof op.insert === "object") {
                const key = Object.keys(op.insert)[0]; // There should only be one key
                if (key == null) return index;
                parent.insertAt(index, key, op.insert[key]);
                const isInlineEmbed = parent.scroll.query(key, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE) != null;
                if (isInlineEmbed) {
                    const [leaf] = parent.descendant((0, $4617b32e1de5ada7$export$7420b9c542181544), index);
                    const formats = (0, $0b2398fdb319908b$export$e4bb5a6163449612)(leaf);
                    attributes = (0, $5cea9abc67034d4a$exports.AttributeMap).diff(formats, attributes) || {};
                }
            }
        }
        Object.keys(attributes).forEach((key)=>{
            parent.formatAt(index, length, key, attributes[key]);
        });
        return index + length;
    }, index);
}
var $292dfb5df194549e$export$2e2bcd8739ae039 = $292dfb5df194549e$var$Scroll;










const $337ca6b70475fd89$var$config = {
    scope: (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        "right",
        "center",
        "justify"
    ]
};
const $337ca6b70475fd89$export$2ef0f9fb04a51388 = new (0, $4617b32e1de5ada7$export$217610c4183502d0)("align", "align", $337ca6b70475fd89$var$config);
const $337ca6b70475fd89$export$7f3685f5846c07da = new (0, $4617b32e1de5ada7$export$651d45509677cf07)("align", "ql-align", $337ca6b70475fd89$var$config);
const $337ca6b70475fd89$export$d2060f5d114c9fe8 = new (0, $4617b32e1de5ada7$export$7c8099bbfe87b94d)("align", "text-align", $337ca6b70475fd89$var$config);




class $8c6ac1207aa6a978$export$c992e3369f248f6e extends (0, $4617b32e1de5ada7$export$7c8099bbfe87b94d) {
    value(domNode) {
        let value = super.value(domNode);
        if (!value.startsWith("rgb(")) return value;
        value = value.replace(/^[^\d]+/, "").replace(/[^\d]+$/, "");
        const hex = value.split(",").map((component)=>`00${parseInt(component, 10).toString(16)}`.slice(-2)).join("");
        return `#${hex}`;
    }
}
const $8c6ac1207aa6a978$export$42795dcf0ec6f3c8 = new (0, $4617b32e1de5ada7$export$651d45509677cf07)("color", "ql-color", {
    scope: (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE
});
const $8c6ac1207aa6a978$export$1415f56796d9a5a9 = new $8c6ac1207aa6a978$export$c992e3369f248f6e("color", "color", {
    scope: (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE
});


const $b2d8f55b55dc7dde$export$8aa96c8963152b12 = new (0, $4617b32e1de5ada7$export$651d45509677cf07)("background", "ql-bg", {
    scope: (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE
});
const $b2d8f55b55dc7dde$export$dc1cbcab4c682ef = new (0, $8c6ac1207aa6a978$export$c992e3369f248f6e)("background", "background-color", {
    scope: (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE
});









class $77064d128953548d$export$3b131632d3d15165 extends (0, $c85e381b4b7319fe$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        domNode.setAttribute("spellcheck", "false");
        return domNode;
    }
    code(index, length) {
        return this.children// @ts-expect-error
        .map((child)=>child.length() <= 1 ? "" : child.domNode.innerText).join("\n").slice(index, index + length);
    }
    html(index, length) {
        // `\n`s are needed in order to support empty lines at the beginning and the end.
        // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
        return `<pre>\n${(0, $725c99fa2d4b9334$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
}
class $77064d128953548d$export$2e2bcd8739ae039 extends (0, $0b2398fdb319908b$export$2e2bcd8739ae039) {
    static TAB = "  ";
    static register() {
        (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).register($77064d128953548d$export$3b131632d3d15165);
    }
}
class $77064d128953548d$export$52f0f02147b12c03 extends (0, $6713b0f866164989$export$2e2bcd8739ae039) {
}
$77064d128953548d$export$52f0f02147b12c03.blotName = "code";
$77064d128953548d$export$52f0f02147b12c03.tagName = "CODE";
$77064d128953548d$export$2e2bcd8739ae039.blotName = "code-block";
$77064d128953548d$export$2e2bcd8739ae039.className = "ql-code-block";
$77064d128953548d$export$2e2bcd8739ae039.tagName = "DIV";
$77064d128953548d$export$3b131632d3d15165.blotName = "code-block-container";
$77064d128953548d$export$3b131632d3d15165.className = "ql-code-block-container";
$77064d128953548d$export$3b131632d3d15165.tagName = "DIV";
$77064d128953548d$export$3b131632d3d15165.allowedChildren = [
    $77064d128953548d$export$2e2bcd8739ae039
];
$77064d128953548d$export$2e2bcd8739ae039.allowedChildren = [
    (0, $725c99fa2d4b9334$export$2e2bcd8739ae039),
    (0, $55d7c792844fdf31$export$2e2bcd8739ae039),
    (0, $4df559780cba7baa$export$2e2bcd8739ae039)
];
$77064d128953548d$export$2e2bcd8739ae039.requiredContainer = $77064d128953548d$export$3b131632d3d15165;




const $05731c47851567d5$var$config = {
    scope: (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        "rtl"
    ]
};
const $05731c47851567d5$export$4158215dafad9efa = new (0, $4617b32e1de5ada7$export$217610c4183502d0)("direction", "dir", $05731c47851567d5$var$config);
const $05731c47851567d5$export$630028b3af294dec = new (0, $4617b32e1de5ada7$export$651d45509677cf07)("direction", "ql-direction", $05731c47851567d5$var$config);
const $05731c47851567d5$export$175979e518d1dfd1 = new (0, $4617b32e1de5ada7$export$7c8099bbfe87b94d)("direction", "direction", $05731c47851567d5$var$config);



const $37324b3d3c9fa7f2$var$config = {
    scope: (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE,
    whitelist: [
        "serif",
        "monospace"
    ]
};
const $37324b3d3c9fa7f2$export$78a99ee601572ab = new (0, $4617b32e1de5ada7$export$651d45509677cf07)("font", "ql-font", $37324b3d3c9fa7f2$var$config);
class $37324b3d3c9fa7f2$var$FontStyleAttributor extends (0, $4617b32e1de5ada7$export$7c8099bbfe87b94d) {
    value(node) {
        return super.value(node).replace(/["']/g, "");
    }
}
const $37324b3d3c9fa7f2$export$23b468d4ca3f8c96 = new $37324b3d3c9fa7f2$var$FontStyleAttributor("font", "font-family", $37324b3d3c9fa7f2$var$config);



const $5af457acd7848d59$export$c84684d52bca9684 = new (0, $4617b32e1de5ada7$export$651d45509677cf07)("size", "ql-size", {
    scope: (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE,
    whitelist: [
        "small",
        "large",
        "huge"
    ]
});
const $5af457acd7848d59$export$5443b95a30e89ac5 = new (0, $4617b32e1de5ada7$export$7c8099bbfe87b94d)("size", "font-size", {
    scope: (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE,
    whitelist: [
        "10px",
        "18px",
        "32px"
    ]
});








const $827a064b715d18b6$var$debug = (0, $4548fff023e32856$export$2e2bcd8739ae039)("quill:keyboard");
const $827a064b715d18b6$export$34a157fc58f3dd07 = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey";
class $827a064b715d18b6$export$2e2bcd8739ae039 extends (0, $cdd9fa07e4762b38$export$2e2bcd8739ae039) {
    static match(evt, binding) {
        if ([
            "altKey",
            "ctrlKey",
            "metaKey",
            "shiftKey"
        ].some((key)=>{
            return !!binding[key] !== evt[key] && binding[key] !== null;
        })) return false;
        return binding.key === evt.key || binding.key === evt.which;
    }
    constructor(quill, options){
        super(quill, options);
        this.bindings = {};
        // @ts-expect-error Fix me later
        Object.keys(this.options.bindings).forEach((name)=>{
            // @ts-expect-error Fix me later
            if (this.options.bindings[name]) // @ts-expect-error Fix me later
            this.addBinding(this.options.bindings[name]);
        });
        this.addBinding({
            key: "Enter",
            shiftKey: null
        }, this.handleEnter);
        this.addBinding({
            key: "Enter",
            metaKey: null,
            ctrlKey: null,
            altKey: null
        }, ()=>{});
        if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            this.addBinding({
                key: "Backspace"
            }, {
                collapsed: true
            }, this.handleBackspace);
            this.addBinding({
                key: "Delete"
            }, {
                collapsed: true
            }, this.handleDelete);
        } else {
            this.addBinding({
                key: "Backspace"
            }, {
                collapsed: true,
                prefix: /^.?$/
            }, this.handleBackspace);
            this.addBinding({
                key: "Delete"
            }, {
                collapsed: true,
                suffix: /^.?$/
            }, this.handleDelete);
        }
        this.addBinding({
            key: "Backspace"
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: "Delete"
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: "Backspace",
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
        }, {
            collapsed: true,
            offset: 0
        }, this.handleBackspace);
        this.listen();
    }
    addBinding(keyBinding) {
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const binding = $827a064b715d18b6$export$a3295358bff77e(keyBinding);
        if (binding == null) {
            $827a064b715d18b6$var$debug.warn("Attempted to add invalid keyboard binding", binding);
            return;
        }
        if (typeof context === "function") context = {
            handler: context
        };
        if (typeof handler === "function") handler = {
            handler: handler
        };
        const keys = Array.isArray(binding.key) ? binding.key : [
            binding.key
        ];
        keys.forEach((key)=>{
            const singleBinding = {
                ...binding,
                key: key,
                ...context,
                ...handler
            };
            this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
            this.bindings[singleBinding.key].push(singleBinding);
        });
    }
    listen() {
        this.quill.root.addEventListener("keydown", (evt)=>{
            if (evt.defaultPrevented || evt.isComposing) return;
            // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            const isComposing = evt.keyCode === 229 && (evt.key === "Enter" || evt.key === "Backspace");
            if (isComposing) return;
            const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
            const matches = bindings.filter((binding)=>$827a064b715d18b6$export$2e2bcd8739ae039.match(evt, binding));
            if (matches.length === 0) return;
            // @ts-expect-error
            const blot = (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).find(evt.target, true);
            if (blot && blot.scroll !== this.quill.scroll) return;
            const range = this.quill.getSelection();
            if (range == null || !this.quill.hasFocus()) return;
            const [line, offset] = this.quill.getLine(range.index);
            const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
            const [leafEnd, offsetEnd] = range.length === 0 ? [
                leafStart,
                offsetStart
            ] : this.quill.getLeaf(range.index + range.length);
            const prefixText = leafStart instanceof (0, $4617b32e1de5ada7$export$10ac0c5716409de6) ? leafStart.value().slice(0, offsetStart) : "";
            const suffixText = leafEnd instanceof (0, $4617b32e1de5ada7$export$10ac0c5716409de6) ? leafEnd.value().slice(offsetEnd) : "";
            const curContext = {
                collapsed: range.length === 0,
                // @ts-expect-error Fix me later
                empty: range.length === 0 && line.length() <= 1,
                format: this.quill.getFormat(range),
                line: line,
                offset: offset,
                prefix: prefixText,
                suffix: suffixText,
                event: evt
            };
            const prevented = matches.some((binding)=>{
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                    // any format is present
                    if (binding.format.every((name)=>curContext.format[name] == null)) return false;
                } else if (typeof binding.format === "object") {
                    // all formats must match
                    if (!Object.keys(binding.format).every((name)=>{
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === true) return curContext.format[name] != null;
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === false) return curContext.format[name] == null;
                        // @ts-expect-error Fix me later
                        return (0, $969c2efa807ab995$export$2e2bcd8739ae039)(binding.format[name], curContext.format[name]);
                    })) return false;
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                // @ts-expect-error Fix me later
                return binding.handler.call(this, range, curContext, binding) !== true;
            });
            if (prevented) evt.preventDefault();
        });
    }
    handleBackspace(range, context) {
        // Check for astral symbols
        const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        if (range.index === 0 || this.quill.getLength() <= 1) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(range.index - length).delete(length);
        if (context.offset === 0) {
            // Always deleting newline here, length always 1
            const [prev] = this.quill.getLine(range.index - 1);
            if (prev) {
                const isPrevLineEmpty = prev.statics.blotName === "block" && prev.length() <= 1;
                if (!isPrevLineEmpty) {
                    // @ts-expect-error Fix me later
                    const curFormats = line.formats();
                    const prevFormats = this.quill.getFormat(range.index - 1, 1);
                    formats = (0, $5cea9abc67034d4a$exports.AttributeMap).diff(curFormats, prevFormats) || {};
                    if (Object.keys(formats).length > 0) {
                        // line.length() - 1 targets \n in line, another -1 for newline being deleted
                        const formatDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - 2).retain(1, formats);
                        delta = delta.compose(formatDelta);
                    }
                }
            }
        }
        this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDelete(range, context) {
        // Check for astral symbols
        const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(range.index).delete(length);
        // @ts-expect-error Fix me later
        if (context.offset >= line.length() - 1) {
            const [next] = this.quill.getLine(range.index + 1);
            if (next) {
                // @ts-expect-error Fix me later
                const curFormats = line.formats();
                const nextFormats = this.quill.getFormat(range.index, 1);
                formats = (0, $5cea9abc67034d4a$exports.AttributeMap).diff(curFormats, nextFormats) || {};
                if (Object.keys(formats).length > 0) delta = delta.retain(next.length() - 1).retain(1, formats);
            }
        }
        this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDeleteRange(range) {
        $827a064b715d18b6$export$a6c813797f379898({
            range: range,
            quill: this.quill
        });
        this.quill.focus();
    }
    handleEnter(range, context) {
        const lineFormats = Object.keys(context.format).reduce((formats, format)=>{
            if (this.quill.scroll.query(format, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK) && !Array.isArray(context.format[format])) formats[format] = context.format[format];
            return formats;
        }, {});
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(range.index).delete(range.length).insert("\n", lineFormats);
        this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index + 1, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.focus();
    }
}
const $827a064b715d18b6$var$defaultOptions = {
    bindings: {
        bold: $827a064b715d18b6$var$makeFormatHandler("bold"),
        italic: $827a064b715d18b6$var$makeFormatHandler("italic"),
        underline: $827a064b715d18b6$var$makeFormatHandler("underline"),
        indent: {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: "Tab",
            format: [
                "blockquote",
                "indent",
                "list"
            ],
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format("indent", "+1", (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        outdent: {
            key: "Tab",
            shiftKey: true,
            format: [
                "blockquote",
                "indent",
                "list"
            ],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format("indent", "-1", (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        "outdent backspace": {
            key: "Backspace",
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: [
                "indent",
                "list"
            ],
            offset: 0,
            handler (range, context) {
                if (context.format.indent != null) this.quill.format("indent", "-1", (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                else if (context.format.list != null) this.quill.format("list", false, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            }
        },
        "indent code-block": $827a064b715d18b6$var$makeCodeBlockHandler(true),
        "outdent code-block": $827a064b715d18b6$var$makeCodeBlockHandler(false),
        "remove tab": {
            key: "Tab",
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler (range) {
                this.quill.deleteText(range.index - 1, 1, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            }
        },
        tab: {
            key: "Tab",
            handler (range, context) {
                if (context.format.table) return true;
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(range.index).delete(range.length).insert("	");
                this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index + 1, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        "blockquote empty enter": {
            key: "Enter",
            collapsed: true,
            format: [
                "blockquote"
            ],
            empty: true,
            handler () {
                this.quill.format("blockquote", false, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            }
        },
        "list empty enter": {
            key: "Enter",
            collapsed: true,
            format: [
                "list"
            ],
            empty: true,
            handler (range, context) {
                const formats = {
                    list: false
                };
                if (context.format.indent) formats.indent = false;
                this.quill.formatLine(range.index, range.length, formats, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            }
        },
        "checklist enter": {
            key: "Enter",
            collapsed: true,
            format: {
                list: "checked"
            },
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                const formats = {
                    // @ts-expect-error Fix me later
                    ...line.formats(),
                    list: "checked"
                };
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(range.index).insert("\n", formats)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    list: "unchecked"
                });
                this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        "header enter": {
            key: "Enter",
            collapsed: true,
            format: [
                "header"
            ],
            suffix: /^$/,
            handler (range, context) {
                const [line, offset] = this.quill.getLine(range.index);
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(range.index).insert("\n", context.format)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    header: null
                });
                this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        "table backspace": {
            key: "Backspace",
            format: [
                "table"
            ],
            collapsed: true,
            offset: 0,
            handler () {}
        },
        "table delete": {
            key: "Delete",
            format: [
                "table"
            ],
            collapsed: true,
            suffix: /^$/,
            handler () {}
        },
        "table enter": {
            key: "Enter",
            shiftKey: null,
            format: [
                "table"
            ],
            handler (range) {
                const module = this.quill.getModule("table");
                if (module) {
                    // @ts-expect-error
                    const [table, row, cell, offset] = module.getTable(range);
                    const shift = $827a064b715d18b6$var$tableSide(table, row, cell, offset);
                    if (shift == null) return;
                    let index = table.offset();
                    if (shift < 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(index).insert("\n");
                        this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index + 1, range.length, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
                    } else if (shift > 0) {
                        index += table.length();
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(index).insert("\n");
                        this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                    }
                }
            }
        },
        "table tab": {
            key: "Tab",
            shiftKey: null,
            format: [
                "table"
            ],
            handler (range, context) {
                const { event: event, line: cell } = context;
                const offset = cell.offset(this.quill.scroll);
                if (event.shiftKey) this.quill.setSelection(offset - 1, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(offset + cell.length(), (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            }
        },
        "list autofill": {
            key: " ",
            shiftKey: null,
            collapsed: true,
            format: {
                "code-block": false,
                blockquote: false,
                table: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler (range, context) {
                if (this.quill.scroll.query("list") == null) return true;
                const { length: length } = context.prefix;
                const [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch(context.prefix.trim()){
                    case "[]":
                    case "[ ]":
                        value = "unchecked";
                        break;
                    case "[x]":
                        value = "checked";
                        break;
                    case "-":
                    case "*":
                        value = "bullet";
                        break;
                    default:
                        value = "ordered";
                }
                this.quill.insertText(range.index, " ", (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(range.index - offset).delete(length + 1)// @ts-expect-error Fix me later
                .retain(line.length() - 2 - offset).retain(1, {
                    list: value
                });
                this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        "code exit": {
            key: "Enter",
            collapsed: true,
            format: [
                "code-block"
            ],
            prefix: /^$/,
            suffix: /^\s*$/,
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                let numLines = 2;
                let cur = line;
                while(cur != null && cur.length() <= 1 && cur.formats()["code-block"]){
                    // @ts-expect-error
                    cur = cur.prev;
                    numLines -= 1;
                    // Requisite prev lines are empty
                    if (numLines <= 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - offset - 2).retain(1, {
                            "code-block": null
                        }).delete(1);
                        this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index - 1, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
                        return false;
                    }
                }
                return true;
            }
        },
        "embed left": $827a064b715d18b6$var$makeEmbedArrowHandler("ArrowLeft", false),
        "embed left shift": $827a064b715d18b6$var$makeEmbedArrowHandler("ArrowLeft", true),
        "embed right": $827a064b715d18b6$var$makeEmbedArrowHandler("ArrowRight", false),
        "embed right shift": $827a064b715d18b6$var$makeEmbedArrowHandler("ArrowRight", true),
        "table down": $827a064b715d18b6$var$makeTableArrowHandler(false),
        "table up": $827a064b715d18b6$var$makeTableArrowHandler(true)
    }
};
$827a064b715d18b6$export$2e2bcd8739ae039.DEFAULTS = $827a064b715d18b6$var$defaultOptions;
function $827a064b715d18b6$var$makeCodeBlockHandler(indent) {
    return {
        key: "Tab",
        shiftKey: !indent,
        format: {
            "code-block": true
        },
        handler (range, _ref) {
            let { event: event } = _ref;
            const CodeBlock = this.quill.scroll.query("code-block");
            // @ts-expect-error
            const { TAB: TAB } = CodeBlock;
            if (range.length === 0 && !event.shiftKey) {
                this.quill.insertText(range.index, TAB, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + TAB.length, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
                return;
            }
            const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
            let { index: index, length: length } = range;
            lines.forEach((line, i)=>{
                if (indent) {
                    line.insertAt(0, TAB);
                    if (i === 0) index += TAB.length;
                    else length += TAB.length;
                // @ts-expect-error Fix me later
                } else if (line.domNode.textContent.startsWith(TAB)) {
                    line.deleteAt(0, TAB.length);
                    if (i === 0) index -= TAB.length;
                    else length -= TAB.length;
                }
            });
            this.quill.update((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(index, length, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
        }
    };
}
function $827a064b715d18b6$var$makeEmbedArrowHandler(key, shiftKey) {
    const where = key === "ArrowLeft" ? "prefix" : "suffix";
    return {
        key: key,
        shiftKey: shiftKey,
        altKey: null,
        [where]: /^$/,
        handler (range) {
            let { index: index } = range;
            if (key === "ArrowRight") index += range.length + 1;
            const [leaf] = this.quill.getLeaf(index);
            if (!(leaf instanceof (0, $4617b32e1de5ada7$export$297a1fa96f55f00f))) return true;
            if (key === "ArrowLeft") {
                if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(range.index - 1, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            else this.quill.setSelection(range.index + range.length + 1, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            return false;
        }
    };
}
function $827a064b715d18b6$var$makeFormatHandler(format) {
    return {
        key: format[0],
        shortKey: true,
        handler (range, context) {
            this.quill.format(format, !context.format[format], (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        }
    };
}
function $827a064b715d18b6$var$makeTableArrowHandler(up) {
    return {
        key: up ? "ArrowUp" : "ArrowDown",
        collapsed: true,
        format: [
            "table"
        ],
        handler (range, context) {
            // TODO move to table module
            const key = up ? "prev" : "next";
            const cell = context.line;
            const targetRow = cell.parent[key];
            if (targetRow != null) {
                if (targetRow.statics.blotName === "table-row") {
                    // @ts-expect-error
                    let targetCell = targetRow.children.head;
                    let cur = cell;
                    while(cur.prev != null){
                        // @ts-expect-error
                        cur = cur.prev;
                        targetCell = targetCell.next;
                    }
                    const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
                    this.quill.setSelection(index, 0, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                }
            } else {
                // @ts-expect-error
                const targetLine = cell.table()[key];
                if (targetLine != null) {
                    if (up) this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                    else this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                }
            }
            return false;
        }
    };
}
function $827a064b715d18b6$export$a3295358bff77e(binding) {
    if (typeof binding === "string" || typeof binding === "number") binding = {
        key: binding
    };
    else if (typeof binding === "object") binding = (0, $7b7037edc7b00187$export$2e2bcd8739ae039)(binding);
    else return null;
    if (binding.shortKey) {
        binding[$827a064b715d18b6$export$34a157fc58f3dd07] = binding.shortKey;
        delete binding.shortKey;
    }
    return binding;
}
// TODO: Move into quill.ts or editor.ts
function $827a064b715d18b6$export$a6c813797f379898(_ref2) {
    let { quill: quill, range: range } = _ref2;
    const lines = quill.getLines(range);
    let formats = {};
    if (lines.length > 1) {
        const firstFormats = lines[0].formats();
        const lastFormats = lines[lines.length - 1].formats();
        formats = (0, $5cea9abc67034d4a$exports.AttributeMap).diff(lastFormats, firstFormats) || {};
    }
    quill.deleteText(range, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
    if (Object.keys(formats).length > 0) quill.formatLine(range.index, 1, formats, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
    quill.setSelection(range.index, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
}
function $827a064b715d18b6$var$tableSide(_table, row, cell, offset) {
    if (row.prev == null && row.next == null) {
        if (cell.prev == null && cell.next == null) return offset === 0 ? -1 : 1;
        return cell.prev == null ? -1 : 1;
    }
    if (row.prev == null) return -1;
    if (row.next == null) return 1;
    return null;
}


const $857188b8abfe3a9c$var$normalWeightRegexp = /font-weight:\s*normal/;
const $857188b8abfe3a9c$var$blockTagNames = [
    "P",
    "OL",
    "UL"
];
const $857188b8abfe3a9c$var$isBlockElement = (element)=>{
    return element && $857188b8abfe3a9c$var$blockTagNames.includes(element.tagName);
};
const $857188b8abfe3a9c$var$normalizeEmptyLines = (doc)=>{
    Array.from(doc.querySelectorAll("br")).filter((br)=>$857188b8abfe3a9c$var$isBlockElement(br.previousElementSibling) && $857188b8abfe3a9c$var$isBlockElement(br.nextElementSibling)).forEach((br)=>{
        br.parentNode?.removeChild(br);
    });
};
const $857188b8abfe3a9c$var$normalizeFontWeight = (doc)=>{
    Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter((node)=>node.getAttribute("style")?.match($857188b8abfe3a9c$var$normalWeightRegexp)).forEach((node)=>{
        const fragment = doc.createDocumentFragment();
        fragment.append(...node.childNodes);
        node.parentNode?.replaceChild(fragment, node);
    });
};
function $857188b8abfe3a9c$export$2e2bcd8739ae039(doc) {
    if (doc.querySelector('[id^="docs-internal-guid-"]')) {
        $857188b8abfe3a9c$var$normalizeFontWeight(doc);
        $857188b8abfe3a9c$var$normalizeEmptyLines(doc);
    }
}


const $6f89c793321e9456$var$ignoreRegexp = /\bmso-list:[^;]*ignore/i;
const $6f89c793321e9456$var$idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
const $6f89c793321e9456$var$indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
const $6f89c793321e9456$var$parseListItem = (element, html)=>{
    const style = element.getAttribute("style");
    const idMatch = style?.match($6f89c793321e9456$var$idRegexp);
    if (!idMatch) return null;
    const id = Number(idMatch[1]);
    const indentMatch = style?.match($6f89c793321e9456$var$indentRegexp);
    const indent = indentMatch ? Number(indentMatch[1]) : 1;
    const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, "i");
    const typeMatch = html.match(typeRegexp);
    const type = typeMatch && typeMatch[1] === "bullet" ? "bullet" : "ordered";
    return {
        id: id,
        indent: indent,
        type: type,
        element: element
    };
};
// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
const $6f89c793321e9456$var$normalizeListItem = (doc)=>{
    const msoList = Array.from(doc.querySelectorAll("[style*=mso-list]"));
    const ignored = [];
    const others = [];
    msoList.forEach((node)=>{
        const shouldIgnore = (node.getAttribute("style") || "").match($6f89c793321e9456$var$ignoreRegexp);
        if (shouldIgnore) ignored.push(node);
        else others.push(node);
    });
    // Each list item contains a marker wrapped with "mso-list: Ignore".
    ignored.forEach((node)=>node.parentNode?.removeChild(node));
    // The list stype is not defined inline with the tag, instead, it's in the
    // style tag so we need to pass the html as a string.
    const html = doc.documentElement.innerHTML;
    const listItems = others.map((element)=>$6f89c793321e9456$var$parseListItem(element, html)).filter((parsed)=>parsed);
    while(listItems.length){
        const childListItems = [];
        let current = listItems.shift();
        // Group continuous items into the same group (aka "ul")
        while(current){
            childListItems.push(current);
            current = listItems.length && listItems[0]?.element === current.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
            listItems[0].id === current.id ? listItems.shift() : null;
        }
        const ul = document.createElement("ul");
        childListItems.forEach((listItem)=>{
            const li = document.createElement("li");
            li.setAttribute("data-list", listItem.type);
            if (listItem.indent > 1) li.setAttribute("class", `ql-indent-${listItem.indent - 1}`);
            li.innerHTML = listItem.element.innerHTML;
            ul.appendChild(li);
        });
        const element = childListItems[0]?.element;
        const { parentNode: parentNode } = element ?? {};
        if (element) parentNode?.replaceChild(ul, element);
        childListItems.slice(1).forEach((_ref)=>{
            let { element: e } = _ref;
            parentNode?.removeChild(e);
        });
    }
};
function $6f89c793321e9456$export$2e2bcd8739ae039(doc) {
    if (doc.documentElement.getAttribute("xmlns:w") === "urn:schemas-microsoft-com:office:word") $6f89c793321e9456$var$normalizeListItem(doc);
}


const $b782c6bb26332f4a$var$NORMALIZERS = [
    (0, $6f89c793321e9456$export$2e2bcd8739ae039),
    (0, $857188b8abfe3a9c$export$2e2bcd8739ae039)
];
const $b782c6bb26332f4a$var$normalizeExternalHTML = (doc)=>{
    if (doc.documentElement) $b782c6bb26332f4a$var$NORMALIZERS.forEach((normalize)=>{
        normalize(doc);
    });
};
var $b782c6bb26332f4a$export$2e2bcd8739ae039 = $b782c6bb26332f4a$var$normalizeExternalHTML;


const $d4b997d913817684$var$debug = (0, $4548fff023e32856$export$2e2bcd8739ae039)("quill:clipboard");
const $d4b997d913817684$var$CLIPBOARD_CONFIG = [
    [
        Node.TEXT_NODE,
        $d4b997d913817684$export$9b884371b5570711
    ],
    [
        Node.TEXT_NODE,
        $d4b997d913817684$export$c695b9637111f586
    ],
    [
        "br",
        $d4b997d913817684$var$matchBreak
    ],
    [
        Node.ELEMENT_NODE,
        $d4b997d913817684$export$c695b9637111f586
    ],
    [
        Node.ELEMENT_NODE,
        $d4b997d913817684$export$e9719de873a22c03
    ],
    [
        Node.ELEMENT_NODE,
        $d4b997d913817684$export$7da59a717dc94488
    ],
    [
        Node.ELEMENT_NODE,
        $d4b997d913817684$var$matchStyles
    ],
    [
        "li",
        $d4b997d913817684$var$matchIndent
    ],
    [
        "ol, ul",
        $d4b997d913817684$var$matchList
    ],
    [
        "pre",
        $d4b997d913817684$var$matchCodeBlock
    ],
    [
        "tr",
        $d4b997d913817684$var$matchTable
    ],
    [
        "b",
        $d4b997d913817684$var$createMatchAlias("bold")
    ],
    [
        "i",
        $d4b997d913817684$var$createMatchAlias("italic")
    ],
    [
        "strike",
        $d4b997d913817684$var$createMatchAlias("strike")
    ],
    [
        "style",
        $d4b997d913817684$var$matchIgnore
    ]
];
const $d4b997d913817684$var$ATTRIBUTE_ATTRIBUTORS = [
    (0, $337ca6b70475fd89$export$2ef0f9fb04a51388),
    (0, $05731c47851567d5$export$4158215dafad9efa)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
const $d4b997d913817684$var$STYLE_ATTRIBUTORS = [
    (0, $337ca6b70475fd89$export$d2060f5d114c9fe8),
    (0, $b2d8f55b55dc7dde$export$dc1cbcab4c682ef),
    (0, $8c6ac1207aa6a978$export$1415f56796d9a5a9),
    (0, $05731c47851567d5$export$175979e518d1dfd1),
    (0, $37324b3d3c9fa7f2$export$23b468d4ca3f8c96),
    (0, $5af457acd7848d59$export$5443b95a30e89ac5)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
class $d4b997d913817684$export$2e2bcd8739ae039 extends (0, $cdd9fa07e4762b38$export$2e2bcd8739ae039) {
    static DEFAULTS = {
        matchers: []
    };
    constructor(quill, options){
        super(quill, options);
        this.quill.root.addEventListener("copy", (e)=>this.onCaptureCopy(e, false));
        this.quill.root.addEventListener("cut", (e)=>this.onCaptureCopy(e, true));
        this.quill.root.addEventListener("paste", this.onCapturePaste.bind(this));
        this.matchers = [];
        $d4b997d913817684$var$CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach((_ref)=>{
            let [selector, matcher] = _ref;
            this.addMatcher(selector, matcher);
        });
    }
    addMatcher(selector, matcher) {
        this.matchers.push([
            selector,
            matcher
        ]);
    }
    convert(_ref2) {
        let { html: html, text: text } = _ref2;
        let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (formats[(0, $77064d128953548d$export$2e2bcd8739ae039).blotName]) return new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().insert(text || "", {
            [(0, $77064d128953548d$export$2e2bcd8739ae039).blotName]: formats[(0, $77064d128953548d$export$2e2bcd8739ae039).blotName]
        });
        if (!html) return new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().insert(text || "", formats);
        const delta = this.convertHTML(html);
        // Remove trailing newline
        if ($d4b997d913817684$var$deltaEndsWith(delta, "\n") && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(delta.length() - 1).delete(1));
        return delta;
    }
    normalizeHTML(doc) {
        (0, $b782c6bb26332f4a$export$2e2bcd8739ae039)(doc);
    }
    convertHTML(html) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        this.normalizeHTML(doc);
        const container = doc.body;
        const nodeMatches = new WeakMap();
        const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
        return $d4b997d913817684$export$df3f009e3d155b20(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
    }
    dangerouslyPasteHTML(index, html) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.API;
        if (typeof index === "string") {
            const delta = this.convert({
                html: index,
                text: ""
            });
            // @ts-expect-error
            this.quill.setContents(delta, html);
            this.quill.setSelection(0, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
        } else {
            const paste = this.convert({
                html: html,
                text: ""
            });
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(index).concat(paste), source);
            this.quill.setSelection(index + paste.length(), (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
        }
    }
    onCaptureCopy(e) {
        let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (e.defaultPrevented) return;
        e.preventDefault();
        const [range] = this.quill.selection.getRange();
        if (range == null) return;
        const { html: html, text: text } = this.onCopy(range, isCut);
        e.clipboardData?.setData("text/plain", text);
        e.clipboardData?.setData("text/html", html);
        if (isCut) (0, $827a064b715d18b6$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */ normalizeURIList(urlList) {
        return urlList.split(/\r?\n/)// Ignore all comments
        .filter((url)=>url[0] !== "#").join("\n");
    }
    onCapturePaste(e) {
        if (e.defaultPrevented || !this.quill.isEnabled()) return;
        e.preventDefault();
        const range = this.quill.getSelection(true);
        if (range == null) return;
        const html = e.clipboardData?.getData("text/html");
        let text = e.clipboardData?.getData("text/plain");
        if (!html && !text) {
            const urlList = e.clipboardData?.getData("text/uri-list");
            if (urlList) text = this.normalizeURIList(urlList);
        }
        const files = Array.from(e.clipboardData?.files || []);
        if (!html && files.length > 0) {
            this.quill.uploader.upload(range, files);
            return;
        }
        if (html && files.length > 0) {
            const doc = new DOMParser().parseFromString(html, "text/html");
            if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === "IMG") {
                this.quill.uploader.upload(range, files);
                return;
            }
        }
        this.onPaste(range, {
            html: html,
            text: text
        });
    }
    onCopy(range) {
        const text = this.quill.getText(range);
        const html = this.quill.getSemanticHTML(range);
        return {
            html: html,
            text: text
        };
    }
    onPaste(range, _ref3) {
        let { text: text, html: html } = _ref3;
        const formats = this.quill.getFormat(range.index);
        const pastedDelta = this.convert({
            text: text,
            html: html
        }, formats);
        $d4b997d913817684$var$debug.log("onPaste", pastedDelta, {
            text: text,
            html: html
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(range.index).delete(range.length).concat(pastedDelta);
        this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        // range.length contributes to delta.length()
        this.quill.setSelection(delta.length() - range.length, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.scrollSelectionIntoView();
    }
    prepareMatching(container, nodeMatches) {
        const elementMatchers = [];
        const textMatchers = [];
        this.matchers.forEach((pair)=>{
            const [selector, matcher] = pair;
            switch(selector){
                case Node.TEXT_NODE:
                    textMatchers.push(matcher);
                    break;
                case Node.ELEMENT_NODE:
                    elementMatchers.push(matcher);
                    break;
                default:
                    Array.from(container.querySelectorAll(selector)).forEach((node)=>{
                        if (nodeMatches.has(node)) {
                            const matches = nodeMatches.get(node);
                            matches?.push(matcher);
                        } else nodeMatches.set(node, [
                            matcher
                        ]);
                    });
                    break;
            }
        });
        return [
            elementMatchers,
            textMatchers
        ];
    }
}
function $d4b997d913817684$var$applyFormat(delta, format, value, scroll) {
    if (!scroll.query(format)) return delta;
    return delta.reduce((newDelta, op)=>{
        if (!op.insert) return newDelta;
        if (op.attributes && op.attributes[format]) return newDelta.push(op);
        const formats = value ? {
            [format]: value
        } : {};
        return newDelta.insert(op.insert, {
            ...formats,
            ...op.attributes
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))());
}
function $d4b997d913817684$var$deltaEndsWith(delta, text) {
    let endText = "";
    for(let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
    ){
        const op = delta.ops[i];
        if (typeof op.insert !== "string") break;
        endText = op.insert + endText;
    }
    return endText.slice(-1 * text.length) === text;
}
function $d4b997d913817684$var$isLine(node, scroll) {
    if (!(node instanceof Element)) return false;
    const match = scroll.query(node);
    // @ts-expect-error
    if (match && match.prototype instanceof (0, $4617b32e1de5ada7$export$297a1fa96f55f00f)) return false;
    return [
        "address",
        "article",
        "blockquote",
        "canvas",
        "dd",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "iframe",
        "li",
        "main",
        "nav",
        "ol",
        "output",
        "p",
        "pre",
        "section",
        "table",
        "td",
        "tr",
        "ul",
        "video"
    ].includes(node.tagName.toLowerCase());
}
function $d4b997d913817684$var$isBetweenInlineElements(node, scroll) {
    return node.previousElementSibling && node.nextElementSibling && !$d4b997d913817684$var$isLine(node.previousElementSibling, scroll) && !$d4b997d913817684$var$isLine(node.nextElementSibling, scroll);
}
const $d4b997d913817684$var$preNodes = new WeakMap();
function $d4b997d913817684$var$isPre(node) {
    if (node == null) return false;
    if (!$d4b997d913817684$var$preNodes.has(node)) {
        // @ts-expect-error
        if (node.tagName === "PRE") $d4b997d913817684$var$preNodes.set(node, true);
        else $d4b997d913817684$var$preNodes.set(node, $d4b997d913817684$var$isPre(node.parentNode));
    }
    return $d4b997d913817684$var$preNodes.get(node);
}
function $d4b997d913817684$export$df3f009e3d155b20(scroll, node, elementMatchers, textMatchers, nodeMatches) {
    // Post-order
    if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce((delta, matcher)=>{
        return matcher(node, delta, scroll);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))());
    if (node.nodeType === node.ELEMENT_NODE) return Array.from(node.childNodes || []).reduce((delta, childNode)=>{
        let childrenDelta = $d4b997d913817684$export$df3f009e3d155b20(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
        if (childNode.nodeType === node.ELEMENT_NODE) {
            childrenDelta = elementMatchers.reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
            childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
        }
        return delta.concat(childrenDelta);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))());
    return new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))();
}
function $d4b997d913817684$var$createMatchAlias(format) {
    return (_node, delta, scroll)=>{
        return $d4b997d913817684$var$applyFormat(delta, format, true, scroll);
    };
}
function $d4b997d913817684$export$7da59a717dc94488(node, delta, scroll) {
    const attributes = (0, $4617b32e1de5ada7$export$217610c4183502d0).keys(node);
    const classes = (0, $4617b32e1de5ada7$export$651d45509677cf07).keys(node);
    const styles = (0, $4617b32e1de5ada7$export$7c8099bbfe87b94d).keys(node);
    const formats = {};
    attributes.concat(classes).concat(styles).forEach((name)=>{
        let attr = scroll.query(name, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).ATTRIBUTE);
        if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
        }
        attr = $d4b997d913817684$var$ATTRIBUTE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
        attr = $d4b997d913817684$var$STYLE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = $d4b997d913817684$var$STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
        }
    });
    return Object.entries(formats).reduce((newDelta, _ref4)=>{
        let [name, value] = _ref4;
        return $d4b997d913817684$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
}
function $d4b997d913817684$export$e9719de873a22c03(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null) return delta;
    // @ts-expect-error
    if (match.prototype instanceof (0, $4617b32e1de5ada7$export$297a1fa96f55f00f)) {
        const embed = {};
        // @ts-expect-error
        const value = match.value(node);
        if (value != null) {
            // @ts-expect-error
            embed[match.blotName] = value;
            // @ts-expect-error
            return new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().insert(embed, match.formats(node, scroll));
        }
    } else {
        // @ts-expect-error
        if (match.prototype instanceof (0, $4617b32e1de5ada7$export$4f7f03641f7bfc8c) && !$d4b997d913817684$var$deltaEndsWith(delta, "\n")) delta.insert("\n");
        if ("blotName" in match && "formats" in match && typeof match.formats === "function") return $d4b997d913817684$var$applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
    }
    return delta;
}
function $d4b997d913817684$var$matchBreak(node, delta) {
    if (!$d4b997d913817684$var$deltaEndsWith(delta, "\n")) delta.insert("\n");
    return delta;
}
function $d4b997d913817684$var$matchCodeBlock(node, delta, scroll) {
    const match = scroll.query("code-block");
    const language = match && "formats" in match && typeof match.formats === "function" ? match.formats(node, scroll) : true;
    return $d4b997d913817684$var$applyFormat(delta, "code-block", language, scroll);
}
function $d4b997d913817684$var$matchIgnore() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))();
}
function $d4b997d913817684$var$matchIndent(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null || // @ts-expect-error
    match.blotName !== "list" || !$d4b997d913817684$var$deltaEndsWith(delta, "\n")) return delta;
    let indent = -1;
    let parent = node.parentNode;
    while(parent != null){
        // @ts-expect-error
        if ([
            "OL",
            "UL"
        ].includes(parent.tagName)) indent += 1;
        parent = parent.parentNode;
    }
    if (indent <= 0) return delta;
    return delta.reduce((composed, op)=>{
        if (!op.insert) return composed;
        if (op.attributes && typeof op.attributes.indent === "number") return composed.push(op);
        return composed.insert(op.insert, {
            indent: indent,
            ...op.attributes || {}
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))());
}
function $d4b997d913817684$var$matchList(node, delta, scroll) {
    const element = node;
    let list = element.tagName === "OL" ? "ordered" : "bullet";
    const checkedAttr = element.getAttribute("data-checked");
    if (checkedAttr) list = checkedAttr === "true" ? "checked" : "unchecked";
    return $d4b997d913817684$var$applyFormat(delta, "list", list, scroll);
}
function $d4b997d913817684$export$c695b9637111f586(node, delta, scroll) {
    if (!$d4b997d913817684$var$deltaEndsWith(delta, "\n")) {
        if ($d4b997d913817684$var$isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) return delta.insert("\n");
        if (delta.length() > 0 && node.nextSibling) {
            let nextSibling = node.nextSibling;
            while(nextSibling != null){
                if ($d4b997d913817684$var$isLine(nextSibling, scroll)) return delta.insert("\n");
                const match = scroll.query(nextSibling);
                // @ts-expect-error
                if (match && match.prototype instanceof (0, $0b2398fdb319908b$export$48b9f0688962d028)) return delta.insert("\n");
                nextSibling = nextSibling.firstChild;
            }
        }
    }
    return delta;
}
function $d4b997d913817684$var$matchStyles(node, delta, scroll) {
    const formats = {};
    const style = node.style || {};
    if (style.fontStyle === "italic") formats.italic = true;
    if (style.textDecoration === "underline") formats.underline = true;
    if (style.textDecoration === "line-through") formats.strike = true;
    if (style.fontWeight?.startsWith("bold") || // @ts-expect-error Fix me later
    parseInt(style.fontWeight, 10) >= 700) formats.bold = true;
    delta = Object.entries(formats).reduce((newDelta, _ref5)=>{
        let [name, value] = _ref5;
        return $d4b997d913817684$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
    // @ts-expect-error
    if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
    return new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().insert("	").concat(delta);
    return delta;
}
function $d4b997d913817684$var$matchTable(node, delta, scroll) {
    const table = node.parentElement?.tagName === "TABLE" ? node.parentElement : node.parentElement?.parentElement;
    if (table != null) {
        const rows = Array.from(table.querySelectorAll("tr"));
        const row = rows.indexOf(node) + 1;
        return $d4b997d913817684$var$applyFormat(delta, "table", row, scroll);
    }
    return delta;
}
function $d4b997d913817684$export$9b884371b5570711(node, delta, scroll) {
    // @ts-expect-error
    let text = node.data;
    // Word represents empty line with <o:p>&nbsp;</o:p>
    if (node.parentElement?.tagName === "O:P") return delta.insert(text.trim());
    if (!$d4b997d913817684$var$isPre(node)) {
        if (text.trim().length === 0 && text.includes("\n") && !$d4b997d913817684$var$isBetweenInlineElements(node, scroll)) return delta;
        const replacer = (collapse, match)=>{
            const replaced = match.replace(/[^\u00a0]/g, ""); // \u00a0 is nbsp;
            return replaced.length < 1 && collapse ? " " : replaced;
        };
        text = text.replace(/\r\n/g, " ").replace(/\n/g, " ");
        text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
        if (node.previousSibling == null && node.parentElement != null && $d4b997d913817684$var$isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && $d4b997d913817684$var$isLine(node.previousSibling, scroll)) text = text.replace(/^\s+/, replacer.bind(replacer, false));
        if (node.nextSibling == null && node.parentElement != null && $d4b997d913817684$var$isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && $d4b997d913817684$var$isLine(node.nextSibling, scroll)) text = text.replace(/\s+$/, replacer.bind(replacer, false));
    }
    return delta.insert(text);
}





class $ecbbc7f2853cf688$export$2e2bcd8739ae039 extends (0, $cdd9fa07e4762b38$export$2e2bcd8739ae039) {
    static DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
    };
    lastRecorded = 0;
    ignoreChange = false;
    stack = {
        undo: [],
        redo: []
    };
    currentRange = null;
    constructor(quill, options){
        super(quill, options);
        this.quill.on((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (eventName, value, oldValue, source)=>{
            if (eventName === (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).events.SELECTION_CHANGE) {
                if (value && source !== (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT) this.currentRange = value;
            } else if (eventName === (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).events.TEXT_CHANGE) {
                if (!this.ignoreChange) {
                    if (!this.options.userOnly || source === (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER) this.record(value, oldValue);
                    else this.transform(value);
                }
                this.currentRange = $ecbbc7f2853cf688$var$transformRange(this.currentRange, value);
            }
        });
        this.quill.keyboard.addBinding({
            key: "z",
            shortKey: true
        }, this.undo.bind(this));
        this.quill.keyboard.addBinding({
            key: [
                "z",
                "Z"
            ],
            shortKey: true,
            shiftKey: true
        }, this.redo.bind(this));
        if (/Win/i.test(navigator.platform)) this.quill.keyboard.addBinding({
            key: "y",
            shortKey: true
        }, this.redo.bind(this));
        this.quill.root.addEventListener("beforeinput", (event)=>{
            if (event.inputType === "historyUndo") {
                this.undo();
                event.preventDefault();
            } else if (event.inputType === "historyRedo") {
                this.redo();
                event.preventDefault();
            }
        });
    }
    change(source, dest) {
        if (this.stack[source].length === 0) return;
        const item = this.stack[source].pop();
        if (!item) return;
        const base = this.quill.getContents();
        const inverseDelta = item.delta.invert(base);
        this.stack[dest].push({
            delta: inverseDelta,
            range: $ecbbc7f2853cf688$var$transformRange(item.range, inverseDelta)
        });
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(item.delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        this.ignoreChange = false;
        this.restoreSelection(item);
    }
    clear() {
        this.stack = {
            undo: [],
            redo: []
        };
    }
    cutoff() {
        this.lastRecorded = 0;
    }
    record(changeDelta, oldDelta) {
        if (changeDelta.ops.length === 0) return;
        this.stack.redo = [];
        let undoDelta = changeDelta.invert(oldDelta);
        let undoRange = this.currentRange;
        const timestamp = Date.now();
        if (// @ts-expect-error Fix me later
        this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
            const item = this.stack.undo.pop();
            if (item) {
                undoDelta = undoDelta.compose(item.delta);
                undoRange = item.range;
            }
        } else this.lastRecorded = timestamp;
        if (undoDelta.length() === 0) return;
        this.stack.undo.push({
            delta: undoDelta,
            range: undoRange
        });
        // @ts-expect-error Fix me later
        if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
    }
    redo() {
        this.change("redo", "undo");
    }
    transform(delta) {
        $ecbbc7f2853cf688$var$transformStack(this.stack.undo, delta);
        $ecbbc7f2853cf688$var$transformStack(this.stack.redo, delta);
    }
    undo() {
        this.change("undo", "redo");
    }
    restoreSelection(stackItem) {
        if (stackItem.range) this.quill.setSelection(stackItem.range, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        else {
            const index = $ecbbc7f2853cf688$export$64042f78dc41d29e(this.quill.scroll, stackItem.delta);
            this.quill.setSelection(index, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        }
    }
}
function $ecbbc7f2853cf688$var$transformStack(stack, delta) {
    let remoteDelta = delta;
    for(let i = stack.length - 1; i >= 0; i -= 1){
        const oldItem = stack[i];
        stack[i] = {
            delta: remoteDelta.transform(oldItem.delta, true),
            range: oldItem.range && $ecbbc7f2853cf688$var$transformRange(oldItem.range, remoteDelta)
        };
        remoteDelta = oldItem.delta.transform(remoteDelta);
        if (stack[i].delta.length() === 0) stack.splice(i, 1);
    }
}
function $ecbbc7f2853cf688$var$endsWithNewlineChange(scroll, delta) {
    const lastOp = delta.ops[delta.ops.length - 1];
    if (lastOp == null) return false;
    if (lastOp.insert != null) return typeof lastOp.insert === "string" && lastOp.insert.endsWith("\n");
    if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some((attr)=>{
        return scroll.query(attr, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK) != null;
    });
    return false;
}
function $ecbbc7f2853cf688$export$64042f78dc41d29e(scroll, delta) {
    const deleteLength = delta.reduce((length, op)=>{
        return length + (op.delete || 0);
    }, 0);
    let changeIndex = delta.length() - deleteLength;
    if ($ecbbc7f2853cf688$var$endsWithNewlineChange(scroll, delta)) changeIndex -= 1;
    return changeIndex;
}
function $ecbbc7f2853cf688$var$transformRange(range, delta) {
    if (!range) return range;
    const start = delta.transformPosition(range.index);
    const end = delta.transformPosition(range.index + range.length);
    return {
        index: start,
        length: end - start
    };
}






class $98051bf2dd6e462d$var$Uploader extends (0, $cdd9fa07e4762b38$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener("drop", (e)=>{
            e.preventDefault();
            let native = null;
            if (document.caretRangeFromPoint) native = document.caretRangeFromPoint(e.clientX, e.clientY);
            else if (document.caretPositionFromPoint) {
                // @ts-expect-error
                const position = document.caretPositionFromPoint(e.clientX, e.clientY);
                native = document.createRange();
                native.setStart(position.offsetNode, position.offset);
                native.setEnd(position.offsetNode, position.offset);
            }
            const normalized = native && quill.selection.normalizeNative(native);
            if (normalized) {
                const range = quill.selection.normalizedToRange(normalized);
                if (e.dataTransfer?.files) this.upload(range, e.dataTransfer.files);
            }
        });
    }
    upload(range, files) {
        const uploads = [];
        Array.from(files).forEach((file)=>{
            if (file && this.options.mimetypes?.includes(file.type)) uploads.push(file);
        });
        if (uploads.length > 0) // @ts-expect-error Fix me later
        this.options.handler.call(this, range, uploads);
    }
}
$98051bf2dd6e462d$var$Uploader.DEFAULTS = {
    mimetypes: [
        "image/png",
        "image/jpeg"
    ],
    handler (range, files) {
        if (!this.quill.scroll.query("image")) return;
        const promises = files.map((file)=>{
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onload = ()=>{
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(promises).then((images)=>{
            const update = images.reduce((delta, image)=>{
                return delta.insert({
                    image: image
                });
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(range.index).delete(range.length));
            this.quill.updateContents(update, (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(range.index + images.length, (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.SILENT);
        });
    }
};
var $98051bf2dd6e462d$export$2e2bcd8739ae039 = $98051bf2dd6e462d$var$Uploader;







const $5727c86a0657985c$var$INSERT_TYPES = [
    "insertText",
    "insertReplacementText"
];
class $5727c86a0657985c$var$Input extends (0, $cdd9fa07e4762b38$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener("beforeinput", (event)=>{
            this.handleBeforeInput(event);
        });
        // Gboard with English input on Android triggers `compositionstart` sometimes even
        // users are not going to type anything.
        if (!/Android/i.test(navigator.userAgent)) quill.on((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.handleCompositionStart();
        });
    }
    deleteRange(range) {
        (0, $827a064b715d18b6$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    replaceText(range) {
        let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        if (range.length === 0) return false;
        if (text) {
            // Follow the native behavior that inherits the formats of the first character
            const formats = this.quill.getFormat(range.index, 1);
            this.deleteRange(range);
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(range.index).insert(text, formats), (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        } else this.deleteRange(range);
        this.quill.setSelection(range.index + text.length, 0, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
        return true;
    }
    handleBeforeInput(event) {
        if (this.quill.composition.isComposing || event.defaultPrevented || !$5727c86a0657985c$var$INSERT_TYPES.includes(event.inputType)) return;
        const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
        if (!staticRange || staticRange.collapsed === true) return;
        const text = $5727c86a0657985c$var$getPlainTextFromInputEvent(event);
        if (text == null) return;
        const normalized = this.quill.selection.normalizeNative(staticRange);
        const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
        if (range && this.replaceText(range, text)) event.preventDefault();
    }
    handleCompositionStart() {
        const range = this.quill.getSelection();
        if (range) this.replaceText(range);
    }
}
function $5727c86a0657985c$var$getPlainTextFromInputEvent(event) {
    // When `inputType` is "insertText":
    // - `event.data` should be string (Safari uses `event.dataTransfer`).
    // - `event.dataTransfer` should be null.
    // When `inputType` is "insertReplacementText":
    // - `event.data` should be null.
    // - `event.dataTransfer` should contain "text/plain" data.
    if (typeof event.data === "string") return event.data;
    if (event.dataTransfer?.types.includes("text/plain")) return event.dataTransfer.getData("text/plain");
    return null;
}
var $5727c86a0657985c$export$2e2bcd8739ae039 = $5727c86a0657985c$var$Input;





const $11ccbefdb73aa702$var$isMac = /Mac/i.test(navigator.platform);
const $11ccbefdb73aa702$export$b6cc50769bf06658 = 100;
// A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
const $11ccbefdb73aa702$var$canMoveCaretBeforeUINode = (event)=>{
    if (event.key === "ArrowLeft" || event.key === "ArrowRight" || // RTL scripts or moving from the end of the previous line
    event.key === "ArrowUp" || event.key === "ArrowDown" || event.key === "Home") return true;
    if ($11ccbefdb73aa702$var$isMac && event.key === "a" && event.ctrlKey === true) return true;
    return false;
};
class $11ccbefdb73aa702$var$UINode extends (0, $cdd9fa07e4762b38$export$2e2bcd8739ae039) {
    isListening = false;
    selectionChangeDeadline = 0;
    constructor(quill, options){
        super(quill, options);
        this.handleArrowKeys();
        this.handleNavigationShortcuts();
    }
    handleArrowKeys() {
        this.quill.keyboard.addBinding({
            key: [
                "ArrowLeft",
                "ArrowRight"
            ],
            offset: 0,
            shiftKey: null,
            handler (range, _ref) {
                let { line: line, event: event } = _ref;
                if (!(line instanceof (0, $4617b32e1de5ada7$export$e43113f0aad76fe)) || !line.uiNode) return true;
                const isRTL = getComputedStyle(line.domNode)["direction"] === "rtl";
                if (isRTL && event.key !== "ArrowRight" || !isRTL && event.key !== "ArrowLeft") return true;
                this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        });
    }
    handleNavigationShortcuts() {
        this.quill.root.addEventListener("keydown", (event)=>{
            if (!event.defaultPrevented && $11ccbefdb73aa702$var$canMoveCaretBeforeUINode(event)) this.ensureListeningToSelectionChange();
        });
    }
    /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */ ensureListeningToSelectionChange() {
        this.selectionChangeDeadline = Date.now() + $11ccbefdb73aa702$export$b6cc50769bf06658;
        if (this.isListening) return;
        this.isListening = true;
        const listener = ()=>{
            this.isListening = false;
            if (Date.now() <= this.selectionChangeDeadline) this.handleSelectionChange();
        };
        document.addEventListener("selectionchange", listener, {
            once: true
        });
    }
    handleSelectionChange() {
        const selection = document.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        if (range.collapsed !== true || range.startOffset !== 0) return;
        const line = this.quill.scroll.find(range.startContainer);
        if (!(line instanceof (0, $4617b32e1de5ada7$export$e43113f0aad76fe)) || !line.uiNode) return;
        const newRange = document.createRange();
        newRange.setStartAfter(line.uiNode);
        newRange.setEndAfter(line.uiNode);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
}
var $11ccbefdb73aa702$export$2e2bcd8739ae039 = $11ccbefdb73aa702$var$UINode;



(0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).register({
    "blots/block": (0, $0b2398fdb319908b$export$2e2bcd8739ae039),
    "blots/block/embed": (0, $0b2398fdb319908b$export$48b9f0688962d028),
    "blots/break": (0, $55d7c792844fdf31$export$2e2bcd8739ae039),
    "blots/container": (0, $c85e381b4b7319fe$export$2e2bcd8739ae039),
    "blots/cursor": (0, $4df559780cba7baa$export$2e2bcd8739ae039),
    "blots/embed": (0, $96e5a527124b0524$export$2e2bcd8739ae039),
    "blots/inline": (0, $6713b0f866164989$export$2e2bcd8739ae039),
    "blots/scroll": (0, $292dfb5df194549e$export$2e2bcd8739ae039),
    "blots/text": (0, $725c99fa2d4b9334$export$2e2bcd8739ae039),
    "modules/clipboard": (0, $d4b997d913817684$export$2e2bcd8739ae039),
    "modules/history": (0, $ecbbc7f2853cf688$export$2e2bcd8739ae039),
    "modules/keyboard": (0, $827a064b715d18b6$export$2e2bcd8739ae039),
    "modules/uploader": (0, $98051bf2dd6e462d$export$2e2bcd8739ae039),
    "modules/input": (0, $5727c86a0657985c$export$2e2bcd8739ae039),
    "modules/uiNode": (0, $11ccbefdb73aa702$export$2e2bcd8739ae039)
});
var $a01df3575c0d914e$export$2e2bcd8739ae039 = (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039);





class $a7f25e87db2ed210$var$IndentAttributor extends (0, $4617b32e1de5ada7$export$651d45509677cf07) {
    add(node, value) {
        let normalizedValue = 0;
        if (value === "+1" || value === "-1") {
            const indent = this.value(node) || 0;
            normalizedValue = value === "+1" ? indent + 1 : indent - 1;
        } else if (typeof value === "number") normalizedValue = value;
        if (normalizedValue === 0) {
            this.remove(node);
            return true;
        }
        return super.add(node, normalizedValue.toString());
    }
    canAdd(node, value) {
        return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
    }
    value(node) {
        return parseInt(super.value(node), 10) || undefined; // Don't return NaN
    }
}
const $a7f25e87db2ed210$var$IndentClass = new $a7f25e87db2ed210$var$IndentAttributor("indent", "ql-indent", {
    scope: (0, $4617b32e1de5ada7$export$775b6bb06e53a214).BLOCK,
    // @ts-expect-error
    whitelist: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]
});
var $a7f25e87db2ed210$export$2e2bcd8739ae039 = $a7f25e87db2ed210$var$IndentClass;



class $d2435c2a0ffc3827$var$Blockquote extends (0, $0b2398fdb319908b$export$2e2bcd8739ae039) {
    static blotName = "blockquote";
    static tagName = "blockquote";
}
var $d2435c2a0ffc3827$export$2e2bcd8739ae039 = $d2435c2a0ffc3827$var$Blockquote;



class $7d73013d9a7cc10b$var$Header extends (0, $0b2398fdb319908b$export$2e2bcd8739ae039) {
    static blotName = "header";
    static tagName = [
        "H1",
        "H2",
        "H3",
        "H4",
        "H5",
        "H6"
    ];
    static formats(domNode) {
        return this.tagName.indexOf(domNode.tagName) + 1;
    }
}
var $7d73013d9a7cc10b$export$2e2bcd8739ae039 = $7d73013d9a7cc10b$var$Header;





class $4ae264b8c51ddb3b$export$122a2a667e12876b extends (0, $c85e381b4b7319fe$export$2e2bcd8739ae039) {
}
$4ae264b8c51ddb3b$export$122a2a667e12876b.blotName = "list-container";
$4ae264b8c51ddb3b$export$122a2a667e12876b.tagName = "OL";
class $4ae264b8c51ddb3b$export$2e2bcd8739ae039 extends (0, $0b2398fdb319908b$export$2e2bcd8739ae039) {
    static create(value) {
        const node = super.create();
        node.setAttribute("data-list", value);
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute("data-list") || undefined;
    }
    static register() {
        (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).register($4ae264b8c51ddb3b$export$122a2a667e12876b);
    }
    constructor(scroll, domNode){
        super(scroll, domNode);
        const ui = domNode.ownerDocument.createElement("span");
        const listEventHandler = (e)=>{
            if (!scroll.isEnabled()) return;
            const format = this.statics.formats(domNode, scroll);
            if (format === "checked") {
                this.format("list", "unchecked");
                e.preventDefault();
            } else if (format === "unchecked") {
                this.format("list", "checked");
                e.preventDefault();
            }
        };
        ui.addEventListener("mousedown", listEventHandler);
        ui.addEventListener("touchstart", listEventHandler);
        this.attachUI(ui);
    }
    format(name, value) {
        if (name === this.statics.blotName && value) this.domNode.setAttribute("data-list", value);
        else super.format(name, value);
    }
}
$4ae264b8c51ddb3b$export$2e2bcd8739ae039.blotName = "list";
$4ae264b8c51ddb3b$export$2e2bcd8739ae039.tagName = "LI";
$4ae264b8c51ddb3b$export$122a2a667e12876b.allowedChildren = [
    $4ae264b8c51ddb3b$export$2e2bcd8739ae039
];
$4ae264b8c51ddb3b$export$2e2bcd8739ae039.requiredContainer = $4ae264b8c51ddb3b$export$122a2a667e12876b;







class $8d319051fe03484e$var$Bold extends (0, $6713b0f866164989$export$2e2bcd8739ae039) {
    static blotName = "bold";
    static tagName = [
        "STRONG",
        "B"
    ];
    static create() {
        return super.create();
    }
    static formats() {
        return true;
    }
    optimize(context) {
        super.optimize(context);
        if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
    }
}
var $8d319051fe03484e$export$2e2bcd8739ae039 = $8d319051fe03484e$var$Bold;



class $d40d4db502a7f134$var$Italic extends (0, $8d319051fe03484e$export$2e2bcd8739ae039) {
    static blotName = "italic";
    static tagName = [
        "EM",
        "I"
    ];
}
var $d40d4db502a7f134$export$2e2bcd8739ae039 = $d40d4db502a7f134$var$Italic;



class $c37a786fd52764f9$export$2e2bcd8739ae039 extends (0, $6713b0f866164989$export$2e2bcd8739ae039) {
    static blotName = "link";
    static tagName = "A";
    static SANITIZED_URL = "about:blank";
    static PROTOCOL_WHITELIST = [
        "http",
        "https",
        "mailto",
        "tel",
        "sms"
    ];
    static create(value) {
        const node = super.create(value);
        node.setAttribute("href", this.sanitize(value));
        node.setAttribute("rel", "noopener noreferrer");
        node.setAttribute("target", "_blank");
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute("href");
    }
    static sanitize(url) {
        return $c37a786fd52764f9$export$83d2e9e3e4ee39ed(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
    format(name, value) {
        if (name !== this.statics.blotName || !value) super.format(name, value);
        else // @ts-expect-error
        this.domNode.setAttribute("href", this.constructor.sanitize(value));
    }
}
function $c37a786fd52764f9$export$83d2e9e3e4ee39ed(url, protocols) {
    const anchor = document.createElement("a");
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(":"));
    return protocols.indexOf(protocol) > -1;
}



class $6dd0321fcfb194e1$var$Script extends (0, $6713b0f866164989$export$2e2bcd8739ae039) {
    static blotName = "script";
    static tagName = [
        "SUB",
        "SUP"
    ];
    static create(value) {
        if (value === "super") return document.createElement("sup");
        if (value === "sub") return document.createElement("sub");
        return super.create(value);
    }
    static formats(domNode) {
        if (domNode.tagName === "SUB") return "sub";
        if (domNode.tagName === "SUP") return "super";
        return undefined;
    }
}
var $6dd0321fcfb194e1$export$2e2bcd8739ae039 = $6dd0321fcfb194e1$var$Script;



class $efae789a1aa9dfab$var$Strike extends (0, $8d319051fe03484e$export$2e2bcd8739ae039) {
    static blotName = "strike";
    static tagName = [
        "S",
        "STRIKE"
    ];
}
var $efae789a1aa9dfab$export$2e2bcd8739ae039 = $efae789a1aa9dfab$var$Strike;



class $267a34f4d39d38b3$var$Underline extends (0, $6713b0f866164989$export$2e2bcd8739ae039) {
    static blotName = "underline";
    static tagName = "U";
}
var $267a34f4d39d38b3$export$2e2bcd8739ae039 = $267a34f4d39d38b3$var$Underline;



class $75ddaa5c0d54a8b8$var$Formula extends (0, $96e5a527124b0524$export$2e2bcd8739ae039) {
    static blotName = "formula";
    static className = "ql-formula";
    static tagName = "SPAN";
    static create(value) {
        // @ts-expect-error
        if (window.katex == null) throw new Error("Formula module requires KaTeX.");
        const node = super.create(value);
        if (typeof value === "string") {
            // @ts-expect-error
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: "#f00"
            });
            node.setAttribute("data-value", value);
        }
        return node;
    }
    static value(domNode) {
        return domNode.getAttribute("data-value");
    }
    html() {
        const { formula: formula } = this.value();
        return `<span>${formula}</span>`;
    }
}
var $75ddaa5c0d54a8b8$export$2e2bcd8739ae039 = $75ddaa5c0d54a8b8$var$Formula;




const $9f0a9bceae9b296f$var$ATTRIBUTES = [
    "alt",
    "height",
    "width"
];
class $9f0a9bceae9b296f$var$Image extends (0, $4617b32e1de5ada7$export$297a1fa96f55f00f) {
    static blotName = "image";
    static tagName = "IMG";
    static create(value) {
        const node = super.create(value);
        if (typeof value === "string") node.setAttribute("src", this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $9f0a9bceae9b296f$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static match(url) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
    static sanitize(url) {
        return (0, $c37a786fd52764f9$export$83d2e9e3e4ee39ed)(url, [
            "http",
            "https",
            "data"
        ]) ? url : "//:0";
    }
    static value(domNode) {
        return domNode.getAttribute("src");
    }
    format(name, value) {
        if ($9f0a9bceae9b296f$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
}
var $9f0a9bceae9b296f$export$2e2bcd8739ae039 = $9f0a9bceae9b296f$var$Image;




const $c98ab345673724c5$var$ATTRIBUTES = [
    "height",
    "width"
];
class $c98ab345673724c5$var$Video extends (0, $0b2398fdb319908b$export$48b9f0688962d028) {
    static blotName = "video";
    static className = "ql-video";
    static tagName = "IFRAME";
    static create(value) {
        const node = super.create(value);
        node.setAttribute("frameborder", "0");
        node.setAttribute("allowfullscreen", "true");
        node.setAttribute("src", this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $c98ab345673724c5$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static sanitize(url) {
        return (0, $c37a786fd52764f9$export$2e2bcd8739ae039).sanitize(url);
    }
    static value(domNode) {
        return domNode.getAttribute("src");
    }
    format(name, value) {
        if ($c98ab345673724c5$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
    html() {
        const { video: video } = this.value();
        return `<a href="${video}">${video}</a>`;
    }
}
var $c98ab345673724c5$export$2e2bcd8739ae039 = $c98ab345673724c5$var$Video;














const $1e008732fe422fd8$var$TokenAttributor = new (0, $4617b32e1de5ada7$export$651d45509677cf07)("code-token", "hljs", {
    scope: (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE
});
class $1e008732fe422fd8$export$9460eee64f276be7 extends (0, $6713b0f866164989$export$2e2bcd8739ae039) {
    static formats(node, scroll) {
        while(node != null && node !== scroll.domNode){
            if (node.classList && node.classList.contains((0, $77064d128953548d$export$2e2bcd8739ae039).className)) // @ts-expect-error
            return super.formats(node, scroll);
            // @ts-expect-error
            node = node.parentNode;
        }
        return undefined;
    }
    constructor(scroll, domNode, value){
        // @ts-expect-error
        super(scroll, domNode, value);
        $1e008732fe422fd8$var$TokenAttributor.add(this.domNode, value);
    }
    format(format, value) {
        if (format !== $1e008732fe422fd8$export$9460eee64f276be7.blotName) super.format(format, value);
        else if (value) $1e008732fe422fd8$var$TokenAttributor.add(this.domNode, value);
        else {
            $1e008732fe422fd8$var$TokenAttributor.remove(this.domNode);
            this.domNode.classList.remove(this.statics.className);
        }
    }
    optimize() {
        // @ts-expect-error
        super.optimize(...arguments);
        if (!$1e008732fe422fd8$var$TokenAttributor.value(this.domNode)) this.unwrap();
    }
}
$1e008732fe422fd8$export$9460eee64f276be7.blotName = "code-token";
$1e008732fe422fd8$export$9460eee64f276be7.className = "ql-token";
class $1e008732fe422fd8$export$6c415d1fdae3dfdb extends (0, $77064d128953548d$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        if (typeof value === "string") domNode.setAttribute("data-language", value);
        return domNode;
    }
    static formats(domNode) {
        // @ts-expect-error
        return domNode.getAttribute("data-language") || "plain";
    }
    static register() {}
    format(name, value) {
        if (name === this.statics.blotName && value) // @ts-expect-error
        this.domNode.setAttribute("data-language", value);
        else super.format(name, value);
    }
    replaceWith(name, value) {
        this.formatAt(0, this.length(), $1e008732fe422fd8$export$9460eee64f276be7.blotName, false);
        return super.replaceWith(name, value);
    }
}
class $1e008732fe422fd8$var$SyntaxCodeBlockContainer extends (0, $77064d128953548d$export$3b131632d3d15165) {
    attach() {
        super.attach();
        this.forceNext = false;
        // @ts-expect-error
        this.scroll.emitMount(this);
    }
    format(name, value) {
        if (name === $1e008732fe422fd8$export$6c415d1fdae3dfdb.blotName) {
            this.forceNext = true;
            this.children.forEach((child)=>{
                // @ts-expect-error
                child.format(name, value);
            });
        }
    }
    formatAt(index, length, name, value) {
        if (name === $1e008732fe422fd8$export$6c415d1fdae3dfdb.blotName) this.forceNext = true;
        super.formatAt(index, length, name, value);
    }
    highlight(highlight) {
        let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.children.head == null) return;
        const nodes = Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode);
        const text = `${nodes.map((node)=>node.textContent).join("\n")}\n`;
        const language = $1e008732fe422fd8$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
        if (forced || this.forceNext || this.cachedText !== text) {
            if (text.trim().length > 0 || this.cachedText == null) {
                const oldDelta = this.children.reduce((delta, child)=>{
                    // @ts-expect-error
                    return delta.concat((0, $0b2398fdb319908b$export$992ff47219af5a2b)(child, false));
                }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))());
                const delta = highlight(text, language);
                oldDelta.diff(delta).reduce((index, _ref)=>{
                    let { retain: retain, attributes: attributes } = _ref;
                    // Should be all retains
                    if (!retain) return index;
                    if (attributes) Object.keys(attributes).forEach((format)=>{
                        if ([
                            $1e008732fe422fd8$export$6c415d1fdae3dfdb.blotName,
                            $1e008732fe422fd8$export$9460eee64f276be7.blotName
                        ].includes(format)) // @ts-expect-error
                        this.formatAt(index, retain, format, attributes[format]);
                    });
                    // @ts-expect-error
                    return index + retain;
                }, 0);
            }
            this.cachedText = text;
            this.forceNext = false;
        }
    }
    html(index, length) {
        const [codeBlock] = this.children.find(index);
        const language = codeBlock ? $1e008732fe422fd8$export$6c415d1fdae3dfdb.formats(codeBlock.domNode) : "plain";
        return `<pre data-language="${language}">\n${(0, $725c99fa2d4b9334$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent != null && this.children.head != null && this.uiNode != null) {
            const language = $1e008732fe422fd8$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
            // @ts-expect-error
            if (language !== this.uiNode.value) // @ts-expect-error
            this.uiNode.value = language;
        }
    }
}
$1e008732fe422fd8$var$SyntaxCodeBlockContainer.allowedChildren = [
    $1e008732fe422fd8$export$6c415d1fdae3dfdb
];
$1e008732fe422fd8$export$6c415d1fdae3dfdb.requiredContainer = $1e008732fe422fd8$var$SyntaxCodeBlockContainer;
$1e008732fe422fd8$export$6c415d1fdae3dfdb.allowedChildren = [
    $1e008732fe422fd8$export$9460eee64f276be7,
    (0, $4df559780cba7baa$export$2e2bcd8739ae039),
    (0, $725c99fa2d4b9334$export$2e2bcd8739ae039),
    (0, $55d7c792844fdf31$export$2e2bcd8739ae039)
];
const $1e008732fe422fd8$var$highlight = (lib, language, text)=>{
    if (typeof lib.versionString === "string") {
        const majorVersion = lib.versionString.split(".")[0];
        if (parseInt(majorVersion, 10) >= 11) return lib.highlight(text, {
            language: language
        }).value;
    }
    return lib.highlight(language, text).value;
};
class $1e008732fe422fd8$export$2e2bcd8739ae039 extends (0, $cdd9fa07e4762b38$export$2e2bcd8739ae039) {
    static register() {
        (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).register($1e008732fe422fd8$export$9460eee64f276be7, true);
        (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).register($1e008732fe422fd8$export$6c415d1fdae3dfdb, true);
        (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).register($1e008732fe422fd8$var$SyntaxCodeBlockContainer, true);
    }
    constructor(quill, options){
        super(quill, options);
        if (this.options.hljs == null) throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
        // @ts-expect-error Fix me later
        this.languages = this.options.languages.reduce((memo, _ref2)=>{
            let { key: key } = _ref2;
            memo[key] = true;
            return memo;
        }, {});
        this.highlightBlot = this.highlightBlot.bind(this);
        this.initListener();
        this.initTimer();
    }
    initListener() {
        this.quill.on((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, (blot)=>{
            if (!(blot instanceof $1e008732fe422fd8$var$SyntaxCodeBlockContainer)) return;
            const select = this.quill.root.ownerDocument.createElement("select");
            // @ts-expect-error Fix me later
            this.options.languages.forEach((_ref3)=>{
                let { key: key, label: label } = _ref3;
                const option = select.ownerDocument.createElement("option");
                option.textContent = label;
                option.setAttribute("value", key);
                select.appendChild(option);
            });
            select.addEventListener("change", ()=>{
                blot.format($1e008732fe422fd8$export$6c415d1fdae3dfdb.blotName, select.value);
                this.quill.root.focus(); // Prevent scrolling
                this.highlight(blot, true);
            });
            if (blot.uiNode == null) {
                blot.attachUI(select);
                if (blot.children.head) select.value = $1e008732fe422fd8$export$6c415d1fdae3dfdb.formats(blot.children.head.domNode);
            }
        });
    }
    initTimer() {
        let timer = null;
        this.quill.on((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.highlight();
                timer = null;
            }, this.options.interval);
        });
    }
    highlight() {
        let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.quill.selection.composing) return;
        this.quill.update((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        const range = this.quill.getSelection();
        const blots = blot == null ? this.quill.scroll.descendants($1e008732fe422fd8$var$SyntaxCodeBlockContainer) : [
            blot
        ];
        blots.forEach((container)=>{
            container.highlight(this.highlightBlot, force);
        });
        this.quill.update((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
        if (range != null) this.quill.setSelection(range, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
    }
    highlightBlot(text) {
        let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "plain";
        language = this.languages[language] ? language : "plain";
        if (language === "plain") return (0, $725c99fa2d4b9334$export$96e6fc3a139b2555)(text).split("\n").reduce((delta, line, i)=>{
            if (i !== 0) delta.insert("\n", {
                [(0, $77064d128953548d$export$2e2bcd8739ae039).blotName]: language
            });
            return delta.insert(line);
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))());
        const container = this.quill.root.ownerDocument.createElement("div");
        container.classList.add((0, $77064d128953548d$export$2e2bcd8739ae039).className);
        container.innerHTML = $1e008732fe422fd8$var$highlight(this.options.hljs, language, text);
        return (0, $d4b997d913817684$export$df3f009e3d155b20)(this.quill.scroll, container, [
            (node, delta)=>{
                // @ts-expect-error
                const value = $1e008732fe422fd8$var$TokenAttributor.value(node);
                if (value) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(delta.length(), {
                    [$1e008732fe422fd8$export$9460eee64f276be7.blotName]: value
                }));
                return delta;
            }
        ], [
            (node, delta)=>{
                // @ts-expect-error
                return node.data.split("\n").reduce((memo, nodeText, i)=>{
                    if (i !== 0) memo.insert("\n", {
                        [(0, $77064d128953548d$export$2e2bcd8739ae039).blotName]: language
                    });
                    return memo.insert(nodeText);
                }, delta);
            }
        ], new WeakMap());
    }
}
$1e008732fe422fd8$export$2e2bcd8739ae039.DEFAULTS = {
    hljs: (()=>{
        return window.hljs;
    })(),
    interval: 1000,
    languages: [
        {
            key: "plain",
            label: "Plain"
        },
        {
            key: "bash",
            label: "Bash"
        },
        {
            key: "cpp",
            label: "C++"
        },
        {
            key: "cs",
            label: "C#"
        },
        {
            key: "css",
            label: "CSS"
        },
        {
            key: "diff",
            label: "Diff"
        },
        {
            key: "xml",
            label: "HTML/XML"
        },
        {
            key: "java",
            label: "Java"
        },
        {
            key: "javascript",
            label: "JavaScript"
        },
        {
            key: "markdown",
            label: "Markdown"
        },
        {
            key: "php",
            label: "PHP"
        },
        {
            key: "python",
            label: "Python"
        },
        {
            key: "ruby",
            label: "Ruby"
        },
        {
            key: "sql",
            label: "SQL"
        }
    ]
};







class $16c9f62467165882$export$1e4baea7053fc0e3 extends (0, $0b2398fdb319908b$export$2e2bcd8739ae039) {
    static blotName = "table";
    static tagName = "TD";
    static create(value) {
        const node = super.create();
        if (value) node.setAttribute("data-row", value);
        else node.setAttribute("data-row", $16c9f62467165882$export$9bd6f73cbe857f1b());
        return node;
    }
    static formats(domNode) {
        if (domNode.hasAttribute("data-row")) return domNode.getAttribute("data-row");
        return undefined;
    }
    cellOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    format(name, value) {
        if (name === $16c9f62467165882$export$1e4baea7053fc0e3.blotName && value) this.domNode.setAttribute("data-row", value);
        else super.format(name, value);
    }
    row() {
        return this.parent;
    }
    rowOffset() {
        if (this.row()) return this.row().rowOffset();
        return -1;
    }
    table() {
        return this.row() && this.row().table();
    }
}
class $16c9f62467165882$export$b05581f4e764e162 extends (0, $c85e381b4b7319fe$export$2e2bcd8739ae039) {
    static blotName = "table-row";
    static tagName = "TR";
    checkMerge() {
        // @ts-expect-error
        if (super.checkMerge() && this.next.children.head != null) {
            // @ts-expect-error
            const thisHead = this.children.head.formats();
            // @ts-expect-error
            const thisTail = this.children.tail.formats();
            // @ts-expect-error
            const nextHead = this.next.children.head.formats();
            // @ts-expect-error
            const nextTail = this.next.children.tail.formats();
            return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
        }
        return false;
    }
    optimize(context) {
        super.optimize(context);
        this.children.forEach((child)=>{
            if (child.next == null) return;
            const childFormats = child.formats();
            const nextFormats = child.next.formats();
            if (childFormats.table !== nextFormats.table) {
                const next = this.splitAfter(child);
                if (next) // @ts-expect-error TODO: parameters of optimize() should be a optional
                next.optimize();
                // We might be able to merge with prev now
                if (this.prev) // @ts-expect-error TODO: parameters of optimize() should be a optional
                this.prev.optimize();
            }
        });
    }
    rowOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    table() {
        return this.parent && this.parent.parent;
    }
}
class $16c9f62467165882$export$76ccd210b9029917 extends (0, $c85e381b4b7319fe$export$2e2bcd8739ae039) {
    static blotName = "table-body";
    static tagName = "TBODY";
}
class $16c9f62467165882$export$f2c3aea42b2a048f extends (0, $c85e381b4b7319fe$export$2e2bcd8739ae039) {
    static blotName = "table-container";
    static tagName = "TABLE";
    balanceCells() {
        const rows = this.descendants($16c9f62467165882$export$b05581f4e764e162);
        const maxColumns = rows.reduce((max, row)=>{
            return Math.max(row.children.length, max);
        }, 0);
        rows.forEach((row)=>{
            new Array(maxColumns - row.children.length).fill(0).forEach(()=>{
                let value;
                if (row.children.head != null) value = $16c9f62467165882$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
                const blot = this.scroll.create($16c9f62467165882$export$1e4baea7053fc0e3.blotName, value);
                row.appendChild(blot);
                // @ts-expect-error TODO: parameters of optimize() should be a optional
                blot.optimize(); // Add break blot
            });
        });
    }
    cells(column) {
        return this.rows().map((row)=>row.children.at(column));
    }
    deleteColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($16c9f62467165882$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const cell = row.children.at(index);
            if (cell != null) cell.remove();
        });
    }
    insertColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($16c9f62467165882$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const ref = row.children.at(index);
            // @ts-expect-error
            const value = $16c9f62467165882$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
            const cell = this.scroll.create($16c9f62467165882$export$1e4baea7053fc0e3.blotName, value);
            row.insertBefore(cell, ref);
        });
    }
    insertRow(index) {
        // @ts-expect-error
        const [body] = this.descendant($16c9f62467165882$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        const id = $16c9f62467165882$export$9bd6f73cbe857f1b();
        const row = this.scroll.create($16c9f62467165882$export$b05581f4e764e162.blotName);
        body.children.head.children.forEach(()=>{
            const cell = this.scroll.create($16c9f62467165882$export$1e4baea7053fc0e3.blotName, id);
            row.appendChild(cell);
        });
        const ref = body.children.at(index);
        body.insertBefore(row, ref);
    }
    rows() {
        const body = this.children.head;
        if (body == null) return [];
        return body.children.map((row)=>row);
    }
}
$16c9f62467165882$export$f2c3aea42b2a048f.allowedChildren = [
    $16c9f62467165882$export$76ccd210b9029917
];
$16c9f62467165882$export$76ccd210b9029917.requiredContainer = $16c9f62467165882$export$f2c3aea42b2a048f;
$16c9f62467165882$export$76ccd210b9029917.allowedChildren = [
    $16c9f62467165882$export$b05581f4e764e162
];
$16c9f62467165882$export$b05581f4e764e162.requiredContainer = $16c9f62467165882$export$76ccd210b9029917;
$16c9f62467165882$export$b05581f4e764e162.allowedChildren = [
    $16c9f62467165882$export$1e4baea7053fc0e3
];
$16c9f62467165882$export$1e4baea7053fc0e3.requiredContainer = $16c9f62467165882$export$b05581f4e764e162;
function $16c9f62467165882$export$9bd6f73cbe857f1b() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}


class $c05e45a610b7f1a2$var$Table extends (0, $cdd9fa07e4762b38$export$2e2bcd8739ae039) {
    static register() {
        (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).register((0, $16c9f62467165882$export$1e4baea7053fc0e3));
        (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).register((0, $16c9f62467165882$export$b05581f4e764e162));
        (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).register((0, $16c9f62467165882$export$76ccd210b9029917));
        (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).register((0, $16c9f62467165882$export$f2c3aea42b2a048f));
    }
    constructor(){
        super(...arguments);
        this.listenBalanceCells();
    }
    balanceTables() {
        this.quill.scroll.descendants((0, $16c9f62467165882$export$f2c3aea42b2a048f)).forEach((table)=>{
            table.balanceCells();
        });
    }
    deleteColumn() {
        const [table, , cell] = this.getTable();
        if (cell == null) return;
        // @ts-expect-error
        table.deleteColumn(cell.cellOffset());
        this.quill.update((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
    }
    deleteRow() {
        const [, row] = this.getTable();
        if (row == null) return;
        row.remove();
        this.quill.update((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
    }
    deleteTable() {
        const [table] = this.getTable();
        if (table == null) return;
        // @ts-expect-error
        const offset = table.offset();
        // @ts-expect-error
        table.remove();
        this.quill.update((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(offset, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
    }
    getTable() {
        let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
        if (range == null) return [
            null,
            null,
            null,
            -1
        ];
        const [cell, offset] = this.quill.getLine(range.index);
        if (cell == null || cell.statics.blotName !== (0, $16c9f62467165882$export$1e4baea7053fc0e3).blotName) return [
            null,
            null,
            null,
            -1
        ];
        const row = cell.parent;
        const table = row.parent.parent;
        // @ts-expect-error
        return [
            table,
            row,
            cell,
            offset
        ];
    }
    insertColumn(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const column = cell.cellOffset();
        table.insertColumn(column + offset);
        this.quill.update((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        let shift = row.rowOffset();
        if (offset === 0) shift += 1;
        this.quill.setSelection(range.index + shift, range.length, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertColumnLeft() {
        this.insertColumn(0);
    }
    insertColumnRight() {
        this.insertColumn(1);
    }
    insertRow(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const index = row.rowOffset();
        table.insertRow(index + offset);
        this.quill.update((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        if (offset > 0) this.quill.setSelection(range, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
        else this.quill.setSelection(range.index + row.children.length, range.length, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertRowAbove() {
        this.insertRow(0);
    }
    insertRowBelow() {
        this.insertRow(1);
    }
    insertTable(rows, columns) {
        const range = this.quill.getSelection();
        if (range == null) return;
        const delta = new Array(rows).fill(0).reduce((memo)=>{
            const text = new Array(columns).fill("\n").join("");
            return memo.insert(text, {
                table: (0, $16c9f62467165882$export$9bd6f73cbe857f1b)()
            });
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))().retain(range.index));
        this.quill.updateContents(delta, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.SILENT);
        this.balanceTables();
    }
    listenBalanceCells() {
        this.quill.on((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations)=>{
            mutations.some((mutation)=>{
                if ([
                    "TD",
                    "TR",
                    "TBODY",
                    "TABLE"
                ].includes(mutation.target.tagName)) {
                    this.quill.once((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).events.TEXT_CHANGE, (delta, old, source)=>{
                        if (source !== (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER) return;
                        this.balanceTables();
                    });
                    return true;
                }
                return false;
            });
        });
    }
}
var $c05e45a610b7f1a2$export$2e2bcd8739ae039 = $c05e45a610b7f1a2$var$Table;







const $bedbec4eefd090ee$var$debug = (0, $4548fff023e32856$export$2e2bcd8739ae039)("quill:toolbar");
class $bedbec4eefd090ee$export$2e2bcd8739ae039 extends (0, $cdd9fa07e4762b38$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        if (Array.isArray(this.options.container)) {
            const container = document.createElement("div");
            container.setAttribute("role", "toolbar");
            $bedbec4eefd090ee$export$faadaf0198b97fbe(container, this.options.container);
            quill.container?.parentNode?.insertBefore(container, quill.container);
            this.container = container;
        } else if (typeof this.options.container === "string") this.container = document.querySelector(this.options.container);
        else this.container = this.options.container;
        if (!(this.container instanceof HTMLElement)) {
            $bedbec4eefd090ee$var$debug.error("Container required for toolbar", this.options);
            return;
        }
        this.container.classList.add("ql-toolbar");
        this.controls = [];
        this.handlers = {};
        if (this.options.handlers) Object.keys(this.options.handlers).forEach((format)=>{
            const handler = this.options.handlers?.[format];
            if (handler) this.addHandler(format, handler);
        });
        Array.from(this.container.querySelectorAll("button, select")).forEach((input)=>{
            // @ts-expect-error
            this.attach(input);
        });
        this.quill.on((0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ()=>{
            const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
            this.update(range);
        });
    }
    addHandler(format, handler) {
        this.handlers[format] = handler;
    }
    attach(input) {
        let format = Array.from(input.classList).find((className)=>{
            return className.indexOf("ql-") === 0;
        });
        if (!format) return;
        format = format.slice(3);
        if (input.tagName === "BUTTON") input.setAttribute("type", "button");
        if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
            $bedbec4eefd090ee$var$debug.warn("ignoring attaching to nonexistent format", format, input);
            return;
        }
        const eventName = input.tagName === "SELECT" ? "change" : "click";
        input.addEventListener(eventName, (e)=>{
            let value;
            if (input.tagName === "SELECT") {
                // @ts-expect-error
                if (input.selectedIndex < 0) return;
                // @ts-expect-error
                const selected = input.options[input.selectedIndex];
                if (selected.hasAttribute("selected")) value = false;
                else value = selected.value || false;
            } else {
                if (input.classList.contains("ql-active")) value = false;
                else // @ts-expect-error
                value = input.value || !input.hasAttribute("value");
                e.preventDefault();
            }
            this.quill.focus();
            const [range] = this.quill.selection.getRange();
            if (this.handlers[format] != null) this.handlers[format].call(this, value);
            else if (// @ts-expect-error
            this.quill.scroll.query(format).prototype instanceof (0, $4617b32e1de5ada7$export$297a1fa96f55f00f)) {
                value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
                if (!value) return;
                this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($5cea9abc67034d4a$exports)))()// @ts-expect-error Fix me later
                .retain(range.index)// @ts-expect-error Fix me later
                .delete(range.length).insert({
                    [format]: value
                }), (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format(format, value, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            this.update(range);
        });
        this.controls.push([
            format,
            input
        ]);
    }
    update(range) {
        const formats = range == null ? {} : this.quill.getFormat(range);
        this.controls.forEach((pair)=>{
            const [format, input] = pair;
            if (input.tagName === "SELECT") {
                let option = null;
                if (range == null) option = null;
                else if (formats[format] == null) option = input.querySelector("option[selected]");
                else if (!Array.isArray(formats[format])) {
                    let value = formats[format];
                    if (typeof value === "string") value = value.replace(/"/g, '\\"');
                    option = input.querySelector(`option[value="${value}"]`);
                }
                if (option == null) {
                    // @ts-expect-error TODO fix me later
                    input.value = ""; // TODO make configurable?
                    // @ts-expect-error TODO fix me later
                    input.selectedIndex = -1;
                } else option.selected = true;
            } else if (range == null) {
                input.classList.remove("ql-active");
                input.setAttribute("aria-pressed", "false");
            } else if (input.hasAttribute("value")) {
                // both being null should match (default values)
                // '1' should match with 1 (headers)
                const value = formats[format];
                const isActive = value === input.getAttribute("value") || value != null && value.toString() === input.getAttribute("value") || value == null && !input.getAttribute("value");
                input.classList.toggle("ql-active", isActive);
                input.setAttribute("aria-pressed", isActive.toString());
            } else {
                const isActive = formats[format] != null;
                input.classList.toggle("ql-active", isActive);
                input.setAttribute("aria-pressed", isActive.toString());
            }
        });
    }
}
$bedbec4eefd090ee$export$2e2bcd8739ae039.DEFAULTS = {};
function $bedbec4eefd090ee$var$addButton(container, format, value) {
    const input = document.createElement("button");
    input.setAttribute("type", "button");
    input.classList.add(`ql-${format}`);
    input.setAttribute("aria-pressed", "false");
    if (value != null) {
        input.value = value;
        input.setAttribute("aria-label", `${format}: ${value}`);
    } else input.setAttribute("aria-label", format);
    container.appendChild(input);
}
function $bedbec4eefd090ee$export$faadaf0198b97fbe(container, groups) {
    if (!Array.isArray(groups[0])) // @ts-expect-error
    groups = [
        groups
    ];
    groups.forEach((controls)=>{
        const group = document.createElement("span");
        group.classList.add("ql-formats");
        controls.forEach((control)=>{
            if (typeof control === "string") $bedbec4eefd090ee$var$addButton(group, control);
            else {
                const format = Object.keys(control)[0];
                const value = control[format];
                if (Array.isArray(value)) $bedbec4eefd090ee$var$addSelect(group, format, value);
                else $bedbec4eefd090ee$var$addButton(group, format, value);
            }
        });
        container.appendChild(group);
    });
}
function $bedbec4eefd090ee$var$addSelect(container, format, values) {
    const input = document.createElement("select");
    input.classList.add(`ql-${format}`);
    values.forEach((value)=>{
        const option = document.createElement("option");
        if (value !== false) option.setAttribute("value", String(value));
        else option.setAttribute("selected", "selected");
        input.appendChild(option);
    });
    container.appendChild(input);
}
$bedbec4eefd090ee$export$2e2bcd8739ae039.DEFAULTS = {
    container: null,
    handlers: {
        clean () {
            const range = this.quill.getSelection();
            if (range == null) return;
            if (range.length === 0) {
                const formats = this.quill.getFormat();
                Object.keys(formats).forEach((name)=>{
                    // Clean functionality in existing apps only clean inline formats
                    if (this.quill.scroll.query(name, (0, $4617b32e1de5ada7$export$775b6bb06e53a214).INLINE) != null) this.quill.format(name, false, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                });
            } else this.quill.removeFormat(range.index, range.length, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        },
        direction (value) {
            const { align: align } = this.quill.getFormat();
            if (value === "rtl" && align == null) this.quill.format("align", "right", (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            else if (!value && align === "right") this.quill.format("align", false, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            this.quill.format("direction", value, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        },
        indent (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            // @ts-expect-error
            const indent = parseInt(formats.indent || 0, 10);
            if (value === "+1" || value === "-1") {
                let modifier = value === "+1" ? 1 : -1;
                if (formats.direction === "rtl") modifier *= -1;
                this.quill.format("indent", indent + modifier, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            }
        },
        link (value) {
            if (value === true) value = prompt("Enter link URL:"); // eslint-disable-line no-alert
            this.quill.format("link", value, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        },
        list (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            if (value === "check") {
                if (formats.list === "checked" || formats.list === "unchecked") this.quill.format("list", false, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                else this.quill.format("list", "unchecked", (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format("list", value, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
        }
    }
};


const $e1c8b3ce09702a41$var$alignLeftIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"/></svg>';
const $e1c8b3ce09702a41$var$alignCenterIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="14" x2="4" y1="14" y2="14"/><line class="ql-stroke" x1="12" x2="6" y1="4" y2="4"/></svg>';
const $e1c8b3ce09702a41$var$alignRightIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="15" x2="5" y1="14" y2="14"/><line class="ql-stroke" x1="15" x2="9" y1="4" y2="4"/></svg>';
const $e1c8b3ce09702a41$var$alignJustifyIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="15" x2="3" y1="14" y2="14"/><line class="ql-stroke" x1="15" x2="3" y1="4" y2="4"/></svg>';
const $e1c8b3ce09702a41$var$backgroundIcon = '<svg viewbox="0 0 18 18"><g class="ql-fill ql-color-label"><polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"/><rect height="1" width="1" x="4" y="4"/><polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"/><rect height="1" width="1" x="2" y="6"/><rect height="1" width="1" x="3" y="5"/><rect height="1" width="1" x="4" y="7"/><polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"/><rect height="1" width="1" x="2" y="12"/><rect height="1" width="1" x="2" y="9"/><rect height="1" width="1" x="2" y="15"/><polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"/><rect height="1" width="1" x="3" y="8"/><path d="M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z"/><path d="M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z"/><path d="M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z"/><rect height="1" width="1" x="12" y="2"/><rect height="1" width="1" x="11" y="3"/><path d="M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z"/><rect height="1" width="1" x="2" y="3"/><rect height="1" width="1" x="6" y="2"/><rect height="1" width="1" x="3" y="2"/><rect height="1" width="1" x="5" y="3"/><rect height="1" width="1" x="9" y="2"/><rect height="1" width="1" x="15" y="14"/><polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"/><rect height="1" width="1" x="13" y="7"/><rect height="1" width="1" x="15" y="5"/><rect height="1" width="1" x="14" y="6"/><rect height="1" width="1" x="15" y="8"/><rect height="1" width="1" x="14" y="9"/><path d="M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z"/><rect height="1" width="1" x="14" y="3"/><polygon points="12 6.868 12 6 11.62 6 12 6.868"/><rect height="1" width="1" x="15" y="2"/><rect height="1" width="1" x="12" y="5"/><rect height="1" width="1" x="13" y="4"/><polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"/><rect height="1" width="1" x="9" y="14"/><rect height="1" width="1" x="8" y="15"/><path d="M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z"/><rect height="1" width="1" x="5" y="15"/><path d="M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z"/><rect height="1" width="1" x="11" y="15"/><path d="M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z"/><rect height="1" width="1" x="14" y="15"/><rect height="1" width="1" x="15" y="11"/></g><polyline class="ql-stroke" points="5.5 13 9 5 12.5 13"/><line class="ql-stroke" x1="11.63" x2="6.38" y1="11" y2="11"/></svg>';
const $e1c8b3ce09702a41$var$blockquoteIcon = '<svg viewbox="0 0 18 18"><rect class="ql-fill ql-stroke" height="3" width="3" x="4" y="5"/><rect class="ql-fill ql-stroke" height="3" width="3" x="11" y="5"/><path class="ql-even ql-fill ql-stroke" d="M7,8c0,4.031-3,5-3,5"/><path class="ql-even ql-fill ql-stroke" d="M14,8c0,4.031-3,5-3,5"/></svg>';
const $e1c8b3ce09702a41$var$boldIcon = '<svg viewbox="0 0 18 18"><path class="ql-stroke" d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"/><path class="ql-stroke" d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"/></svg>';
const $e1c8b3ce09702a41$var$cleanIcon = '<svg class="" viewbox="0 0 18 18"><line class="ql-stroke" x1="5" x2="13" y1="3" y2="3"/><line class="ql-stroke" x1="6" x2="9.35" y1="12" y2="3"/><line class="ql-stroke" x1="11" x2="15" y1="11" y2="15"/><line class="ql-stroke" x1="15" x2="11" y1="11" y2="15"/><rect class="ql-fill" height="1" rx="0.5" ry="0.5" width="7" x="2" y="14"/></svg>';
const $e1c8b3ce09702a41$var$codeIcon = '<svg viewbox="0 0 18 18"><polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"/><polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"/><line class="ql-stroke" x1="10" x2="8" y1="5" y2="13"/></svg>';
const $e1c8b3ce09702a41$var$colorIcon = '<svg viewbox="0 0 18 18"><line class="ql-color-label ql-stroke ql-transparent" x1="3" x2="15" y1="15" y2="15"/><polyline class="ql-stroke" points="5.5 11 9 3 12.5 11"/><line class="ql-stroke" x1="11.63" x2="6.38" y1="9" y2="9"/></svg>';
const $e1c8b3ce09702a41$var$directionLeftToRightIcon = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"/><line class="ql-stroke ql-fill" x1="15" x2="11" y1="4" y2="4"/><path class="ql-fill" d="M11,3a3,3,0,0,0,0,6h1V3H11Z"/><rect class="ql-fill" height="11" width="1" x="11" y="4"/><rect class="ql-fill" height="11" width="1" x="13" y="4"/></svg>';
const $e1c8b3ce09702a41$var$directionRightToLeftIcon = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"/><line class="ql-stroke ql-fill" x1="9" x2="5" y1="4" y2="4"/><path class="ql-fill" d="M5,3A3,3,0,0,0,5,9H6V3H5Z"/><rect class="ql-fill" height="11" width="1" x="5" y="4"/><rect class="ql-fill" height="11" width="1" x="7" y="4"/></svg>';
const $e1c8b3ce09702a41$var$formulaIcon = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z"/><rect class="ql-fill" height="1.6" rx="0.8" ry="0.8" width="5" x="5.15" y="6.2"/><path class="ql-fill" d="M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z"/></svg>';
const $e1c8b3ce09702a41$var$headerIcon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z"/></svg>';
const $e1c8b3ce09702a41$var$header2Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>';
const $e1c8b3ce09702a41$var$header3Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>';
const $e1c8b3ce09702a41$var$header4Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z"/></svg>';
const $e1c8b3ce09702a41$var$header5Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>';
const $e1c8b3ce09702a41$var$header6Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z"/></svg>';
const $e1c8b3ce09702a41$var$italicIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="13" y1="4" y2="4"/><line class="ql-stroke" x1="5" x2="11" y1="14" y2="14"/><line class="ql-stroke" x1="8" x2="10" y1="14" y2="4"/></svg>';
const $e1c8b3ce09702a41$var$imageIcon = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="10" width="12" x="3" y="4"/><circle class="ql-fill" cx="6" cy="7" r="1"/><polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"/></svg>';
const $e1c8b3ce09702a41$var$indentIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"/></svg>';
const $e1c8b3ce09702a41$var$outdentIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-stroke" points="5 7 5 11 3 9 5 7"/></svg>';
const $e1c8b3ce09702a41$var$linkIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="11" y1="7" y2="11"/><path class="ql-even ql-stroke" d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"/><path class="ql-even ql-stroke" d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"/></svg>';
const $e1c8b3ce09702a41$var$listBulletIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="6" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="6" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="6" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="3" y1="4" y2="4"/><line class="ql-stroke" x1="3" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="3" x2="3" y1="14" y2="14"/></svg>';
const $e1c8b3ce09702a41$var$listCheckIcon = '<svg class="" viewbox="0 0 18 18"><line class="ql-stroke" x1="9" x2="15" y1="4" y2="4"/><polyline class="ql-stroke" points="3 4 4 5 6 3"/><line class="ql-stroke" x1="9" x2="15" y1="14" y2="14"/><polyline class="ql-stroke" points="3 14 4 15 6 13"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-stroke" points="3 9 4 10 6 8"/></svg>';
const $e1c8b3ce09702a41$var$listOrderedIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="7" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="7" x2="15" y1="14" y2="14"/><line class="ql-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"/><path class="ql-fill" d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"/><path class="ql-stroke ql-thin" d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"/><path class="ql-stroke ql-thin" d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"/></svg>';
const $e1c8b3ce09702a41$var$subscriptIcon = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z"/><path class="ql-fill" d="M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z"/></svg>';
const $e1c8b3ce09702a41$var$superscriptIcon = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z"/><path class="ql-fill" d="M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z"/></svg>';
const $e1c8b3ce09702a41$var$strikeIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke ql-thin" x1="15.5" x2="2.5" y1="8.5" y2="9.5"/><path class="ql-fill" d="M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z"/><path class="ql-fill" d="M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z"/></svg>';
const $e1c8b3ce09702a41$var$tableIcon = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="12" width="12" x="3" y="3"/><rect class="ql-fill" height="2" width="3" x="5" y="5"/><rect class="ql-fill" height="2" width="4" x="9" y="5"/><g class="ql-fill ql-transparent"><rect height="2" width="3" x="5" y="8"/><rect height="2" width="4" x="9" y="8"/><rect height="2" width="3" x="5" y="11"/><rect height="2" width="4" x="9" y="11"/></g></svg>';
const $e1c8b3ce09702a41$var$underlineIcon = '<svg viewbox="0 0 18 18"><path class="ql-stroke" d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"/><rect class="ql-fill" height="1" rx="0.5" ry="0.5" width="12" x="3" y="15"/></svg>';
const $e1c8b3ce09702a41$var$videoIcon = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="12" width="12" x="3" y="3"/><rect class="ql-fill" height="12" width="1" x="5" y="3"/><rect class="ql-fill" height="12" width="1" x="12" y="3"/><rect class="ql-fill" height="2" width="8" x="5" y="8"/><rect class="ql-fill" height="1" width="3" x="3" y="5"/><rect class="ql-fill" height="1" width="3" x="3" y="7"/><rect class="ql-fill" height="1" width="3" x="3" y="10"/><rect class="ql-fill" height="1" width="3" x="3" y="12"/><rect class="ql-fill" height="1" width="3" x="12" y="5"/><rect class="ql-fill" height="1" width="3" x="12" y="7"/><rect class="ql-fill" height="1" width="3" x="12" y="10"/><rect class="ql-fill" height="1" width="3" x="12" y="12"/></svg>';
var $e1c8b3ce09702a41$export$2e2bcd8739ae039 = {
    align: {
        "": $e1c8b3ce09702a41$var$alignLeftIcon,
        center: $e1c8b3ce09702a41$var$alignCenterIcon,
        right: $e1c8b3ce09702a41$var$alignRightIcon,
        justify: $e1c8b3ce09702a41$var$alignJustifyIcon
    },
    background: $e1c8b3ce09702a41$var$backgroundIcon,
    blockquote: $e1c8b3ce09702a41$var$blockquoteIcon,
    bold: $e1c8b3ce09702a41$var$boldIcon,
    clean: $e1c8b3ce09702a41$var$cleanIcon,
    code: $e1c8b3ce09702a41$var$codeIcon,
    "code-block": $e1c8b3ce09702a41$var$codeIcon,
    color: $e1c8b3ce09702a41$var$colorIcon,
    direction: {
        "": $e1c8b3ce09702a41$var$directionLeftToRightIcon,
        rtl: $e1c8b3ce09702a41$var$directionRightToLeftIcon
    },
    formula: $e1c8b3ce09702a41$var$formulaIcon,
    header: {
        "1": $e1c8b3ce09702a41$var$headerIcon,
        "2": $e1c8b3ce09702a41$var$header2Icon,
        "3": $e1c8b3ce09702a41$var$header3Icon,
        "4": $e1c8b3ce09702a41$var$header4Icon,
        "5": $e1c8b3ce09702a41$var$header5Icon,
        "6": $e1c8b3ce09702a41$var$header6Icon
    },
    italic: $e1c8b3ce09702a41$var$italicIcon,
    image: $e1c8b3ce09702a41$var$imageIcon,
    indent: {
        "+1": $e1c8b3ce09702a41$var$indentIcon,
        "-1": $e1c8b3ce09702a41$var$outdentIcon
    },
    link: $e1c8b3ce09702a41$var$linkIcon,
    list: {
        bullet: $e1c8b3ce09702a41$var$listBulletIcon,
        check: $e1c8b3ce09702a41$var$listCheckIcon,
        ordered: $e1c8b3ce09702a41$var$listOrderedIcon
    },
    script: {
        sub: $e1c8b3ce09702a41$var$subscriptIcon,
        super: $e1c8b3ce09702a41$var$superscriptIcon
    },
    strike: $e1c8b3ce09702a41$var$strikeIcon,
    table: $e1c8b3ce09702a41$var$tableIcon,
    underline: $e1c8b3ce09702a41$var$underlineIcon,
    video: $e1c8b3ce09702a41$var$videoIcon
};


const $1920969441832edc$var$DropdownIcon = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke" points="7 11 9 13 11 11 7 11"/><polygon class="ql-stroke" points="7 7 9 5 11 7 7 7"/></svg>';
let $1920969441832edc$var$optionsCounter = 0;
function $1920969441832edc$var$toggleAriaAttribute(element, attribute) {
    element.setAttribute(attribute, `${!(element.getAttribute(attribute) === "true")}`);
}
class $1920969441832edc$var$Picker {
    constructor(select){
        this.select = select;
        this.container = document.createElement("span");
        this.buildPicker();
        this.select.style.display = "none";
        // @ts-expect-error Fix me later
        this.select.parentNode.insertBefore(this.container, this.select);
        this.label.addEventListener("mousedown", ()=>{
            this.togglePicker();
        });
        this.label.addEventListener("keydown", (event)=>{
            switch(event.key){
                case "Enter":
                    this.togglePicker();
                    break;
                case "Escape":
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        this.select.addEventListener("change", this.update.bind(this));
    }
    togglePicker() {
        this.container.classList.toggle("ql-expanded");
        // Toggle aria-expanded and aria-hidden to make the picker accessible
        $1920969441832edc$var$toggleAriaAttribute(this.label, "aria-expanded");
        // @ts-expect-error
        $1920969441832edc$var$toggleAriaAttribute(this.options, "aria-hidden");
    }
    buildItem(option) {
        const item = document.createElement("span");
        // @ts-expect-error
        item.tabIndex = "0";
        item.setAttribute("role", "button");
        item.classList.add("ql-picker-item");
        const value = option.getAttribute("value");
        if (value) item.setAttribute("data-value", value);
        if (option.textContent) item.setAttribute("data-label", option.textContent);
        item.addEventListener("click", ()=>{
            this.selectItem(item, true);
        });
        item.addEventListener("keydown", (event)=>{
            switch(event.key){
                case "Enter":
                    this.selectItem(item, true);
                    event.preventDefault();
                    break;
                case "Escape":
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        return item;
    }
    buildLabel() {
        const label = document.createElement("span");
        label.classList.add("ql-picker-label");
        label.innerHTML = $1920969441832edc$var$DropdownIcon;
        // @ts-expect-error
        label.tabIndex = "0";
        label.setAttribute("role", "button");
        label.setAttribute("aria-expanded", "false");
        this.container.appendChild(label);
        return label;
    }
    buildOptions() {
        const options = document.createElement("span");
        options.classList.add("ql-picker-options");
        // Don't want screen readers to read this until options are visible
        options.setAttribute("aria-hidden", "true");
        // @ts-expect-error
        options.tabIndex = "-1";
        // Need a unique id for aria-controls
        options.id = `ql-picker-options-${$1920969441832edc$var$optionsCounter}`;
        $1920969441832edc$var$optionsCounter += 1;
        this.label.setAttribute("aria-controls", options.id);
        // @ts-expect-error
        this.options = options;
        Array.from(this.select.options).forEach((option)=>{
            const item = this.buildItem(option);
            options.appendChild(item);
            if (option.selected === true) this.selectItem(item);
        });
        this.container.appendChild(options);
    }
    buildPicker() {
        Array.from(this.select.attributes).forEach((item)=>{
            this.container.setAttribute(item.name, item.value);
        });
        this.container.classList.add("ql-picker");
        this.label = this.buildLabel();
        this.buildOptions();
    }
    escape() {
        // Close menu and return focus to trigger label
        this.close();
        // Need setTimeout for accessibility to ensure that the browser executes
        // focus on the next process thread and after any DOM content changes
        setTimeout(()=>this.label.focus(), 1);
    }
    close() {
        this.container.classList.remove("ql-expanded");
        this.label.setAttribute("aria-expanded", "false");
        // @ts-expect-error
        this.options.setAttribute("aria-hidden", "true");
    }
    selectItem(item) {
        let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const selected = this.container.querySelector(".ql-selected");
        if (item === selected) return;
        if (selected != null) selected.classList.remove("ql-selected");
        if (item == null) return;
        item.classList.add("ql-selected");
        // @ts-expect-error Fix me later
        this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
        if (item.hasAttribute("data-value")) // @ts-expect-error Fix me later
        this.label.setAttribute("data-value", item.getAttribute("data-value"));
        else this.label.removeAttribute("data-value");
        if (item.hasAttribute("data-label")) // @ts-expect-error Fix me later
        this.label.setAttribute("data-label", item.getAttribute("data-label"));
        else this.label.removeAttribute("data-label");
        if (trigger) {
            this.select.dispatchEvent(new Event("change"));
            this.close();
        }
    }
    update() {
        let option;
        if (this.select.selectedIndex > -1) {
            const item = // @ts-expect-error Fix me later
            this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];
            option = this.select.options[this.select.selectedIndex];
            // @ts-expect-error
            this.selectItem(item);
        } else this.selectItem(null);
        const isActive = option != null && option !== this.select.querySelector("option[selected]");
        this.label.classList.toggle("ql-active", isActive);
    }
}
var $1920969441832edc$export$2e2bcd8739ae039 = $1920969441832edc$var$Picker;



class $86768ccce102f46f$var$ColorPicker extends (0, $1920969441832edc$export$2e2bcd8739ae039) {
    constructor(select, label){
        super(select);
        this.label.innerHTML = label;
        this.container.classList.add("ql-color-picker");
        Array.from(this.container.querySelectorAll(".ql-picker-item")).slice(0, 7).forEach((item)=>{
            item.classList.add("ql-primary");
        });
    }
    buildItem(option) {
        const item = super.buildItem(option);
        item.style.backgroundColor = option.getAttribute("value") || "";
        return item;
    }
    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        const colorLabel = this.label.querySelector(".ql-color-label");
        const value = item ? item.getAttribute("data-value") || "" : "";
        if (colorLabel) {
            if (colorLabel.tagName === "line") colorLabel.style.stroke = value;
            else colorLabel.style.fill = value;
        }
    }
}
var $86768ccce102f46f$export$2e2bcd8739ae039 = $86768ccce102f46f$var$ColorPicker;



class $dde0bf0caeeca9bb$var$IconPicker extends (0, $1920969441832edc$export$2e2bcd8739ae039) {
    constructor(select, icons){
        super(select);
        this.container.classList.add("ql-icon-picker");
        Array.from(this.container.querySelectorAll(".ql-picker-item")).forEach((item)=>{
            item.innerHTML = icons[item.getAttribute("data-value") || ""];
        });
        this.defaultItem = this.container.querySelector(".ql-selected");
        this.selectItem(this.defaultItem);
    }
    selectItem(target, trigger) {
        super.selectItem(target, trigger);
        const item = target || this.defaultItem;
        if (item != null) {
            if (this.label.innerHTML === item.innerHTML) return;
            this.label.innerHTML = item.innerHTML;
        }
    }
}
var $dde0bf0caeeca9bb$export$2e2bcd8739ae039 = $dde0bf0caeeca9bb$var$IconPicker;


const $2165d4c4848d0d34$var$isScrollable = (el)=>{
    const { overflowY: overflowY } = getComputedStyle(el, null);
    return overflowY !== "visible" && overflowY !== "clip";
};
class $2165d4c4848d0d34$var$Tooltip {
    constructor(quill, boundsContainer){
        this.quill = quill;
        this.boundsContainer = boundsContainer || document.body;
        this.root = quill.addContainer("ql-tooltip");
        // @ts-expect-error
        this.root.innerHTML = this.constructor.TEMPLATE;
        if ($2165d4c4848d0d34$var$isScrollable(this.quill.root)) this.quill.root.addEventListener("scroll", ()=>{
            this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
        });
        this.hide();
    }
    hide() {
        this.root.classList.add("ql-hidden");
    }
    position(reference) {
        const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
        // root.scrollTop should be 0 if scrollContainer !== root
        const top = reference.bottom + this.quill.root.scrollTop;
        this.root.style.left = `${left}px`;
        this.root.style.top = `${top}px`;
        this.root.classList.remove("ql-flip");
        const containerBounds = this.boundsContainer.getBoundingClientRect();
        const rootBounds = this.root.getBoundingClientRect();
        let shift = 0;
        if (rootBounds.right > containerBounds.right) {
            shift = containerBounds.right - rootBounds.right;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.left < containerBounds.left) {
            shift = containerBounds.left - rootBounds.left;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.bottom > containerBounds.bottom) {
            const height = rootBounds.bottom - rootBounds.top;
            const verticalShift = reference.bottom - reference.top + height;
            this.root.style.top = `${top - verticalShift}px`;
            this.root.classList.add("ql-flip");
        }
        return shift;
    }
    show() {
        this.root.classList.remove("ql-editing");
        this.root.classList.remove("ql-hidden");
    }
}
var $2165d4c4848d0d34$export$2e2bcd8739ae039 = $2165d4c4848d0d34$var$Tooltip;











const $11ec1ac80cf3b803$var$ALIGNS = [
    false,
    "center",
    "right",
    "justify"
];
const $11ec1ac80cf3b803$var$COLORS = [
    "#000000",
    "#e60000",
    "#ff9900",
    "#ffff00",
    "#008a00",
    "#0066cc",
    "#9933ff",
    "#ffffff",
    "#facccc",
    "#ffebcc",
    "#ffffcc",
    "#cce8cc",
    "#cce0f5",
    "#ebd6ff",
    "#bbbbbb",
    "#f06666",
    "#ffc266",
    "#ffff66",
    "#66b966",
    "#66a3e0",
    "#c285ff",
    "#888888",
    "#a10000",
    "#b26b00",
    "#b2b200",
    "#006100",
    "#0047b2",
    "#6b24b2",
    "#444444",
    "#5c0000",
    "#663d00",
    "#666600",
    "#003700",
    "#002966",
    "#3d1466"
];
const $11ec1ac80cf3b803$var$FONTS = [
    false,
    "serif",
    "monospace"
];
const $11ec1ac80cf3b803$var$HEADERS = [
    "1",
    "2",
    "3",
    false
];
const $11ec1ac80cf3b803$var$SIZES = [
    "small",
    false,
    "large",
    "huge"
];
class $11ec1ac80cf3b803$export$2e2bcd8739ae039 extends (0, $a5d391299f891d74$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        const listener = (e)=>{
            if (!document.body.contains(quill.root)) {
                document.body.removeEventListener("click", listener);
                return;
            }
            if (this.tooltip != null && // @ts-expect-error
            !this.tooltip.root.contains(e.target) && // @ts-expect-error
            document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) this.tooltip.hide();
            if (this.pickers != null) this.pickers.forEach((picker)=>{
                // @ts-expect-error
                if (!picker.container.contains(e.target)) picker.close();
            });
        };
        quill.emitter.listenDOM("click", document.body, listener);
    }
    addModule(name) {
        const module = super.addModule(name);
        if (name === "toolbar") // @ts-expect-error
        this.extendToolbar(module);
        return module;
    }
    buildButtons(buttons, icons) {
        Array.from(buttons).forEach((button)=>{
            const className = button.getAttribute("class") || "";
            className.split(/\s+/).forEach((name)=>{
                if (!name.startsWith("ql-")) return;
                name = name.slice(3);
                if (icons[name] == null) return;
                if (name === "direction") // @ts-expect-error
                button.innerHTML = icons[name][""] + icons[name].rtl;
                else if (typeof icons[name] === "string") // @ts-expect-error
                button.innerHTML = icons[name];
                else {
                    // @ts-expect-error
                    const value = button.value || "";
                    // @ts-expect-error
                    if (value != null && icons[name][value]) // @ts-expect-error
                    button.innerHTML = icons[name][value];
                }
            });
        });
    }
    buildPickers(selects, icons) {
        this.pickers = Array.from(selects).map((select)=>{
            if (select.classList.contains("ql-align")) {
                if (select.querySelector("option") == null) $11ec1ac80cf3b803$var$fillSelect(select, $11ec1ac80cf3b803$var$ALIGNS);
                if (typeof icons.align === "object") return new (0, $dde0bf0caeeca9bb$export$2e2bcd8739ae039)(select, icons.align);
            }
            if (select.classList.contains("ql-background") || select.classList.contains("ql-color")) {
                const format = select.classList.contains("ql-background") ? "background" : "color";
                if (select.querySelector("option") == null) $11ec1ac80cf3b803$var$fillSelect(select, $11ec1ac80cf3b803$var$COLORS, format === "background" ? "#ffffff" : "#000000");
                return new (0, $86768ccce102f46f$export$2e2bcd8739ae039)(select, icons[format]);
            }
            if (select.querySelector("option") == null) {
                if (select.classList.contains("ql-font")) $11ec1ac80cf3b803$var$fillSelect(select, $11ec1ac80cf3b803$var$FONTS);
                else if (select.classList.contains("ql-header")) $11ec1ac80cf3b803$var$fillSelect(select, $11ec1ac80cf3b803$var$HEADERS);
                else if (select.classList.contains("ql-size")) $11ec1ac80cf3b803$var$fillSelect(select, $11ec1ac80cf3b803$var$SIZES);
            }
            return new (0, $1920969441832edc$export$2e2bcd8739ae039)(select);
        });
        const update = ()=>{
            this.pickers.forEach((picker)=>{
                picker.update();
            });
        };
        this.quill.on((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.EDITOR_CHANGE, update);
    }
}
$11ec1ac80cf3b803$export$2e2bcd8739ae039.DEFAULTS = (0, $f1bd5ef7b2b6a87a$export$2e2bcd8739ae039)({}, (0, $a5d391299f891d74$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                formula () {
                    this.quill.theme.tooltip.edit("formula");
                },
                image () {
                    let fileInput = this.container.querySelector("input.ql-image[type=file]");
                    if (fileInput == null) {
                        fileInput = document.createElement("input");
                        fileInput.setAttribute("type", "file");
                        fileInput.setAttribute("accept", this.quill.uploader.options.mimetypes.join(", "));
                        fileInput.classList.add("ql-image");
                        fileInput.addEventListener("change", ()=>{
                            const range = this.quill.getSelection(true);
                            this.quill.uploader.upload(range, fileInput.files);
                            fileInput.value = "";
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                },
                video () {
                    this.quill.theme.tooltip.edit("video");
                }
            }
        }
    }
});
class $11ec1ac80cf3b803$export$ba0102162f9e195c extends (0, $2165d4c4848d0d34$export$2e2bcd8739ae039) {
    constructor(quill, boundsContainer){
        super(quill, boundsContainer);
        this.textbox = this.root.querySelector('input[type="text"]');
        this.listen();
    }
    listen() {
        // @ts-expect-error Fix me later
        this.textbox.addEventListener("keydown", (event)=>{
            if (event.key === "Enter") {
                this.save();
                event.preventDefault();
            } else if (event.key === "Escape") {
                this.cancel();
                event.preventDefault();
            }
        });
    }
    cancel() {
        this.hide();
        this.restoreFocus();
    }
    edit() {
        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "link";
        let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.root.classList.remove("ql-hidden");
        this.root.classList.add("ql-editing");
        if (this.textbox == null) return;
        if (preview != null) this.textbox.value = preview;
        else if (mode !== this.root.getAttribute("data-mode")) this.textbox.value = "";
        const bounds = this.quill.getBounds(this.quill.selection.savedRange);
        if (bounds != null) this.position(bounds);
        this.textbox.select();
        this.textbox.setAttribute("placeholder", this.textbox.getAttribute(`data-${mode}`) || "");
        this.root.setAttribute("data-mode", mode);
    }
    restoreFocus() {
        this.quill.focus({
            preventScroll: true
        });
    }
    save() {
        // @ts-expect-error Fix me later
        let { value: value } = this.textbox;
        switch(this.root.getAttribute("data-mode")){
            case "link":
                {
                    const { scrollTop: scrollTop } = this.quill.root;
                    if (this.linkRange) {
                        this.quill.formatText(this.linkRange, "link", value, (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER);
                        delete this.linkRange;
                    } else {
                        this.restoreFocus();
                        this.quill.format("link", value, (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                }
            case "video":
                value = $11ec1ac80cf3b803$var$extractVideoUrl(value);
            // eslint-disable-next-line no-fallthrough
            case "formula":
                {
                    if (!value) break;
                    const range = this.quill.getSelection(true);
                    if (range != null) {
                        const index = range.index + range.length;
                        this.quill.insertEmbed(index, // @ts-expect-error Fix me later
                        this.root.getAttribute("data-mode"), value, (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER);
                        if (this.root.getAttribute("data-mode") === "formula") this.quill.insertText(index + 1, " ", (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index + 2, (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER);
                    }
                    break;
                }
            default:
        }
        // @ts-expect-error Fix me later
        this.textbox.value = "";
        this.hide();
    }
}
function $11ec1ac80cf3b803$var$extractVideoUrl(url) {
    let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) return `${match[1] || "https"}://www.youtube.com/embed/${match[2]}?showinfo=0`;
    // eslint-disable-next-line no-cond-assign
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) return `${match[1] || "https"}://player.vimeo.com/video/${match[2]}/`;
    return url;
}
function $11ec1ac80cf3b803$var$fillSelect(select, values) {
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    values.forEach((value)=>{
        const option = document.createElement("option");
        if (value === defaultValue) option.setAttribute("selected", "selected");
        else option.setAttribute("value", String(value));
        select.appendChild(option);
    });
}





const $c8ae8205cb7e66d5$var$TOOLBAR_CONFIG = [
    [
        "bold",
        "italic",
        "link"
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        },
        "blockquote"
    ]
];
class $c8ae8205cb7e66d5$export$572b56f7a5e9813a extends (0, $11ec1ac80cf3b803$export$ba0102162f9e195c) {
    static TEMPLATE = [
        '<span class="ql-tooltip-arrow"></span>',
        '<div class="ql-tooltip-editor">',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-close"></a>',
        "</div>"
    ].join("");
    constructor(quill, bounds){
        super(quill, bounds);
        this.quill.on((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type, range, oldRange, source)=>{
            if (type !== (0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER) {
                this.show();
                // Lock our width so we will expand beyond our offsetParent boundaries
                this.root.style.left = "0px";
                this.root.style.width = "";
                this.root.style.width = `${this.root.offsetWidth}px`;
                const lines = this.quill.getLines(range.index, range.length);
                if (lines.length === 1) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                } else {
                    const lastLine = lines[lines.length - 1];
                    const index = this.quill.getIndex(lastLine);
                    const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    const indexBounds = this.quill.getBounds(new (0, $da439b8df62e063a$export$9a58ef0d7ad3278c)(index, length));
                    if (indexBounds != null) this.position(indexBounds);
                }
            } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) this.hide();
        });
    }
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector(".ql-close").addEventListener("click", ()=>{
            this.root.classList.remove("ql-editing");
        });
        this.quill.on((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            // Let selection be restored by toolbar handlers before repositioning
            setTimeout(()=>{
                if (this.root.classList.contains("ql-hidden")) return;
                const range = this.quill.getSelection();
                if (range != null) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                }
            }, 1);
        });
    }
    cancel() {
        this.show();
    }
    position(reference) {
        const shift = super.position(reference);
        const arrow = this.root.querySelector(".ql-tooltip-arrow");
        // @ts-expect-error
        arrow.style.marginLeft = "";
        if (shift !== 0) // @ts-expect-error
        arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
        return shift;
    }
}
class $c8ae8205cb7e66d5$export$2e2bcd8739ae039 extends (0, $11ec1ac80cf3b803$export$2e2bcd8739ae039) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $c8ae8205cb7e66d5$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add("ql-bubble");
    }
    extendToolbar(toolbar) {
        // @ts-expect-error
        this.tooltip = new $c8ae8205cb7e66d5$export$572b56f7a5e9813a(this.quill, this.options.bounds);
        if (toolbar.container != null) {
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons(toolbar.container.querySelectorAll("button"), (0, $e1c8b3ce09702a41$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll("select"), (0, $e1c8b3ce09702a41$export$2e2bcd8739ae039));
        }
    }
}
$c8ae8205cb7e66d5$export$2e2bcd8739ae039.DEFAULTS = (0, $f1bd5ef7b2b6a87a$export$2e2bcd8739ae039)({}, (0, $11ec1ac80cf3b803$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (!value) this.quill.format("link", false, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                    else // @ts-expect-error
                    this.quill.theme.tooltip.edit();
                }
            }
        }
    }
});









const $16f2131f5684f119$var$TOOLBAR_CONFIG = [
    [
        {
            header: [
                "1",
                "2",
                "3",
                false
            ]
        }
    ],
    [
        "bold",
        "italic",
        "underline",
        "link"
    ],
    [
        {
            list: "ordered"
        },
        {
            list: "bullet"
        }
    ],
    [
        "clean"
    ]
];
class $16f2131f5684f119$var$SnowTooltip extends (0, $11ec1ac80cf3b803$export$ba0102162f9e195c) {
    static TEMPLATE = [
        '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-action"></a>',
        '<a class="ql-remove"></a>'
    ].join("");
    preview = this.root.querySelector("a.ql-preview");
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector("a.ql-action").addEventListener("click", (event)=>{
            if (this.root.classList.contains("ql-editing")) this.save();
            else // @ts-expect-error Fix me later
            this.edit("link", this.preview.textContent);
            event.preventDefault();
        });
        // @ts-expect-error Fix me later
        this.root.querySelector("a.ql-remove").addEventListener("click", (event)=>{
            if (this.linkRange != null) {
                const range = this.linkRange;
                this.restoreFocus();
                this.quill.formatText(range, "link", false, (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER);
                delete this.linkRange;
            }
            event.preventDefault();
            this.hide();
        });
        this.quill.on((0, $427c503a5337bba7$export$2e2bcd8739ae039).events.SELECTION_CHANGE, (range, oldRange, source)=>{
            if (range == null) return;
            if (range.length === 0 && source === (0, $427c503a5337bba7$export$2e2bcd8739ae039).sources.USER) {
                const [link, offset] = this.quill.scroll.descendant((0, $c37a786fd52764f9$export$2e2bcd8739ae039), range.index);
                if (link != null) {
                    this.linkRange = new (0, $da439b8df62e063a$export$9a58ef0d7ad3278c)(range.index - offset, link.length());
                    const preview = (0, $c37a786fd52764f9$export$2e2bcd8739ae039).formats(link.domNode);
                    // @ts-expect-error Fix me later
                    this.preview.textContent = preview;
                    // @ts-expect-error Fix me later
                    this.preview.setAttribute("href", preview);
                    this.show();
                    const bounds = this.quill.getBounds(this.linkRange);
                    if (bounds != null) this.position(bounds);
                    return;
                }
            } else delete this.linkRange;
            this.hide();
        });
    }
    show() {
        super.show();
        this.root.removeAttribute("data-mode");
    }
}
class $16f2131f5684f119$var$SnowTheme extends (0, $11ec1ac80cf3b803$export$2e2bcd8739ae039) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $16f2131f5684f119$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add("ql-snow");
    }
    extendToolbar(toolbar) {
        if (toolbar.container != null) {
            toolbar.container.classList.add("ql-snow");
            this.buildButtons(toolbar.container.querySelectorAll("button"), (0, $e1c8b3ce09702a41$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll("select"), (0, $e1c8b3ce09702a41$export$2e2bcd8739ae039));
            // @ts-expect-error
            this.tooltip = new $16f2131f5684f119$var$SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector(".ql-link")) this.quill.keyboard.addBinding({
                key: "k",
                shortKey: true
            }, (_range, context)=>{
                toolbar.handlers.link.call(toolbar, !context.format.link);
            });
        }
    }
}
$16f2131f5684f119$var$SnowTheme.DEFAULTS = (0, $f1bd5ef7b2b6a87a$export$2e2bcd8739ae039)({}, (0, $11ec1ac80cf3b803$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) return;
                        let preview = this.quill.getText(range);
                        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf("mailto:") !== 0) preview = `mailto:${preview}`;
                        // @ts-expect-error
                        const { tooltip: tooltip } = this.quill.theme;
                        tooltip.edit("link", preview);
                    } else this.quill.format("link", false, (0, $a10f3bd4ce427c01$export$2e2bcd8739ae039).sources.USER);
                }
            }
        }
    }
});
var $16f2131f5684f119$export$2e2bcd8739ae039 = $16f2131f5684f119$var$SnowTheme;


(0, $a01df3575c0d914e$export$2e2bcd8739ae039).register({
    "attributors/attribute/direction": (0, $05731c47851567d5$export$4158215dafad9efa),
    "attributors/class/align": (0, $337ca6b70475fd89$export$7f3685f5846c07da),
    "attributors/class/background": (0, $b2d8f55b55dc7dde$export$8aa96c8963152b12),
    "attributors/class/color": (0, $8c6ac1207aa6a978$export$42795dcf0ec6f3c8),
    "attributors/class/direction": (0, $05731c47851567d5$export$630028b3af294dec),
    "attributors/class/font": (0, $37324b3d3c9fa7f2$export$78a99ee601572ab),
    "attributors/class/size": (0, $5af457acd7848d59$export$c84684d52bca9684),
    "attributors/style/align": (0, $337ca6b70475fd89$export$d2060f5d114c9fe8),
    "attributors/style/background": (0, $b2d8f55b55dc7dde$export$dc1cbcab4c682ef),
    "attributors/style/color": (0, $8c6ac1207aa6a978$export$1415f56796d9a5a9),
    "attributors/style/direction": (0, $05731c47851567d5$export$175979e518d1dfd1),
    "attributors/style/font": (0, $37324b3d3c9fa7f2$export$23b468d4ca3f8c96),
    "attributors/style/size": (0, $5af457acd7848d59$export$5443b95a30e89ac5)
}, true);
(0, $a01df3575c0d914e$export$2e2bcd8739ae039).register({
    "formats/align": (0, $337ca6b70475fd89$export$7f3685f5846c07da),
    "formats/direction": (0, $05731c47851567d5$export$630028b3af294dec),
    "formats/indent": (0, $a7f25e87db2ed210$export$2e2bcd8739ae039),
    "formats/background": (0, $b2d8f55b55dc7dde$export$dc1cbcab4c682ef),
    "formats/color": (0, $8c6ac1207aa6a978$export$1415f56796d9a5a9),
    "formats/font": (0, $37324b3d3c9fa7f2$export$78a99ee601572ab),
    "formats/size": (0, $5af457acd7848d59$export$c84684d52bca9684),
    "formats/blockquote": (0, $d2435c2a0ffc3827$export$2e2bcd8739ae039),
    "formats/code-block": (0, $77064d128953548d$export$2e2bcd8739ae039),
    "formats/header": (0, $7d73013d9a7cc10b$export$2e2bcd8739ae039),
    "formats/list": (0, $4ae264b8c51ddb3b$export$2e2bcd8739ae039),
    "formats/bold": (0, $8d319051fe03484e$export$2e2bcd8739ae039),
    "formats/code": (0, $77064d128953548d$export$52f0f02147b12c03),
    "formats/italic": (0, $d40d4db502a7f134$export$2e2bcd8739ae039),
    "formats/link": (0, $c37a786fd52764f9$export$2e2bcd8739ae039),
    "formats/script": (0, $6dd0321fcfb194e1$export$2e2bcd8739ae039),
    "formats/strike": (0, $efae789a1aa9dfab$export$2e2bcd8739ae039),
    "formats/underline": (0, $267a34f4d39d38b3$export$2e2bcd8739ae039),
    "formats/formula": (0, $75ddaa5c0d54a8b8$export$2e2bcd8739ae039),
    "formats/image": (0, $9f0a9bceae9b296f$export$2e2bcd8739ae039),
    "formats/video": (0, $c98ab345673724c5$export$2e2bcd8739ae039),
    "modules/syntax": (0, $1e008732fe422fd8$export$2e2bcd8739ae039),
    "modules/table": (0, $c05e45a610b7f1a2$export$2e2bcd8739ae039),
    "modules/toolbar": (0, $bedbec4eefd090ee$export$2e2bcd8739ae039),
    "themes/bubble": (0, $c8ae8205cb7e66d5$export$2e2bcd8739ae039),
    "themes/snow": (0, $16f2131f5684f119$export$2e2bcd8739ae039),
    "ui/icons": (0, $e1c8b3ce09702a41$export$2e2bcd8739ae039),
    "ui/picker": (0, $1920969441832edc$export$2e2bcd8739ae039),
    "ui/icon-picker": (0, $dde0bf0caeeca9bb$export$2e2bcd8739ae039),
    "ui/color-picker": (0, $86768ccce102f46f$export$2e2bcd8739ae039),
    "ui/tooltip": (0, $2165d4c4848d0d34$export$2e2bcd8739ae039)
}, true);
var $c197469b58ae8971$export$2e2bcd8739ae039 = (0, $a01df3575c0d914e$export$2e2bcd8739ae039);




const $e87d4bd42ac851f3$export$3f3b4272299f29de = ()=>{
    const QUILL_EL = document.querySelectorAll(".quill-inner");
    // Replace icons
    let icons = (0, $c197469b58ae8971$export$2e2bcd8739ae039).import("ui/icons");
    icons["bold"] = '<i class="ph ph-text-b"></i>';
    icons["italic"] = '<i class="ph ph-text-italic"></i>';
    icons["underline"] = '<i class="ph ph-text-underline"></i>';
    icons["link"] = '<i class="ph ph-link"></i>';
    icons["image"] = '<i class="ph ph-image"></i>';
    icons["list"]["ordered"] = '<i class="ph ph-list-numbers"></i>';
    icons["list"]["bullet"] = '<i class="ph ph-list-bullets"></i>';
    if (QUILL_EL.length > 0) QUILL_EL.forEach((item)=>{
        let placeholder = item.getAttribute("data-placeholder");
        new (0, $c197469b58ae8971$export$2e2bcd8739ae039)(item, {
            modules: {
                toolbar: [
                    [
                        "bold",
                        "italic",
                        "underline"
                    ],
                    [
                        {
                            list: "ordered"
                        },
                        {
                            list: "bullet"
                        }
                    ],
                    [
                        "link",
                        "image"
                    ]
                ]
            },
            placeholder: placeholder,
            theme: "snow"
        });
    });
};



var $60Xwh = parcelRequire("60Xwh");
const $2f8c1ce30a15b0c7$export$565dcf582cc7e325 = ()=>{
    // Popovers
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    const popoverList = [
        ...popoverTriggerList
    ].map((popoverTriggerEl)=>new $60Xwh.Popover(popoverTriggerEl));
    // Tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [
        ...tooltipTriggerList
    ].map((tooltipTriggerEl)=>new $60Xwh.Tooltip(tooltipTriggerEl));
};


"use strict";
var $e9704b94b3b62e8f$export$126649350cd02471;
(function(PipsMode) {
    PipsMode["Range"] = "range";
    PipsMode["Steps"] = "steps";
    PipsMode["Positions"] = "positions";
    PipsMode["Count"] = "count";
    PipsMode["Values"] = "values";
})($e9704b94b3b62e8f$export$126649350cd02471 || ($e9704b94b3b62e8f$export$126649350cd02471 = {}));
var $e9704b94b3b62e8f$export$ab20e68cdcd7a4fc;
(function(PipsType) {
    PipsType[PipsType["None"] = -1] = "None";
    PipsType[PipsType["NoValue"] = 0] = "NoValue";
    PipsType[PipsType["LargeValue"] = 1] = "LargeValue";
    PipsType[PipsType["SmallValue"] = 2] = "SmallValue";
})($e9704b94b3b62e8f$export$ab20e68cdcd7a4fc || ($e9704b94b3b62e8f$export$ab20e68cdcd7a4fc = {}));
//region Helper Methods
function $e9704b94b3b62e8f$var$isValidFormatter(entry) {
    return $e9704b94b3b62e8f$var$isValidPartialFormatter(entry) && typeof entry.from === "function";
}
function $e9704b94b3b62e8f$var$isValidPartialFormatter(entry) {
    // partial formatters only need a to function and not a from function
    return typeof entry === "object" && typeof entry.to === "function";
}
function $e9704b94b3b62e8f$var$removeElement(el) {
    el.parentElement.removeChild(el);
}
function $e9704b94b3b62e8f$var$isSet(value) {
    return value !== null && value !== undefined;
}
// Bindable version
function $e9704b94b3b62e8f$var$preventDefault(e) {
    e.preventDefault();
}
// Removes duplicates from an array.
function $e9704b94b3b62e8f$var$unique(array) {
    return array.filter(function(a) {
        return !this[a] ? this[a] = true : false;
    }, {});
}
// Round a value to the closest 'to'.
function $e9704b94b3b62e8f$var$closest(value, to) {
    return Math.round(value / to) * to;
}
// Current position of an element relative to the document.
function $e9704b94b3b62e8f$var$offset(elem, orientation) {
    var rect = elem.getBoundingClientRect();
    var doc = elem.ownerDocument;
    var docElem = doc.documentElement;
    var pageOffset = $e9704b94b3b62e8f$var$getPageOffset(doc);
    // getBoundingClientRect contains left scroll in Chrome on Android.
    // I haven't found a feature detection that proves this. Worst case
    // scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
    if (/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)) pageOffset.x = 0;
    return orientation ? rect.top + pageOffset.y - docElem.clientTop : rect.left + pageOffset.x - docElem.clientLeft;
}
// Checks whether a value is numerical.
function $e9704b94b3b62e8f$var$isNumeric(a) {
    return typeof a === "number" && !isNaN(a) && isFinite(a);
}
// Sets a class and removes it after [duration] ms.
function $e9704b94b3b62e8f$var$addClassFor(element, className, duration) {
    if (duration > 0) {
        $e9704b94b3b62e8f$var$addClass(element, className);
        setTimeout(function() {
            $e9704b94b3b62e8f$var$removeClass(element, className);
        }, duration);
    }
}
// Limits a value to 0 - 100
function $e9704b94b3b62e8f$var$limit(a) {
    return Math.max(Math.min(a, 100), 0);
}
// Wraps a variable as an array, if it isn't one yet.
// Note that an input array is returned by reference!
function $e9704b94b3b62e8f$var$asArray(a) {
    return Array.isArray(a) ? a : [
        a
    ];
}
// Counts decimals
function $e9704b94b3b62e8f$var$countDecimals(numStr) {
    numStr = String(numStr);
    var pieces = numStr.split(".");
    return pieces.length > 1 ? pieces[1].length : 0;
}
// http://youmightnotneedjquery.com/#add_class
function $e9704b94b3b62e8f$var$addClass(el, className) {
    if (el.classList && !/\s/.test(className)) el.classList.add(className);
    else el.className += " " + className;
}
// http://youmightnotneedjquery.com/#remove_class
function $e9704b94b3b62e8f$var$removeClass(el, className) {
    if (el.classList && !/\s/.test(className)) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
}
// https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
function $e9704b94b3b62e8f$var$hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp("\\b" + className + "\\b").test(el.className);
}
// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
function $e9704b94b3b62e8f$var$getPageOffset(doc) {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (doc.compatMode || "") === "CSS1Compat";
    var x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? doc.documentElement.scrollLeft : doc.body.scrollLeft;
    var y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? doc.documentElement.scrollTop : doc.body.scrollTop;
    return {
        x: x,
        y: y
    };
}
// we provide a function to compute constants instead
// of accessing window.* as soon as the module needs it
// so that we do not compute anything if not needed
function $e9704b94b3b62e8f$var$getActions() {
    // Determine the events to bind. IE11 implements pointerEvents without
    // a prefix, which breaks compatibility with the IE10 implementation.
    return window.navigator.pointerEnabled ? {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup"
    } : window.navigator.msPointerEnabled ? {
        start: "MSPointerDown",
        move: "MSPointerMove",
        end: "MSPointerUp"
    } : {
        start: "mousedown touchstart",
        move: "mousemove touchmove",
        end: "mouseup touchend"
    };
}
// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
// Issue #785
function $e9704b94b3b62e8f$var$getSupportsPassive() {
    var supportsPassive = false;
    /* eslint-disable */ try {
        var opts = Object.defineProperty({}, "passive", {
            get: function() {
                supportsPassive = true;
            }
        });
        // @ts-ignore
        window.addEventListener("test", null, opts);
    } catch (e) {}
    /* eslint-enable */ return supportsPassive;
}
function $e9704b94b3b62e8f$var$getSupportsTouchActionNone() {
    return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
}
//endregion
//region Range Calculation
// Determine the size of a sub-range in relation to a full range.
function $e9704b94b3b62e8f$var$subRangeRatio(pa, pb) {
    return 100 / (pb - pa);
}
// (percentage) How many percent is this value of this range?
function $e9704b94b3b62e8f$var$fromPercentage(range, value, startRange) {
    return value * 100 / (range[startRange + 1] - range[startRange]);
}
// (percentage) Where is this value on this range?
function $e9704b94b3b62e8f$var$toPercentage(range, value) {
    return $e9704b94b3b62e8f$var$fromPercentage(range, range[0] < 0 ? value + Math.abs(range[0]) : value - range[0], 0);
}
// (value) How much is this percentage on this range?
function $e9704b94b3b62e8f$var$isPercentage(range, value) {
    return value * (range[1] - range[0]) / 100 + range[0];
}
function $e9704b94b3b62e8f$var$getJ(value, arr) {
    var j = 1;
    while(value >= arr[j])j += 1;
    return j;
}
// (percentage) Input a value, find where, on a scale of 0-100, it applies.
function $e9704b94b3b62e8f$var$toStepping(xVal, xPct, value) {
    if (value >= xVal.slice(-1)[0]) return 100;
    var j = $e9704b94b3b62e8f$var$getJ(value, xVal);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return pa + $e9704b94b3b62e8f$var$toPercentage([
        va,
        vb
    ], value) / $e9704b94b3b62e8f$var$subRangeRatio(pa, pb);
}
// (value) Input a percentage, find where it is on the specified range.
function $e9704b94b3b62e8f$var$fromStepping(xVal, xPct, value) {
    // There is no range group that fits 100
    if (value >= 100) return xVal.slice(-1)[0];
    var j = $e9704b94b3b62e8f$var$getJ(value, xPct);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return $e9704b94b3b62e8f$var$isPercentage([
        va,
        vb
    ], (value - pa) * $e9704b94b3b62e8f$var$subRangeRatio(pa, pb));
}
// (percentage) Get the step that applies at a certain value.
function $e9704b94b3b62e8f$var$getStep(xPct, xSteps, snap, value) {
    if (value === 100) return value;
    var j = $e9704b94b3b62e8f$var$getJ(value, xPct);
    var a = xPct[j - 1];
    var b = xPct[j];
    // If 'snap' is set, steps are used as fixed points on the slider.
    if (snap) {
        // Find the closest position, a or b.
        if (value - a > (b - a) / 2) return b;
        return a;
    }
    if (!xSteps[j - 1]) return value;
    return xPct[j - 1] + $e9704b94b3b62e8f$var$closest(value - xPct[j - 1], xSteps[j - 1]);
}
//endregion
//region Spectrum
var $e9704b94b3b62e8f$var$Spectrum = /** @class */ function() {
    function Spectrum(entry, snap, singleStep) {
        this.xPct = [];
        this.xVal = [];
        this.xSteps = [];
        this.xNumSteps = [];
        this.xHighestCompleteStep = [];
        this.xSteps = [
            singleStep || false
        ];
        this.xNumSteps = [
            false
        ];
        this.snap = snap;
        var index;
        var ordered = [];
        // Map the object keys to an array.
        Object.keys(entry).forEach(function(index) {
            ordered.push([
                $e9704b94b3b62e8f$var$asArray(entry[index]),
                index
            ]);
        });
        // Sort all entries by value (numeric sort).
        ordered.sort(function(a, b) {
            return a[0][0] - b[0][0];
        });
        // Convert all entries to subranges.
        for(index = 0; index < ordered.length; index++)this.handleEntryPoint(ordered[index][1], ordered[index][0]);
        // Store the actual step values.
        // xSteps is sorted in the same order as xPct and xVal.
        this.xNumSteps = this.xSteps.slice(0);
        // Convert all numeric steps to the percentage of the subrange they represent.
        for(index = 0; index < this.xNumSteps.length; index++)this.handleStepPoint(index, this.xNumSteps[index]);
    }
    Spectrum.prototype.getDistance = function(value) {
        var distances = [];
        for(var index = 0; index < this.xNumSteps.length - 1; index++)distances[index] = $e9704b94b3b62e8f$var$fromPercentage(this.xVal, value, index);
        return distances;
    };
    // Calculate the percentual distance over the whole scale of ranges.
    // direction: 0 = backwards / 1 = forwards
    Spectrum.prototype.getAbsoluteDistance = function(value, distances, direction) {
        var xPct_index = 0;
        // Calculate range where to start calculation
        if (value < this.xPct[this.xPct.length - 1]) while(value > this.xPct[xPct_index + 1])xPct_index++;
        else if (value === this.xPct[this.xPct.length - 1]) xPct_index = this.xPct.length - 2;
        // If looking backwards and the value is exactly at a range separator then look one range further
        if (!direction && value === this.xPct[xPct_index + 1]) xPct_index++;
        if (distances === null) distances = [];
        var start_factor;
        var rest_factor = 1;
        var rest_rel_distance = distances[xPct_index];
        var range_pct = 0;
        var rel_range_distance = 0;
        var abs_distance_counter = 0;
        var range_counter = 0;
        // Calculate what part of the start range the value is
        if (direction) start_factor = (value - this.xPct[xPct_index]) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        else start_factor = (this.xPct[xPct_index + 1] - value) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        // Do until the complete distance across ranges is calculated
        while(rest_rel_distance > 0){
            // Calculate the percentage of total range
            range_pct = this.xPct[xPct_index + 1 + range_counter] - this.xPct[xPct_index + range_counter];
            // Detect if the margin, padding or limit is larger then the current range and calculate
            if (distances[xPct_index + range_counter] * rest_factor + 100 - start_factor * 100 > 100) {
                // If larger then take the percentual distance of the whole range
                rel_range_distance = range_pct * start_factor;
                // Rest factor of relative percentual distance still to be calculated
                rest_factor = (rest_rel_distance - 100 * start_factor) / distances[xPct_index + range_counter];
                // Set start factor to 1 as for next range it does not apply.
                start_factor = 1;
            } else {
                // If smaller or equal then take the percentual distance of the calculate percentual part of that range
                rel_range_distance = distances[xPct_index + range_counter] * range_pct / 100 * rest_factor;
                // No rest left as the rest fits in current range
                rest_factor = 0;
            }
            if (direction) {
                abs_distance_counter = abs_distance_counter - rel_range_distance;
                // Limit range to first range when distance becomes outside of minimum range
                if (this.xPct.length + range_counter >= 1) range_counter--;
            } else {
                abs_distance_counter = abs_distance_counter + rel_range_distance;
                // Limit range to last range when distance becomes outside of maximum range
                if (this.xPct.length - range_counter >= 1) range_counter++;
            }
            // Rest of relative percentual distance still to be calculated
            rest_rel_distance = distances[xPct_index + range_counter] * rest_factor;
        }
        return value + abs_distance_counter;
    };
    Spectrum.prototype.toStepping = function(value) {
        value = $e9704b94b3b62e8f$var$toStepping(this.xVal, this.xPct, value);
        return value;
    };
    Spectrum.prototype.fromStepping = function(value) {
        return $e9704b94b3b62e8f$var$fromStepping(this.xVal, this.xPct, value);
    };
    Spectrum.prototype.getStep = function(value) {
        value = $e9704b94b3b62e8f$var$getStep(this.xPct, this.xSteps, this.snap, value);
        return value;
    };
    Spectrum.prototype.getDefaultStep = function(value, isDown, size) {
        var j = $e9704b94b3b62e8f$var$getJ(value, this.xPct);
        // When at the top or stepping down, look at the previous sub-range
        if (value === 100 || isDown && value === this.xPct[j - 1]) j = Math.max(j - 1, 1);
        return (this.xVal[j] - this.xVal[j - 1]) / size;
    };
    Spectrum.prototype.getNearbySteps = function(value) {
        var j = $e9704b94b3b62e8f$var$getJ(value, this.xPct);
        return {
            stepBefore: {
                startValue: this.xVal[j - 2],
                step: this.xNumSteps[j - 2],
                highestStep: this.xHighestCompleteStep[j - 2]
            },
            thisStep: {
                startValue: this.xVal[j - 1],
                step: this.xNumSteps[j - 1],
                highestStep: this.xHighestCompleteStep[j - 1]
            },
            stepAfter: {
                startValue: this.xVal[j],
                step: this.xNumSteps[j],
                highestStep: this.xHighestCompleteStep[j]
            }
        };
    };
    Spectrum.prototype.countStepDecimals = function() {
        var stepDecimals = this.xNumSteps.map($e9704b94b3b62e8f$var$countDecimals);
        return Math.max.apply(null, stepDecimals);
    };
    Spectrum.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
    };
    // Outside testing
    Spectrum.prototype.convert = function(value) {
        return this.getStep(this.toStepping(value));
    };
    Spectrum.prototype.handleEntryPoint = function(index, value) {
        var percentage;
        // Covert min/max syntax to 0 and 100.
        if (index === "min") percentage = 0;
        else if (index === "max") percentage = 100;
        else percentage = parseFloat(index);
        // Check for correct input.
        if (!$e9704b94b3b62e8f$var$isNumeric(percentage) || !$e9704b94b3b62e8f$var$isNumeric(value[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        // Store values.
        this.xPct.push(percentage);
        this.xVal.push(value[0]);
        var value1 = Number(value[1]);
        // NaN will evaluate to false too, but to keep
        // logging clear, set step explicitly. Make sure
        // not to override the 'step' setting with false.
        if (!percentage) {
            if (!isNaN(value1)) this.xSteps[0] = value1;
        } else this.xSteps.push(isNaN(value1) ? false : value1);
        this.xHighestCompleteStep.push(0);
    };
    Spectrum.prototype.handleStepPoint = function(i, n) {
        // Ignore 'false' stepping.
        if (!n) return;
        // Step over zero-length ranges (#948);
        if (this.xVal[i] === this.xVal[i + 1]) {
            this.xSteps[i] = this.xHighestCompleteStep[i] = this.xVal[i];
            return;
        }
        // Factor to range ratio
        this.xSteps[i] = $e9704b94b3b62e8f$var$fromPercentage([
            this.xVal[i],
            this.xVal[i + 1]
        ], n, 0) / $e9704b94b3b62e8f$var$subRangeRatio(this.xPct[i], this.xPct[i + 1]);
        var totalSteps = (this.xVal[i + 1] - this.xVal[i]) / this.xNumSteps[i];
        var highestStep = Math.ceil(Number(totalSteps.toFixed(3)) - 1);
        var step = this.xVal[i] + this.xNumSteps[i] * highestStep;
        this.xHighestCompleteStep[i] = step;
    };
    return Spectrum;
}();
//endregion
//region Options
/*	Every input option is tested and parsed. This will prevent
    endless validation in internal methods. These tests are
    structured with an item for every option available. An
    option can be marked as required by setting the 'r' flag.
    The testing function is provided with three arguments:
        - The provided value for the option;
        - A reference to the options object;
        - The name for the option;

    The testing function returns false when an error is detected,
    or true when everything is OK. It can also modify the option
    object, to make sure all values can be correctly looped elsewhere. */ //region Defaults
var $e9704b94b3b62e8f$var$defaultFormatter = {
    to: function(value) {
        return value === undefined ? "" : value.toFixed(2);
    },
    from: Number
};
var $e9704b94b3b62e8f$export$c1c0562ec8379000 = {
    target: "target",
    base: "base",
    origin: "origin",
    handle: "handle",
    handleLower: "handle-lower",
    handleUpper: "handle-upper",
    touchArea: "touch-area",
    horizontal: "horizontal",
    vertical: "vertical",
    background: "background",
    connect: "connect",
    connects: "connects",
    ltr: "ltr",
    rtl: "rtl",
    textDirectionLtr: "txt-dir-ltr",
    textDirectionRtl: "txt-dir-rtl",
    draggable: "draggable",
    drag: "state-drag",
    tap: "state-tap",
    active: "active",
    tooltip: "tooltip",
    pips: "pips",
    pipsHorizontal: "pips-horizontal",
    pipsVertical: "pips-vertical",
    marker: "marker",
    markerHorizontal: "marker-horizontal",
    markerVertical: "marker-vertical",
    markerNormal: "marker-normal",
    markerLarge: "marker-large",
    markerSub: "marker-sub",
    value: "value",
    valueHorizontal: "value-horizontal",
    valueVertical: "value-vertical",
    valueNormal: "value-normal",
    valueLarge: "value-large",
    valueSub: "value-sub"
};
// Namespaces of internal event listeners
var $e9704b94b3b62e8f$var$INTERNAL_EVENT_NS = {
    tooltips: ".__tooltips",
    aria: ".__aria"
};
//endregion
function $e9704b94b3b62e8f$var$testStep(parsed, entry) {
    if (!$e9704b94b3b62e8f$var$isNumeric(entry)) throw new Error("noUiSlider: 'step' is not numeric.");
    // The step option can still be used to set stepping
    // for linear sliders. Overwritten if set in 'range'.
    parsed.singleStep = entry;
}
function $e9704b94b3b62e8f$var$testKeyboardPageMultiplier(parsed, entry) {
    if (!$e9704b94b3b62e8f$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
    parsed.keyboardPageMultiplier = entry;
}
function $e9704b94b3b62e8f$var$testKeyboardMultiplier(parsed, entry) {
    if (!$e9704b94b3b62e8f$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
    parsed.keyboardMultiplier = entry;
}
function $e9704b94b3b62e8f$var$testKeyboardDefaultStep(parsed, entry) {
    if (!$e9704b94b3b62e8f$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
    parsed.keyboardDefaultStep = entry;
}
function $e9704b94b3b62e8f$var$testRange(parsed, entry) {
    // Filter incorrect input.
    if (typeof entry !== "object" || Array.isArray(entry)) throw new Error("noUiSlider: 'range' is not an object.");
    // Catch missing start or end.
    if (entry.min === undefined || entry.max === undefined) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
    parsed.spectrum = new $e9704b94b3b62e8f$var$Spectrum(entry, parsed.snap || false, parsed.singleStep);
}
function $e9704b94b3b62e8f$var$testStart(parsed, entry) {
    entry = $e9704b94b3b62e8f$var$asArray(entry);
    // Validate input. Values aren't tested, as the public .val method
    // will always provide a valid location.
    if (!Array.isArray(entry) || !entry.length) throw new Error("noUiSlider: 'start' option is incorrect.");
    // Store the number of handles.
    parsed.handles = entry.length;
    // When the slider is initialized, the .val method will
    // be called with the start options.
    parsed.start = entry;
}
function $e9704b94b3b62e8f$var$testSnap(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
    // Enforce 100% stepping within subranges.
    parsed.snap = entry;
}
function $e9704b94b3b62e8f$var$testAnimate(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
    // Enforce 100% stepping within subranges.
    parsed.animate = entry;
}
function $e9704b94b3b62e8f$var$testAnimationDuration(parsed, entry) {
    if (typeof entry !== "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
    parsed.animationDuration = entry;
}
function $e9704b94b3b62e8f$var$testConnect(parsed, entry) {
    var connect = [
        false
    ];
    var i;
    // Map legacy options
    if (entry === "lower") entry = [
        true,
        false
    ];
    else if (entry === "upper") entry = [
        false,
        true
    ];
    // Handle boolean options
    if (entry === true || entry === false) {
        for(i = 1; i < parsed.handles; i++)connect.push(entry);
        connect.push(false);
    } else if (!Array.isArray(entry) || !entry.length || entry.length !== parsed.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
    else connect = entry;
    parsed.connect = connect;
}
function $e9704b94b3b62e8f$var$testOrientation(parsed, entry) {
    // Set orientation to an a numerical value for easy
    // array selection.
    switch(entry){
        case "horizontal":
            parsed.ort = 0;
            break;
        case "vertical":
            parsed.ort = 1;
            break;
        default:
            throw new Error("noUiSlider: 'orientation' option is invalid.");
    }
}
function $e9704b94b3b62e8f$var$testMargin(parsed, entry) {
    if (!$e9704b94b3b62e8f$var$isNumeric(entry)) throw new Error("noUiSlider: 'margin' option must be numeric.");
    // Issue #582
    if (entry === 0) return;
    parsed.margin = parsed.spectrum.getDistance(entry);
}
function $e9704b94b3b62e8f$var$testLimit(parsed, entry) {
    if (!$e9704b94b3b62e8f$var$isNumeric(entry)) throw new Error("noUiSlider: 'limit' option must be numeric.");
    parsed.limit = parsed.spectrum.getDistance(entry);
    if (!parsed.limit || parsed.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
}
function $e9704b94b3b62e8f$var$testPadding(parsed, entry) {
    var index;
    if (!$e9704b94b3b62e8f$var$isNumeric(entry) && !Array.isArray(entry)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (Array.isArray(entry) && !(entry.length === 2 || $e9704b94b3b62e8f$var$isNumeric(entry[0]) || $e9704b94b3b62e8f$var$isNumeric(entry[1]))) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (entry === 0) return;
    if (!Array.isArray(entry)) entry = [
        entry,
        entry
    ];
    // 'getDistance' returns false for invalid values.
    parsed.padding = [
        parsed.spectrum.getDistance(entry[0]),
        parsed.spectrum.getDistance(entry[1])
    ];
    for(index = 0; index < parsed.spectrum.xNumSteps.length - 1; index++){
        // last "range" can't contain step size as it is purely an endpoint.
        if (parsed.padding[0][index] < 0 || parsed.padding[1][index] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
    }
    var totalPadding = entry[0] + entry[1];
    var firstValue = parsed.spectrum.xVal[0];
    var lastValue = parsed.spectrum.xVal[parsed.spectrum.xVal.length - 1];
    if (totalPadding / (lastValue - firstValue) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
}
function $e9704b94b3b62e8f$var$testDirection(parsed, entry) {
    // Set direction as a numerical value for easy parsing.
    // Invert connection for RTL sliders, so that the proper
    // handles get the connect/background classes.
    switch(entry){
        case "ltr":
            parsed.dir = 0;
            break;
        case "rtl":
            parsed.dir = 1;
            break;
        default:
            throw new Error("noUiSlider: 'direction' option was not recognized.");
    }
}
function $e9704b94b3b62e8f$var$testBehaviour(parsed, entry) {
    // Make sure the input is a string.
    if (typeof entry !== "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
    // Check if the string contains any keywords.
    // None are required.
    var tap = entry.indexOf("tap") >= 0;
    var drag = entry.indexOf("drag") >= 0;
    var fixed = entry.indexOf("fixed") >= 0;
    var snap = entry.indexOf("snap") >= 0;
    var hover = entry.indexOf("hover") >= 0;
    var unconstrained = entry.indexOf("unconstrained") >= 0;
    var invertConnects = entry.indexOf("invert-connects") >= 0;
    var dragAll = entry.indexOf("drag-all") >= 0;
    var smoothSteps = entry.indexOf("smooth-steps") >= 0;
    if (fixed) {
        if (parsed.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        // Use margin to enforce fixed state
        $e9704b94b3b62e8f$var$testMargin(parsed, parsed.start[1] - parsed.start[0]);
    }
    if (invertConnects && parsed.handles !== 2) throw new Error("noUiSlider: 'invert-connects' behaviour must be used with 2 handles");
    if (unconstrained && (parsed.margin || parsed.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
    parsed.events = {
        tap: tap || snap,
        drag: drag,
        dragAll: dragAll,
        smoothSteps: smoothSteps,
        fixed: fixed,
        snap: snap,
        hover: hover,
        unconstrained: unconstrained,
        invertConnects: invertConnects
    };
}
function $e9704b94b3b62e8f$var$testTooltips(parsed, entry) {
    if (entry === false) return;
    if (entry === true || $e9704b94b3b62e8f$var$isValidPartialFormatter(entry)) {
        parsed.tooltips = [];
        for(var i = 0; i < parsed.handles; i++)parsed.tooltips.push(entry);
    } else {
        entry = $e9704b94b3b62e8f$var$asArray(entry);
        if (entry.length !== parsed.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        entry.forEach(function(formatter) {
            if (typeof formatter !== "boolean" && !$e9704b94b3b62e8f$var$isValidPartialFormatter(formatter)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        });
        parsed.tooltips = entry;
    }
}
function $e9704b94b3b62e8f$var$testHandleAttributes(parsed, entry) {
    if (entry.length !== parsed.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
    parsed.handleAttributes = entry;
}
function $e9704b94b3b62e8f$var$testAriaFormat(parsed, entry) {
    if (!$e9704b94b3b62e8f$var$isValidPartialFormatter(entry)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
    parsed.ariaFormat = entry;
}
function $e9704b94b3b62e8f$var$testFormat(parsed, entry) {
    if (!$e9704b94b3b62e8f$var$isValidFormatter(entry)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
    parsed.format = entry;
}
function $e9704b94b3b62e8f$var$testKeyboardSupport(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
    parsed.keyboardSupport = entry;
}
function $e9704b94b3b62e8f$var$testDocumentElement(parsed, entry) {
    // This is an advanced option. Passed values are used without validation.
    parsed.documentElement = entry;
}
function $e9704b94b3b62e8f$var$testCssPrefix(parsed, entry) {
    if (typeof entry !== "string" && entry !== false) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
    parsed.cssPrefix = entry;
}
function $e9704b94b3b62e8f$var$testCssClasses(parsed, entry) {
    if (typeof entry !== "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
    if (typeof parsed.cssPrefix === "string") {
        parsed.cssClasses = {};
        Object.keys(entry).forEach(function(key) {
            parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
        });
    } else parsed.cssClasses = entry;
}
// Test all developer settings and parse to assumption-safe values.
function $e9704b94b3b62e8f$var$testOptions(options) {
    // To prove a fix for #537, freeze options here.
    // If the object is modified, an error will be thrown.
    // Object.freeze(options);
    var parsed = {
        margin: null,
        limit: null,
        padding: null,
        animate: true,
        animationDuration: 300,
        ariaFormat: $e9704b94b3b62e8f$var$defaultFormatter,
        format: $e9704b94b3b62e8f$var$defaultFormatter
    };
    // Tests are executed in the order they are presented here.
    var tests = {
        step: {
            r: false,
            t: $e9704b94b3b62e8f$var$testStep
        },
        keyboardPageMultiplier: {
            r: false,
            t: $e9704b94b3b62e8f$var$testKeyboardPageMultiplier
        },
        keyboardMultiplier: {
            r: false,
            t: $e9704b94b3b62e8f$var$testKeyboardMultiplier
        },
        keyboardDefaultStep: {
            r: false,
            t: $e9704b94b3b62e8f$var$testKeyboardDefaultStep
        },
        start: {
            r: true,
            t: $e9704b94b3b62e8f$var$testStart
        },
        connect: {
            r: true,
            t: $e9704b94b3b62e8f$var$testConnect
        },
        direction: {
            r: true,
            t: $e9704b94b3b62e8f$var$testDirection
        },
        snap: {
            r: false,
            t: $e9704b94b3b62e8f$var$testSnap
        },
        animate: {
            r: false,
            t: $e9704b94b3b62e8f$var$testAnimate
        },
        animationDuration: {
            r: false,
            t: $e9704b94b3b62e8f$var$testAnimationDuration
        },
        range: {
            r: true,
            t: $e9704b94b3b62e8f$var$testRange
        },
        orientation: {
            r: false,
            t: $e9704b94b3b62e8f$var$testOrientation
        },
        margin: {
            r: false,
            t: $e9704b94b3b62e8f$var$testMargin
        },
        limit: {
            r: false,
            t: $e9704b94b3b62e8f$var$testLimit
        },
        padding: {
            r: false,
            t: $e9704b94b3b62e8f$var$testPadding
        },
        behaviour: {
            r: true,
            t: $e9704b94b3b62e8f$var$testBehaviour
        },
        ariaFormat: {
            r: false,
            t: $e9704b94b3b62e8f$var$testAriaFormat
        },
        format: {
            r: false,
            t: $e9704b94b3b62e8f$var$testFormat
        },
        tooltips: {
            r: false,
            t: $e9704b94b3b62e8f$var$testTooltips
        },
        keyboardSupport: {
            r: true,
            t: $e9704b94b3b62e8f$var$testKeyboardSupport
        },
        documentElement: {
            r: false,
            t: $e9704b94b3b62e8f$var$testDocumentElement
        },
        cssPrefix: {
            r: true,
            t: $e9704b94b3b62e8f$var$testCssPrefix
        },
        cssClasses: {
            r: true,
            t: $e9704b94b3b62e8f$var$testCssClasses
        },
        handleAttributes: {
            r: false,
            t: $e9704b94b3b62e8f$var$testHandleAttributes
        }
    };
    var defaults = {
        connect: false,
        direction: "ltr",
        behaviour: "tap",
        orientation: "horizontal",
        keyboardSupport: true,
        cssPrefix: "noUi-",
        cssClasses: $e9704b94b3b62e8f$export$c1c0562ec8379000,
        keyboardPageMultiplier: 5,
        keyboardMultiplier: 1,
        keyboardDefaultStep: 10
    };
    // AriaFormat defaults to regular format, if any.
    if (options.format && !options.ariaFormat) options.ariaFormat = options.format;
    // Run all options through a testing mechanism to ensure correct
    // input. It should be noted that options might get modified to
    // be handled properly. E.g. wrapping integers in arrays.
    Object.keys(tests).forEach(function(name) {
        // If the option isn't set, but it is required, throw an error.
        if (!$e9704b94b3b62e8f$var$isSet(options[name]) && defaults[name] === undefined) {
            if (tests[name].r) throw new Error("noUiSlider: '" + name + "' is required.");
            return;
        }
        tests[name].t(parsed, !$e9704b94b3b62e8f$var$isSet(options[name]) ? defaults[name] : options[name]);
    });
    // Forward pips options
    parsed.pips = options.pips;
    // All recent browsers accept unprefixed transform.
    // We need -ms- for IE9 and -webkit- for older Android;
    // Assume use of -webkit- if unprefixed and -ms- are not supported.
    // https://caniuse.com/#feat=transforms2d
    var d = document.createElement("div");
    var msPrefix = d.style.msTransform !== undefined;
    var noPrefix = d.style.transform !== undefined;
    parsed.transformRule = noPrefix ? "transform" : msPrefix ? "msTransform" : "webkitTransform";
    // Pips don't move, so we can place them using left/top.
    var styles = [
        [
            "left",
            "top"
        ],
        [
            "right",
            "bottom"
        ]
    ];
    parsed.style = styles[parsed.dir][parsed.ort];
    return parsed;
}
//endregion
function $e9704b94b3b62e8f$var$scope(target, options, originalOptions) {
    var actions = $e9704b94b3b62e8f$var$getActions();
    var supportsTouchActionNone = $e9704b94b3b62e8f$var$getSupportsTouchActionNone();
    var supportsPassive = supportsTouchActionNone && $e9704b94b3b62e8f$var$getSupportsPassive();
    // All variables local to 'scope' are prefixed with 'scope_'
    // Slider DOM Nodes
    var scope_Target = target;
    var scope_Base;
    var scope_ConnectBase;
    var scope_Handles;
    var scope_Connects;
    var scope_Pips;
    var scope_Tooltips;
    // Slider state values
    var scope_Spectrum = options.spectrum;
    var scope_Values = [];
    var scope_Locations = [];
    var scope_HandleNumbers = [];
    var scope_ActiveHandlesCount = 0;
    var scope_Events = {};
    var scope_ConnectsInverted = false;
    // Document Nodes
    var scope_Document = target.ownerDocument;
    var scope_DocumentElement = options.documentElement || scope_Document.documentElement;
    var scope_Body = scope_Document.body;
    // For horizontal sliders in standard ltr documents,
    // make .noUi-origin overflow to the left so the document doesn't scroll.
    var scope_DirOffset = scope_Document.dir === "rtl" || options.ort === 1 ? 0 : 100;
    // Creates a node, adds it to target, returns the new node.
    function addNodeTo(addTarget, className) {
        var div = scope_Document.createElement("div");
        if (className) $e9704b94b3b62e8f$var$addClass(div, className);
        addTarget.appendChild(div);
        return div;
    }
    // Append a origin to the base
    function addOrigin(base, handleNumber) {
        var origin = addNodeTo(base, options.cssClasses.origin);
        var handle = addNodeTo(origin, options.cssClasses.handle);
        addNodeTo(handle, options.cssClasses.touchArea);
        handle.setAttribute("data-handle", String(handleNumber));
        if (options.keyboardSupport) {
            // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
            // 0 = focusable and reachable
            handle.setAttribute("tabindex", "0");
            handle.addEventListener("keydown", function(event) {
                return eventKeydown(event, handleNumber);
            });
        }
        if (options.handleAttributes !== undefined) {
            var attributes_1 = options.handleAttributes[handleNumber];
            Object.keys(attributes_1).forEach(function(attribute) {
                handle.setAttribute(attribute, attributes_1[attribute]);
            });
        }
        handle.setAttribute("role", "slider");
        handle.setAttribute("aria-orientation", options.ort ? "vertical" : "horizontal");
        if (handleNumber === 0) $e9704b94b3b62e8f$var$addClass(handle, options.cssClasses.handleLower);
        else if (handleNumber === options.handles - 1) $e9704b94b3b62e8f$var$addClass(handle, options.cssClasses.handleUpper);
        origin.handle = handle;
        return origin;
    }
    // Insert nodes for connect elements
    function addConnect(base, add) {
        if (!add) return false;
        return addNodeTo(base, options.cssClasses.connect);
    }
    // Add handles to the slider base.
    function addElements(connectOptions, base) {
        scope_ConnectBase = addNodeTo(base, options.cssClasses.connects);
        scope_Handles = [];
        scope_Connects = [];
        scope_Connects.push(addConnect(scope_ConnectBase, connectOptions[0]));
        // [::::O====O====O====]
        // connectOptions = [0, 1, 1, 1]
        for(var i = 0; i < options.handles; i++){
            // Keep a list of all added handles.
            scope_Handles.push(addOrigin(base, i));
            scope_HandleNumbers[i] = i;
            scope_Connects.push(addConnect(scope_ConnectBase, connectOptions[i + 1]));
        }
    }
    // Initialize a single slider.
    function addSlider(addTarget) {
        // Apply classes and data to the target.
        $e9704b94b3b62e8f$var$addClass(addTarget, options.cssClasses.target);
        if (options.dir === 0) $e9704b94b3b62e8f$var$addClass(addTarget, options.cssClasses.ltr);
        else $e9704b94b3b62e8f$var$addClass(addTarget, options.cssClasses.rtl);
        if (options.ort === 0) $e9704b94b3b62e8f$var$addClass(addTarget, options.cssClasses.horizontal);
        else $e9704b94b3b62e8f$var$addClass(addTarget, options.cssClasses.vertical);
        var textDirection = getComputedStyle(addTarget).direction;
        if (textDirection === "rtl") $e9704b94b3b62e8f$var$addClass(addTarget, options.cssClasses.textDirectionRtl);
        else $e9704b94b3b62e8f$var$addClass(addTarget, options.cssClasses.textDirectionLtr);
        return addNodeTo(addTarget, options.cssClasses.base);
    }
    function addTooltip(handle, handleNumber) {
        if (!options.tooltips || !options.tooltips[handleNumber]) return false;
        return addNodeTo(handle.firstChild, options.cssClasses.tooltip);
    }
    function isSliderDisabled() {
        return scope_Target.hasAttribute("disabled");
    }
    // Disable the slider dragging if any handle is disabled
    function isHandleDisabled(handleNumber) {
        var handleOrigin = scope_Handles[handleNumber];
        return handleOrigin.hasAttribute("disabled");
    }
    function disable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].setAttribute("disabled", "");
            scope_Handles[handleNumber].handle.removeAttribute("tabindex");
        } else {
            scope_Target.setAttribute("disabled", "");
            scope_Handles.forEach(function(handle) {
                handle.handle.removeAttribute("tabindex");
            });
        }
    }
    function enable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].removeAttribute("disabled");
            scope_Handles[handleNumber].handle.setAttribute("tabindex", "0");
        } else {
            scope_Target.removeAttribute("disabled");
            scope_Handles.forEach(function(handle) {
                handle.removeAttribute("disabled");
                handle.handle.setAttribute("tabindex", "0");
            });
        }
    }
    function removeTooltips() {
        if (scope_Tooltips) {
            removeEvent("update" + $e9704b94b3b62e8f$var$INTERNAL_EVENT_NS.tooltips);
            scope_Tooltips.forEach(function(tooltip) {
                if (tooltip) $e9704b94b3b62e8f$var$removeElement(tooltip);
            });
            scope_Tooltips = null;
        }
    }
    // The tooltips option is a shorthand for using the 'update' event.
    function tooltips() {
        removeTooltips();
        // Tooltips are added with options.tooltips in original order.
        scope_Tooltips = scope_Handles.map(addTooltip);
        bindEvent("update" + $e9704b94b3b62e8f$var$INTERNAL_EVENT_NS.tooltips, function(values, handleNumber, unencoded) {
            if (!scope_Tooltips || !options.tooltips) return;
            if (scope_Tooltips[handleNumber] === false) return;
            var formattedValue = values[handleNumber];
            if (options.tooltips[handleNumber] !== true) formattedValue = options.tooltips[handleNumber].to(unencoded[handleNumber]);
            scope_Tooltips[handleNumber].innerHTML = formattedValue;
        });
    }
    function aria() {
        removeEvent("update" + $e9704b94b3b62e8f$var$INTERNAL_EVENT_NS.aria);
        bindEvent("update" + $e9704b94b3b62e8f$var$INTERNAL_EVENT_NS.aria, function(values, handleNumber, unencoded, tap, positions) {
            // Update Aria Values for all handles, as a change in one changes min and max values for the next.
            scope_HandleNumbers.forEach(function(index) {
                var handle = scope_Handles[index];
                var min = checkHandlePosition(scope_Locations, index, 0, true, true, true);
                var max = checkHandlePosition(scope_Locations, index, 100, true, true, true);
                var now = positions[index];
                // Formatted value for display
                var text = String(options.ariaFormat.to(unencoded[index]));
                // Map to slider range values
                min = scope_Spectrum.fromStepping(min).toFixed(1);
                max = scope_Spectrum.fromStepping(max).toFixed(1);
                now = scope_Spectrum.fromStepping(now).toFixed(1);
                handle.children[0].setAttribute("aria-valuemin", min);
                handle.children[0].setAttribute("aria-valuemax", max);
                handle.children[0].setAttribute("aria-valuenow", now);
                handle.children[0].setAttribute("aria-valuetext", text);
            });
        });
    }
    function getGroup(pips) {
        // Use the range.
        if (pips.mode === $e9704b94b3b62e8f$export$126649350cd02471.Range || pips.mode === $e9704b94b3b62e8f$export$126649350cd02471.Steps) return scope_Spectrum.xVal;
        if (pips.mode === $e9704b94b3b62e8f$export$126649350cd02471.Count) {
            if (pips.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
            // Divide 0 - 100 in 'count' parts.
            var interval = pips.values - 1;
            var spread = 100 / interval;
            var values = [];
            // List these parts and have them handled as 'positions'.
            while(interval--)values[interval] = interval * spread;
            values.push(100);
            return mapToRange(values, pips.stepped);
        }
        if (pips.mode === $e9704b94b3b62e8f$export$126649350cd02471.Positions) // Map all percentages to on-range values.
        return mapToRange(pips.values, pips.stepped);
        if (pips.mode === $e9704b94b3b62e8f$export$126649350cd02471.Values) {
            // If the value must be stepped, it needs to be converted to a percentage first.
            if (pips.stepped) return pips.values.map(function(value) {
                // Convert to percentage, apply step, return to value.
                return scope_Spectrum.fromStepping(scope_Spectrum.getStep(scope_Spectrum.toStepping(value)));
            });
            // Otherwise, we can simply use the values.
            return pips.values;
        }
        return []; // pips.mode = never
    }
    function mapToRange(values, stepped) {
        return values.map(function(value) {
            return scope_Spectrum.fromStepping(stepped ? scope_Spectrum.getStep(value) : value);
        });
    }
    function generateSpread(pips) {
        function safeIncrement(value, increment) {
            // Avoid floating point variance by dropping the smallest decimal places.
            return Number((value + increment).toFixed(7));
        }
        var group = getGroup(pips);
        var indexes = {};
        var firstInRange = scope_Spectrum.xVal[0];
        var lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length - 1];
        var ignoreFirst = false;
        var ignoreLast = false;
        var prevPct = 0;
        // Create a copy of the group, sort it and filter away all duplicates.
        group = $e9704b94b3b62e8f$var$unique(group.slice().sort(function(a, b) {
            return a - b;
        }));
        // Make sure the range starts with the first element.
        if (group[0] !== firstInRange) {
            group.unshift(firstInRange);
            ignoreFirst = true;
        }
        // Likewise for the last one.
        if (group[group.length - 1] !== lastInRange) {
            group.push(lastInRange);
            ignoreLast = true;
        }
        group.forEach(function(current, index) {
            // Get the current step and the lower + upper positions.
            var step;
            var i;
            var q;
            var low = current;
            var high = group[index + 1];
            var newPct;
            var pctDifference;
            var pctPos;
            var type;
            var steps;
            var realSteps;
            var stepSize;
            var isSteps = pips.mode === $e9704b94b3b62e8f$export$126649350cd02471.Steps;
            // When using 'steps' mode, use the provided steps.
            // Otherwise, we'll step on to the next subrange.
            if (isSteps) step = scope_Spectrum.xNumSteps[index];
            // Default to a 'full' step.
            if (!step) step = high - low;
            // If high is undefined we are at the last subrange. Make sure it iterates once (#1088)
            if (high === undefined) high = low;
            // Make sure step isn't 0, which would cause an infinite loop (#654)
            step = Math.max(step, 0.0000001);
            // Find all steps in the subrange.
            for(i = low; i <= high; i = safeIncrement(i, step)){
                // Get the percentage value for the current step,
                // calculate the size for the subrange.
                newPct = scope_Spectrum.toStepping(i);
                pctDifference = newPct - prevPct;
                steps = pctDifference / (pips.density || 1);
                realSteps = Math.round(steps);
                // This ratio represents the amount of percentage-space a point indicates.
                // For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-divided.
                // Round the percentage offset to an even number, then divide by two
                // to spread the offset on both sides of the range.
                stepSize = pctDifference / realSteps;
                // Divide all points evenly, adding the correct number to this subrange.
                // Run up to <= so that 100% gets a point, event if ignoreLast is set.
                for(q = 1; q <= realSteps; q += 1){
                    // The ratio between the rounded value and the actual size might be ~1% off.
                    // Correct the percentage offset by the number of points
                    // per subrange. density = 1 will result in 100 points on the
                    // full range, 2 for 50, 4 for 25, etc.
                    pctPos = prevPct + q * stepSize;
                    indexes[pctPos.toFixed(5)] = [
                        scope_Spectrum.fromStepping(pctPos),
                        0
                    ];
                }
                // Determine the point type.
                type = group.indexOf(i) > -1 ? $e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.LargeValue : isSteps ? $e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.SmallValue : $e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.NoValue;
                // Enforce the 'ignoreFirst' option by overwriting the type for 0.
                if (!index && ignoreFirst && i !== high) type = 0;
                if (!(i === high && ignoreLast)) // Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
                indexes[newPct.toFixed(5)] = [
                    i,
                    type
                ];
                // Update the percentage count.
                prevPct = newPct;
            }
        });
        return indexes;
    }
    function addMarking(spread, filterFunc, formatter) {
        var _a, _b;
        var element = scope_Document.createElement("div");
        var valueSizeClasses = (_a = {}, _a[$e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.None] = "", _a[$e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.NoValue] = options.cssClasses.valueNormal, _a[$e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.LargeValue] = options.cssClasses.valueLarge, _a[$e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.SmallValue] = options.cssClasses.valueSub, _a);
        var markerSizeClasses = (_b = {}, _b[$e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.None] = "", _b[$e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.NoValue] = options.cssClasses.markerNormal, _b[$e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.LargeValue] = options.cssClasses.markerLarge, _b[$e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.SmallValue] = options.cssClasses.markerSub, _b);
        var valueOrientationClasses = [
            options.cssClasses.valueHorizontal,
            options.cssClasses.valueVertical
        ];
        var markerOrientationClasses = [
            options.cssClasses.markerHorizontal,
            options.cssClasses.markerVertical
        ];
        $e9704b94b3b62e8f$var$addClass(element, options.cssClasses.pips);
        $e9704b94b3b62e8f$var$addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);
        function getClasses(type, source) {
            var a = source === options.cssClasses.value;
            var orientationClasses = a ? valueOrientationClasses : markerOrientationClasses;
            var sizeClasses = a ? valueSizeClasses : markerSizeClasses;
            return source + " " + orientationClasses[options.ort] + " " + sizeClasses[type];
        }
        function addSpread(offset, value, type) {
            // Apply the filter function, if it is set.
            type = filterFunc ? filterFunc(value, type) : type;
            if (type === $e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.None) return;
            // Add a marker for every point
            var node = addNodeTo(element, false);
            node.className = getClasses(type, options.cssClasses.marker);
            node.style[options.style] = offset + "%";
            // Values are only appended for points marked '1' or '2'.
            if (type > $e9704b94b3b62e8f$export$ab20e68cdcd7a4fc.NoValue) {
                node = addNodeTo(element, false);
                node.className = getClasses(type, options.cssClasses.value);
                node.setAttribute("data-value", String(value));
                node.style[options.style] = offset + "%";
                node.innerHTML = String(formatter.to(value));
            }
        }
        // Append all points.
        Object.keys(spread).forEach(function(offset) {
            addSpread(offset, spread[offset][0], spread[offset][1]);
        });
        return element;
    }
    function removePips() {
        if (scope_Pips) {
            $e9704b94b3b62e8f$var$removeElement(scope_Pips);
            scope_Pips = null;
        }
    }
    function pips(pips) {
        // Fix #669
        removePips();
        var spread = generateSpread(pips);
        var filter = pips.filter;
        var format = pips.format || {
            to: function(value) {
                return String(Math.round(value));
            }
        };
        scope_Pips = scope_Target.appendChild(addMarking(spread, filter, format));
        return scope_Pips;
    }
    // Shorthand for base dimensions.
    function baseSize() {
        var rect = scope_Base.getBoundingClientRect();
        var alt = "offset" + [
            "Width",
            "Height"
        ][options.ort];
        return options.ort === 0 ? rect.width || scope_Base[alt] : rect.height || scope_Base[alt];
    }
    // Handler for attaching events trough a proxy.
    function attachEvent(events, element, callback, data) {
        // This function can be used to 'filter' events to the slider.
        // element is a node, not a nodeList
        var method = function(event) {
            var e = fixEvent(event, data.pageOffset, data.target || element);
            // fixEvent returns false if this event has a different target
            // when handling (multi-) touch events;
            if (!e) return false;
            // doNotReject is passed by all end events to make sure released touches
            // are not rejected, leaving the slider "stuck" to the cursor;
            if (isSliderDisabled() && !data.doNotReject) return false;
            // Stop if an active 'tap' transition is taking place.
            if ($e9704b94b3b62e8f$var$hasClass(scope_Target, options.cssClasses.tap) && !data.doNotReject) return false;
            // Ignore right or middle clicks on start #454
            if (events === actions.start && e.buttons !== undefined && e.buttons > 1) return false;
            // Ignore right or middle clicks on start #454
            if (data.hover && e.buttons) return false;
            // 'supportsPassive' is only true if a browser also supports touch-action: none in CSS.
            // iOS safari does not, so it doesn't get to benefit from passive scrolling. iOS does support
            // touch-action: manipulation, but that allows panning, which breaks
            // sliders after zooming/on non-responsive pages.
            // See: https://bugs.webkit.org/show_bug.cgi?id=133112
            if (!supportsPassive) e.preventDefault();
            e.calcPoint = e.points[options.ort];
            // Call the event handler with the event [ and additional data ].
            callback(e, data);
            return;
        };
        var methods = [];
        // Bind a closure on the target for every event type.
        events.split(" ").forEach(function(eventName) {
            element.addEventListener(eventName, method, supportsPassive ? {
                passive: true
            } : false);
            methods.push([
                eventName,
                method
            ]);
        });
        return methods;
    }
    // Provide a clean event with standardized offset values.
    function fixEvent(e, pageOffset, eventTarget) {
        // Filter the event to register the type, which can be
        // touch, mouse or pointer. Offset changes need to be
        // made on an event specific basis.
        var touch = e.type.indexOf("touch") === 0;
        var mouse = e.type.indexOf("mouse") === 0;
        var pointer = e.type.indexOf("pointer") === 0;
        var x = 0;
        var y = 0;
        // IE10 implemented pointer events with a prefix;
        if (e.type.indexOf("MSPointer") === 0) pointer = true;
        // Erroneous events seem to be passed in occasionally on iOS/iPadOS after user finishes interacting with
        // the slider. They appear to be of type MouseEvent, yet they don't have usual properties set. Ignore
        // events that have no touches or buttons associated with them. (#1057, #1079, #1095)
        if (e.type === "mousedown" && !e.buttons && !e.touches) return false;
        // The only thing one handle should be concerned about is the touches that originated on top of it.
        if (touch) {
            // Returns true if a touch originated on the target.
            var isTouchOnTarget = function(checkTouch) {
                var target = checkTouch.target;
                return target === eventTarget || eventTarget.contains(target) || e.composed && e.composedPath().shift() === eventTarget;
            };
            // In the case of touchstart events, we need to make sure there is still no more than one
            // touch on the target so we look amongst all touches.
            if (e.type === "touchstart") {
                var targetTouches = Array.prototype.filter.call(e.touches, isTouchOnTarget);
                // Do not support more than one touch per handle.
                if (targetTouches.length > 1) return false;
                x = targetTouches[0].pageX;
                y = targetTouches[0].pageY;
            } else {
                // In the other cases, find on changedTouches is enough.
                var targetTouch = Array.prototype.find.call(e.changedTouches, isTouchOnTarget);
                // Cancel if the target touch has not moved.
                if (!targetTouch) return false;
                x = targetTouch.pageX;
                y = targetTouch.pageY;
            }
        }
        pageOffset = pageOffset || $e9704b94b3b62e8f$var$getPageOffset(scope_Document);
        if (mouse || pointer) {
            x = e.clientX + pageOffset.x;
            y = e.clientY + pageOffset.y;
        }
        e.pageOffset = pageOffset;
        e.points = [
            x,
            y
        ];
        e.cursor = mouse || pointer; // Fix #435
        return e;
    }
    // Translate a coordinate in the document to a percentage on the slider
    function calcPointToPercentage(calcPoint) {
        var location = calcPoint - $e9704b94b3b62e8f$var$offset(scope_Base, options.ort);
        var proposal = location * 100 / baseSize();
        // Clamp proposal between 0% and 100%
        // Out-of-bound coordinates may occur when .noUi-base pseudo-elements
        // are used (e.g. contained handles feature)
        proposal = $e9704b94b3b62e8f$var$limit(proposal);
        return options.dir ? 100 - proposal : proposal;
    }
    // Find handle closest to a certain percentage on the slider
    function getClosestHandle(clickedPosition) {
        var smallestDifference = 100;
        var handleNumber = false;
        scope_Handles.forEach(function(handle, index) {
            // Disabled handles are ignored
            if (isHandleDisabled(index)) return;
            var handlePosition = scope_Locations[index];
            var differenceWithThisHandle = Math.abs(handlePosition - clickedPosition);
            // Initial state
            var clickAtEdge = differenceWithThisHandle === 100 && smallestDifference === 100;
            // Difference with this handle is smaller than the previously checked handle
            var isCloser = differenceWithThisHandle < smallestDifference;
            var isCloserAfter = differenceWithThisHandle <= smallestDifference && clickedPosition > handlePosition;
            if (isCloser || isCloserAfter || clickAtEdge) {
                handleNumber = index;
                smallestDifference = differenceWithThisHandle;
            }
        });
        return handleNumber;
    }
    // Fire 'end' when a mouse or pen leaves the document.
    function documentLeave(event, data) {
        if (event.type === "mouseout" && event.target.nodeName === "HTML" && event.relatedTarget === null) eventEnd(event, data);
    }
    // Handle movement on document for handle and range drag.
    function eventMove(event, data) {
        // Fix #498
        // Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
        // https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
        // IE9 has .buttons and .which zero on mousemove.
        // Firefox breaks the spec MDN defines.
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0) return eventEnd(event, data);
        // Check if we are moving up or down
        var movement = (options.dir ? -1 : 1) * (event.calcPoint - data.startCalcPoint);
        // Convert the movement into a percentage of the slider width/height
        var proposal = movement * 100 / data.baseSize;
        moveHandles(movement > 0, proposal, data.locations, data.handleNumbers, data.connect);
    }
    // Unbind move events on document, call callbacks.
    function eventEnd(event, data) {
        // The handle is no longer active, so remove the class.
        if (data.handle) {
            $e9704b94b3b62e8f$var$removeClass(data.handle, options.cssClasses.active);
            scope_ActiveHandlesCount -= 1;
        }
        // Unbind the move and end events, which are added on 'start'.
        data.listeners.forEach(function(c) {
            scope_DocumentElement.removeEventListener(c[0], c[1]);
        });
        if (scope_ActiveHandlesCount === 0) {
            // Remove dragging class.
            $e9704b94b3b62e8f$var$removeClass(scope_Target, options.cssClasses.drag);
            setZindex();
            // Remove cursor styles and text-selection events bound to the body.
            if (event.cursor) {
                scope_Body.style.cursor = "";
                scope_Body.removeEventListener("selectstart", $e9704b94b3b62e8f$var$preventDefault);
            }
        }
        if (options.events.smoothSteps) {
            data.handleNumbers.forEach(function(handleNumber) {
                setHandle(handleNumber, scope_Locations[handleNumber], true, true, false, false);
            });
            data.handleNumbers.forEach(function(handleNumber) {
                fireEvent("update", handleNumber);
            });
        }
        data.handleNumbers.forEach(function(handleNumber) {
            fireEvent("change", handleNumber);
            fireEvent("set", handleNumber);
            fireEvent("end", handleNumber);
        });
    }
    // Bind move events on document.
    function eventStart(event, data) {
        // Ignore event if any handle is disabled
        if (data.handleNumbers.some(isHandleDisabled)) return;
        var handle;
        if (data.handleNumbers.length === 1) {
            var handleOrigin = scope_Handles[data.handleNumbers[0]];
            handle = handleOrigin.children[0];
            scope_ActiveHandlesCount += 1;
            // Mark the handle as 'active' so it can be styled.
            $e9704b94b3b62e8f$var$addClass(handle, options.cssClasses.active);
        }
        // A drag should never propagate up to the 'tap' event.
        event.stopPropagation();
        // Record the event listeners.
        var listeners = [];
        // Attach the move and end events.
        var moveEvent = attachEvent(actions.move, scope_DocumentElement, eventMove, {
            // The event target has changed so we need to propagate the original one so that we keep
            // relying on it to extract target touches.
            target: event.target,
            handle: handle,
            connect: data.connect,
            listeners: listeners,
            startCalcPoint: event.calcPoint,
            baseSize: baseSize(),
            pageOffset: event.pageOffset,
            handleNumbers: data.handleNumbers,
            buttonsProperty: event.buttons,
            locations: scope_Locations.slice()
        });
        var endEvent = attachEvent(actions.end, scope_DocumentElement, eventEnd, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers
        });
        var outEvent = attachEvent("mouseout", scope_DocumentElement, documentLeave, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers
        });
        // We want to make sure we pushed the listeners in the listener list rather than creating
        // a new one as it has already been passed to the event handlers.
        listeners.push.apply(listeners, moveEvent.concat(endEvent, outEvent));
        // Text selection isn't an issue on touch devices,
        // so adding cursor styles can be skipped.
        if (event.cursor) {
            // Prevent the 'I' cursor and extend the range-drag cursor.
            scope_Body.style.cursor = getComputedStyle(event.target).cursor;
            // Mark the target with a dragging state.
            if (scope_Handles.length > 1) $e9704b94b3b62e8f$var$addClass(scope_Target, options.cssClasses.drag);
            // Prevent text selection when dragging the handles.
            // In noUiSlider <= 9.2.0, this was handled by calling preventDefault on mouse/touch start/move,
            // which is scroll blocking. The selectstart event is supported by FireFox starting from version 52,
            // meaning the only holdout is iOS Safari. This doesn't matter: text selection isn't triggered there.
            // The 'cursor' flag is false.
            // See: http://caniuse.com/#search=selectstart
            scope_Body.addEventListener("selectstart", $e9704b94b3b62e8f$var$preventDefault, false);
        }
        data.handleNumbers.forEach(function(handleNumber) {
            fireEvent("start", handleNumber);
        });
    }
    // Move closest handle to tapped location.
    function eventTap(event) {
        // The tap event shouldn't propagate up
        event.stopPropagation();
        var proposal = calcPointToPercentage(event.calcPoint);
        var handleNumber = getClosestHandle(proposal);
        // Tackle the case that all handles are 'disabled'.
        if (handleNumber === false) return;
        // Flag the slider as it is now in a transitional state.
        // Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
        if (!options.events.snap) $e9704b94b3b62e8f$var$addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        setHandle(handleNumber, proposal, true, true);
        setZindex();
        fireEvent("slide", handleNumber, true);
        fireEvent("update", handleNumber, true);
        if (!options.events.snap) {
            fireEvent("change", handleNumber, true);
            fireEvent("set", handleNumber, true);
        } else eventStart(event, {
            handleNumbers: [
                handleNumber
            ]
        });
    }
    // Fires a 'hover' event for a hovered mouse/pen position.
    function eventHover(event) {
        var proposal = calcPointToPercentage(event.calcPoint);
        var to = scope_Spectrum.getStep(proposal);
        var value = scope_Spectrum.fromStepping(to);
        Object.keys(scope_Events).forEach(function(targetEvent) {
            if ("hover" === targetEvent.split(".")[0]) scope_Events[targetEvent].forEach(function(callback) {
                callback.call(scope_Self, value);
            });
        });
    }
    // Handles keydown on focused handles
    // Don't move the document when pressing arrow keys on focused handles
    function eventKeydown(event, handleNumber) {
        if (isSliderDisabled() || isHandleDisabled(handleNumber)) return false;
        var horizontalKeys = [
            "Left",
            "Right"
        ];
        var verticalKeys = [
            "Down",
            "Up"
        ];
        var largeStepKeys = [
            "PageDown",
            "PageUp"
        ];
        var edgeKeys = [
            "Home",
            "End"
        ];
        if (options.dir && !options.ort) // On an right-to-left slider, the left and right keys act inverted
        horizontalKeys.reverse();
        else if (options.ort && !options.dir) {
            // On a top-to-bottom slider, the up and down keys act inverted
            verticalKeys.reverse();
            largeStepKeys.reverse();
        }
        // Strip "Arrow" for IE compatibility. https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
        var key = event.key.replace("Arrow", "");
        var isLargeDown = key === largeStepKeys[0];
        var isLargeUp = key === largeStepKeys[1];
        var isDown = key === verticalKeys[0] || key === horizontalKeys[0] || isLargeDown;
        var isUp = key === verticalKeys[1] || key === horizontalKeys[1] || isLargeUp;
        var isMin = key === edgeKeys[0];
        var isMax = key === edgeKeys[1];
        if (!isDown && !isUp && !isMin && !isMax) return true;
        event.preventDefault();
        var to;
        if (isUp || isDown) {
            var direction = isDown ? 0 : 1;
            var steps = getNextStepsForHandle(handleNumber);
            var step = steps[direction];
            // At the edge of a slider, do nothing
            if (step === null) return false;
            // No step set, use the default of 10% of the sub-range
            if (step === false) step = scope_Spectrum.getDefaultStep(scope_Locations[handleNumber], isDown, options.keyboardDefaultStep);
            if (isLargeUp || isLargeDown) step *= options.keyboardPageMultiplier;
            else step *= options.keyboardMultiplier;
            // Step over zero-length ranges (#948);
            step = Math.max(step, 0.0000001);
            // Decrement for down steps
            step = (isDown ? -1 : 1) * step;
            to = scope_Values[handleNumber] + step;
        } else if (isMax) // End key
        to = options.spectrum.xVal[options.spectrum.xVal.length - 1];
        else // Home key
        to = options.spectrum.xVal[0];
        setHandle(handleNumber, scope_Spectrum.toStepping(to), true, true);
        fireEvent("slide", handleNumber);
        fireEvent("update", handleNumber);
        fireEvent("change", handleNumber);
        fireEvent("set", handleNumber);
        return false;
    }
    // Attach events to several slider parts.
    function bindSliderEvents(behaviour) {
        // Attach the standard drag event to the handles.
        if (!behaviour.fixed) scope_Handles.forEach(function(handle, index) {
            // These events are only bound to the visual handle
            // element, not the 'real' origin element.
            attachEvent(actions.start, handle.children[0], eventStart, {
                handleNumbers: [
                    index
                ]
            });
        });
        // Attach the tap event to the slider base.
        if (behaviour.tap) attachEvent(actions.start, scope_Base, eventTap, {});
        // Fire hover events
        if (behaviour.hover) attachEvent(actions.move, scope_Base, eventHover, {
            hover: true
        });
        // Make the range draggable.
        if (behaviour.drag) scope_Connects.forEach(function(connect, index) {
            if (connect === false || index === 0 || index === scope_Connects.length - 1) return;
            var handleBefore = scope_Handles[index - 1];
            var handleAfter = scope_Handles[index];
            var eventHolders = [
                connect
            ];
            var handlesToDrag = [
                handleBefore,
                handleAfter
            ];
            var handleNumbersToDrag = [
                index - 1,
                index
            ];
            $e9704b94b3b62e8f$var$addClass(connect, options.cssClasses.draggable);
            // When the range is fixed, the entire range can
            // be dragged by the handles. The handle in the first
            // origin will propagate the start event upward,
            // but it needs to be bound manually on the other.
            if (behaviour.fixed) {
                eventHolders.push(handleBefore.children[0]);
                eventHolders.push(handleAfter.children[0]);
            }
            if (behaviour.dragAll) {
                handlesToDrag = scope_Handles;
                handleNumbersToDrag = scope_HandleNumbers;
            }
            eventHolders.forEach(function(eventHolder) {
                attachEvent(actions.start, eventHolder, eventStart, {
                    handles: handlesToDrag,
                    handleNumbers: handleNumbersToDrag,
                    connect: connect
                });
            });
        });
    }
    // Attach an event to this slider, possibly including a namespace
    function bindEvent(namespacedEvent, callback) {
        scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
        scope_Events[namespacedEvent].push(callback);
        // If the event bound is 'update,' fire it immediately for all handles.
        if (namespacedEvent.split(".")[0] === "update") scope_Handles.forEach(function(a, index) {
            fireEvent("update", index);
        });
    }
    function isInternalNamespace(namespace) {
        return namespace === $e9704b94b3b62e8f$var$INTERNAL_EVENT_NS.aria || namespace === $e9704b94b3b62e8f$var$INTERNAL_EVENT_NS.tooltips;
    }
    // Undo attachment of event
    function removeEvent(namespacedEvent) {
        var event = namespacedEvent && namespacedEvent.split(".")[0];
        var namespace = event ? namespacedEvent.substring(event.length) : namespacedEvent;
        Object.keys(scope_Events).forEach(function(bind) {
            var tEvent = bind.split(".")[0];
            var tNamespace = bind.substring(tEvent.length);
            if ((!event || event === tEvent) && (!namespace || namespace === tNamespace)) // only delete protected internal event if intentional
            {
                if (!isInternalNamespace(tNamespace) || namespace === tNamespace) delete scope_Events[bind];
            }
        });
    }
    // External event handling
    function fireEvent(eventName, handleNumber, tap) {
        Object.keys(scope_Events).forEach(function(targetEvent) {
            var eventType = targetEvent.split(".")[0];
            if (eventName === eventType) scope_Events[targetEvent].forEach(function(callback) {
                callback.call(// Use the slider public API as the scope ('this')
                scope_Self, // Return values as array, so arg_1[arg_2] is always valid.
                scope_Values.map(options.format.to), // Handle index, 0 or 1
                handleNumber, // Un-formatted slider values
                scope_Values.slice(), // Event is fired by tap, true or false
                tap || false, // Left offset of the handle, in relation to the slider
                scope_Locations.slice(), // add the slider public API to an accessible parameter when this is unavailable
                scope_Self);
            });
        });
    }
    // Split out the handle positioning logic so the Move event can use it, too
    function checkHandlePosition(reference, handleNumber, to, lookBackward, lookForward, getValue, smoothSteps) {
        var distance;
        // For sliders with multiple handles, limit movement to the other handle.
        // Apply the margin option by adding it to the handle positions.
        if (scope_Handles.length > 1 && !options.events.unconstrained) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.margin, false);
                to = Math.max(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.margin, true);
                to = Math.min(to, distance);
            }
        }
        // The limit option has the opposite effect, limiting handles to a
        // maximum distance from another. Limit must be > 0, as otherwise
        // handles would be unmovable.
        if (scope_Handles.length > 1 && options.limit) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.limit, false);
                to = Math.min(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.limit, true);
                to = Math.max(to, distance);
            }
        }
        // The padding option keeps the handles a certain distance from the
        // edges of the slider. Padding must be > 0.
        if (options.padding) {
            if (handleNumber === 0) {
                distance = scope_Spectrum.getAbsoluteDistance(0, options.padding[0], false);
                to = Math.max(to, distance);
            }
            if (handleNumber === scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(100, options.padding[1], true);
                to = Math.min(to, distance);
            }
        }
        if (!smoothSteps) to = scope_Spectrum.getStep(to);
        // Limit percentage to the 0 - 100 range
        to = $e9704b94b3b62e8f$var$limit(to);
        // Return false if handle can't move
        if (to === reference[handleNumber] && !getValue) return false;
        return to;
    }
    // Uses slider orientation to create CSS rules. a = base value;
    function inRuleOrder(v, a) {
        var o = options.ort;
        return (o ? a : v) + ", " + (o ? v : a);
    }
    // Moves handle(s) by a percentage
    // (bool, % to move, [% where handle started, ...], [index in scope_Handles, ...])
    function moveHandles(upward, proposal, locations, handleNumbers, connect) {
        var proposals = locations.slice();
        // Store first handle now, so we still have it in case handleNumbers is reversed
        var firstHandle = handleNumbers[0];
        var smoothSteps = options.events.smoothSteps;
        var b = [
            !upward,
            upward
        ];
        var f = [
            upward,
            !upward
        ];
        // Copy handleNumbers so we don't change the dataset
        handleNumbers = handleNumbers.slice();
        // Check to see which handle is 'leading'.
        // If that one can't move the second can't either.
        if (upward) handleNumbers.reverse();
        // Step 1: get the maximum percentage that any of the handles can move
        if (handleNumbers.length > 1) handleNumbers.forEach(function(handleNumber, o) {
            var to = checkHandlePosition(proposals, handleNumber, proposals[handleNumber] + proposal, b[o], f[o], false, smoothSteps);
            // Stop if one of the handles can't move.
            if (to === false) proposal = 0;
            else {
                proposal = to - proposals[handleNumber];
                proposals[handleNumber] = to;
            }
        });
        else b = f = [
            true
        ];
        var state = false;
        // Step 2: Try to set the handles with the found percentage
        handleNumbers.forEach(function(handleNumber, o) {
            state = setHandle(handleNumber, locations[handleNumber] + proposal, b[o], f[o], false, smoothSteps) || state;
        });
        // Step 3: If a handle moved, fire events
        if (state) {
            handleNumbers.forEach(function(handleNumber) {
                fireEvent("update", handleNumber);
                fireEvent("slide", handleNumber);
            });
            // If target is a connect, then fire drag event
            if (connect != undefined) fireEvent("drag", firstHandle);
        }
    }
    // Takes a base value and an offset. This offset is used for the connect bar size.
    // In the initial design for this feature, the origin element was 1% wide.
    // Unfortunately, a rounding bug in Chrome makes it impossible to implement this feature
    // in this manner: https://bugs.chromium.org/p/chromium/issues/detail?id=798223
    function transformDirection(a, b) {
        return options.dir ? 100 - a - b : a;
    }
    // Updates scope_Locations and scope_Values, updates visual state
    function updateHandlePosition(handleNumber, to) {
        // Update locations.
        scope_Locations[handleNumber] = to;
        // Convert the value to the slider stepping/range.
        scope_Values[handleNumber] = scope_Spectrum.fromStepping(to);
        var translation = transformDirection(to, 0) - scope_DirOffset;
        var translateRule = "translate(" + inRuleOrder(translation + "%", "0") + ")";
        scope_Handles[handleNumber].style[options.transformRule] = translateRule;
        // sanity check for at least 2 handles (e.g. during setup)
        if (options.events.invertConnects && scope_Locations.length > 1) {
            // check if handles passed each other, but don't match the ConnectsInverted state
            var handlesAreInOrder = scope_Locations.every(function(position, index, locations) {
                return index === 0 || position >= locations[index - 1];
            });
            if (scope_ConnectsInverted !== !handlesAreInOrder) {
                // invert connects when handles pass each other
                invertConnects();
                // invertConnects already updates all connect elements
                return;
            }
        }
        updateConnect(handleNumber);
        updateConnect(handleNumber + 1);
        if (scope_ConnectsInverted) {
            // When connects are inverted, we also have to update adjacent connects
            updateConnect(handleNumber - 1);
            updateConnect(handleNumber + 2);
        }
    }
    // Handles before the slider middle are stacked later = higher,
    // Handles after the middle later is lower
    // [[7] [8] .......... | .......... [5] [4]
    function setZindex() {
        scope_HandleNumbers.forEach(function(handleNumber) {
            var dir = scope_Locations[handleNumber] > 50 ? -1 : 1;
            var zIndex = 3 + (scope_Handles.length + dir * handleNumber);
            scope_Handles[handleNumber].style.zIndex = String(zIndex);
        });
    }
    // Test suggested values and apply margin, step.
    // if exactInput is true, don't run checkHandlePosition, then the handle can be placed in between steps (#436)
    function setHandle(handleNumber, to, lookBackward, lookForward, exactInput, smoothSteps) {
        if (!exactInput) to = checkHandlePosition(scope_Locations, handleNumber, to, lookBackward, lookForward, false, smoothSteps);
        if (to === false) return false;
        updateHandlePosition(handleNumber, to);
        return true;
    }
    // Updates style attribute for connect nodes
    function updateConnect(index) {
        // Skip connects set to false
        if (!scope_Connects[index]) return;
        // Create a copy of locations, so we can sort them for the local scope logic
        var locations = scope_Locations.slice();
        if (scope_ConnectsInverted) locations.sort(function(a, b) {
            return a - b;
        });
        var l = 0;
        var h = 100;
        if (index !== 0) l = locations[index - 1];
        if (index !== scope_Connects.length - 1) h = locations[index];
        // We use two rules:
        // 'translate' to change the left/top offset;
        // 'scale' to change the width of the element;
        // As the element has a width of 100%, a translation of 100% is equal to 100% of the parent (.noUi-base)
        var connectWidth = h - l;
        var translateRule = "translate(" + inRuleOrder(transformDirection(l, connectWidth) + "%", "0") + ")";
        var scaleRule = "scale(" + inRuleOrder(connectWidth / 100, "1") + ")";
        scope_Connects[index].style[options.transformRule] = translateRule + " " + scaleRule;
    }
    // Parses value passed to .set method. Returns current value if not parse-able.
    function resolveToValue(to, handleNumber) {
        // Setting with null indicates an 'ignore'.
        // Inputting 'false' is invalid.
        if (to === null || to === false || to === undefined) return scope_Locations[handleNumber];
        // If a formatted number was passed, attempt to decode it.
        if (typeof to === "number") to = String(to);
        to = options.format.from(to);
        if (to !== false) to = scope_Spectrum.toStepping(to);
        // If parsing the number failed, use the current value.
        if (to === false || isNaN(to)) return scope_Locations[handleNumber];
        return to;
    }
    // Set the slider value.
    function valueSet(input, fireSetEvent, exactInput) {
        var values = $e9704b94b3b62e8f$var$asArray(input);
        var isInit = scope_Locations[0] === undefined;
        // Event fires by default
        fireSetEvent = fireSetEvent === undefined ? true : fireSetEvent;
        // Animation is optional.
        // Make sure the initial values were set before using animated placement.
        if (options.animate && !isInit) $e9704b94b3b62e8f$var$addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        // First pass, without lookAhead but with lookBackward. Values are set from left to right.
        scope_HandleNumbers.forEach(function(handleNumber) {
            setHandle(handleNumber, resolveToValue(values[handleNumber], handleNumber), true, false, exactInput);
        });
        var i = scope_HandleNumbers.length === 1 ? 0 : 1;
        // Spread handles evenly across the slider if the range has no size (min=max)
        if (isInit && scope_Spectrum.hasNoSize()) {
            exactInput = true;
            scope_Locations[0] = 0;
            if (scope_HandleNumbers.length > 1) {
                var space_1 = 100 / (scope_HandleNumbers.length - 1);
                scope_HandleNumbers.forEach(function(handleNumber) {
                    scope_Locations[handleNumber] = handleNumber * space_1;
                });
            }
        }
        // Secondary passes. Now that all base values are set, apply constraints.
        // Iterate all handles to ensure constraints are applied for the entire slider (Issue #1009)
        for(; i < scope_HandleNumbers.length; ++i)scope_HandleNumbers.forEach(function(handleNumber) {
            setHandle(handleNumber, scope_Locations[handleNumber], true, true, exactInput);
        });
        setZindex();
        scope_HandleNumbers.forEach(function(handleNumber) {
            fireEvent("update", handleNumber);
            // Fire the event only for handles that received a new value, as per #579
            if (values[handleNumber] !== null && fireSetEvent) fireEvent("set", handleNumber);
        });
    }
    // Reset slider to initial values
    function valueReset(fireSetEvent) {
        valueSet(options.start, fireSetEvent);
    }
    // Set value for a single handle
    function valueSetHandle(handleNumber, value, fireSetEvent, exactInput) {
        // Ensure numeric input
        handleNumber = Number(handleNumber);
        if (!(handleNumber >= 0 && handleNumber < scope_HandleNumbers.length)) throw new Error("noUiSlider: invalid handle number, got: " + handleNumber);
        // Look both backward and forward, since we don't want this handle to "push" other handles (#960);
        // The exactInput argument can be used to ignore slider stepping (#436)
        setHandle(handleNumber, resolveToValue(value, handleNumber), true, true, exactInput);
        fireEvent("update", handleNumber);
        if (fireSetEvent) fireEvent("set", handleNumber);
    }
    // Get the slider value.
    function valueGet(unencoded) {
        if (unencoded === void 0) unencoded = false;
        if (unencoded) // return a copy of the raw values
        return scope_Values.length === 1 ? scope_Values[0] : scope_Values.slice(0);
        var values = scope_Values.map(options.format.to);
        // If only one handle is used, return a single value.
        if (values.length === 1) return values[0];
        return values;
    }
    // Removes classes from the root and empties it.
    function destroy() {
        // remove protected internal listeners
        removeEvent($e9704b94b3b62e8f$var$INTERNAL_EVENT_NS.aria);
        removeEvent($e9704b94b3b62e8f$var$INTERNAL_EVENT_NS.tooltips);
        Object.keys(options.cssClasses).forEach(function(key) {
            $e9704b94b3b62e8f$var$removeClass(scope_Target, options.cssClasses[key]);
        });
        while(scope_Target.firstChild)scope_Target.removeChild(scope_Target.firstChild);
        delete scope_Target.noUiSlider;
    }
    function getNextStepsForHandle(handleNumber) {
        var location = scope_Locations[handleNumber];
        var nearbySteps = scope_Spectrum.getNearbySteps(location);
        var value = scope_Values[handleNumber];
        var increment = nearbySteps.thisStep.step;
        var decrement = null;
        // If snapped, directly use defined step value
        if (options.snap) return [
            value - nearbySteps.stepBefore.startValue || null,
            nearbySteps.stepAfter.startValue - value || null
        ];
        // If the next value in this step moves into the next step,
        // the increment is the start of the next step - the current value
        if (increment !== false) {
            if (value + increment > nearbySteps.stepAfter.startValue) increment = nearbySteps.stepAfter.startValue - value;
        }
        // If the value is beyond the starting point
        if (value > nearbySteps.thisStep.startValue) decrement = nearbySteps.thisStep.step;
        else if (nearbySteps.stepBefore.step === false) decrement = false;
        else decrement = value - nearbySteps.stepBefore.highestStep;
        // Now, if at the slider edges, there is no in/decrement
        if (location === 100) increment = null;
        else if (location === 0) decrement = null;
        // As per #391, the comparison for the decrement step can have some rounding issues.
        var stepDecimals = scope_Spectrum.countStepDecimals();
        // Round per #391
        if (increment !== null && increment !== false) increment = Number(increment.toFixed(stepDecimals));
        if (decrement !== null && decrement !== false) decrement = Number(decrement.toFixed(stepDecimals));
        return [
            decrement,
            increment
        ];
    }
    // Get the current step size for the slider.
    function getNextSteps() {
        return scope_HandleNumbers.map(getNextStepsForHandle);
    }
    // Updatable: margin, limit, padding, step, range, animate, snap
    function updateOptions(optionsToUpdate, fireSetEvent) {
        // Spectrum is created using the range, snap, direction and step options.
        // 'snap' and 'step' can be updated.
        // If 'snap' and 'step' are not passed, they should remain unchanged.
        var v = valueGet();
        var updateAble = [
            "margin",
            "limit",
            "padding",
            "range",
            "animate",
            "snap",
            "step",
            "format",
            "pips",
            "tooltips",
            "connect"
        ];
        // Only change options that we're actually passed to update.
        updateAble.forEach(function(name) {
            // Check for undefined. null removes the value.
            if (optionsToUpdate[name] !== undefined) originalOptions[name] = optionsToUpdate[name];
        });
        var newOptions = $e9704b94b3b62e8f$var$testOptions(originalOptions);
        // Load new options into the slider state
        updateAble.forEach(function(name) {
            if (optionsToUpdate[name] !== undefined) options[name] = newOptions[name];
        });
        scope_Spectrum = newOptions.spectrum;
        // Limit, margin and padding depend on the spectrum but are stored outside of it. (#677)
        options.margin = newOptions.margin;
        options.limit = newOptions.limit;
        options.padding = newOptions.padding;
        // Update pips, removes existing.
        if (options.pips) pips(options.pips);
        else removePips();
        // Update tooltips, removes existing.
        if (options.tooltips) tooltips();
        else removeTooltips();
        // Invalidate the current positioning so valueSet forces an update.
        scope_Locations = [];
        valueSet($e9704b94b3b62e8f$var$isSet(optionsToUpdate.start) ? optionsToUpdate.start : v, fireSetEvent);
        // Update connects only if it was set
        if (optionsToUpdate.connect) updateConnectOption();
    }
    function updateConnectOption() {
        // IE supported way of removing children including event handlers
        while(scope_ConnectBase.firstChild)scope_ConnectBase.removeChild(scope_ConnectBase.firstChild);
        // Adding new connects according to the new connect options
        for(var i = 0; i <= options.handles; i++){
            scope_Connects[i] = addConnect(scope_ConnectBase, options.connect[i]);
            updateConnect(i);
        }
        // re-adding drag events for the new connect elements
        // to ignore the other events we have to negate the 'if (!behaviour.fixed)' check
        bindSliderEvents({
            drag: options.events.drag,
            fixed: true
        });
    }
    // Invert options for connect handles
    function invertConnects() {
        scope_ConnectsInverted = !scope_ConnectsInverted;
        $e9704b94b3b62e8f$var$testConnect(options, // inverse the connect boolean array
        options.connect.map(function(b) {
            return !b;
        }));
        updateConnectOption();
    }
    // Initialization steps
    function setupSlider() {
        // Create the base element, initialize HTML and set classes.
        // Add handles and connect elements.
        scope_Base = addSlider(scope_Target);
        addElements(options.connect, scope_Base);
        // Attach user events.
        bindSliderEvents(options.events);
        // Use the public value method to set the start values.
        valueSet(options.start);
        if (options.pips) pips(options.pips);
        if (options.tooltips) tooltips();
        aria();
    }
    setupSlider();
    var scope_Self = {
        destroy: destroy,
        steps: getNextSteps,
        on: bindEvent,
        off: removeEvent,
        get: valueGet,
        set: valueSet,
        setHandle: valueSetHandle,
        reset: valueReset,
        disable: disable,
        enable: enable,
        // Exposed for unit testing, don't use this in your application.
        __moveHandles: function(upward, proposal, handleNumbers) {
            moveHandles(upward, proposal, scope_Locations, handleNumbers);
        },
        options: originalOptions,
        updateOptions: updateOptions,
        target: scope_Target,
        removePips: removePips,
        removeTooltips: removeTooltips,
        getPositions: function() {
            return scope_Locations.slice();
        },
        getTooltips: function() {
            return scope_Tooltips;
        },
        getOrigins: function() {
            return scope_Handles;
        },
        pips: pips
    };
    return scope_Self;
}
// Run the standard initializer
function $e9704b94b3b62e8f$export$185802fd694ee1f5(target, originalOptions) {
    if (!target || !target.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + target);
    // Throw an error if the slider was already initialized.
    if (target.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
    // Test the options and create the slider environment;
    var options = $e9704b94b3b62e8f$var$testOptions(originalOptions);
    var api = $e9704b94b3b62e8f$var$scope(target, options, originalOptions);
    target.noUiSlider = api;
    return api;
}
var $e9704b94b3b62e8f$export$2e2bcd8739ae039 = {
    // Exposed for unit testing, don't use this in your application.
    __spectrum: $e9704b94b3b62e8f$var$Spectrum,
    // A reference to the default classes, allows global changes.
    // Use the cssClasses option for changes to one slider.
    cssClasses: $e9704b94b3b62e8f$export$c1c0562ec8379000,
    create: $e9704b94b3b62e8f$export$185802fd694ee1f5
};



const $c03fe7fdaf35f625$export$b38bf4f33e9e4c25 = ()=>{
    const SLIDER_BASIC = document.getElementById("slider-basic");
    const SLIDER_RANGE = document.getElementById("slider-range");
    if (SLIDER_BASIC) {
        (0, $e9704b94b3b62e8f$export$2e2bcd8739ae039).create(SLIDER_BASIC, {
            start: [
                20
            ],
            connect: "lower",
            range: {
                min: 0,
                max: 100
            }
        });
        SLIDER_BASIC.noUiSlider.on("update", function(values, handle) {
            document.getElementById("slider-basic-input").value = values[handle];
        });
    }
    if (SLIDER_RANGE) {
        const SLIDER_RANGER_UPPER = document.getElementById("slider-range-upper-input");
        const SLIDER_RANGER_LOWER = document.getElementById("slider-range-lower-input");
        const SLIDER_RANGER_INPUTS = [
            SLIDER_RANGER_UPPER,
            SLIDER_RANGER_LOWER
        ];
        (0, $e9704b94b3b62e8f$export$2e2bcd8739ae039).create(SLIDER_RANGE, {
            start: [
                30,
                70
            ],
            connect: true,
            range: {
                min: 0,
                max: 100
            }
        });
        SLIDER_RANGE.noUiSlider.on("update", function(values, handle) {
            SLIDER_RANGER_INPUTS[handle].value = values[handle];
        });
    }
};


// Clamps a value between an upper and lower bound.
// We use ternary operators because it makes the minified code
// 2 times shorter then `Math.min(Math.max(a,b),c)`
const $47fa805aec43113c$export$7d15b64cf5a3a4c4 = (number, min = 0, max = 1)=>{
    return number > max ? max : number < min ? min : number;
};
const $47fa805aec43113c$export$2077e0241d6afd3c = (number, digits = 0, base = Math.pow(10, digits))=>{
    return Math.round(base * number) / base;
};


/**
 * Valid CSS <angle> units.
 * https://developer.mozilla.org/en-US/docs/Web/CSS/angle
 */ const $e6bfc89c66ca8481$var$angleUnits = {
    grad: 0.9,
    turn: 360,
    rad: 360 / (Math.PI * 2)
};
const $e6bfc89c66ca8481$export$b46408e00e83b492 = (hex)=>$e6bfc89c66ca8481$export$f4deeebdec6065f9($e6bfc89c66ca8481$export$9665a07d9187b414(hex));
const $e6bfc89c66ca8481$export$9665a07d9187b414 = (hex)=>{
    if (hex[0] === "#") hex = hex.substring(1);
    if (hex.length < 6) return {
        r: parseInt(hex[0] + hex[0], 16),
        g: parseInt(hex[1] + hex[1], 16),
        b: parseInt(hex[2] + hex[2], 16),
        a: hex.length === 4 ? (0, $47fa805aec43113c$export$2077e0241d6afd3c)(parseInt(hex[3] + hex[3], 16) / 255, 2) : 1
    };
    return {
        r: parseInt(hex.substring(0, 2), 16),
        g: parseInt(hex.substring(2, 4), 16),
        b: parseInt(hex.substring(4, 6), 16),
        a: hex.length === 8 ? (0, $47fa805aec43113c$export$2077e0241d6afd3c)(parseInt(hex.substring(6, 8), 16) / 255, 2) : 1
    };
};
const $e6bfc89c66ca8481$export$7c374483fd1c382f = (value, unit = "deg")=>{
    return Number(value) * ($e6bfc89c66ca8481$var$angleUnits[unit] || 1);
};
const $e6bfc89c66ca8481$export$f1cc23c1d78956ee = (hslString)=>{
    const matcher = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
    const match = matcher.exec(hslString);
    if (!match) return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    return $e6bfc89c66ca8481$export$cad8462dfe655319({
        h: $e6bfc89c66ca8481$export$7c374483fd1c382f(match[1], match[2]),
        s: Number(match[3]),
        l: Number(match[4]),
        a: match[5] === undefined ? 1 : Number(match[5]) / (match[6] ? 100 : 1)
    });
};
const $e6bfc89c66ca8481$export$da6b3453e45f3684 = $e6bfc89c66ca8481$export$f1cc23c1d78956ee;
const $e6bfc89c66ca8481$export$cad8462dfe655319 = ({ h: h, s: s, l: l, a: a })=>{
    s *= (l < 50 ? l : 100 - l) / 100;
    return {
        h: h,
        s: s > 0 ? 2 * s / (l + s) * 100 : 0,
        v: l + s,
        a: a
    };
};
const $e6bfc89c66ca8481$export$8f550ac642b2adec = (hsva)=>$e6bfc89c66ca8481$export$ffee5509a14af63d($e6bfc89c66ca8481$export$e41dcd4e52af69bc(hsva));
const $e6bfc89c66ca8481$export$ea93620c892f6b62 = ({ h: h, s: s, v: v, a: a })=>{
    const hh = (200 - s) * v / 100;
    return {
        h: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(h),
        s: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(hh > 0 && hh < 200 ? s * v / 100 / (hh <= 100 ? hh : 200 - hh) * 100 : 0),
        l: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(hh / 2),
        a: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(a, 2)
    };
};
const $e6bfc89c66ca8481$export$d4f32970db1e882f = (hsva)=>{
    const { h: h, s: s, v: v } = $e6bfc89c66ca8481$export$e238eb0805b2bdfe(hsva);
    return `hsv(${h}, ${s}%, ${v}%)`;
};
const $e6bfc89c66ca8481$export$31b9c8c33b563570 = (hsva)=>{
    const { h: h, s: s, v: v, a: a } = $e6bfc89c66ca8481$export$e238eb0805b2bdfe(hsva);
    return `hsva(${h}, ${s}%, ${v}%, ${a})`;
};
const $e6bfc89c66ca8481$export$5088895f11133875 = (hsva)=>{
    const { h: h, s: s, l: l } = $e6bfc89c66ca8481$export$ea93620c892f6b62(hsva);
    return `hsl(${h}, ${s}%, ${l}%)`;
};
const $e6bfc89c66ca8481$export$9d8fe27c1d6d5ed0 = (hsva)=>{
    const { h: h, s: s, l: l, a: a } = $e6bfc89c66ca8481$export$ea93620c892f6b62(hsva);
    return `hsla(${h}, ${s}%, ${l}%, ${a})`;
};
const $e6bfc89c66ca8481$export$e41dcd4e52af69bc = ({ h: h, s: s, v: v, a: a })=>{
    h = h / 360 * 6;
    s = s / 100;
    v = v / 100;
    const hh = Math.floor(h), b = v * (1 - s), c = v * (1 - (h - hh) * s), d = v * (1 - (1 - h + hh) * s), module = hh % 6;
    return {
        r: (0, $47fa805aec43113c$export$2077e0241d6afd3c)([
            v,
            c,
            b,
            b,
            d,
            v
        ][module] * 255),
        g: (0, $47fa805aec43113c$export$2077e0241d6afd3c)([
            d,
            v,
            v,
            c,
            b,
            b
        ][module] * 255),
        b: (0, $47fa805aec43113c$export$2077e0241d6afd3c)([
            b,
            b,
            d,
            v,
            v,
            c
        ][module] * 255),
        a: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(a, 2)
    };
};
const $e6bfc89c66ca8481$export$48759cfe1e576e90 = (hsva)=>{
    const { r: r, g: g, b: b } = $e6bfc89c66ca8481$export$e41dcd4e52af69bc(hsva);
    return `rgb(${r}, ${g}, ${b})`;
};
const $e6bfc89c66ca8481$export$4f8847fa6078ef9d = (hsva)=>{
    const { r: r, g: g, b: b, a: a } = $e6bfc89c66ca8481$export$e41dcd4e52af69bc(hsva);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
};
const $e6bfc89c66ca8481$export$b2d5debb615cb646 = (hsvString)=>{
    const matcher = /hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
    const match = matcher.exec(hsvString);
    if (!match) return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    return $e6bfc89c66ca8481$export$e238eb0805b2bdfe({
        h: $e6bfc89c66ca8481$export$7c374483fd1c382f(match[1], match[2]),
        s: Number(match[3]),
        v: Number(match[4]),
        a: match[5] === undefined ? 1 : Number(match[5]) / (match[6] ? 100 : 1)
    });
};
const $e6bfc89c66ca8481$export$6b2bc07f8f228168 = $e6bfc89c66ca8481$export$b2d5debb615cb646;
const $e6bfc89c66ca8481$export$8a47db680f105266 = (rgbaString)=>{
    const matcher = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
    const match = matcher.exec(rgbaString);
    if (!match) return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    return $e6bfc89c66ca8481$export$f4deeebdec6065f9({
        r: Number(match[1]) / (match[2] ? 100 / 255 : 1),
        g: Number(match[3]) / (match[4] ? 100 / 255 : 1),
        b: Number(match[5]) / (match[6] ? 100 / 255 : 1),
        a: match[7] === undefined ? 1 : Number(match[7]) / (match[8] ? 100 : 1)
    });
};
const $e6bfc89c66ca8481$export$43c951a6cd314995 = $e6bfc89c66ca8481$export$8a47db680f105266;
const $e6bfc89c66ca8481$var$format = (number)=>{
    const hex = number.toString(16);
    return hex.length < 2 ? "0" + hex : hex;
};
const $e6bfc89c66ca8481$export$ffee5509a14af63d = ({ r: r, g: g, b: b, a: a })=>{
    const alphaHex = a < 1 ? $e6bfc89c66ca8481$var$format((0, $47fa805aec43113c$export$2077e0241d6afd3c)(a * 255)) : "";
    return "#" + $e6bfc89c66ca8481$var$format(r) + $e6bfc89c66ca8481$var$format(g) + $e6bfc89c66ca8481$var$format(b) + alphaHex;
};
const $e6bfc89c66ca8481$export$f4deeebdec6065f9 = ({ r: r, g: g, b: b, a: a })=>{
    const max = Math.max(r, g, b);
    const delta = max - Math.min(r, g, b);
    // prettier-ignore
    const hh = delta ? max === r ? (g - b) / delta : max === g ? 2 + (b - r) / delta : 4 + (r - g) / delta : 0;
    return {
        h: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(60 * (hh < 0 ? hh + 6 : hh)),
        s: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(max ? delta / max * 100 : 0),
        v: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(max / 255 * 100),
        a: a
    };
};
const $e6bfc89c66ca8481$export$e238eb0805b2bdfe = (hsva)=>({
        h: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(hsva.h),
        s: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(hsva.s),
        v: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(hsva.v),
        a: (0, $47fa805aec43113c$export$2077e0241d6afd3c)(hsva.a, 2)
    });
const $e6bfc89c66ca8481$export$e1a7c5bad5659d47 = ({ r: r, g: g, b: b })=>({
        r: r,
        g: g,
        b: b
    });
const $e6bfc89c66ca8481$export$933a8dde080f58ff = ({ h: h, s: s, l: l })=>({
        h: h,
        s: s,
        l: l
    });
const $e6bfc89c66ca8481$export$fc6c9f0fcd96330f = (hsva)=>{
    const { h: h, s: s, v: v } = $e6bfc89c66ca8481$export$e238eb0805b2bdfe(hsva);
    return {
        h: h,
        s: s,
        v: v
    };
};


const $6a2d79cb5d7cd78d$export$2123f06676026de7 = (first, second)=>{
    if (first === second) return true;
    for(const prop in first){
        // The following allows for a type-safe calling of this function (first & second have to be HSL, HSV, or RGB)
        // with type-unsafe iterating over object keys. TS does not allow this without an index (`[key: string]: number`)
        // on an object to define how iteration is normally done. To ensure extra keys are not allowed on our types,
        // we must cast our object to unknown (as RGB demands `r` be a key, while `Record<string, x>` does not care if
        // there is or not), and then as a type TS can iterate over.
        if (first[prop] !== second[prop]) return false;
    }
    return true;
};
const $6a2d79cb5d7cd78d$export$6ece4d09186dd7d4 = (first, second)=>{
    return first.replace(/\s/g, "") === second.replace(/\s/g, "");
};
const $6a2d79cb5d7cd78d$export$30c81f1d8f88a836 = (first, second)=>{
    if (first.toLowerCase() === second.toLowerCase()) return true;
    // To compare colors like `#FFF` and `ffffff` we convert them into RGB objects
    return $6a2d79cb5d7cd78d$export$2123f06676026de7((0, $e6bfc89c66ca8481$export$9665a07d9187b414)(first), (0, $e6bfc89c66ca8481$export$9665a07d9187b414)(second));
};


const $d85280ae51b5ccd7$var$cache = {};
const $d85280ae51b5ccd7$export$5dfe2efd653fcea4 = (html)=>{
    let template = $d85280ae51b5ccd7$var$cache[html];
    if (!template) {
        template = document.createElement("template");
        template.innerHTML = html;
        $d85280ae51b5ccd7$var$cache[html] = template;
    }
    return template;
};
const $d85280ae51b5ccd7$export$46ff36df9b99bc25 = (target, type, detail)=>{
    target.dispatchEvent(new CustomEvent(type, {
        bubbles: true,
        detail: detail
    }));
};




let $3e2ba416295abab3$var$hasTouched = false;
// Check if an event was triggered by touch
const $3e2ba416295abab3$var$isTouch = (e)=>"touches" in e;
// Prevent mobile browsers from handling mouse events (conflicting with touch ones).
// If we detected a touch interaction before, we prefer reacting to touch events only.
const $3e2ba416295abab3$var$isValid = (event)=>{
    if ($3e2ba416295abab3$var$hasTouched && !$3e2ba416295abab3$var$isTouch(event)) return false;
    if (!$3e2ba416295abab3$var$hasTouched) $3e2ba416295abab3$var$hasTouched = $3e2ba416295abab3$var$isTouch(event);
    return true;
};
const $3e2ba416295abab3$var$pointerMove = (target, event)=>{
    const pointer = $3e2ba416295abab3$var$isTouch(event) ? event.touches[0] : event;
    const rect = target.el.getBoundingClientRect();
    (0, $d85280ae51b5ccd7$export$46ff36df9b99bc25)(target.el, "move", target.getMove({
        x: (0, $47fa805aec43113c$export$7d15b64cf5a3a4c4)((pointer.pageX - (rect.left + window.pageXOffset)) / rect.width),
        y: (0, $47fa805aec43113c$export$7d15b64cf5a3a4c4)((pointer.pageY - (rect.top + window.pageYOffset)) / rect.height)
    }));
};
const $3e2ba416295abab3$var$keyMove = (target, event)=>{
    // We use `keyCode` instead of `key` to reduce the size of the library.
    const keyCode = event.keyCode;
    // Ignore all keys except arrow ones, Page Up, Page Down, Home and End.
    if (keyCode > 40 || target.xy && keyCode < 37 || keyCode < 33) return;
    // Do not scroll page by keys when color picker element has focus.
    event.preventDefault();
    // Send relative offset to the parent component.
    (0, $d85280ae51b5ccd7$export$46ff36df9b99bc25)(target.el, "move", target.getMove({
        x: keyCode === 39 // Arrow Right
         ? 0.01 : keyCode === 37 // Arrow Left
         ? -0.01 : keyCode === 34 // Page Down
         ? 0.05 : keyCode === 33 // Page Up
         ? -0.05 : keyCode === 35 // End
         ? 1 : keyCode === 36 // Home
         ? -1 : 0,
        y: keyCode === 40 // Arrow down
         ? 0.01 : keyCode === 38 // Arrow Up
         ? -0.01 : 0
    }, true));
};
class $3e2ba416295abab3$export$472062a354075cee {
    constructor(root, part, aria, xy){
        const template = (0, $d85280ae51b5ccd7$export$5dfe2efd653fcea4)(`<div role="slider" tabindex="0" part="${part}" ${aria}><div part="${part}-pointer"></div></div>`);
        root.appendChild(template.content.cloneNode(true));
        const el = root.querySelector(`[part=${part}]`);
        el.addEventListener("mousedown", this);
        el.addEventListener("touchstart", this);
        el.addEventListener("keydown", this);
        this.el = el;
        this.xy = xy;
        this.nodes = [
            el.firstChild,
            el
        ];
    }
    set dragging(state) {
        const toggleEvent = state ? document.addEventListener : document.removeEventListener;
        toggleEvent($3e2ba416295abab3$var$hasTouched ? "touchmove" : "mousemove", this);
        toggleEvent($3e2ba416295abab3$var$hasTouched ? "touchend" : "mouseup", this);
    }
    handleEvent(event) {
        switch(event.type){
            case "mousedown":
            case "touchstart":
                event.preventDefault();
                // event.button is 0 in mousedown for left button activation
                if (!$3e2ba416295abab3$var$isValid(event) || !$3e2ba416295abab3$var$hasTouched && event.button != 0) return;
                this.el.focus();
                $3e2ba416295abab3$var$pointerMove(this, event);
                this.dragging = true;
                break;
            case "mousemove":
            case "touchmove":
                event.preventDefault();
                $3e2ba416295abab3$var$pointerMove(this, event);
                break;
            case "mouseup":
            case "touchend":
                this.dragging = false;
                break;
            case "keydown":
                $3e2ba416295abab3$var$keyMove(this, event);
                break;
        }
    }
    style(styles) {
        styles.forEach((style, i)=>{
            for(const p in style)this.nodes[i].style.setProperty(p, style[p]);
        });
    }
}




class $7345cf7e21cd5689$export$3e22a96a58989a47 extends (0, $3e2ba416295abab3$export$472062a354075cee) {
    constructor(root){
        super(root, "hue", 'aria-label="Hue" aria-valuemin="0" aria-valuemax="360"', false);
    }
    update({ h: h }) {
        this.h = h;
        this.style([
            {
                left: `${h / 360 * 100}%`,
                color: (0, $e6bfc89c66ca8481$export$5088895f11133875)({
                    h: h,
                    s: 100,
                    v: 100,
                    a: 1
                })
            }
        ]);
        this.el.setAttribute("aria-valuenow", `${(0, $47fa805aec43113c$export$2077e0241d6afd3c)(h)}`);
    }
    getMove(offset, key) {
        // Hue measured in degrees of the color circle ranging from 0 to 360
        return {
            h: key ? (0, $47fa805aec43113c$export$7d15b64cf5a3a4c4)(this.h + offset.x * 360, 0, 360) : 360 * offset.x
        };
    }
}





class $16b07794380a87aa$export$c4dbe12ffaee3c8e extends (0, $3e2ba416295abab3$export$472062a354075cee) {
    constructor(root){
        super(root, "saturation", 'aria-label="Color"', true);
    }
    update(hsva) {
        this.hsva = hsva;
        this.style([
            {
                top: `${100 - hsva.v}%`,
                left: `${hsva.s}%`,
                color: (0, $e6bfc89c66ca8481$export$5088895f11133875)(hsva)
            },
            {
                "background-color": (0, $e6bfc89c66ca8481$export$5088895f11133875)({
                    h: hsva.h,
                    s: 100,
                    v: 100,
                    a: 1
                })
            }
        ]);
        this.el.setAttribute("aria-valuetext", `Saturation ${(0, $47fa805aec43113c$export$2077e0241d6afd3c)(hsva.s)}%, Brightness ${(0, $47fa805aec43113c$export$2077e0241d6afd3c)(hsva.v)}%`);
    }
    getMove(offset, key) {
        // Saturation and brightness always fit into [0, 100] range
        return {
            s: key ? (0, $47fa805aec43113c$export$7d15b64cf5a3a4c4)(this.hsva.s + offset.x * 100, 0, 100) : offset.x * 100,
            v: key ? (0, $47fa805aec43113c$export$7d15b64cf5a3a4c4)(this.hsva.v - offset.y * 100, 0, 100) : Math.round(100 - offset.y * 100)
        };
    }
}


var $11111ca76114e20a$export$2e2bcd8739ae039 = `:host{display:flex;flex-direction:column;position:relative;width:200px;height:200px;user-select:none;-webkit-user-select:none;cursor:default}:host([hidden]){display:none!important}[role=slider]{position:relative;touch-action:none;user-select:none;-webkit-user-select:none;outline:0}[role=slider]:last-child{border-radius:0 0 8px 8px}[part$=pointer]{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;display:flex;place-content:center center;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}[part$=pointer]::after{content:"";width:100%;height:100%;border-radius:inherit;background-color:currentColor}[role=slider]:focus [part$=pointer]{transform:translate(-50%,-50%) scale(1.1)}`;


var $114e775d4bff05cb$export$2e2bcd8739ae039 = `[part=hue]{flex:0 0 24px;background:linear-gradient(to right,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red 100%)}[part=hue-pointer]{top:50%;z-index:2}`;


var $bac55ef557326607$export$2e2bcd8739ae039 = `[part=saturation]{flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(to top,#000,transparent),linear-gradient(to right,#fff,rgba(255,255,255,0));box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}[part=saturation-pointer]{z-index:3}`;


const $a5b5807dc851aeb3$var$$isSame = Symbol("same");
const $a5b5807dc851aeb3$var$$color = Symbol("color");
const $a5b5807dc851aeb3$var$$hsva = Symbol("hsva");
const $a5b5807dc851aeb3$var$$update = Symbol("update");
const $a5b5807dc851aeb3$var$$parts = Symbol("parts");
const $a5b5807dc851aeb3$export$639d3bf3586a8ae1 = Symbol("css");
const $a5b5807dc851aeb3$export$6892090d606d23aa = Symbol("sliders");
class $a5b5807dc851aeb3$export$9feb1bc2e5f1ccb3 extends HTMLElement {
    static get observedAttributes() {
        return [
            "color"
        ];
    }
    get [$a5b5807dc851aeb3$export$639d3bf3586a8ae1]() {
        return [
            (0, $11111ca76114e20a$export$2e2bcd8739ae039),
            (0, $114e775d4bff05cb$export$2e2bcd8739ae039),
            (0, $bac55ef557326607$export$2e2bcd8739ae039)
        ];
    }
    get [$a5b5807dc851aeb3$export$6892090d606d23aa]() {
        return [
            (0, $16b07794380a87aa$export$c4dbe12ffaee3c8e),
            (0, $7345cf7e21cd5689$export$3e22a96a58989a47)
        ];
    }
    get color() {
        return this[$a5b5807dc851aeb3$var$$color];
    }
    set color(newColor) {
        if (!this[$a5b5807dc851aeb3$var$$isSame](newColor)) {
            const newHsva = this.colorModel.toHsva(newColor);
            this[$a5b5807dc851aeb3$var$$update](newHsva);
            this[$a5b5807dc851aeb3$var$$color] = newColor;
        }
    }
    constructor(){
        super();
        const template = (0, $d85280ae51b5ccd7$export$5dfe2efd653fcea4)(`<style>${this[$a5b5807dc851aeb3$export$639d3bf3586a8ae1].join("")}</style>`);
        const root = this.attachShadow({
            mode: "open"
        });
        root.appendChild(template.content.cloneNode(true));
        root.addEventListener("move", this);
        this[$a5b5807dc851aeb3$var$$parts] = this[$a5b5807dc851aeb3$export$6892090d606d23aa].map((slider)=>new slider(root));
    }
    connectedCallback() {
        // A user may set a property on an _instance_ of an element,
        // before its prototype has been connected to this class.
        // If so, we need to run it through the proper class setter.
        if (this.hasOwnProperty("color")) {
            const value = this.color;
            delete this["color"];
            this.color = value;
        } else if (!this.color) this.color = this.colorModel.defaultColor;
    }
    attributeChangedCallback(_attr, _oldVal, newVal) {
        const color = this.colorModel.fromAttr(newVal);
        if (!this[$a5b5807dc851aeb3$var$$isSame](color)) this.color = color;
    }
    handleEvent(event) {
        // Merge the current HSV color object with updated params.
        const oldHsva = this[$a5b5807dc851aeb3$var$$hsva];
        const newHsva = {
            ...oldHsva,
            ...event.detail
        };
        this[$a5b5807dc851aeb3$var$$update](newHsva);
        let newColor;
        if (!(0, $6a2d79cb5d7cd78d$export$2123f06676026de7)(newHsva, oldHsva) && !this[$a5b5807dc851aeb3$var$$isSame](newColor = this.colorModel.fromHsva(newHsva))) {
            this[$a5b5807dc851aeb3$var$$color] = newColor;
            (0, $d85280ae51b5ccd7$export$46ff36df9b99bc25)(this, "color-changed", {
                value: newColor
            });
        }
    }
    [$a5b5807dc851aeb3$var$$isSame](color) {
        return this.color && this.colorModel.equal(color, this.color);
    }
    [$a5b5807dc851aeb3$var$$update](hsva) {
        this[$a5b5807dc851aeb3$var$$hsva] = hsva;
        this[$a5b5807dc851aeb3$var$$parts].forEach((part)=>part.update(hsva));
    }
}




const $8988beb2487d91d1$var$colorModel = {
    defaultColor: "#000",
    toHsva: (0, $e6bfc89c66ca8481$export$b46408e00e83b492),
    fromHsva: ({ h: h, s: s, v: v })=>(0, $e6bfc89c66ca8481$export$8f550ac642b2adec)({
            h: h,
            s: s,
            v: v,
            a: 1
        }),
    equal: (0, $6a2d79cb5d7cd78d$export$30c81f1d8f88a836),
    fromAttr: (color)=>color
};
class $8988beb2487d91d1$export$aac89129a4eb37b4 extends (0, $a5b5807dc851aeb3$export$9feb1bc2e5f1ccb3) {
    get colorModel() {
        return $8988beb2487d91d1$var$colorModel;
    }
}


class $acff970c06fd6113$export$a3bc3c32746e9f3a extends (0, $8988beb2487d91d1$export$aac89129a4eb37b4) {
}
customElements.define("hex-color-picker", $acff970c06fd6113$export$a3bc3c32746e9f3a);





const $97f65cddc95011e7$var$colorModel = {
    defaultColor: "hsl(0, 0%, 0%)",
    toHsva: (0, $e6bfc89c66ca8481$export$da6b3453e45f3684),
    fromHsva: (0, $e6bfc89c66ca8481$export$5088895f11133875),
    equal: (0, $6a2d79cb5d7cd78d$export$6ece4d09186dd7d4),
    fromAttr: (color)=>color
};
class $97f65cddc95011e7$export$898be2d0ea41bd67 extends (0, $a5b5807dc851aeb3$export$9feb1bc2e5f1ccb3) {
    get colorModel() {
        return $97f65cddc95011e7$var$colorModel;
    }
}


class $6392642072f4f752$export$f4f988c96ece960 extends (0, $97f65cddc95011e7$export$898be2d0ea41bd67) {
}
customElements.define("hsl-string-color-picker", $6392642072f4f752$export$f4f988c96ece960);






class $3ac9be9257771118$export$b3d0ceb706f8af43 extends (0, $3e2ba416295abab3$export$472062a354075cee) {
    constructor(root){
        super(root, "alpha", 'aria-label="Alpha" aria-valuemin="0" aria-valuemax="1"', false);
    }
    update(hsva) {
        this.hsva = hsva;
        const colorFrom = (0, $e6bfc89c66ca8481$export$9d8fe27c1d6d5ed0)({
            ...hsva,
            a: 0
        });
        const colorTo = (0, $e6bfc89c66ca8481$export$9d8fe27c1d6d5ed0)({
            ...hsva,
            a: 1
        });
        const value = hsva.a * 100;
        this.style([
            {
                left: `${value}%`,
                color: (0, $e6bfc89c66ca8481$export$9d8fe27c1d6d5ed0)(hsva)
            },
            {
                "--gradient": `linear-gradient(90deg, ${colorFrom}, ${colorTo}`
            }
        ]);
        const v = (0, $47fa805aec43113c$export$2077e0241d6afd3c)(value);
        this.el.setAttribute("aria-valuenow", `${v}`);
        this.el.setAttribute("aria-valuetext", `${v}%`);
    }
    getMove(offset, key) {
        // Alpha always fit into [0, 1] range
        return {
            a: key ? (0, $47fa805aec43113c$export$7d15b64cf5a3a4c4)(this.hsva.a + offset.x) : offset.x
        };
    }
}


var $776bca523c7f04f9$export$2e2bcd8739ae039 = `[part=alpha]{flex:0 0 24px}[part=alpha]::after{display:block;content:"";position:absolute;top:0;left:0;right:0;bottom:0;border-radius:inherit;background-image:var(--gradient);box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}[part^=alpha]{background-color:#fff;background-image:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><rect x="8" width="8" height="8"/><rect y="8" width="8" height="8"/></svg>')}[part=alpha-pointer]{top:50%}`;


class $37a48e612f53b678$export$140fbb69603eb3d extends (0, $a5b5807dc851aeb3$export$9feb1bc2e5f1ccb3) {
    get [(0, $a5b5807dc851aeb3$export$639d3bf3586a8ae1)]() {
        return [
            ...super[0, $a5b5807dc851aeb3$export$639d3bf3586a8ae1],
            (0, $776bca523c7f04f9$export$2e2bcd8739ae039)
        ];
    }
    get [(0, $a5b5807dc851aeb3$export$6892090d606d23aa)]() {
        return [
            ...super[0, $a5b5807dc851aeb3$export$6892090d606d23aa],
            (0, $3ac9be9257771118$export$b3d0ceb706f8af43)
        ];
    }
}




const $1f50245abd084ad3$var$colorModel = {
    defaultColor: "rgba(0, 0, 0, 1)",
    toHsva: (0, $e6bfc89c66ca8481$export$8a47db680f105266),
    fromHsva: (0, $e6bfc89c66ca8481$export$4f8847fa6078ef9d),
    equal: (0, $6a2d79cb5d7cd78d$export$6ece4d09186dd7d4),
    fromAttr: (color)=>color
};
class $1f50245abd084ad3$export$6d272aebd7e85caa extends (0, $37a48e612f53b678$export$140fbb69603eb3d) {
    get colorModel() {
        return $1f50245abd084ad3$var$colorModel;
    }
}


class $a6f5cf3b69d50b12$export$be07dcc7abc11a36 extends (0, $1f50245abd084ad3$export$6d272aebd7e85caa) {
}
customElements.define("rgba-string-color-picker", $a6f5cf3b69d50b12$export$be07dcc7abc11a36);


const $601a1a02a92d61a5$export$fd9a8359a728871b = ()=>{
    const HEX_EL = document.querySelector("hex-color-picker");
    const HEX_INPUT_EL = document.getElementById("hex-input");
    const HSL_EL = document.querySelector("hsl-string-color-picker");
    const HSL_INPUT_EL = document.getElementById("hsl-input");
    const RGBA_EL = document.querySelector("rgba-string-color-picker");
    const RGBA_INPUT_EL = document.getElementById("rgba-input");
    if (HEX_EL) HEX_EL.addEventListener("color-changed", (event)=>{
        const newColor = event.detail.value;
        HEX_INPUT_EL.value = newColor;
    });
    if (HSL_EL) HSL_EL.addEventListener("color-changed", (event)=>{
        const newColor = event.detail.value;
        HSL_INPUT_EL.value = newColor;
    });
    if (RGBA_EL) RGBA_EL.addEventListener("color-changed", (event)=>{
        const newColor = event.detail.value;
        RGBA_INPUT_EL.value = newColor;
    });
};


/**
 * simplebar - v6.2.7
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ /**
 * simplebar-core - v1.2.6
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ 

var $ht9qF = parcelRequire("ht9qF");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $d972f10f16ff61c7$var$now = function() {
    return (0, $ht9qF.default).Date.now();
};
var $d972f10f16ff61c7$export$2e2bcd8739ae039 = $d972f10f16ff61c7$var$now;


/** Used to match a single whitespace character. */ var $cc7b5a3fcb492156$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $cc7b5a3fcb492156$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $cc7b5a3fcb492156$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $cc7b5a3fcb492156$export$2e2bcd8739ae039 = $cc7b5a3fcb492156$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $378d140336f3f794$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $378d140336f3f794$var$baseTrim(string) {
    return string ? string.slice(0, (0, $cc7b5a3fcb492156$export$2e2bcd8739ae039)(string) + 1).replace($378d140336f3f794$var$reTrimStart, "") : string;
}
var $378d140336f3f794$export$2e2bcd8739ae039 = $378d140336f3f794$var$baseTrim;





/** `Object#toString` result references. */ var $5a81ce1b6f8899ef$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5a81ce1b6f8899ef$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $b48ae904b6702ab5$export$2e2bcd8739ae039)(value) && (0, $f9754adf838f9df5$export$2e2bcd8739ae039)(value) == $5a81ce1b6f8899ef$var$symbolTag;
}
var $5a81ce1b6f8899ef$export$2e2bcd8739ae039 = $5a81ce1b6f8899ef$var$isSymbol;


/** Used as references for various `Number` constants. */ var $c355ee5af4c2530f$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $c355ee5af4c2530f$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $c355ee5af4c2530f$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $c355ee5af4c2530f$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $c355ee5af4c2530f$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $c355ee5af4c2530f$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $5a81ce1b6f8899ef$export$2e2bcd8739ae039)(value)) return $c355ee5af4c2530f$var$NAN;
    if ((0, $2305f62ead79bff9$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $2305f62ead79bff9$export$2e2bcd8739ae039)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $378d140336f3f794$export$2e2bcd8739ae039)(value);
    var isBinary = $c355ee5af4c2530f$var$reIsBinary.test(value);
    return isBinary || $c355ee5af4c2530f$var$reIsOctal.test(value) ? $c355ee5af4c2530f$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $c355ee5af4c2530f$var$reIsBadHex.test(value) ? $c355ee5af4c2530f$var$NAN : +value;
}
var $c355ee5af4c2530f$export$2e2bcd8739ae039 = $c355ee5af4c2530f$var$toNumber;


/** Error message constants. */ var $d38f7b7195f47e9c$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d38f7b7195f47e9c$var$nativeMax = Math.max, $d38f7b7195f47e9c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d38f7b7195f47e9c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($d38f7b7195f47e9c$var$FUNC_ERROR_TEXT);
    wait = (0, $c355ee5af4c2530f$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $2305f62ead79bff9$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $d38f7b7195f47e9c$var$nativeMax((0, $c355ee5af4c2530f$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d38f7b7195f47e9c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $d972f10f16ff61c7$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $d972f10f16ff61c7$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $d972f10f16ff61c7$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $d38f7b7195f47e9c$export$2e2bcd8739ae039 = $d38f7b7195f47e9c$var$debounce;



/** Error message constants. */ var $a90d634f67577793$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $a90d634f67577793$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($a90d634f67577793$var$FUNC_ERROR_TEXT);
    if ((0, $2305f62ead79bff9$export$2e2bcd8739ae039)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, $d38f7b7195f47e9c$export$2e2bcd8739ae039)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $a90d634f67577793$export$2e2bcd8739ae039 = $a90d634f67577793$var$throttle;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $7b7c3d0272544179$var$__assign = function() {
    $7b7c3d0272544179$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7b7c3d0272544179$var$__assign.apply(this, arguments);
};
function $7b7c3d0272544179$var$getElementWindow$1(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function $7b7c3d0272544179$var$getElementDocument$1(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
// Helper function to retrieve options from element attributes
var $7b7c3d0272544179$var$getOptions$1 = function(obj) {
    var initialObj = {};
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(_, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case "true":
                    acc[key] = true;
                    break;
                case "false":
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, initialObj);
    return options;
};
function $7b7c3d0272544179$var$addClasses$1(el, classes) {
    var _a;
    if (!el) return;
    (_a = el.classList).add.apply(_a, classes.split(" "));
}
function $7b7c3d0272544179$var$removeClasses$1(el, classes) {
    if (!el) return;
    classes.split(" ").forEach(function(className) {
        el.classList.remove(className);
    });
}
function $7b7c3d0272544179$var$classNamesToQuery$1(classNames) {
    return ".".concat(classNames.split(" ").join("."));
}
var $7b7c3d0272544179$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $7b7c3d0272544179$var$helpers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    addClasses: $7b7c3d0272544179$var$addClasses$1,
    canUseDOM: $7b7c3d0272544179$var$canUseDOM,
    classNamesToQuery: $7b7c3d0272544179$var$classNamesToQuery$1,
    getElementDocument: $7b7c3d0272544179$var$getElementDocument$1,
    getElementWindow: $7b7c3d0272544179$var$getElementWindow$1,
    getOptions: $7b7c3d0272544179$var$getOptions$1,
    removeClasses: $7b7c3d0272544179$var$removeClasses$1
});
var $7b7c3d0272544179$var$cachedScrollbarWidth = null;
var $7b7c3d0272544179$var$cachedDevicePixelRatio = null;
if ($7b7c3d0272544179$var$canUseDOM) window.addEventListener("resize", function() {
    if ($7b7c3d0272544179$var$cachedDevicePixelRatio !== window.devicePixelRatio) {
        $7b7c3d0272544179$var$cachedDevicePixelRatio = window.devicePixelRatio;
        $7b7c3d0272544179$var$cachedScrollbarWidth = null;
    }
});
function $7b7c3d0272544179$var$scrollbarWidth() {
    if ($7b7c3d0272544179$var$cachedScrollbarWidth === null) {
        if (typeof document === "undefined") {
            $7b7c3d0272544179$var$cachedScrollbarWidth = 0;
            return $7b7c3d0272544179$var$cachedScrollbarWidth;
        }
        var body = document.body;
        var box = document.createElement("div");
        box.classList.add("simplebar-hide-scrollbar");
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        $7b7c3d0272544179$var$cachedScrollbarWidth = width;
    }
    return $7b7c3d0272544179$var$cachedScrollbarWidth;
}
var $7b7c3d0272544179$var$getElementWindow = $7b7c3d0272544179$var$getElementWindow$1, $7b7c3d0272544179$var$getElementDocument = $7b7c3d0272544179$var$getElementDocument$1, $7b7c3d0272544179$var$getOptions = $7b7c3d0272544179$var$getOptions$1, $7b7c3d0272544179$var$addClasses = $7b7c3d0272544179$var$addClasses$1, $7b7c3d0272544179$var$removeClasses = $7b7c3d0272544179$var$removeClasses$1, $7b7c3d0272544179$var$classNamesToQuery = $7b7c3d0272544179$var$classNamesToQuery$1;
var $7b7c3d0272544179$export$2e2bcd8739ae039 = /** @class */ function() {
    function SimpleBarCore(element, options) {
        if (options === void 0) options = {};
        var _this = this;
        this.removePreventClickId = null;
        this.minScrollbarWidth = 20;
        this.stopScrollDelay = 175;
        this.isScrolling = false;
        this.isMouseEntering = false;
        this.isDragging = false;
        this.scrollXTicking = false;
        this.scrollYTicking = false;
        this.wrapperEl = null;
        this.contentWrapperEl = null;
        this.contentEl = null;
        this.offsetEl = null;
        this.maskEl = null;
        this.placeholderEl = null;
        this.heightAutoObserverWrapperEl = null;
        this.heightAutoObserverEl = null;
        this.rtlHelpers = null;
        this.scrollbarWidth = 0;
        this.resizeObserver = null;
        this.mutationObserver = null;
        this.elStyles = null;
        this.isRtl = null;
        this.mouseX = 0;
        this.mouseY = 0;
        this.onMouseMove = function() {};
        this.onWindowResize = function() {};
        this.onStopScrolling = function() {};
        this.onMouseEntered = function() {};
        /**
         * On scroll event handling
         */ this.onScroll = function() {
            var elWindow = $7b7c3d0272544179$var$getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
            if (!_this.isScrolling) {
                _this.isScrolling = true;
                $7b7c3d0272544179$var$addClasses(_this.el, _this.classNames.scrolling);
            }
            _this.showScrollbar("x");
            _this.showScrollbar("y");
            _this.onStopScrolling();
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) _this.positionScrollbar("x");
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) _this.positionScrollbar("y");
            _this.scrollYTicking = false;
        };
        this._onStopScrolling = function() {
            $7b7c3d0272544179$var$removeClasses(_this.el, _this.classNames.scrolling);
            if (_this.options.autoHide) {
                _this.hideScrollbar("x");
                _this.hideScrollbar("y");
            }
            _this.isScrolling = false;
        };
        this.onMouseEnter = function() {
            if (!_this.isMouseEntering) {
                $7b7c3d0272544179$var$addClasses(_this.el, _this.classNames.mouseEntered);
                _this.showScrollbar("x");
                _this.showScrollbar("y");
                _this.isMouseEntering = true;
            }
            _this.onMouseEntered();
        };
        this._onMouseEntered = function() {
            $7b7c3d0272544179$var$removeClasses(_this.el, _this.classNames.mouseEntered);
            if (_this.options.autoHide) {
                _this.hideScrollbar("x");
                _this.hideScrollbar("y");
            }
            _this.isMouseEntering = false;
        };
        this._onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis("y");
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis("y");
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this._onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.onPointerEvent = function(e) {
            if (!_this.axis.x.track.el || !_this.axis.y.track.el || !_this.axis.x.scrollbar.el || !_this.axis.y.scrollbar.el) return;
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
            // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Prevent event leaking
                e.stopPropagation();
                if (e.type === "pointerdown" && e.pointerType !== "touch") {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, "x");
                        else _this.onTrackClick(e, "x");
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, "y");
                        else _this.onTrackClick(e, "y");
                    }
                }
            }
        };
        /**
         * Drag scrollbar handle
         */ this.drag = function(e) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if (!_this.draggedAxis || !_this.contentWrapperEl) return;
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = (_b = (_a = track.rect) === null || _a === void 0 ? void 0 : _a[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _b !== void 0 ? _b : 0;
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = (_d = (_c = _this.contentWrapperEl) === null || _c === void 0 ? void 0 : _c[_this.axis[_this.draggedAxis].scrollSizeAttr]) !== null && _d !== void 0 ? _d : 0;
            var hostSize = parseInt((_f = (_e = _this.elStyles) === null || _e === void 0 ? void 0 : _e[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _f !== void 0 ? _f : "0px", 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === "y") eventOffset = e.pageY;
            else eventOffset = e.pageX;
            // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - ((_h = (_g = track.rect) === null || _g === void 0 ? void 0 : _g[_this.axis[_this.draggedAxis].offsetAttr]) !== null && _h !== void 0 ? _h : 0) - _this.axis[_this.draggedAxis].dragOffset;
            dragPos = _this.draggedAxis === "x" && _this.isRtl ? ((_k = (_j = track.rect) === null || _j === void 0 ? void 0 : _j[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _k !== void 0 ? _k : 0) - scrollbar.size - dragPos : dragPos;
            // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size);
            // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize);
            // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === "x" && _this.isRtl) scrollPos = ((_l = SimpleBarCore.getRtlHelpers()) === null || _l === void 0 ? void 0 : _l.isScrollingToNegative) ? -scrollPos : scrollPos;
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        /**
         * End scroll handle drag
         */ this.onEndDrag = function(e) {
            _this.isDragging = false;
            var elDocument = $7b7c3d0272544179$var$getElementDocument(_this.el);
            var elWindow = $7b7c3d0272544179$var$getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            $7b7c3d0272544179$var$removeClasses(_this.el, _this.classNames.dragging);
            _this.onStopScrolling();
            elDocument.removeEventListener("mousemove", _this.drag, true);
            elDocument.removeEventListener("mouseup", _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener("click", _this.preventClick, true);
                elDocument.removeEventListener("dblclick", _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        /**
         * Handler to ignore click events during drag
         */ this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.options = $7b7c3d0272544179$var$__assign($7b7c3d0272544179$var$__assign({}, SimpleBarCore.defaultOptions), options);
        this.classNames = $7b7c3d0272544179$var$__assign($7b7c3d0272544179$var$__assign({}, SimpleBarCore.defaultOptions.classNames), options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: "scrollLeft",
                sizeAttr: "width",
                scrollSizeAttr: "scrollWidth",
                offsetSizeAttr: "offsetWidth",
                offsetAttr: "left",
                overflowAttr: "overflowX",
                dragOffset: 0,
                isOverflowing: true,
                forceVisible: false,
                track: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                },
                scrollbar: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                }
            },
            y: {
                scrollOffsetAttr: "scrollTop",
                sizeAttr: "height",
                scrollSizeAttr: "scrollHeight",
                offsetSizeAttr: "offsetHeight",
                offsetAttr: "top",
                overflowAttr: "overflowY",
                dragOffset: 0,
                isOverflowing: true,
                forceVisible: false,
                track: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                },
                scrollbar: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                }
            }
        };
        if (typeof this.el !== "object" || !this.el.nodeName) throw new Error("Argument passed to SimpleBar must be an HTML element instead of ".concat(this.el));
        this.onMouseMove = (0, $a90d634f67577793$export$2e2bcd8739ae039)(this._onMouseMove, 64);
        this.onWindowResize = (0, $d38f7b7195f47e9c$export$2e2bcd8739ae039)(this._onWindowResize, 64, {
            leading: true
        });
        this.onStopScrolling = (0, $d38f7b7195f47e9c$export$2e2bcd8739ae039)(this._onStopScrolling, this.stopScrollDelay);
        this.onMouseEntered = (0, $d38f7b7195f47e9c$export$2e2bcd8739ae039)(this._onMouseEntered, this.stopScrollDelay);
        this.init();
    }
    /**
     * Helper to fix browsers inconsistency on RTL:
     *  - Firefox inverts the scrollbar initial position
     *  - IE11 inverts both scrollbar position and scrolling offset
     * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
     */ SimpleBarCore.getRtlHelpers = function() {
        if (SimpleBarCore.rtlHelpers) return SimpleBarCore.rtlHelpers;
        var dummyDiv = document.createElement("div");
        dummyDiv.innerHTML = '<div class="simplebar-dummy-scrollbar-size"><div></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        var dummyChild = scrollbarDummyEl === null || scrollbarDummyEl === void 0 ? void 0 : scrollbarDummyEl.firstElementChild;
        if (!dummyChild) return null;
        document.body.appendChild(scrollbarDummyEl);
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBarCore.getOffset(scrollbarDummyEl);
        var dummyChildOffset = SimpleBarCore.getOffset(dummyChild);
        scrollbarDummyEl.scrollLeft = -999;
        var dummyChildOffsetAfterScroll = SimpleBarCore.getOffset(dummyChild);
        document.body.removeChild(scrollbarDummyEl);
        SimpleBarCore.rtlHelpers = {
            // determines if the scrolling is responding with negative values
            isScrollOriginAtZero: dummyContainerOffset.left !== dummyChildOffset.left,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isScrollingToNegative: dummyChildOffset.left !== dummyChildOffsetAfterScroll.left
        };
        return SimpleBarCore.rtlHelpers;
    };
    SimpleBarCore.prototype.getScrollbarWidth = function() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (this.contentWrapperEl && getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display === "none" || "scrollbarWidth" in document.documentElement.style || "-ms-overflow-style" in document.documentElement.style) return 0;
            else return $7b7c3d0272544179$var$scrollbarWidth();
        } catch (e) {
            return $7b7c3d0272544179$var$scrollbarWidth();
        }
    };
    SimpleBarCore.getOffset = function(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = $7b7c3d0272544179$var$getElementDocument(el);
        var elWindow = $7b7c3d0272544179$var$getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    SimpleBarCore.prototype.init = function() {
        // We stop here on server-side
        if ($7b7c3d0272544179$var$canUseDOM) {
            this.initDOM();
            this.rtlHelpers = SimpleBarCore.getRtlHelpers();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    SimpleBarCore.prototype.initDOM = function() {
        var _a, _b;
        // assume that element has his DOM already initiated
        this.wrapperEl = this.el.querySelector($7b7c3d0272544179$var$classNamesToQuery(this.classNames.wrapper));
        this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector($7b7c3d0272544179$var$classNamesToQuery(this.classNames.contentWrapper));
        this.contentEl = this.options.contentNode || this.el.querySelector($7b7c3d0272544179$var$classNamesToQuery(this.classNames.contentEl));
        this.offsetEl = this.el.querySelector($7b7c3d0272544179$var$classNamesToQuery(this.classNames.offset));
        this.maskEl = this.el.querySelector($7b7c3d0272544179$var$classNamesToQuery(this.classNames.mask));
        this.placeholderEl = this.findChild(this.wrapperEl, $7b7c3d0272544179$var$classNamesToQuery(this.classNames.placeholder));
        this.heightAutoObserverWrapperEl = this.el.querySelector($7b7c3d0272544179$var$classNamesToQuery(this.classNames.heightAutoObserverWrapperEl));
        this.heightAutoObserverEl = this.el.querySelector($7b7c3d0272544179$var$classNamesToQuery(this.classNames.heightAutoObserverEl));
        this.axis.x.track.el = this.findChild(this.el, "".concat($7b7c3d0272544179$var$classNamesToQuery(this.classNames.track)).concat($7b7c3d0272544179$var$classNamesToQuery(this.classNames.horizontal)));
        this.axis.y.track.el = this.findChild(this.el, "".concat($7b7c3d0272544179$var$classNamesToQuery(this.classNames.track)).concat($7b7c3d0272544179$var$classNamesToQuery(this.classNames.vertical)));
        this.axis.x.scrollbar.el = ((_a = this.axis.x.track.el) === null || _a === void 0 ? void 0 : _a.querySelector($7b7c3d0272544179$var$classNamesToQuery(this.classNames.scrollbar))) || null;
        this.axis.y.scrollbar.el = ((_b = this.axis.y.track.el) === null || _b === void 0 ? void 0 : _b.querySelector($7b7c3d0272544179$var$classNamesToQuery(this.classNames.scrollbar))) || null;
        if (!this.options.autoHide) {
            $7b7c3d0272544179$var$addClasses(this.axis.x.scrollbar.el, this.classNames.visible);
            $7b7c3d0272544179$var$addClasses(this.axis.y.scrollbar.el, this.classNames.visible);
        }
    };
    SimpleBarCore.prototype.initListeners = function() {
        var _this = this;
        var _a;
        var elWindow = $7b7c3d0272544179$var$getElementWindow(this.el);
        // Event listeners
        this.el.addEventListener("mouseenter", this.onMouseEnter);
        this.el.addEventListener("pointerdown", this.onPointerEvent, true);
        this.el.addEventListener("mousemove", this.onMouseMove);
        this.el.addEventListener("mouseleave", this.onMouseLeave);
        (_a = this.contentWrapperEl) === null || _a === void 0 || _a.addEventListener("scroll", this.onScroll);
        // Browser zoom triggers a window resize
        elWindow.addEventListener("resize", this.onWindowResize);
        if (!this.contentEl) return;
        if (window.ResizeObserver) {
            // Hack for https://github.com/WICG/ResizeObserver/issues/38
            var resizeObserverStarted_1 = false;
            var resizeObserver = elWindow.ResizeObserver || ResizeObserver;
            this.resizeObserver = new resizeObserver(function() {
                if (!resizeObserverStarted_1) return;
                elWindow.requestAnimationFrame(function() {
                    _this.recalculate();
                });
            });
            this.resizeObserver.observe(this.el);
            this.resizeObserver.observe(this.contentEl);
            elWindow.requestAnimationFrame(function() {
                resizeObserverStarted_1 = true;
            });
        }
        // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(function() {
            elWindow.requestAnimationFrame(function() {
                _this.recalculate();
            });
        });
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    SimpleBarCore.prototype.recalculate = function() {
        if (!this.heightAutoObserverEl || !this.contentEl || !this.contentWrapperEl || !this.wrapperEl || !this.placeholderEl) return;
        var elWindow = $7b7c3d0272544179$var$getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === "rtl";
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1 || contentElOffsetWidth > 0;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = "".concat(this.elStyles.paddingTop, " ").concat(this.elStyles.paddingRight, " ").concat(this.elStyles.paddingBottom, " ").concat(this.elStyles.paddingLeft);
        this.wrapperEl.style.margin = "-".concat(this.elStyles.paddingTop, " -").concat(this.elStyles.paddingRight, " -").concat(this.elStyles.paddingBottom, " -").concat(this.elStyles.paddingLeft);
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? "auto" : "100%";
        // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? "".concat(contentElOffsetWidth || contentElScrollWidth, "px") : "auto";
        this.placeholderEl.style.height = "".concat(contentElScrollHeight, "px");
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElOffsetWidth !== 0 && contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight;
        // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === "hidden" ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === "hidden" ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === "x" || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === "y" || this.options.forceVisible === true;
        this.hideNativeScrollbar();
        // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize("x");
        this.axis.y.scrollbar.size = this.getScrollbarSize("y");
        if (this.axis.x.scrollbar.el) this.axis.x.scrollbar.el.style.width = "".concat(this.axis.x.scrollbar.size, "px");
        if (this.axis.y.scrollbar.el) this.axis.y.scrollbar.el.style.height = "".concat(this.axis.y.scrollbar.size, "px");
        this.positionScrollbar("x");
        this.positionScrollbar("y");
        this.toggleTrackVisibility("x");
        this.toggleTrackVisibility("y");
    };
    /**
     * Calculate scrollbar size
     */ SimpleBarCore.prototype.getScrollbarSize = function(axis) {
        var _a, _b;
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing || !this.contentEl) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = (_b = (_a = this.axis[axis].track.el) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetSizeAttr]) !== null && _b !== void 0 ? _b : 0;
        var scrollbarRatio = trackSize / contentSize;
        var scrollbarSize;
        // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    SimpleBarCore.prototype.positionScrollbar = function(axis) {
        var _a, _b, _c;
        if (axis === void 0) axis = "y";
        var scrollbar = this.axis[axis].scrollbar;
        if (!this.axis[axis].isOverflowing || !this.contentWrapperEl || !scrollbar.el || !this.elStyles) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = ((_a = this.axis[axis].track.el) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetSizeAttr]) || 0;
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === "x" && this.isRtl && ((_b = SimpleBarCore.getRtlHelpers()) === null || _b === void 0 ? void 0 : _b.isScrollOriginAtZero) ? -scrollOffset : scrollOffset;
        if (axis === "x" && this.isRtl) scrollOffset = ((_c = SimpleBarCore.getRtlHelpers()) === null || _c === void 0 ? void 0 : _c.isScrollingToNegative) ? scrollOffset : -scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === "x" && this.isRtl ? -handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === "x" ? "translate3d(".concat(handleOffset, "px, 0, 0)") : "translate3d(0, ".concat(handleOffset, "px, 0)");
    };
    SimpleBarCore.prototype.toggleTrackVisibility = function(axis) {
        if (axis === void 0) axis = "y";
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!track || !scrollbar || !this.contentWrapperEl) return;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = "visible";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "scroll";
            this.el.classList.add("".concat(this.classNames.scrollable, "-").concat(axis));
        } else {
            track.style.visibility = "hidden";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "hidden";
            this.el.classList.remove("".concat(this.classNames.scrollable, "-").concat(axis));
        }
        // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = "block";
        else scrollbar.style.display = "none";
    };
    SimpleBarCore.prototype.showScrollbar = function(axis) {
        if (axis === void 0) axis = "y";
        if (this.axis[axis].isOverflowing && !this.axis[axis].scrollbar.isVisible) {
            $7b7c3d0272544179$var$addClasses(this.axis[axis].scrollbar.el, this.classNames.visible);
            this.axis[axis].scrollbar.isVisible = true;
        }
    };
    SimpleBarCore.prototype.hideScrollbar = function(axis) {
        if (axis === void 0) axis = "y";
        if (this.isDragging) return;
        if (this.axis[axis].isOverflowing && this.axis[axis].scrollbar.isVisible) {
            $7b7c3d0272544179$var$removeClasses(this.axis[axis].scrollbar.el, this.classNames.visible);
            this.axis[axis].scrollbar.isVisible = false;
        }
    };
    SimpleBarCore.prototype.hideNativeScrollbar = function() {
        if (!this.offsetEl) return;
        this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-".concat(this.scrollbarWidth, "px") : "0px";
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-".concat(this.scrollbarWidth, "px") : "0px";
    };
    SimpleBarCore.prototype.onMouseMoveForAxis = function(axis) {
        if (axis === void 0) axis = "y";
        var currentAxis = this.axis[axis];
        if (!currentAxis.track.el || !currentAxis.scrollbar.el) return;
        currentAxis.track.rect = currentAxis.track.el.getBoundingClientRect();
        currentAxis.scrollbar.rect = currentAxis.scrollbar.el.getBoundingClientRect();
        if (this.isWithinBounds(currentAxis.track.rect)) {
            this.showScrollbar(axis);
            $7b7c3d0272544179$var$addClasses(currentAxis.track.el, this.classNames.hover);
            if (this.isWithinBounds(currentAxis.scrollbar.rect)) $7b7c3d0272544179$var$addClasses(currentAxis.scrollbar.el, this.classNames.hover);
            else $7b7c3d0272544179$var$removeClasses(currentAxis.scrollbar.el, this.classNames.hover);
        } else {
            $7b7c3d0272544179$var$removeClasses(currentAxis.track.el, this.classNames.hover);
            if (this.options.autoHide) this.hideScrollbar(axis);
        }
    };
    SimpleBarCore.prototype.onMouseLeaveForAxis = function(axis) {
        if (axis === void 0) axis = "y";
        $7b7c3d0272544179$var$removeClasses(this.axis[axis].track.el, this.classNames.hover);
        $7b7c3d0272544179$var$removeClasses(this.axis[axis].scrollbar.el, this.classNames.hover);
        if (this.options.autoHide) this.hideScrollbar(axis);
    };
    /**
     * on scrollbar handle drag movement starts
     */ SimpleBarCore.prototype.onDragStart = function(e, axis) {
        var _a;
        if (axis === void 0) axis = "y";
        this.isDragging = true;
        var elDocument = $7b7c3d0272544179$var$getElementDocument(this.el);
        var elWindow = $7b7c3d0272544179$var$getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar;
        // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === "y" ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - (((_a = scrollbar.rect) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetAttr]) || 0);
        this.draggedAxis = axis;
        $7b7c3d0272544179$var$addClasses(this.el, this.classNames.dragging);
        elDocument.addEventListener("mousemove", this.drag, true);
        elDocument.addEventListener("mouseup", this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener("click", this.preventClick, true);
            elDocument.addEventListener("dblclick", this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    };
    SimpleBarCore.prototype.onTrackClick = function(e, axis) {
        var _this = this;
        var _a, _b, _c, _d;
        if (axis === void 0) axis = "y";
        var currentAxis = this.axis[axis];
        if (!this.options.clickOnTrack || !currentAxis.scrollbar.el || !this.contentWrapperEl) return;
        // Preventing the event's default to trigger click underneath
        e.preventDefault();
        var elWindow = $7b7c3d0272544179$var$getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = currentAxis.scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = (_b = (_a = scrollbar.rect) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetAttr]) !== null && _b !== void 0 ? _b : 0;
        var hostSize = parseInt((_d = (_c = this.elStyles) === null || _c === void 0 ? void 0 : _c[this.axis[axis].sizeAttr]) !== null && _d !== void 0 ? _d : "0px", 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === "y" ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var speed = 40;
        var scrollTo = function() {
            if (!_this.contentWrapperEl) return;
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    scrolled -= speed;
                    _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                scrolled += speed;
                _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    };
    /**
     * Getter for content element
     */ SimpleBarCore.prototype.getContentElement = function() {
        return this.contentEl;
    };
    /**
     * Getter for original scrolling element
     */ SimpleBarCore.prototype.getScrollElement = function() {
        return this.contentWrapperEl;
    };
    SimpleBarCore.prototype.removeListeners = function() {
        var elWindow = $7b7c3d0272544179$var$getElementWindow(this.el);
        // Event listeners
        this.el.removeEventListener("mouseenter", this.onMouseEnter);
        this.el.removeEventListener("pointerdown", this.onPointerEvent, true);
        this.el.removeEventListener("mousemove", this.onMouseMove);
        this.el.removeEventListener("mouseleave", this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener("scroll", this.onScroll);
        elWindow.removeEventListener("resize", this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        // Cancel all debounced functions
        this.onMouseMove.cancel();
        this.onWindowResize.cancel();
        this.onStopScrolling.cancel();
        this.onMouseEntered.cancel();
    };
    /**
     * Remove all listeners from DOM nodes
     */ SimpleBarCore.prototype.unMount = function() {
        this.removeListeners();
    };
    /**
     * Check if mouse is within bounds
     */ SimpleBarCore.prototype.isWithinBounds = function(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    };
    /**
     * Find element children matches query
     */ SimpleBarCore.prototype.findChild = function(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    SimpleBarCore.rtlHelpers = null;
    SimpleBarCore.defaultOptions = {
        forceVisible: false,
        clickOnTrack: true,
        scrollbarMinSize: 25,
        scrollbarMaxSize: 0,
        ariaLabel: "scrollable content",
        tabIndex: 0,
        classNames: {
            contentEl: "simplebar-content",
            contentWrapper: "simplebar-content-wrapper",
            offset: "simplebar-offset",
            mask: "simplebar-mask",
            wrapper: "simplebar-wrapper",
            placeholder: "simplebar-placeholder",
            scrollbar: "simplebar-scrollbar",
            track: "simplebar-track",
            heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
            heightAutoObserverEl: "simplebar-height-auto-observer",
            visible: "simplebar-visible",
            horizontal: "simplebar-horizontal",
            vertical: "simplebar-vertical",
            hover: "simplebar-hover",
            dragging: "simplebar-dragging",
            scrolling: "simplebar-scrolling",
            scrollable: "simplebar-scrollable",
            mouseEntered: "simplebar-mouse-entered"
        },
        scrollableNode: null,
        contentNode: null,
        autoHide: true
    };
    /**
     * Static functions
     */ SimpleBarCore.getOptions = $7b7c3d0272544179$var$getOptions;
    SimpleBarCore.helpers = $7b7c3d0272544179$var$helpers;
    return SimpleBarCore;
}();


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ad38314621af4ab1$var$extendStatics = function(d, b) {
    $ad38314621af4ab1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ad38314621af4ab1$var$extendStatics(d, b);
};
function $ad38314621af4ab1$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ad38314621af4ab1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ad38314621af4ab1$var$_a = (0, $7b7c3d0272544179$export$2e2bcd8739ae039).helpers, $ad38314621af4ab1$var$getOptions = $ad38314621af4ab1$var$_a.getOptions, $ad38314621af4ab1$var$addClasses = $ad38314621af4ab1$var$_a.addClasses, $ad38314621af4ab1$var$canUseDOM = $ad38314621af4ab1$var$_a.canUseDOM;
var $ad38314621af4ab1$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $ad38314621af4ab1$var$__extends(SimpleBar, _super);
    function SimpleBar() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        // // Save a reference to the instance, so we know this DOM node has already been instancied
        SimpleBar.instances.set(args[0], _this);
        return _this;
    }
    SimpleBar.initDOMLoadedElements = function() {
        document.removeEventListener("DOMContentLoaded", this.initDOMLoadedElements);
        window.removeEventListener("load", this.initDOMLoadedElements);
        Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"), function(el) {
            if (el.getAttribute("data-simplebar") !== "init" && !SimpleBar.instances.has(el)) new SimpleBar(el, $ad38314621af4ab1$var$getOptions(el.attributes));
        });
    };
    SimpleBar.removeObserver = function() {
        var _a;
        (_a = SimpleBar.globalObserver) === null || _a === void 0 || _a.disconnect();
    };
    SimpleBar.prototype.initDOM = function() {
        var _this = this;
        var _a, _b, _c;
        // make sure this element doesn't have the elements yet
        if (!Array.prototype.filter.call(this.el.children, function(child) {
            return child.classList.contains(_this.classNames.wrapper);
        }).length) {
            // Prepare DOM
            this.wrapperEl = document.createElement("div");
            this.contentWrapperEl = document.createElement("div");
            this.offsetEl = document.createElement("div");
            this.maskEl = document.createElement("div");
            this.contentEl = document.createElement("div");
            this.placeholderEl = document.createElement("div");
            this.heightAutoObserverWrapperEl = document.createElement("div");
            this.heightAutoObserverEl = document.createElement("div");
            $ad38314621af4ab1$var$addClasses(this.wrapperEl, this.classNames.wrapper);
            $ad38314621af4ab1$var$addClasses(this.contentWrapperEl, this.classNames.contentWrapper);
            $ad38314621af4ab1$var$addClasses(this.offsetEl, this.classNames.offset);
            $ad38314621af4ab1$var$addClasses(this.maskEl, this.classNames.mask);
            $ad38314621af4ab1$var$addClasses(this.contentEl, this.classNames.contentEl);
            $ad38314621af4ab1$var$addClasses(this.placeholderEl, this.classNames.placeholder);
            $ad38314621af4ab1$var$addClasses(this.heightAutoObserverWrapperEl, this.classNames.heightAutoObserverWrapperEl);
            $ad38314621af4ab1$var$addClasses(this.heightAutoObserverEl, this.classNames.heightAutoObserverEl);
            while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
            this.contentWrapperEl.appendChild(this.contentEl);
            this.offsetEl.appendChild(this.contentWrapperEl);
            this.maskEl.appendChild(this.offsetEl);
            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
            this.wrapperEl.appendChild(this.maskEl);
            this.wrapperEl.appendChild(this.placeholderEl);
            this.el.appendChild(this.wrapperEl);
            (_a = this.contentWrapperEl) === null || _a === void 0 || _a.setAttribute("tabindex", this.options.tabIndex.toString());
            (_b = this.contentWrapperEl) === null || _b === void 0 || _b.setAttribute("role", "region");
            (_c = this.contentWrapperEl) === null || _c === void 0 || _c.setAttribute("aria-label", this.options.ariaLabel);
        }
        if (!this.axis.x.track.el || !this.axis.y.track.el) {
            var track = document.createElement("div");
            var scrollbar = document.createElement("div");
            $ad38314621af4ab1$var$addClasses(track, this.classNames.track);
            $ad38314621af4ab1$var$addClasses(scrollbar, this.classNames.scrollbar);
            track.appendChild(scrollbar);
            this.axis.x.track.el = track.cloneNode(true);
            $ad38314621af4ab1$var$addClasses(this.axis.x.track.el, this.classNames.horizontal);
            this.axis.y.track.el = track.cloneNode(true);
            $ad38314621af4ab1$var$addClasses(this.axis.y.track.el, this.classNames.vertical);
            this.el.appendChild(this.axis.x.track.el);
            this.el.appendChild(this.axis.y.track.el);
        }
        (0, $7b7c3d0272544179$export$2e2bcd8739ae039).prototype.initDOM.call(this);
        this.el.setAttribute("data-simplebar", "init");
    };
    SimpleBar.prototype.unMount = function() {
        (0, $7b7c3d0272544179$export$2e2bcd8739ae039).prototype.unMount.call(this);
        SimpleBar.instances["delete"](this.el);
    };
    SimpleBar.initHtmlApi = function() {
        this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this);
        // MutationObserver is IE11+
        if (typeof MutationObserver !== "undefined") {
            // Mutation observer to observe dynamically added elements
            this.globalObserver = new MutationObserver(SimpleBar.handleMutations);
            this.globalObserver.observe(document, {
                childList: true,
                subtree: true
            });
        }
        // Taken from jQuery `ready` function
        // Instantiate elements already present on the page
        if (document.readyState === "complete" || // @ts-ignore: IE specific
        document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay init
        window.setTimeout(this.initDOMLoadedElements);
        else {
            document.addEventListener("DOMContentLoaded", this.initDOMLoadedElements);
            window.addEventListener("load", this.initDOMLoadedElements);
        }
    };
    SimpleBar.handleMutations = function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(addedNode) {
                if (addedNode.nodeType === 1) {
                    if (addedNode.hasAttribute("data-simplebar")) !SimpleBar.instances.has(addedNode) && document.documentElement.contains(addedNode) && new SimpleBar(addedNode, $ad38314621af4ab1$var$getOptions(addedNode.attributes));
                    else addedNode.querySelectorAll("[data-simplebar]").forEach(function(el) {
                        if (el.getAttribute("data-simplebar") !== "init" && !SimpleBar.instances.has(el) && document.documentElement.contains(el)) new SimpleBar(el, $ad38314621af4ab1$var$getOptions(el.attributes));
                    });
                }
            });
            mutation.removedNodes.forEach(function(removedNode) {
                var _a;
                if (removedNode.nodeType === 1) {
                    if (removedNode.getAttribute("data-simplebar") === "init") !document.documentElement.contains(removedNode) && ((_a = SimpleBar.instances.get(removedNode)) === null || _a === void 0 || _a.unMount());
                    else Array.prototype.forEach.call(removedNode.querySelectorAll('[data-simplebar="init"]'), function(el) {
                        var _a;
                        !document.documentElement.contains(el) && ((_a = SimpleBar.instances.get(el)) === null || _a === void 0 || _a.unMount());
                    });
                }
            });
        });
    };
    SimpleBar.instances = new WeakMap();
    return SimpleBar;
}((0, $7b7c3d0272544179$export$2e2bcd8739ae039));
/**
 * HTML API
 * Called only in a browser env.
 */ if ($ad38314621af4ab1$var$canUseDOM) $ad38314621af4ab1$export$2e2bcd8739ae039.initHtmlApi();



var $ed3b5288f705ed1e$var$head = document.getElementsByTagName("head")[0];
for (const weight of [
    "regular",
    "thin",
    "light",
    "bold",
    "fill",
    "duotone"
]){
    var $ed3b5288f705ed1e$var$link = document.createElement("link");
    $ed3b5288f705ed1e$var$link.rel = "stylesheet";
    $ed3b5288f705ed1e$var$link.type = "text/css";
    $ed3b5288f705ed1e$var$link.href = "https://unpkg.com/@phosphor-icons/web@2.1.1/src/" + weight + "/style.css";
    $ed3b5288f705ed1e$var$head.appendChild($ed3b5288f705ed1e$var$link);
}


parcelRequire("60Xwh");
(0, $2f8c1ce30a15b0c7$export$565dcf582cc7e325)();
// Vanilla JS Datepicker
(0, $941b38af69543b93$export$e95f23a3da8bb3c7)();
// Quill
(0, $e87d4bd42ac851f3$export$3f3b4272299f29de)();
// noUiSlider
(0, $c03fe7fdaf35f625$export$b38bf4f33e9e4c25)();
// Vanilla Colorful
(0, $601a1a02a92d61a5$export$fd9a8359a728871b)();


//# sourceMappingURL=vendor.b731a90c.js.map
